module.exports = {
  nativeDescription: 'polski',
  englishDescription: 'Polish',
  translation: {

    //  ozaria_home: {
    //    subtitle: "Computer Science that Captivates",
    //    heading_subtitle: "A coding adventure for students and your turnkey solution for teaching Computer Science.",
    //    item_list_p: "Try Chapter 1 for Free Today!",
    //    engaging_heading_corner: "A solution to Engage Students and Support Teachers",
    //    engaging_row1_h2: "Easy Implementation",
    //    engaging_row1_p: "Even with no coding experience, you can teach a full Computer Science curriculum with Ozaria. Our ready-to-go lesson plans and intuitive dashboard will provide you with the tools you need to be ready to teach on day one.",
    //    engaging_row2_h2: "Immersive Gameplay",
    //    engaging_row2_p: "Students are immersed in an adventure game in which their knowledge of Computer Science advances with the storyline. In this engaging learning environment, students build real-world skills through the power of play.",
    //    engaging_row3_h2: "Standards-Aligned Curriculum",
    //    engaging_row3_p: "Ozaria meets CSTA and ISTE standards, enabling you to teach with confidence as your students master core Computer Science concepts, develop computational thinking skills, and learn about the relevance of Computer Science to their daily lives.",
    //    pd_blurb: "Learn the skills to effectively teach computer science with our self-directed, CSTA-accredited __pd__ course. Earn up to 40 credit hours any time, from any device.",
    //    back_cta_1_a: "Try Chapter 1 for Free",
    //    speech_bubble_testimonial_1_blockquote: "Once again, your team has managed to accomplish the Holy Grail of Edutainment. In my opinion as a 26-year veteran Middle School educator, there is no more engaging resource for teaching coding.",
    //    core_curriculum_header: "Core Computer Science Curriculum",
    //    core_curriculum_p: "We have developed our instructional model based on proven theories and extensive evidence around how students learn best.",
    //    core_curriculum_carousel_item1_header: "Make Connections",
    //    core_curriculum_carousel_item1_p: "At the start of every module, use our turnkey lesson slides to help your students make the connection between new Computer Science concepts and relevant examples from their daily lives.",
    //    core_curriculum_carousel_item2_header: "Construct Own Meaning",
    //    core_curriculum_carousel_item2_p: "Next, guide your students in constructing a deeper understanding of new concepts through unplugged and discussion activities that are built into our lesson plans.",
    //    core_curriculum_carousel_item3_header: "Learn New Concepts",
    //    core_curriculum_carousel_item3_p: "In the third stage of the learning cycle, your students will learn new concepts through expositional dialogue between characters in the Ozaria story. Voice-over, graphics, and animations make absorbing new information even more accessible and fun.",
    //    core_curriculum_carousel_item4_header: "Apply New Knowledge",
    //    core_curriculum_carousel_item4_p: "Next, your students will put what they learned into practice by typing real Python or JavaScript to solve a variety of challenges in scaffolded game levels. Built-in hints help students identify and fix bugs, leading to greater coding confidence.",
    //    core_curriculum_carousel_item5_header: "Summative Project",
    //    core_curriculum_carousel_item5_p: "At the end of each chapter, your students will be challenged to showcase their new skills and express their creativity through summative projects in which they build their own games, stories, and more.",
    //    core_curriculum_scope_sequence: "View Scope & Sequence",
    //    core_curriculum_sample_lesson_slides: "View Sample Lesson Slides",
    //    global_community_header: "Join Our Global Community",
    //    global_community_row1_p: "Learners",
    //    global_community_row2_p: "Lines of Code",
    //    global_community_row3_p: "Teachers",
    //    global_community_row4_p: "Countries",
    //    admin_dashboard_header: "Comprehensive Teacher & Admin Dashboards",
    //    admin_dashboard_p: "Designed with feedback from our community of over 140,000 educators, Ozaria addresses the challenges of teaching Computer Science by providing tools and resources that work.",
    //    admin_dashboard_row1_p: "The intuitive Teacher Dashboard provides access to student-facing lesson plans, pacing guides, distance learning strategies, and other resources to support your needs.",
    //    admin_dashboard_row2_p: "The Track Progress page allows you to monitor student progress on an ongoing basis, get valuable information on their performance, and immediately identify whether interventions are needed.",
    //    admin_dashboard_row3_a: "Request a Quote",
    //    acodus_awards_a: "Try Chapter 1 for Free",
    //    speech_bubble_testimonial_2_blockquote: "It’s the most accessible programming site I’ve seen as of yet. I appreciate the story that goes with Ozaria, as it aligns with a mission my students can empathize with. Frankly, I love it. In fact, I found myself playing for far longer than I wish to admit last weekend!",
    //    shareable_resources_header: "Shareable Resources",
    //    shareable_resources_p: "Share the resources below with teachers, administrators, and others involved in bringing Computer Science to your school or expanding offerings already in place.",
    //    shareable_resources_a: "Download Flyer",
    //    back_cta_2_a: "Try Chapter 1 for Free",
    //    faq_header: "Frequently Asked Questions",
    //    faq_row1_header: "How is Ozaria related to CodeCombat?",
    //    faq_row1_p: "Ozaria is the classroom-centered evolution of CodeCombat, one of the most popular coding games in history. We built Ozaria based off the insights gained from teaching over 20 million learners Python and JavaScript. Ozaria incorporates new pedagogical models, an immersive story-driven narrative, and was designed to be implemented in classrooms, for both in-person and remote learning settings.",
    //    faq_row2_header: "What ages or grades are appropriate for Ozaria?",
    //    faq_row2_p: "Ozaria is aligned to the CSTA and ISTE middle school CS standards, but has been practiced and enjoyed by students ranging from upper elementary through high school.",
    //    faq_row3_header: "How much does it cost to access all of the available units and resources?",
    //    faq_row3_p_part1: "We customize solutions for schools and districts and work with you to understand your use case, context, and budget. ",
    //    faq_row3_p_part2: " for further details! We also provide a ",
    //    faq_row3_p_part3: "funding resources guide",
    //    faq_row3_p_part4: " for school and district CS programs.",
    //    faq_row4_header: "Does Ozaria have project-based learning?",
    //    faq_row4_p: "Yes. Ozaria incorporates shareable Capstone Projects at the end of each Chapter, where students create their own games. These projects serve as summative assessments and are great ways for students to express themselves and demonstrate their learnings to classmates, friends, and family.",
    //    faq_row5_header: "Can I use Ozaria as my class’s main curriculum?",
    //    faq_row5_p: "Absolutely! Ozaria has everything you need to run a full Computer Science class, even if you don't have a Computer Science background. From lesson plans and solution guides to project rubrics and built-in standards alignment, it's all here.",
    //    faq_row6_p_part1: "If you have any other questions, please ",
    //    see_faq_prefix: "See more",
    //    see_faq_link: "frequently asked questions in our help center",
    //    see_faq_suffix: ".",
    //    summary: "Ozaria is a computer science program, an adventure game, and a fantasy story where students master the lost magic of coding to save their world.",
    //    value_prop1_h1: "Epic Story. Immersive Gameplay.",
    //    value_prop1_h2: "Inspire a deeper connection to learning",
    //    value_prop1_p: "In Ozaria, students find themselves embedded in a new world where they master core computer science concepts to progress within the game. The unfolding narrative creates a powerful student-centered learning experience, with each student’s investment in Ozaria’s story paralleling the investment they are making in their own learning journey.",
    //    value_prop2_h1: "Discover the Hero within Every Student",
    //    value_prop2_h2: "Build real skills through play",
    //    value_prop2_p: "Concepts and skills are introduced via a thoughtfully-designed content progression that includes game levels, instructional character dialogue, cutscenes, and more. Students learn to type Python or JavaScript, problem-solve using computational thinking, demonstrate understanding through formative assessments, and apply what they learn by making their own projects.",
    //    value_prop3_h1: "Start Your Journey For Free",
    //    value_prop3_p: "Teach through adventure with free content covering introductory computer science concepts, plus access to implementation guides and lesson plans.",
    //    projects_inspire_heading: "Projects that Inspire. Resources that Empower.",
    //    student_creativity: "Unleash Student Creativity",
    //    student_creativity_paragraph: "At the end of each unit, students apply what they've learned by creating projects, from games to choose-your-own adventure stories and more. Built with scaffolded goals, yet allowing for limitless ideation, students build a shareable and playable portfolio of work that showcases their creative identity.",
    //    teach_with_support: "Teach with Support",
    //    teach_with_support_paragraph: "Ozaria is built for educators. Each unit throughout the curriculum has a lesson plan that outlines learning objectives, common student misconceptions, key terms, and CSTA standards. In addition, a comprehensive teacher dashboard helps teachers to track student progress and check student code.",
    //    request_demo: "Request a Demo",
    //    im_an_educator: "I'm an Educator",
    //    im_a_student: "I'm a Student",
    //    global_title: "Join Our Global Community of Learners and Educators",
    //    global_subtitle1: "Learners",
    //    global_subtitle2: "Lines of Code",
    //    global_subtitle3: "Teachers",
    //    global_subtitle4: "Countries",
    //    sign_up: "Sign Up",
    //    individual_account_warning: "You are logged in as __name__, which is an individual account. Ozaria is for teacher and student accounts only; do you need to update your account?",
    //    learner_number: "12 Million",
    //    code_line_number: "1 Billion",
    //    dei_initiatives: "What initiatives does Ozaria have to ensure diversity, equity, and inclusion in the game?",
    //    dei_initiatives_blurb: "Ozaria is dedicated to promoting diversity, equity, and inclusion (DEI) within the game. Through diverse character representation, equitable opportunities, and an inclusive environment, Ozaria embraces differences and fosters a welcoming experience for players of all backgrounds and abilities. Explore our __deipage__ to learn more about our commitment and initiatives towards DEI in Ozaria.",
    //    dei_page: "DEI page",
    //    ozaria_efficacy: "How does Ozaria measure and demonstrate its effectiveness in improving learning outcomes in the classroom?",
    //    ozaria_efficacy_blurb: "We prioritize effectiveness through evidence-based practices and assessment. Our __efficacypage__ offers detailed statistics, real teacher quotes, and compelling case studies demonstrating the transformative impact of Ozaria. By creating meaningful learning experiences and employing evidence-based practices, we design content that delivers the outcomes that matter most to teachers and students.",
    //    efficacy_page: "efficacy page",
    //    social_learning: "Does Ozaria promote social and emotional learning (SEL)?",
    //    social_learning_blurb: "Yes! Ozaria actively integrates social and emotional learning (SEL) into its curriculum. Through gamified activities, students develop essential skills such as decision-making, self-awareness, self-management, social awareness, relationship skills, and responsible decision-making. You can learn more about our philosophy on our __selpage__.",
    //    sel_page: "SEL page",
    //  },

    new_home: {
      title_coco: 'CodeCombat - Gra koderska do nauki Pythona i JavaScriptu',
      title_ozar: 'CodeCombat - Gra koderska do nauki Pythona i JavaScriptu',
      //    title_cn_home: "CodeCombat|Python, Javascript",
      meta_keywords_coco: 'CodeCombat, python, javascript, Coding Games',
      meta_keywords_ozar: 'CodeCombat, python, javascript, Coding Games',
      meta_description_coco: 'Naucz się pisać kod poprzez programowanie gry. Naucz się Pythona, JavaScript i HTMLa w trakcie rozwiązywania zagadek i naucz soę tworzenia twoich własnych gier i stron internetowych',
      meta_description_ozar: 'Naucz się pisać kod poprzez programowanie gry. Naucz się Pythona, JavaScript i HTMLa w trakcie rozwiązywania zagadek i naucz soę tworzenia twoich własnych gier i stron internetowych',
      meta_og_url: 'https://codecombat.com',
      become_investor: 'Zostań inwestorem w CodeCombat',
      built_for_teachers_title: 'Gra koderska zbudowana z myślą o nauczycielach',
      built_for_teachers_blurb: 'Uczenie dzieci programowania często może być przytłaczające. CodeCombat pomaga wszystkim nauczycielom nauczyć uczniów jak kodować albo w JavaScripcie albo w Pythonie, dwóch z najbardziej popularnych języków programowania. Z kompleskowym programem nauczania, który zawiera sześć lekcji informatyki i który wspomaga naukę poprzez projektowe umiejętności gamedevowe i webdevowe, dzieci będą poczyniać postępy w podróży od podstawowej składni do rekurencji!',
      built_for_teachers_subtitle1: 'Informatyka',
      built_for_teachers_subblurb1: 'Rozpoczynając z naszym darmowym kursem Wprowadzenia do Informatyki, uczniowie doskonalą podstawowe znajomości programistyczne takie jak pętle while/for, funkcje i algorytmy.',
      built_for_teachers_subtitle2: 'Tworzenie gier',
      built_for_teachers_subblurb2: 'Uczniowie konstruują labirynty i używają podstawowej obsługi wejścia aby programować własne gry, które mogą udostęnić rodzinie i przyjaciołom.',
      built_for_teachers_subtitle3: 'Tworzenie stron internetowych',
      built_for_teachers_subblurb3: 'Używając HTML, CSS i jQuery, uczniowie wykazują się kreatywnością abt stworzyć ich własne strony internetowe z ustalonym adresem URL, który mogą udostępnić go swoim kolegom/koleżankom z klasy.',
      century_skills_title: 'Umiejętności na miarę 21 wieku',
      century_skills_blurb1: 'Uczniowie nie tylko rozwijają swojego bohatera, ale również i siebie.',
      century_skills_quote1: 'Zepsułeś...więc myślisz o wszystkich możliwych drogach aby to naprawić i wtedy próbujesz ponownie. Nie byłbym w stanie tutaj dotrzeć bez starań',
      century_skills_subtitle1: 'Krytyczne myślenie',
      century_skills_subblurb1: 'Z zagadkami koderskimi, które są naturalnie rozstawione na coraz trudniejszych pozomach, gra koderska CodeCombaya zapewnia, że dzieciaki zawsze praktykuja krytyczne myślenie.',
      century_skills_quote2: "Każdy inny robił labirynty, więc pomyślałem sobie 'znajdź flagę' i to wlaśnie zrobiłem.",
      century_skills_subtitle2: 'Kreatywność',
      century_skills_subblurb2: 'CodeCombat zachęca uczniów do ukazania swojej kreatywności poprzez budowanie i udostępnianie swoich gier i stron.',
      century_skills_quote3: 'Jeżeli utknę w poziomie, mogę pracować z ludźmi wokół mnie dopóki będziemy w stanie wymyślić rozwiązanie.',
      century_skills_subtitle3: 'Współpraca',
      century_skills_subblurb3: 'Poprzez grę, są tu możliwości dla uczniów, aby współpracować kiedy utkną, używając naszego przewodnika po pair programmingu.',
      century_skills_quote4: 'Zawsze miałem  aspiracje do projektowania gier i nauka programowania... daje mi świetny start.',
      century_skills_quote4_author: 'Joey, Klasa 10',
      century_skills_subtitle4: 'Komunikacja',
      century_skills_subblurb4: 'Kodowanie wymaga od dzieci użycia nowych form komunikacji, wliczając komunikację z samym konputerem i przeniesienie swoich pomysłów używając najbardziej efektywnego kodu.',
      classroom_in_box_title: 'Dążymy do:',
      classroom_in_box_blurb1: 'Zaangażowania każdego ucznia tak, aby uwierzyli że programowanie jest dla nich.',
      classroom_in_box_blurb2: 'Dać każdemu nauczycielowi poczucie pewności podczas nauczania kodowania.',
      classroom_in_box_blurb3: 'Zainspirować wszystkich aby stworzyć światowy program nauki informatyki.',
      //    classroom_in_box_blurb4: "",
      click_here: 'Kliknij tutaj!',
      creativity_rigor_title: 'Gdzie kreatywność spotyka się z rygorem',
      creativity_rigor_subtitle1: 'Spraw, żeby kodowanie bylo przyjemnością i naucz umiejętności  Make coding fun and teach real-world skills',
      creativity_rigor_blurb1: 'Uczniowie używają prawdziwego Pythona i JavaScriptu podczas grania w gry które zachęcają do prób i błędów, krytycznego myślenia i kreatywności. Uczniowie stosują umoejętności, których się nauczyli poprzez tworzenie swoich gier i stron w kursach bazowanych o projekty.',
      creativity_rigor_subtitle2: 'Dotrzyj do uczniów na ich poziomie',
      creativity_rigor_blurb2: 'Każdy poziom CodeCombat jest oparty na milionach punktów danych i zoptymalizowany pod kątem dostosowania do każdego ucznia. Poziomy ćwiczeń i wskazówki pomagają uczniom, gdy utkną, a poziomy wyzwań oceniają naukę uczniów w trakcie gry.',
      creativity_rigor_subtitle3: 'Zbudowany dla wszystkich nauczycieli, niezależnie od doświadczenia.',
      creativity_rigor_blurb3: 'Samodzielny, dostosowany do standardów program CodeCombat sprawia, że ​​nauczanie informatyki jest możliwe dla każdego. CodeCombat wyposaża nauczycieli w szkolenia, zasoby instruktażowe i dedykowane wsparcie, aby czuć się pewnie i odnosić sukcesy w klasie.',
      featured_partners_title1: 'Jesteśmy wyróżnieni w:',
      featured_partners_title2: 'Awards & Partners',
      featured_partners_blurb1: 'Clever Partner',
      featured_partners_blurb2: 'Best Creativity Tool for Students',
      featured_partners_blurb3: 'Top Pick for Learning',
      featured_partners_blurb4: 'Code.org Official Partner',
      featured_partners_blurb5: 'CSforAll Official Member',
      featured_partners_blurb6: 'Hour of Code Activity Partner',
      for_leaders_title: 'Dla dyrektorów: ',
      for_leaders_blurb: 'Kompleksowy, zgodny ze standardami program informatyczny',
      for_leaders_subtitle1: 'Łatwa implementacja',
      for_leaders_subblurb1: 'Program internetowy, który nie wymaga wsparcia IT. Rozpocznij w mniej niż 5 minut, korzystając z Google lub Clever Single Sign-On (SSO).',
      for_leaders_subtitle2: 'Pełny program nauczania',
      for_leaders_subblurb2: 'Zgodny ze standardami program nauczania z zasobami instruktażowymi i rozwojem zawodowym, aby umożliwić każdemu nauczycielowi nauczanie informatyki.',
      for_leaders_subtitle3: 'Elastyczne przypadki użycia',
      for_leaders_subblurb3: 'Niezależnie od tego, czy chcesz stworzyć fakultatywne zajęcia z programowania w gimnazjum, ścieżkę CTE, czy prowadzić zajęcia wprowadzające do informatyki, CodeCombat jest dostosowany do Twoich potrzeb.',
      for_leaders_subtitle4: 'Umiejętności w świecie rzeczywistym',
      for_leaders_subblurb4: 'Uczniowie budują wytrwałość i rozwijają nastawienie na rozwój poprzez wyzwania związane z kodowaniem, które przygotowują ich do ponad 500 000 zadań związanych z otwartym komputerem.',
      for_teachers_title: 'Dla nauczycieli',
      for_teachers_blurb: 'Narzędzia do odblokowania potencjału ucznia',
      for_teachers_subtitle1: 'Nauczanie oparte na projekty',
      for_teachers_subblurb1: 'Promuj kreatywność, rozwiązywanie problemów i pewność siebie na kursach opartych na projektach, podczas których uczniowie tworzą własne gry i strony internetowe.',
      for_teachers_subtitle2: 'Dashboard dla nauczyciela',
      for_teachers_subblurb2: 'Przeglądaj dane o postępach uczniów, odkrywaj zasoby programowe i korzystaj ze wsparcia w czasie rzeczywistym, aby wzmocnić naukę uczniów.',
      for_teachers_subtitle3: 'Wbudowane oceny',
      for_teachers_subblurb3: 'Spersonalizuj instrukcje i upewnij się, że uczniowie rozumieją podstawowe pojęcia dzięki ocenom formatywnym i podsumowującym.',
      for_teachers_subtitle4: 'Automatyczne różnicowanie',
      for_teachers_subblurb4: 'Zaangażuj wszystkich uczniów w zróżnicowanej klasie z poziomami ćwiczeń, które dostosowują się do potrzeb edukacyjnych każdego ucznia.',
      game_based_blurb: 'CodeCombat to program informatyczny oparty na grach, w którym uczniowie wpisują prawdziwy kod i widzą, jak ich postacie reagują w czasie rzeczywistym.',
      get_started: 'Zacznij tutaj',
      global_title: 'Dołącz do naszej globalnej społeczności uczniów i nauczycieli',
      global_subtitle1: 'Uczniowie',
      global_subtitle2: 'Linie kodu',
      global_subtitle3: 'Nauczyciele',
      global_subtitle4: 'Kraje',
      go_to_my_classes: 'Przejdź do moich klas',
      go_to_my_courses: 'Przejdź do moich kursów',
      quotes_quote1: 'Nazwij dowolny program online, próbowałem go. Żaden z nich nie pasuje do CodeCombat i Ozarii. Każdy nauczyciel, który chce, aby jego uczniowie nauczyli się kodować... zacznij tutaj!',
      quotes_quote2: ' Zaskoczyło mnie, jak CodeCombat sprawia, że ​​nauka informatyki jest łatwa i intuicyjna. Wyniki na egzaminie AP były znacznie wyższe niż się spodziewałem i uważam, że CodeCombat jest powodem, dla którego tak się stało.',
      quotes_quote3: 'CodeCombat był najbardziej korzystny w nauczaniu moich uczniów umiejętności kodowania w prawdziwym życiu. Mój mąż jest inżynierem oprogramowania i przetestował wszystkie moje programy. Uznał to za swój najlepszy wybór.',
      quotes_quote4: 'Odzew… był tak pozytywny, że organizujemy zajęcia z informatyki wokół CodeCombat. Program naprawdę angażuje uczniów dzięki platformie w stylu gier, która jest jednocześnie zabawna i pouczająca. Tak trzymaj, CodeCombat!',
      quotes_quote5: 'Chociaż zajęcia zaczynają się w każdą sobotę o 7 rano, mój syn jest tak podekscytowany, że budzi się przede mną! CodeCombat stwarza mojemu synowi ścieżkę rozwoju umiejętności kodowania.',
      quotes_quote5_author: 'Latthaphon Pohpon, Parent',
      see_example: 'Zobacz przykład',
      slogan: 'Najbardziej angażujący sposób na naukę informatyki!',
      slogan_power_of_play: 'Naucz się kodować dzięki mocy zabawy',
      teach_cs1_free: 'Ucz podstaw informatyki za darmo',
      teachers_love_codecombat_title: 'Nauczyciele kochają CodeCombat',
      teachers_love_codecombat_blurb1: 'Zgłaszają, że ich uczniowie lubią używać CodeCombat, aby nauczyć się kodować',
      teachers_love_codecombat_blurb2: 'Poleciliby CodeCombat innym nauczycielom informatyki',
      teachers_love_codecombat_blurb3: 'Mówią, że CodeCombat pomaga im wspierać umiejętności rozwiązywania problemów uczniów',
      teachers_love_codecombat_subblurb: 'We współpracy z McREL International, liderem w zakresie poradnictwa opartego na badaniach i oceny technologii edukacyjnych.',
      top_banner_blurb: 'Rodzice, podarujcie swojemu dziecku dar kodowania i spersonalizowane instrukcje z naszymi nauczycielami !',
      top_banner_summer_camp: 'Zapisy na nasze letnie obozy kodowania są już otwarte – zapytaj nas o nasze tygodniowe sesje wirtualne już od 199 USD.',
      //    top_banner_blurb_pd: "We now offer professional development for educators.",
      //    top_banner_blurb_funding: "New: CARES Act funding resources guide to ESSER and GEER funds for your CS programs.",
      //    top_banner_blurb_maintenance: "Upgrades coming! Scheduled maintenance: up to 3 hours starting at __maintenanceStartTime__.",
      //    top_banner_blurb_podcast: "NEW: Explore the world of EdTech with our new podcast EdTech Adventures.",
      //    top_banner_blurb_roblox: "NEW! CodeCombat is coming to Roblox!",
      //    top_banner_blurb_roblox_teachers: "NEW! CodeCombat has partnered with Roblox Education!",
      //    top_banner_blurb_roblox_players: "NEW! Learn to code while playing Roblox!",
      //    top_banner_blurb_roblox_players_cta: "Join Beta Waitlist",
      //    top_banner_blurb_live_online_classes_parents: "PARENTS! Get your child coding today with a free trial class.",
      //    top_banner_blurb_live_online_classes: "Live online coding classes powered by play!",
      //    top_banner_blurb_live_online_classes_cta: "Sign up for a free trial class!",
      //    top_banner_blurb_demo_day: "Please join us for a demo day webinar on Thursday, August 25 at 4:00 pm EDT.",
      //    top_banner_blurb_demo_day_10_20: "Join us for a spooktacular demo of CodeCombat & Ozaria on Thursday, October 20 at 4:00 pm CDT.",
      //    top_banner_blurb_hoc_2022_12_01: "Join us Dec. 1st for our Hour of Code Walkthrough! Everything you need to implement our all new activities __topBannerHereLink__",
      //    top_banner_blurb_hoc_2022_12_01_here: "HERE",
      //    top_banner_blurb_demo_day_2023_02_16: "LIVE DEMO! See how you can use esports to teach coding. Join us Thursday February 16th at 2:00 pm PST.",
      try_the_game: 'Spróbuj gry',
      classroom_edition: 'Wersja szkolna:',
      learn_to_code: 'Naucz się programowania:',
      play_now: 'Zagraj teraz!',
      im_a_parent: 'Jestem rodzicem',
      //    im_a_parent_description: "Explore our live online coding classes",
      im_an_educator: 'Jestem nauczycielem',
      //    im_an_educator_description: "Teach Computer Science with CodeCombat",
      im_a_teacher: 'Jestem Nauczycielem',
      im_a_student: 'Jestem Uczniem',
      //    im_a_student_description: "Learn Computer Science with your class",
      //    im_an_individual: "I'm an Individual",
      //    im_an_individual_description: "Play at home outside of a class setting",
      learn_more: 'Dowiedz się więcej',
      //    check_it_out: "Check it out!",
      classroom_in_a_box: 'Gotowy zestaw do nauki programowania.',
      codecombat_is: 'CodeCombat jest platformą <strong>dla uczniów</strong> stworzoną do nauki programowania przez granie w ciekawą grę.',
      our_courses: 'Nasze kursy zostały szczególnie przygotowane do użycia <strong>w czasie zajęć</strong>, nawet przez nauczycieli bez wcześniejszego doświadczenia w programowaniu.',
      watch_how: 'Zobacz jak CodeCombat zmienia sposób w jaki ludzie uczą się komputerów.',
      top_screenshots_hint: 'Uczniowie piszą kod i od razu widzą jego efekt na ekranie',
      designed_with: 'Zaprojektowane z myślą o nauczycielach',
      real_code: 'Piszesz prawdziwy kod',
      from_the_first_level: 'od pierwszego poziomu',
      getting_students: 'W czasie nauki programowania ważniejsze od poprawnej składni i struktury jest to jak szybko zaczniesz po prostu pisać sam kod.',
      educator_resources: 'Dostęp do materiałów pomocniczych',
      course_guides: 'oraz przewodników',
      teaching_computer_science: 'Nauka programowania nie wymaga żadnych stopni naukowych ani kosztownych kursów, ponieważ przygotowaliśmy materiały do pomocy nuczycielom bez względu jakiego przedmiotu uczysz oraz jak dobrze znasz programowanie.',
      accessible_to: 'Dostępne dla',
      everyone: 'każdego',
      democratizing: 'Powszechny dostęp do nauki programowania jest podstawą naszej filozofii. Każdy powinien nauczyć się programować.',
      forgot_learning: 'Myślę, że zapomnieli już, że się czegokolwiek uczyli.',
      wanted_to_do: ' Zawsze chciałem nauczyć się programowania, nie sądziłem że uda mi się to w szkole.',
      builds_concepts_up: 'Lubię, jak CodeCombat pokazuje koncepty. To jest naprawdę łatwe do zrozumienia i fajne do rozpracownaia.',
      why_games: 'Dlaczego nauka przez gry jest tak ważna?',
      games_reward: 'Gry wynagradzają rozwiązywanie prawdziwych problemów.',
      encourage: 'Gry są medium, które zachęca do interakcji oraz odkrywania metodą prób i błędów. Dobra gra potrafi zachęcić gracza do rozwijania swoich umiejętności, co jest takim samym krytycznym procesem jak podczas nauki.',
      excel: 'Gry celują w wynagradzanie',
      struggle: 'rozwiązania prawdziwych wyzwań',
      kind_of_struggle: ' takich których wynikiem w procesie nauczania jest zaangażowanie oraz',
      motivating: 'motywacja,',
      not_tedious: 'nie trud.',
      gaming_is_good: 'Wyniki badań sugerują pozytywny wpływ gier na stymulację procesów myślowych dzieci.',
      game_based: 'Kiedy ',
      compared: 'porównamy',
      conventional: 'system nauczania oparty na grze z tradycyjnym, różnica jest wyraźna: dzięki grom uczniowie szybciej zapamiętują, lepiej się koncentrują, ',
      perform_at_higher_level: 'oraz osiągają lepsze wyniki.',
      feedback: 'Gry dostarczają także natychmiastową informację zwrotną, która pozwala uczniom dostosować ich rozwiązanie i zrozumieć pomysł całościowo, zamiast być ograniczonym tylko do odpowiedzi dobrze albo źle.',
      real_game: 'Gra, w której piszesz prawdziwy kod.',
      great_game: 'Dobra gra to coś więcej niż tylko odznaki czy osiągnięcia - to podróż, dobrze dobrane zagadki i możliwość samodzielnego sprostania nawet najtrudniejszym wyzwaniom.',
      agency: 'CodeCombat jest grą, która daje graczom tą samodzielność i pewność, żę uda im się rozwiązać zadanie. Wszystko to dzięki naszemu silnikowi pisania kodu, który pomaga zarówno początkującym jak i zaawansowanym uczniom pisać poprawny kod.',
      request_demo_title: 'Namów swoich uczniów już dziś!',
      request_demo_subtitle: 'Zamów wersję demo i pozwól swoim uczniom zacząć w mniej niż godzinę.',
      get_started_title: 'Załóż swoją klasę już dziś',
      get_started_subtitle: 'Przygotuj klasę, dodaj uczniów i śledź ich postęp w nauce.',
      request_demo: 'Zapytaj o wersję demo',
      request_quote: 'Poproś o wycenę',
      setup_a_class: 'Przygotuj klasę',
      have_an_account: 'Masz już konto?',
      logged_in_as: 'Jesteś zalogowany jako',
      computer_science: 'Nasze kursy można wykonywać we własnym tempie i obejmują podstawoą składnię i zaawansowane koncepcje ',
      ffa: 'Darmowe dla wszystkich',
      coming_soon: 'Wkrótce!',
      courses_available_in: 'Kursy dostępne są w języku JavaScript i Python. Kursy z tworzenia stron internetowych wykorzystują HTML, CSS, jQuery, oraz Bootstrap.',
      boast: 'Zagadki, które są wyzwaniem zarówno do programistów jak i dla typowych graczy.',
      winning: 'Perfekcyjne połączenie gry RPG oraz programowania, które wciąga i sprawia, że nauka staje się przyjemnością.',
      run_class: 'Wszystko czego potrzebujesz, żeby zacząć nauczanie programowania w swojej szkole, bez względu jaką widzę o programowaniu posiadasz.',
      goto_classes: 'Idź do moich klas',
      view_profile: 'Profil',
      view_progress: 'Śledź postęp',
      go_to_courses: 'Przejdź do klas',
      want_coco: 'Chcesz używać CodeCombat w swojej szkole?',
      educator: 'Nauczyciel',
      student: 'Uczeń',
      //    go_to_my_dashboard: "Go to My Dashboard",
      our_coding_programs: 'Nasze programy kodowania',
      codecombat: 'CodeCombat',
      ozaria: 'Ozaria',
      codecombat_blurb: 'Nasza oryginalna gra w kodowanie. Polecany rodzicom, osobom indywidualnym, nauczycielom i uczniom, którzy chcą doświadczyć jednej z najbardziej lubianych gier kodowania na świecie.',
      ozaria_blurb: 'Gra przygodowa i program informatyczny, w którym uczniowie opanowują zagubioną magię kodowania, aby ocalić swój świat. Polecany dla nauczycieli i uczniów.',
      //    ozaria_china_blurb: "",
      try_codecombat: 'Wypróbuj CodeCombata',
      try_ozaria: 'Wypróbuj Ozarię',
      explore_codecombat: 'Poznaj CodeCombat',
      explore_ai_league: 'Poznaj Ligę AI',
      explore_ozaria: 'Poznaj Ozaria',
      explore_online_classes: 'Poznaj zajęcia online',
      explore_pd: 'Poznaj profesjonalny developnent',
      new_adventure_game_blurb: 'Ozaria to nasza zupełnie nowa gra przygodowa i gotowe rozwiązanie do nauczania informatyki. Nasze __slides__ skierowane do uczniów i notatki skierowane do nauczycieli ułatwiają i przyspieszają planowanie i prowadzenie lekcji.',
      lesson_slides: 'Slajdy lekcji',
      pd_blurb: 'Zdobądź umiejętności skutecznego nauczania informatyki dzięki naszemu samodzielnemu kursowi rozwoju zawodowego z akredytacją CSTA. Odbądź do 40 godzin obwiązkowych w dowolnym momencie na dowolnym urządzeniu. Dobrze łączy się z Ozaria Classroom.',
      ai_league_blurb: 'Konkurencyjne kodowanie nigdy nie było tak epickie dzięki tej edukacyjnej lidze e-sportowej, wyjątkowo zarówno symulatorowi bitwy AI, jak i silnikowi gry do nauki prawdziwego kodu.',
      codecombat_live_online_classes: 'Zajęcia online CodeCombat',
      learning_technology_blurb: 'Nasza oryginalna gra uczy rzeczywistych umiejętności poprzez moc zabawy. Program nauczania oparty na rusztowaniach systematycznie opiera się na doświadczeniach i wiedzy uczniów w miarę ich postępów.',
      learning_technology_blurb_short: 'Nasza innowacyjna technologia nauczania oparta na grach zmieniła sposób, w jaki studenci uczą się programować',
      online_classes_blurb: 'Nasze zajęcia z kodowania online łączą w sobie moc gry i spersonalizowanych instrukcji, dzięki czemu Twoje dziecko pokocha to doświadczenie. Dzięki dostępnym opcjom prywatnym lub grupowym, jest to nauka zdalna, która działa.',
      //    codecombat_home_blurb: "__codecombatHome__ offers your child a fun and engaging way to advance their coding skills. With access to over 530 levels and exclusive features like pets, premium-only items, and heroes, your child can fully immerse themselves in the world of coding. They can even design games to challenge their friends, build websites and apps to share, and create private teams to compete on a group leaderboard, all in a safe and interactive environment that encourages learning and socialization.",
      //    codecombat_home: "CodeCombat",
      for_educators: 'Dla nauczycieli',
      for_parents: 'Dla rodziców',
      for_everyone: 'Dla wszystkich',
      //    for_students: "For Students",
      //    for_individuals: "For Individuals",
      //    for_libraries: "For Libraries",
      //    for_partners: "For Partners",
      //    for_partners_title: "Partner With CodeCombat",
      //    for_partners_blurb: "Join our mission to make coding accessible and engaging for all by becoming a valued partner with CodeCombat. Our partnership structures include educational businesses, esports sponsors, international distributors, and social impact partners. Partners receive access to our easy-to-use programs, implementation resources, and training options for a successful and enjoyable experience.",
      //    for_partners_button: "Explore Partnerships",
      //    for_libraries_title: "Library Integration",
      //    for_libraries_blurb: "As an entirely self-paced and self-directed digital resource, CodeCombat is the best integration for libraries that want to empower their members of all ages to learn how to code. Our platform offers everything learners need to experience a high-level coding education through a uniquely exciting, game-based curriculum. Perfect for learners in third grade all the way up to adults who want to master college-level coding concepts.",
      //    for_libraries_button: "Explore Libraries",
      what_our_customers_are_saying: 'Co mówią nasi klienci',
      game_based_learning: 'Uczenie się w oparciu o gry',
      unique_approach_blurb: 'Dzięki naszemu unikalnemu podejściu, uczniowie uczą się bawiąc i pisząc kod od samego początku swojej przygody, promując aktywne uczenie się i nastawienie na rozwój.',
      text_based_coding: 'Kodowanie oparte na tekście',
      custom_code_engine_blurb: 'Nasz niestandardowy silnik kodu i interpreter jest zaprojektowany dla początkujących, ucząc prawdziwych języków programowania Python, JavaScript i C++ używając ludzkich, przyjaznych dla początkujących terminów.',
      student_impact: 'Wpływ studentów',
      help_enjoy_learning_blurb: 'Nasze produkty pomogły ponad 20 milionów studentów cieszyć się nauką informatyki, ucząc ich być krytycznym, pewnym siebie i kreatywnym uczniem. Angażujemy wszystkich uczniów, niezależnie od doświadczenia, pomagając im zrealizować ścieżkę do sukcesu w dziedzinie informatyki.',
      global_community: 'Dołącz do naszej globalnej społeczności',
      million: '__num__ Milion',
      billion: '__num__ Bilion',
      //    meta_keywords_podcast: "CodeCombat, python, javascript, Coding Games, podcast, edtech",
      //    coco_worlds_header: "CodeCombat Worlds",
      //    coco_worlds_description: "Embark on a 3D coding adventure in Roblox, where you can program pets, play with friends, and develop games all while playing one. Join the CodeCombat community and unleash your creativity in the metaverse!",
      //    coco_worlds_button: "Explore CodeCombat Worlds",
      //    promo_modal_title: "CodeCombat Home",
      //    promo_modal_subtitle: "Learn Real Coding Through Epic Gameplay",
      //    promo_modal_text: "Dive into real‑world coding with **Python** and **JavaScript**, solving epic puzzles, battling foes, and building a strong coding foundation. Along the way, you’ll learn the skills to **create your own games** and **websites** — all in their browser, no downloads needed.",
    },

    nav: {
      //    aiyouth: "AI Youth",
      educators: 'Nauczyciele',
      follow_us: 'Śledź nas',
      general: 'Ogólne',
      map: 'Mapa',
      play: 'Poziomy',
      community: 'Społeczność',
      courses: 'Kursy',
      //    units: "Units",
      blog: 'Blog',
      forum: 'Forum',
      account: 'Konto',
      my_account: 'Moje Konto',
      profile: 'Profil',
      home: 'Główna',
      contribute: 'Współpraca',
      legal: 'Nota prawna',
      privacy: 'Polityka prywatności',
      about: 'O nas',
      //    events: "Events",
      //    impact: "Impact",
      //    star: "CoCoStar",
      contact: 'Kontakt',
      //    press: "Press",
      twitter_follow: 'Subskrybuj',
      my_classrooms: 'Moje klasy',
      my_courses: 'Moje kursy',
      //    my_units: "My Units",
      my_teachers: 'Moi nauczyciele',
      careers: 'Kariera',
      facebook: 'Facebook',
      twitter: 'Twitter',
      create_a_class: 'Stwórz klasę',
      other: 'Inne',
      learn_to_code: 'Naucz się programowania!',
      toggle_nav: 'Przełącz nawigację',
      schools: 'Szkoły',
      get_involved: 'Dołącz do nas',
      //    related_urls: "Related Links",
      open_source: 'Open source (GitHub)',
      support: 'Wsparcie',
      faqs: 'FAQs',
      copyright_prefix: 'Copyright',
      copyright_suffix: 'Wszystkie prawa zastrzeżone.',
      help_pref: 'Potrzebujesz pomocy? Wyślij email',
      help_suff: 'a my się odezwiemy!',
      resource_hub: 'Baza Wiedzy',
      apcsp: 'Zasady AP CS',
      parent: 'Rodzice',
      //    faq: "FAQ",
      //    return_coco: "Return to CodeCombat",
      //    classes: "Classes",
      //    term_of_service: "Terms of Service",
      esports: 'E-sporty',
      browser_recommendation: "Dla lepszego dośwadczenia zachęcamy do skorzystania z najnowszej wersji Chrome'a. Poberz przeglądarkę tutaj!",
      ozaria_classroom: 'Klasa Ozarii',
      codecombat_classroom: 'Klasa CodeCombat',
      ozaria_dashboard: 'Ozaria Dashboard',
      //    ozaria_teacher_dashboard: "Ozaria Teacher Dashboard",
      //    ozaria_admin_dashboard: "Ozaria Admin Dashboard",
      codecombat_dashboard: 'CodeCombat Dashboard',
      //    codecombat_teacher_dashboard: "CodeCombat Teacher Dashboard",
      //    codecombat_admin_dashboard: "CodeCombat Admin Dashboard",
      professional_development: 'Doskonalenie zawodowe',
      new: 'New!',
      admin: 'Administrator',
      //    api: "API",
      api_dashboard: 'API Dashboard',
      funding_resources_guide: 'Przewodnik po źródłach finansowania',
      //    partnerships: "Partnerships",
      //    podcast: "Our Podcast",
      //    dashboard: "Dashboard",
      //    products: "Products",
      //    live_online_classes: "Live Online Classes",
      //    codecombat_home: "CodeCombat",
      //    libraries: "Libraries",
      //    codecombat_worlds_on_roblox: "CodeCombat Worlds on Roblox",
      //    pricing: "Pricing",
      //    help_center: "Help Center",
      //    research_efficacy: "Research - Efficacy",
      //    research_impact: "Research - Impact",
      //    terms: "Terms",
      //    podcast_simple: "Podcast",
      //    create_free_account: "Create Free Account",
      //    school_district_solutions: "School & District Solutions",
      //    teacher_toolkit_preview: "Teacher Toolkit Preview",
      //    teacher_toolkit: "Teacher Toolkit",
      //    efficacy_studies: "Efficacy Studies",
      //    success_stories: "Success Stories",
      //    hoc: "Hour of Code & AI",
      //    grants_funding_resources: "Grants & Funding Resources",
      //    accessibility: "Accessibility (ACR/VPAT)",
      //    request_quote_demo: "Request a Demo or Quote",
      //    coco_junior_beta: "CodeCombat Junior (Beta)",
      //    coco_junior: "CodeCombat Junior",
      //    ap_csp: "AP CSP",
      //    ai_league_esports: "AI League Esports",
      //    ai_hackstack_beta: "AI HackStack (Beta)",
      //    ai_junior_beta: "AI Junior (Beta)",
      //    premium_self_paced: "Premium Self-Paced",
      //    codequest: "CodeQuest",
      //    library_solutions: "Library Solutions",
      //    partner_solutions: "Partner Solutions",
      //    teaching_solutions: "Teaching Solutions",
      //    play2: "Play",
      //    my_dashborads: "My Dashboards",
      //    resources: "Resources",
      //    curriculum: "Curriculum",
      //    company: "Company",
      //    coco_home_description: "With access to all 530 levels and exclusive features like pets, premium only items, and heroes, anyone can fully immerse themselves in the world of coding.",
      //    coco_classroom_description: "A full CS curriculum that builds from core concepts all the way through web development, game development and AP CSP.",
      //    coco_junior_description: "Our flagship K-5 curriculum features a progression of learning levels that teach basic coding concepts at a slower pace, modeled specifically for elementary students.",
      //    oz_classroom_description: "An enchanting narrative coding adventure that establishes the fundamentals of computer science.",
      //    ap_csp_description: "Endorsed by the College Board, our AP CSP curriculum provides game-based and turnkey tools to prepare students for the AP exam.",
      //    ai_league_description: "An epic competitive coding esports platform that encourages creative programming practice in a game-based environment.",
      //    roblox_description: "This MMORPG teaches Lua coding and provides a real-world platform to create amazing games and experiences.",
      //    ai_hackstack_description: "The first generative AI companion tool specifically crafted for those new to AI with a focus on student privacy and safety.",
      //    ai_junior_description: "Introduces multimodal generative AI in a simple and intuitive platform designed specifically for K-5 students.",
      //    learning_options: "Learning Options",
      //    ai_hackstack: "AI HackStack",
      //    beta: "Beta",
      //    teacher_tools: "Teacher Tools",
      //    ai_teacher_tool: "AI Teacher Tool",
      //    ccw_short: "Roblox",
    },

    modal: {
      close: 'Zamknij',
      okay: 'OK',
      cancel: 'Anuluj',
      //    try_again: "Try Again",
    },

    not_found: {
      page_not_found: 'Strona nie istnieje',
    },

    diplomat_suggestion: {
      title: 'Pomóż w tłumaczeniu CodeCombat!',
      sub_heading: 'Potrzebujemy twoich zdolności językowych.',
      pitch_body: 'Tworzymy CodeCombat w języku angielskim, jednak nasi gracze pochodzą z całego świata. Wielu z nich chciałoby zagrać w swoim języku, ponieważ nie znają angielskiego, więc jeśli znasz oba języki zostań Dyplomatą i pomóż w tłumaczeniu strony CodeCombat, jak i samej gry.',
      missing_translations: 'Dopóki nie przetłumaczymy wszystkiego na polski, będziesz widział niektóre napisy w języku angielskim.',
      learn_more: 'Dowiedz się więcej o Dyplomatach',
      subscribe_as_diplomat: 'Dołącz do Dyplomatów',
    },

    new_home_faq: {
      what_programming_languages: 'Jakie są dostępne języki programowania?',
      python_and_javascript: 'Obecnie wspieramy Pythona, JavaScript, C++, Java, i Lua.',
      why_python: 'Dlaczego warto wybrać Pythona?',
      why_python_blurb: 'Python jest zarówno przyjazny dla początkujących, jak i używany przez duże korporacje (takie jak Google). Jeśli masz młodszych lub uczących się po raz pierwszy, zdecydowanie polecamy Pythona.',
      why_javascript: 'Dlaczego warto wybrać JavaScript?',
      why_javascript_blurb: 'JavaScript jest językiem sieci i jest używany na prawie każdej stronie internetowej. Możesz wybrać JavaScript, jeśli planujesz studiować także tworzenie stron internetowych. Ułatwiliśmy także studentom przejście z Pythona na tworzenie stron internetowych w JavaScript.',
      javascript_versus_python: 'Składnia JavaScriptu jest nieco trudniejsza dla początkujących niż Pythona, więc jeśli nie możesz się zdecydować między tymi dwoma programami, polecamy Pythona.',
      how_do_i_get_started: 'Jak mogę zacząć?',
      getting_started_1: 'Utwórz swoje Konto Nauczyciela',
      getting_started_2: 'Stwórz klasę',
      getting_started_3: 'Dodaj uczniów',
      getting_started_4: 'Usiądź wygodnie i patrz, jak Twoi uczniowie dobrze się bawią, ucząc się kodowania.',
      main_curriculum: 'Czy mogę używać CodeCombat lub Ozarii jako mojego głównego programu nauczania?',
      main_curriculum_blurb: 'Oczywiście! Spędziliśmy sporo czasu na konsultacjach ze specjalistami w dziedzinie edukacji, aby opracować program nauczania i materiały specjalnie dla nauczycieli, którzy używają CodeCombat lub Ozarii bez wcześniejszego doświadczenia w nauczaniu informatyki. Wiele szkół wdraża CodeCombat i/lub Ozarię jako główny program nauczania informatyki.',
      clever_instant_login: 'Czy CodeCombat i Ozaria wspierają Clever Instant Login?',
      clever_instant_login_blurb: 'Tak! Sprawdź nasze __clever__, aby uzyskać więcej szczegółów na temat tego, jak zacząć.',
      clever_integration_faq: 'FAQ dot. integracji',
      google_classroom: ' Co z Google Classroom?',
      google_classroom_blurb1: 'Tak! Pamiętaj, aby użyć trybu pojedynczego logowania Google (SSO) do zarejestrowania się na konto nauczyciela. Jeśli masz już konto przy użyciu swojego adresu e-mail Google, użyj modułu SSO Google, aby zalogować się następnym razem. W oknie dialogowym Utwórz klasę zobaczysz opcję Połącz klasę Google. W tym momencie obsługujemy tylko rostering przez Google Classroom.',
      google_classroom_blurb2: 'Uwaga: musisz użyć Google SSO do zarejestrowania się lub zalogowania się co najmniej raz, aby zobaczyć opcję integracji z Google Classroom.',
      how_much_does_it_cost: 'Ile kosztuje dostęp do wszystkich dostępnych kursów i zasobów?',
      how_much_does_it_cost_blurb: 'Dostosowujemy rozwiązania dla szkół i okręgów i pracujemy z Tobą, aby zrozumieć Twój przypadek użycia, kontekst i budżet. Skontaktuj się z nami, aby uzyskać więcej szczegółów! Zobacz również nasze __funding__, aby dowiedzieć się, jak wykorzystać źródła finansowania ustawy CARES, takie jak ESSER i GEER.',
      recommended_systems: 'Jakie są zalecane przeglądarka i system operacyjny?',
      recommended_systems_blurb: 'CodeCombat i Ozaria działają najlepiej na komputerach z co najmniej 4GB pamięci RAM, na nowoczesnej przeglądarce, takiej jak Chrome, Safari, Firefox lub Edge. Chromebooki z 2GB RAM mogą mieć drobne problemy z grafiką w późniejszych kursach. Wymagane jest minimum 200 Kbps przepustowości na studenta, choć zalecane jest 1+ Mbps.',
      other_questions: 'Jeśli masz jakiekolwiek inne pytania, prosimy o __kontakt__.',
      //    see_faq_prefix: "See more",
      //    see_faq_link: "frequently asked questions in our help center",
      //    see_faq_suffix: ".",
      //    ai_bot_faq_title: "What is the AI Level Help Bot and what measures are in place to ensure safety?",
      //    ai_bot_faq_blurb: "The AI Chat Level Help Bot in CodeCombat empowers learners with AI-driven hints for coding challenges, ensuring a guided yet independent learning experience. Safety is paramount, as the AI filters out personal data and is trained to handle improper requests.",
    },

    play: {
      title: 'Baw się w poziomach CodeCombata - Naucz się Pythona, JavaScriptu, and HTML-a',
      meta_description: 'Naucz się programowania z grą koderską dla początkujących. Naucz się Pythona lub JavaScriptu tak jak rozwiązujesz zagadki, twórz swoje własne gry i bądź coraz lepszy. Wyzwij swoich przyjaciół w multiplayerowych poziomach-arenach!',
      level_title: '__poziom__ - Naucz się kodować w Python, JavaScript, HTML',
      //    level_title_ozaria: "__level__ - Ozaria",
      video_title: '__video__ | Poziom z filmikiem',
      game_development_title: '__poziom__ | Tworzenie gier',
      web_development_title: '__poziom__ | Tworzenie stron internetowych',
      anon_signup_title_1: 'CodeCombat ma teraz',
      anon_signup_title_2: 'Wersja dla klas!',
      anon_signup_enter_code: 'Wpisz kod klasy:',
      anon_signup_ask_teacher: 'Nie posiadasz go? Zapytaj swojego nauczyciela!',
      anon_signup_create_class: 'Chciałbyś/Chciałabyś stworzyć klasę?',
      anon_signup_setup_class: 'Ustaw klasę, dodaj swoich uczniów i obserwuj progres!',
      anon_signup_create_teacher: 'Stwórz darmowe konto nauczycielskie!',
      play_as: 'Graj jako ',
      get_course_for_class: 'Dodaj Tworzenie Gier i wiele więcej do twoich klas!',
      request_licenses: 'Skontaktuj się z naszymi specjalistami po szczegóły.',
      compete: 'Ukończono!',
      spectate: 'Oglądaj',
      simulate_all: 'Przetestuj wszystkie',
      players: 'graczy',
      hours_played: 'rozegranych godzin',
      items: 'Przedmioty',
      unlock: 'Odblokuj',
      confirm: 'Potwierdź',
      owned: 'Posiadane',
      locked: 'Zablokowane',
      //    locked_by_teacher: "Locked By Teacher",
      //    locked_campaign: "Complete previous world to unlock",
      //    locked_campaign_forest: "Complete Kithgard Dungeon to unlock",
      //    locked_campaign_desert: "Complete Backwoods Forest to unlock",
      //    locked_campaign_mountain: "Complete Sarven Desert to unlock",
      //    locked_campaign_glacier: "Complete Cloudrip Mountain to unlock",
      //    locked_campaign_volcano: "Complete Kelvintaph Mountain to unlock",
      available: 'Dostępny',
      skills_granted: 'Zdobyte umiejętności',
      heroes: 'Bohaterowie',
      //    pets: "Pets",
      achievements: 'Osiągnięcia',
      settings: 'Opcje',
      next: 'Dalej',
      change_hero: 'Wybierz bohatera',
      change_hero_or_language: 'Zmień Bohatera lub Język',
      //    change_language: "Code Language / Code Format",
      buy_gems: 'Kup klejnoty',
      subscribers_only: 'Tylko subskrybenci!',
      subscribe_unlock: 'Zasubskrybuj by odblokować!',
      subscriber_heroes: 'Zasubskrybuj dziś by od razu odblokować Amarę, Hushbauma i Hattoriego!',
      subscriber_gems: 'Zasubskrybuj dziś by wykupić tego bohatera za pomocą kryształów!',
      //    practice_license_required: "(license required for practice levels)",
      anonymous: 'Anonimowy gracz',
      level_difficulty: 'Poziom trudności: ',
      awaiting_levels_adventurer_prefix: 'Co tydzień publikujemy nowe poziomy!',
      awaiting_levels_adventurer: 'Zapisz się jako Podróżnik,',
      awaiting_levels_adventurer_suffix: 'aby jako pierwszy grać w nowe poziomy.',
      adjust_volume: 'Dopasuj głośność',
      //    toggle_fullscreen: "Toggle fullscreen",
      campaign_multiplayer: 'Kampania dla wielu graczy',
      campaign_multiplayer_description: '... w której konkurujesz z innymi graczami.',
      brain_pop_done: 'Pokonałeś ogry kodem! Wygrałeś!',
      brain_pop_challenge: 'Zmierz się ponownie z zagadkami, tym razem wybierając inny język programowania!',
      replay: 'Graj od nowa',
      back_to_classroom: 'Wróć do klasy',
      teacher_button: 'Dla nauczycieli',
      get_more_codecombat: 'Zdobądź więcej CodeCombata!',
      //    back_to_dashboard: "Back to Dashboard",
      //    back_to_ozaria: "Back to ozaria.com",
      //    customize_hero: "Customize Hero",
      //    account_settings: "Account Settings",
      //    back_to_tutorial: "Back to tutorial",
      //    teacher_vega_message: "Students are guided by these tutorial messages. In order to view these messages and to save your progress as you play through the game, please create a student account and play Ozaria as a student.",
      //    beta_levels_on: "beta levels on",
      //    beta_levels_turn_off: "turn off",
      //    confirm_m7_off: "Are you sure to turn beta levels off?",
      //    play_codecombat: "Play CodeCombat",
      //    play_codecombat_junior: "Play CodeCombat Junior",
      //    age_codecombat: "Ages 8+",
      //    age_codecombat_junior: "Ages 5-8",
      //    age_description_codecombat: "Real Python or JavaScript coding for everyone",
      //    age_description_codecombat_junior: "Blocks or simple text coding for beginners",
      //    campaign_about_dungeon: "Real text programming for brave adventurers!",
      //    campaign_about_junior: "Blocks or simple text coding for young heroes!",
      //    want_more_hints: "Want more hints?",
      //    choose_your_adventure: "Choose Your Adventure",
      //    junior: "Junior",
      //    original: "Original",
      //    roblox_button_hover: "Play, Code and Create on Roblox",
      //    ai_league_button_hover: "Compete in AI League Esports",
      //    hackstack_button_hover: "Code and Create with AI HackStack",
      //    junior_button_hover: "Blocks coding for beginners",
      //    cchome_button_hover: "Original CodeCombat Adventure",
      //    home_campaign_redirect_student: "Please visit the course map from your student page.",
      //    blockly_error_msg: "Oops! Something went wrong loading your blocks. Try reloading the page to bring your workspace back.",
    },

    code: {
      if: 'jeżeli',
      else: 'inaczej',
      elif: 'inaczej, jeżeli',
      while: 'dopóki',
      loop: 'pętla',
      for: 'dla',
      break: 'przerwij',
      continue: 'kontynuuj',
      pass: 'pomiń',
      return: 'wróć',
      then: 'wtedy',
      do: 'wykonaj',
      end: 'zakończ',
      function: 'funkcja',
      def: 'definiuj',
      var: 'zmienna',
      self: 'swój',
      hero: 'bohater',
      this: 'ten/ta',
      or: 'lub',
      '||': 'lub',
      and: 'i',
      '&&': 'i',
      not: 'negacja',
      '!': 'negacja',
      '=': 'przypisz',
      '==': 'równy',
      '===': 'identyczny',
      '!=': 'różny',
      '!==': 'nieidentyczny ',
      '>': 'większy niż',
      '>=': 'większy lub równy',
      '<': 'mniejszy niż',
      '<=': 'mniejszy lub równy',
      '*': 'pomnożone przez',
      '/': 'podzielony przez',
      '+': 'plus',
      '-': 'minus',
      '+=': 'dodaj i przypisz',
      '-=': 'odejmij i przypisz',
      True: 'Prawda',
      true: 'prawda',
      False: 'Fałsz',
      false: 'fałsz',
      undefined: 'niezdefiniowany',
      null: 'bez wartości',
      nil: 'nic',
      None: 'Żaden',
    },

    share_progress_modal: {
      blurb: 'Robisz coraz to większe postępy! Pokaż swoim rodzicom jak wiele nauczyłeś się z CodeCombat.',
      email_invalid: 'Błędny adres email.',
      form_blurb: 'Wpisz adres email swoich rodziców, a my ich o tym poinformujemy!',
      form_label: 'Adres email',
      placeholder: 'adres email',
      title: 'Wspaniała robota, Adepcie',
    },

    login: {
      //    auth_sign_up: "New to Ozaria? Create an Account",
      sign_up: 'Stwórz konto',
      email_or_username: 'Email lub nazwa użytkownika',
      //    or: "or",
      log_in: 'Zaloguj się',
      //    sign_in: "Sign In",
      logging_in: 'Logowanie...',
      log_out: 'Wyloguj się',
      forgot_password: 'Nie pamiętasz hasła?',
      finishing: 'Kończenie',
      sign_in_with_facebook: 'Logowanie z Facebookiem',
      sign_in_with_gplus: 'Logowanie z Google+',
      signup_switch: 'Chcesz stworzyć konto?',
      //    already_have_account1: "Already have a CodeCombat Teacher or Student account?",
      //    already_have_account2: "You can sign into Ozaria.com using that account.",
      //    sign_into_ozaria: "Sign Into Ozaria.com",
      //    individual_users_not_supported: "Ozaria is for classrooms only!  Please visit CodeCombat to continue playing!",
      accounts_merge_confirmation: 'Istnieje już konto z mailem z tego konta Google. Czy chciałbyś je połączyć?',
      //    stop_spying: "Stop Spying",
      //    stop_switching: "Stop Switching",
      //    test_as_student: "Test as Student",
      //    gplus_linked: "Google Account linked successfully",
      //    plus_link_error: "Google Account linked failed",
      //    email_or_username_or_library: "Email or Username or Library Card number",
      //    login_failed: "Login failed. You may need to sign up first.",
    },

    signup: {
      complete_subscription: 'Subskrypcja minęla!',
      create_student_header: 'Stwórz konto ucznia',
      create_teacher_header: 'Stwórz konto nauczyciela',
      create_individual_header: 'Stwórz konto prywatne',
      email_announcements: 'Otrzymuj powiadomienia na e-mail o nowych poziomach i funkcjach w CodeCombat',
      sign_in_to_continue: 'zaloguj się  lub utwórz konto, aby kontynuować.',
      //    create_account_to_submit_multiplayer: "Create a free account to rank your multiplayer AI and explore the whole game!",
      teacher_email_announcements: 'Informuj mnie na bieżąco o nowych zasobach dla nauczycieli, programach nauczania i kursach!',
      creating: 'Tworzenie konta...',
      sign_up: 'Zarejestruj się',
      log_in: 'Zaloguj się używając hasła',
      login: 'Login',
      required: 'Musisz się zalogować zanim przejdziesz dalej.',
      login_switch: 'Masz już konto?',
      optional: 'opcjonalnie',
      connected_gplus_header: 'Udało się połączyć konto przez Google+!',
      connected_gplus_p: 'Dokończ rejestrację, żeby móc logować się przez konto w usłudze Google+.',
      connected_facebook_header: 'Udało się połączyć konto przez Facebook!',
      connected_facebook_p: 'Dokończ rejestrację, żeby móc logować się przez konto w usłudze Facebook.',
      hey_students: 'Uczniowie, wprowadźcie otrzymany od nauczyciela kod klasy.',
      birthday: 'Dzień urodzenia',
      parent_email_blurb: 'Wiemy że nie możesz się doczekać programowania &mdash; też się cieszymy! Twoi rodzice otrzymają dalsze instrukcje jak założyć dla ciebie konto. Napisz emaila na {{email_link}} jeżeli masz jakiekolwiek pytania.',
      classroom_not_found: 'Żadna klasa nie jest powiązana z tym kodem. Sprawdź czy wprowadziłeś poprawnie kod lub zapytaj nauczyciela.',
      //    activation_code_used: "The activation code has been used. Check your spelling or ask your teacher for help.",
      checking: 'Sprawdzanie...',
      account_exists: 'Ten email jest już zajęty:',
      sign_in: 'Zaloguj się',
      email_good: 'Email wygląda dobrze!',
      name_taken: 'Nazwa użytkownika zajęta! Spróbuj {{suggestedName}}?',
      name_available: 'Nazwa użytkownika dostępna!',
      name_is_email: 'Nazwa użytkownika nie może być adresem email',
      choose_type: 'Wybierz typ konta:',
      teacher_type_1: 'Naucz programowania korzystając z CodeCombat!',
      teacher_type_2: 'Utwórz swoją klasę',
      teacher_type_3: 'Uzyskaj dostęp do przewodników',
      teacher_type_4: 'Doglądaj postępy swoich uczniów',
      signup_as_teacher: 'Zarejestruj się',
      student_type_1: 'Naucz się programować grając we wciągającą grę!',
      student_type_2: 'Graj ze swoją klasą',
      student_type_3: 'Stań do walki na arenach',
      student_type_4: 'Wybierz swojego bohatera!',
      student_type_5: 'Przygotuj kod swojej klasy!',
      signup_as_student: 'Zarejestruj się',
      individuals_or_parents: 'Osoby prywatne oraz rodzice',
      individual_type: 'Dla graczy chcących programować poza klasą oraz rodziców.',
      signup_as_individual: 'Zarejestruj się jako osoba prywatna',
      enter_class_code: 'Podaj kod swojej klasy',
      enter_birthdate: 'Podaj datę urodzenia:',
      parent_use_birthdate: 'Rodzice, wpiszcie swoją datę urodzin.',
      ask_teacher_1: 'Zapytaj nauczyciela o kod Twojej klasy.',
      ask_teacher_2: 'Nie masz swojej klasy? Stwórz ',
      ask_teacher_3: 'konto prywatne.',
      ask_teacher_4: ' instead.',
      about_to_join: 'Zaraz dołączysz do:',
      enter_parent_email: 'Podaj adres email rodzica:',
      parent_email_error: 'Coś poszło nie tak z wysłaniem emaila. Sprawdź adres email i spróbuj ponownie.',
      parent_email_sent: 'Wysłaliśmy email z instrukcją założenia konta. Poproś rodzica by sprawdził swoją skrzynkę.',
      //    parent_email_header: "What's your parent's email?",
      //    parent_email_label: "Parent email",
      //    parent_email_excited_blurb: "We're excited for you to start coding! Your parent will get an email with instructions to create your account. Contact us at {{email_link}} with any questions.",
      //    parent_email_check_inbox: "Check your parent's inbox",
      //    parent_email_finish_blurb: "Your parent needs to open the email and finish creating your account before you can save progress.",
      //    send_to_parent: "Send to my parent",
      //    step_1_of_2: "Step 1 of 2",
      //    im_under_13: "I'm under 13",
      account_created: 'Konto stworzone!',
      confirm_student_blurb: 'Zapisz sobie te informacje, żebyś ich nie zapomniał. Nauczyciel może pomóc ci jeśli zapomnisz hasła.',
      confirm_individual_blurb: 'Zapisz swoje dane do logowania na wszelki wypadek. Potwierdź swój adres email w razie jakbyś zapomniał hasła w przyszłości - sprawdź swoją skrzynkę!',
      //    confirm_individual_blurb_without_email: "Write down your login information in case you need it later.",
      write_this_down: 'Zapisz to sobie:',
      start_playing: 'Zacznij grę!',
      sso_connected: 'Udało połączyć się z:',
      select_your_starting_hero: 'Wybierz bohatera:',
      you_can_always_change_your_hero_later: 'Zawsze możesz zmienić bohatera później.',
      finish: 'Zakończ',
      teacher_ready_to_create_class: 'Jesteś gotów stworzyć swoją pierwszą klasę!',
      teacher_students_can_start_now_coco: 'Twoi uczniowie będą mogli od razu zacząć grać w pierwszy kurs, Wprowadzenie do informatyki.',
      teacher_students_can_start_now_ozar: 'Twoi uczniowie będą mogli od razu zacząć grać w pierwszy kurs, Wprowadzenie do informatyki.',
      teacher_list_create_class: 'Na następnej stronie będziesz mógł stworzyć swoją pierwszą klasę.',
      teacher_list_add_students: 'Uczniów do klasy można dodać poprzez kliknięcie na link `pokaż klasę`, następnie twoim oczom ukaże się Kod klasy oraz adres URL, który trzeba przekazać uczniom. Można również wysłać tą wiadomość na email, jeśli jakiś już posiadają.',
      teacher_list_resource_hub_1: 'Zajrzyj do',
      teacher_list_resource_hub_2_coco: 'Przewodników kursu',
      teacher_list_resource_hub_2_ozar: 'Przewodników kursu',
      teacher_list_resource_hub_3: 'po rozwiązania dla każdego z poziomów, oraz do',
      teacher_list_resource_hub_4: 'Bazy wiedzy',
      teacher_list_resource_hub_5: 'po porady na temat organizacji zajęć, oraz wiele więcej!',
      teacher_additional_questions: 'To wszystko! Jeśli potrzebujesz dodatkowej pomocy, albo chcesz nas o coś spytać napisz do __supportEmail__.',
      dont_use_our_email_silly: 'Nie wprowadzaj tu swojego adresu email! Wpisz tutaj adres email rodziców.',
      want_codecombat_in_school: 'Chcesz grać w CodeCombat przez cały czas?',
      eu_confirmation: ' Wyrażam zgodę na przechowywanie moich danych przez CodeCombat na serwerach w USA.',
      eu_confirmation_place_of_processing: 'Dowiedz się więcej o możliwych zagrożeniach',
      eu_confirmation_student: 'Jeśli nie jesteś pewien, zapytaj swojego nauczyciela.',
      eu_confirmation_individual: 'Jeśli nie chcesz, abyśmy przechowywali Twoje dane na amerykańskich serwerach, zawsze możesz grać anonimowo bez zapisywania swojego kodu..',
      //    request_class_code: "Students, request a Class Code from your Teacher to create an Account!",
      //    educators_create_account: "Educators, create a Teacher Account to access the first unit for free!",
      //    looking_for_classroom: "Looking for classroom...",
      //    create_your_educator_account: "Create your educator account",
      //    educator_signup_list_1_title: "See what your students see:",
      //    educator_signup_list_1_desc: "Demo each game level in the first unit",
      //    educator_signup_list_2_title: "See teacher resources:",
      //    educator_signup_list_2_desc: "Access scope and sequence, lessons, and more",
      //    educator_signup_list_3_title: "See your students thrive:",
      //    educator_signup_list_3_desc: "Try the first unit with your class for free",
      //    signup_with_email: "Sign up with Email",
      //    sign_up_with: "Sign up with",
      //    already_have_account: "Already have a CodeCombat or Ozaria account",
      //    already_have_account_q: "Already have an account?",
      //    choose_account_title: "Create A Free Account",
      //    choose_account_subtitle: "Please select the option that best describes you",
      //    select_your_role: "Select your role",
      //    select_your_state: "Select your state",
      password_requirements: '8 do 64 znaków bez powtórzeń',
      invalid: 'Nieprawidłowy',
      invalid_password: 'Nieprawidłowe hasło',
      with: 'z',
      want_to_play_codecombat: 'Nie, nie mam, ale chcę zagrać w CodeCombat!',
      have_a_classcode: 'Posiadasz kod klasy?',
      yes_i_have_classcode: 'Tak, posiadam kod klasy!',
      enter_it_here: 'Wpisz go tutaj:',
      //    play_without_saving: "Play without saving",
    },

    recover: {
      recover_account_title: 'Odzyskaj konto',
      send_password: 'Wyślij hasło tymczasowe',
      recovery_sent: 'Email do odzyskania hasła został wysłany.',
    },

    items: {
      primary: 'Główne',
      secondary: 'Drugorzędne',
      armor: 'Zbroja',
      accessories: 'Akcesoria',
      misc: 'Różne',
      books: 'Książki',
    },

    common: {
      //    default_title_coco: "CodeCombat - Coding games to learn Python and JavaScript",
      //    default_title_ozar: "Ozaria - Computer science that captivates",
      //    ozaria: "Ozaria",
      //    default_meta_description_coco: "Learn typed code through a programming game. Learn Python, JavaScript, and HTML as you solve puzzles and learn to make your own coding games and websites.",
      //    default_meta_description_ozar: "Ozaria is a computer science program, an adventure game, and a fantasy story where students master the lost magic of coding to save their world.",
      back: 'Wstecz',
      coming_soon: 'Dostępne wkrótce!',
      continue: 'Dalej',
      next: 'Następny',
      default_code: 'Domyślny kod',
      loading: 'Ładowanie...',
      overview: 'Przegląd',
      //    processing: "Processing...",
      solution: 'Rozwiązanie',
      //    table_of_contents: "Table of Contents",
      intro: 'Wprowadzenie',
      saving: 'Zapisywanie...',
      sending: 'Wysyłanie...',
      send: 'Wyślij',
      sent: 'Wysłano',
      cancel: 'Anuluj',
      save: 'Zapisz',
      publish: 'Opublikuj',
      //    output: "Output",
      create: 'Stwórz',
      fork: 'Fork',
      //    clone: "Clone",
      play: 'Zagraj',
      retry: 'Ponów',
      actions: 'Akcje',
      info: 'Informacje',
      help: 'Pomoc',
      watch: 'Obserwuj',
      unwatch: 'Nie obserwuj',
      submit_patch: 'Prześlij łatkę',
      submit_changes: 'Prześlij zmiany',
      save_changes: 'Zapisz zmiany',
      required_field: 'wymagane',
      //    submit: "Submit",
      //    replay: "Replay",
      //    complete: "Complete",
      //    pick_image: "Pick Image",
      //    continue_editing: "Continue Editing",
      //    logout: "Logout",
      //    empty: "Empty",
      //    done: "Done",
      //    remove: "Remove",
      //    locked: "Locked",
      //    internal_error: "Internal Error",
      //    manage: "Manage",
      //    empty_results: "Empty Results.",
      //    roblox: "Roblox",
      //    warning: "Warning",
    },

    general: {
      and: 'i',
      name: 'Nazwa',
      date: 'Data',
      body: 'Zawartość',
      version: 'Wersja',
      pending: 'W trakcie',
      accepted: 'Przyjęto',
      rejected: 'Odrzucono',
      withdrawn: 'Wycofano',
      accept: 'Akceptuj',
      //    accept_and_save: "Accept&Save",
      reject: 'Odrzuć',
      withdraw: 'Wycofaj',
      submitter: 'Przesyłający',
      submitted: 'Przesłano',
      commit_msg: 'Wiadomość do commitu',
      version_history: 'Historia wersji',
      version_history_for: 'Historia wersji dla: ',
      select_changes: 'Zaznacz dwie zmiany poniżej aby zobaczyć różnice.',
      undo_prefix: 'Cofnij',
      undo_shortcut: '(Ctrl+Z)',
      redo_prefix: 'Ponów',
      redo_shortcut: '(Ctrl+Shift+Z)',
      play_preview: 'Odtwórz podgląd obecnego poziomu',
      result: 'Wynik',
      results: 'Wyniki',
      description: 'Opis',
      or: 'lub',
      subject: 'Temat',
      email: 'Email',
      password: 'Hasło',
      confirm_password: 'Potwierdź hasło',
      message: 'Wiadomość',
      code: 'Kod',
      ladder: 'Drabinka',
      when: 'kiedy',
      opponent: 'Przeciwnik',
      //    opponent_and_team: "Opponent",
      rank: 'Ranking',
      score: 'Wynik',
      win: 'Wygrana',
      loss: 'Przegrana',
      tie: 'Remis',
      easy: 'Łatwy',
      medium: 'Średni',
      hard: 'Trudny',
      player: 'Gracz',
      player_rank: '[AI_TRANSLATION]Ranga',
      warrior: 'Wojownik',
      ranger: 'Łucznik',
      wizard: 'Czarodziej',
      first_name: 'Imię',
      last_name: 'Nazwisko',
      last_initial: 'Inicjał nazwiska',
      username: 'Nazwa użytkownika',
      contact_us: 'Skontaktuj się z nami',
      close_window: 'Zamknij okno',
      learn_more: 'Dowiedz się więcej',
      more: 'Więcej',
      //    fewer: "Fewer",
      //    with: "with",
      //    archived: "Archived",
      //    chat: "Chat",
      //    chat_with_us: "Chat with us",
      //    email_us: "Send us an email",
      //    sales: "Sales",
      //    support: "Support",
      //    here: "here",
      //    from: "From",
      //    classrooms: "Classrooms",
    },

    units: {
      second: 'sekunda',
      seconds: 'sekund',
      //    sec: "sec",
      minute: 'minuta',
      minutes: 'minut',
      hour: 'godzina',
      hours: 'godzin',
      day: 'dzień',
      days: 'dni',
      week: 'tydzień',
      weeks: 'tygodni',
      month: 'miesiąc',
      months: 'miesięcy',
      year: 'rok',
      years: 'lat',
    },

    play_level: {
      back_to_map: 'Powrót na Mapę',
      directions: 'Kierunki',
      edit_level: 'Edytuj poziom',
      keep_learning: 'Keep Learning',
      explore_codecombat: 'Przeglądaj CodeCombat',
      finished_hoc: 'Skończyłem moją Godzinę Kodu',
      get_certificate: 'Pobierz swój certyfikat!',
      level_complete: 'Poziom ukończony',
      //    level_complete_at: "Level Completed ",
      completed_level: 'Ukończony poziom:',
      course: 'Kurs:',
      done: 'Zrobione',
      next_level: 'Następny poziom',
      //    combo_challenge: "Combo Challenge",
      //    concept_challenge: "Concept Challenge",
      //    challenge: "Challenge",
      challenge_unlocked: 'Odblokowano wyzwanie',
      //    combo_challenge_unlocked: "Combo Challenge Unlocked",
      //    concept_challenge_unlocked: "Concept Challenge Unlocked",
      //    concept_challenge_complete: "Concept Challenge Complete!",
      //    combo_challenge_complete: "Combo Challenge Complete!",
      //    combo_challenge_complete_body: "Great job, it looks like you're well on your way to understanding __concept__!",
      replay_level: 'Powtórz poziom',
      //    combo_concepts_used: "__complete__/__total__ Concepts Used",
      //    combo_all_concepts_used: "You used all concepts possible to solve the challenge. Great job!",
      //    combo_not_all_concepts_used: "You used __complete__ out of the __total__ concepts possible to solve the challenge. Try to get all __total__ concepts next time!",
      start_challenge: 'Rozpocznij wyzwanie',
      next_game: 'Następna gra',
      languages: 'Języki',
      programming_language: 'Język programowania',
      show_menu: 'Pokaż menu gry',
      home: 'Strona główna',
      level: 'Poziom',
      skip: 'Pomiń',
      game_menu: 'Menu gry',
      restart: 'Zacznij od nowa',
      goals: 'Cele',
      goal: 'Cel',
      //    challenge_level_goals: "Challenge Level Goals",
      //    challenge_level_goal: "Challenge Level Goal",
      //    concept_challenge_goals: "Concept Challenge Goals",
      //    combo_challenge_goals: "Challenge Level Goals",
      //    concept_challenge_goal: "Concept Challenge Goal",
      //    combo_challenge_goal: "Challenge Level Goal",
      running: 'Symulacja...',
      success: 'Sukces!',
      incomplete: 'Niekompletne',
      timed_out: 'Czas minął',
      failing: 'Niepowodzenie',
      reload: 'Wczytaj ponownie',
      reload_title: 'Przywrócić cały kod?',
      reload_really: 'Czy jesteś pewien, że chcesz przywrócić kod startowy tego poziomu?',
      reload_confirm: 'Przywróć cały kod',
      restart_really: 'Jesteś pewny, że chcesz powtórz poziom? Stracisz cały kod, który napisałeś.',
      restart_confirm: 'Tak, powtórz',
      test_level: 'Poziom testowy',
      victory: 'Zwycięstwo',
      victory_title_prefix: '',
      victory_title_suffix: ' ukończony',
      victory_sign_up: 'Zarejestruj się, by zapisać postępy',
      victory_sign_up_poke: 'Chcesz zapisać swój kod? Stwórz bezpłatne konto!',
      victory_rate_the_level: 'Jak podobał ci się ten poziom? ',
      victory_return_to_ladder: 'Powrót do drabinki',
      victory_saving_progress: 'Zapisywanie postępów',
      victory_go_home: 'Powrót do strony głównej',
      victory_review: 'Powiedz nam coś więcej!',
      victory_review_placeholder: 'Jak Ci się podobał poziom?',
      victory_hour_of_code_done: 'Skończyłeś już?',
      victory_hour_of_code_done_yes: 'Tak, skończyłem moją Godzinę Kodu.',
      victory_experience_gained: 'Doświadczenie',
      victory_gems_gained: 'Klejnoty',
      victory_new_item: 'Nowy przedmiot',
      victory_new_hero: 'Nowy bohater',
      victory_viking_code_school: 'O jejku, trudny był ten poziom, co? Jeśli jeszcze nie jesteś twórcą oprogramowania, możesz nim już zostać. Złóż swoje podanie o przyjęcie do Viking Code School, a z ich pomocą w zostaniesz na pewno w pełni profesjonalnym programistą.',
      victory_become_a_viking: 'Zostań wikingiem',
      victory_no_progress_for_teachers: 'Postęp dla nauczycieli nie jest zapisywany, ale możesz dodać konto ucznia do swojej klasy.',
      tome_cast_button_run: 'Uruchom',
      tome_cast_button_running: 'Wykonuję kod...',
      tome_cast_button_ran: 'Zakończono',
      tome_cast_button_update: 'Aktualizuj',
      tome_submit_button: 'Prześlij',
      tome_reload_method: 'Wczytaj oryginalny kod i uruchom ponownie poziom',
      tome_available_spells: 'Dostępne czary',
      tome_your_skills: 'Twoje umiejętności',
      //    blocks: "Blocks",
      hints: 'Podpowiedzi',
      //    docs: "Docs",
      videos: 'Filmiki',
      hints_title: 'Podpowiedź {{number}}',
      code_saved: 'Kod zapisano',
      //    chat_placeholder: "Need coding help? Chat with the AI. (experimental!)",
      //    chat_fix_show: "Show Me",
      //    chat_fix_hide: "Hide",
      //    chat_fix_show_code: "Show Code",
      //    chat_fix_hide_code: "Hide Code",
      //    apply_code: "Apply =>",
      skip_tutorial: 'Pomiń (esc)',
      keyboard_shortcuts: 'Skróty klawiszowe',
      loading_start: 'Rozpocznij poziom',
      loading_start_combo: 'Rozpocznij Combo Challenge',
      loading_start_concept: 'Rozpocznij Concept Challenge',
      problem_alert_title: 'Popraw swój kod',
      //    problem_alert_need_help: "Need help?",
      //    problem_alert_ask_the_ai: "Ask the AI",
      //    ask_ai: "Ask AI",
      //    ask_ai_placeholder: "Enter your request here...",
      //    problem_alert_need_hint: "Need a hint? You can ask the AI for help.",
      time_current: 'Teraz:',
      time_total: 'Maksymalnie:',
      time_goto: 'Idź do:',
      non_user_code_problem_title: 'Błąd podczas ładowania poziomu',
      infinite_loop_title: 'Wykryto pętlę nieskończoną',
      infinite_loop_description: 'Kod źródłowy, który miał stworzyć ten świat nigdy nie przestał działać. Albo działa bardzo wolno, albo ma w sobie pętlę nieskończoną. Albo też gdzieś jest błąd systemu. Możesz spróbować uruchomić go jeszcze raz, albo przywrócić domyślny kod. Jeśli nic nie pomoże daj nam o tym znać.',
      //    non_user_code_problem_description: "The initial code to build the world never finished running because of an error: <pre>__error__</pre>You can either try running this code again or reset the code to the default state. If that doesn't fix it, please let us know.",
      check_dev_console: 'Możesz też otworzyć konsolę deweloperską i sprawdzić w czym tkwi problem.',
      check_dev_console_link: '(instrukcje)',
      infinite_loop_try_again: 'Próbuj ponownie',
      infinite_loop_reset_level: 'Resetuj poziom',
      infinite_loop_comment_out: 'Wykomentuj mój kod',
      tip_toggle_play: 'Włącz/zatrzymaj grę naciskając Ctrl+P.',
      tip_scrub_shortcut: 'Ctrl+[ i Ctrl+] przesuwają czas.',
      tip_guide_exists: 'Klikając Przewodnik w menu gry (u góry strony) uzyskasz przydatne informacje.',
      tip_open_source: 'CodeCombat ma w 100% otwarty kod!',
      tip_tell_friends: 'Podoba ci się CodeCombat? Opowiedz o nas swoim znajomym!',
      tip_beta_launch: 'CodeCombat uruchomił fazę beta w październiku 2013.',
      tip_think_solution: 'Myśl nad rozwiązaniem, nie problemem.',
      tip_theory_practice: 'W teorii nie ma różnicy między teorią a praktyką. W praktyce jednak, jest. - Yogi Berra',
      tip_error_free: 'Są dwa sposoby by napisać program bez błędów. Tylko trzeci działa. - Alan Perlis',
      tip_debugging_program: 'Jeżeli debugowanie jest procesem usuwania błędów, to programowanie musi być procesem umieszczania ich. - Edsger W. Dijkstra',
      tip_forums: 'Udaj się na forum i powiedz nam co myślisz!',
      tip_baby_coders: 'W przyszłości, każde dziecko będzie Arcymagiem.',
      tip_morale_improves: 'Ładowanie będzie kontynuowane gdy wzrośnie morale.',
      tip_all_species: 'Wierzymy w równe szanse nauki programowania dla wszystkich gatunków.',
      tip_reticulating: 'Siatkowanie kolców.',
      tip_harry: 'Jesteś czarodziejem ',
      tip_great_responsibility: 'Z wielką mocą programowania wiąże się wielka odpowiedzialność debugowania.',
      tip_munchkin: 'Jeśli nie będziesz jadł warzyw, Munchkin przyjdzie po Ciebie w nocy.',
      tip_binary: 'Jest tylko 10 typów ludzi na świecie: Ci którzy rozumieją kod binarny i ci którzy nie.',
      tip_commitment_yoda: 'Programista musi najgłębsze zaangażowanie okazać. Umysł najpoważniejszy. ~ Yoda',
      tip_no_try: 'Rób. Lub nie rób. Nie ma próbowania. - Yoda',
      tip_patience: 'Cierpliwość musisz mieć, młody Padawanie. - Yoda',
      tip_documented_bug: 'Udokumentowany błąd nie jest błędem. Jest funkcją.',
      tip_impossible: 'To zawsze wygląda na niemożliwe zanim zostanie zrobione. - Nelson Mandela',
      tip_talk_is_cheap: 'Gadać jest łatwo. Pokażcie mi kod. - Linus Torvalds',
      tip_first_language: 'Najbardziej zgubną rzeczą jakiej możesz się nauczyć jest twój pierwszy język programowania. - Alan Kay',
      tip_hardware_problem: 'P: Ilu programistów potrzeba by wymienić żarówkę?  O: Żadnego,to problem sprzętowy.',
      tip_hofstadters_law: 'Prawo Hofstadtera: Każdy projekt zabiera więcej czasu, niż planujesz, nawet jeśli przy planowaniu uwzględnisz prawo Hofstadtera.',
      tip_premature_optimization: 'Przedwczesna optymalizacja jest źródłem wszelkiego zła. - Donald Knuth',
      tip_brute_force: 'Masz jakieś wątpliwości? Użyj techniki brute force. - Ken Thompson',
      tip_extrapolation: 'Są dwa typy ludzi: ci, co potrafią ekstrapolować z niepełnych danych...',
      tip_superpower: 'Umieć programować jest rzeczą bardzo podobną do posiadania super mocy.',
      tip_control_destiny: 'W prawdziwym Open Source, to ty kontrolujesz swoje przeznaczenie. - Linus Torvalds',
      tip_no_code: 'Nie ma szybszego kodu od braku kodu',
      tip_code_never_lies: 'Kod nigdy nie kłamie, komentarze czasami tak. — Ron Jeffries',
      tip_reusable_software: 'Zanim kod stanie się reużywalny musi zacząć działać.',
      tip_optimization_operator: 'Każdy język programowania ma operator optymalizujący. W większości z nich tym operatorem jest ‘//’',
      tip_lines_of_code: 'Mierzenie postępu programowania liniami kodu jest jak mierzenie postępu budowy samolotu za pomocą ciężaru. — Bill Gates',
      tip_source_code: 'Chciałbym zmienić świat, ale nie chcą mi dać kodu źródłowego.',
      tip_javascript_java: 'Java jest tak podobna do JavaScriptu jak minister do ministranta',
      tip_move_forward: 'Nie ważne co robisz. Ważne, że przesz do przodu. - Martin Luther King Jr.',
      tip_google: 'Masz problem z którym nie dajesz sobie rady? Użyj Google!',
      tip_adding_evil: 'Dodajemy szczyptę zła.',
      tip_hate_computers: 'To jest właśnie problem z ludźmi, którzy nie nawidzą komputerów. Tak naprawdę nie nawidzą kiepskich programistów. - Larry Niven',
      tip_open_source_contribute: 'Możesz pomóc w ulepszeniu CodeCombat!',
      tip_recurse: 'Iteracja jest rzeczą ludzką, rekursja boską. - L. Peter Deutsch',
      tip_free_your_mind: 'Musisz to wszystko zostawić, Neo. Strach, wątpliwość i niewiarę. Uwolnij swój umysł. - Morfeusz',
      tip_strong_opponents: 'Nawet najsilniejsi przeciwnicy mają słabe punkty. - Itachi Uchiha',
      tip_paper_and_pen: 'Przed rozpoczęciem kodowania zawsze dobrze jest wziąć kartkę papieru i wszystko dobrze rozplanować.',
      tip_solve_then_write: 'Najpierw rozwiąż problem, a potem napisz kod. - John Johnson',
      tip_compiler_ignores_comments: 'Czasami mi się wydaje, że kompilator ignoruje moje komentarze.',
      tip_understand_recursion: 'Żeby zrozumieć rekurencję, trzeba najpierw zrozumieć rekurencję.',
      tip_life_and_polymorphism: 'Open Source jest jak całkowicie polimorficzna, heterogeniczna struktura: Wszystkie typy są mile widziane.',
      tip_mistakes_proof_of_trying: 'Błędy w twoich kodzie są oznaką, że się starasz.',
      tip_adding_orgres: 'Zaokrąglanie ogrów.',
      tip_sharpening_swords: 'Ostrzymy miecze.',
      tip_ratatouille: 'Nigdy nie pozwólcie, aby ograniczało was to, kim jesteście. Duch nie zna granic. - Gusteau, Ratatuj',
      tip_nemo: 'Wiesz co się robi jak życie dołuje? Mówi się trudno... i płynie się dalej. - Dory, Gdzie jest Nemo',
      tip_internet_weather: 'Przenieś się do internetu, jest tu wspaniale. Żyjemy w miejscu, gdzie pogoda jest zawsze super. - John Green',
      tip_nerds: 'Maniaki komputerowe mają prawo robić różne dziwne rzeczy, takie jak skaczę-z-radości-na-krześle-i-nie-mogę-przestać, kocham to. - John Green',
      tip_self_taught: 'Nauczyłem się 90% tego co się dowiedziałem. I jest to całkowicie normalne! - Hank Green',
      tip_luna_lovegood: 'Nie przejmuj się. Jesteś tak samo zdrowy na umyśle jak ja. - Luna Lovegood',
      tip_good_idea: 'Najlepszym sposobem na dobry pomysł jest wiele pomysłów. - Linus Pauling',
      tip_programming_not_about_computers: 'Informatyka ma tyle samo wspólnego z komputerami, co astronomia ma z teleskopami. - Edsger Dijkstra',
      tip_mulan: 'Jeśli potrafisz o czymś marzyć, to potrafisz także tego dokonać. - Mulan',
      project_complete: 'Projekt ukończony!',
      share_this_project: 'Udostępnij ten projekt znajomym i rodzinie:',
      ready_to_share: 'Gotowt aby udostępnić swój projekt?',
      click_publish: 'Kliknij Publikuj aby porojekt pojawił się w klasowej galerii, potem sprawdź co zbudowali twoi koledzy! Możesz powrócić i kontynuować pracę nad projektem. Każde późniejsze zmiany będą automatycznie zapisywane i udostępniane twojej klasie.',
      //    already_published_prefix: "Your changes have been published to the class gallery.",
      //    already_published_suffix: "Keep experimenting and making this project even better, or see what the rest of your class has built! Your changes will automatically be saved and shared with your classmates.",
      view_gallery: 'Zobacz galerię',
      //    project_published_noty: "Your level has been published!",
      //    keep_editing: "Keep Editing",
      //    learn_new_concepts: "Learn new concepts",
      //    watch_a_video: "Watch a video on __concept_name__",
      //    concept_unlocked: "Concept Unlocked",
      //    use_at_least_one_concept: "Use at least one concept: ",
      //    command_bank: "Code Bank",
      //    learning_goals: "Learning Goals",
      //    start: "Start",
      //    vega_character: "Vega Character",
      //    capella_character: "Capella Character",
      //    octans_character: "Octans Character",
      click_to_continue: 'Kliknij, aby kontynuować',
      //    fill_in_solution: "Fill in solution",
      //    toggle_solution: "Toggle solution",
      //    play_as_humans: "Play As Red",
      //    play_as_ogres: "Play As Blue",
      //    changed: "Last edited ",
      //    team_humans: "Red",
      //    team_ogres: "Blue",
      //    watch_game: "Spectate",
      //    block_go: "go",
      //    block_up: "up",
      //    block_down: "down",
      //    block_left: "left",
      //    block_right: "right",
      //    share_your_project: "Share Your Project",
      //    keep_editing_your_project: "You can always keep editing your project, even after sharing it.",
      //    copy_url: "Copy URL",
      //    level_status: "Status",
      //    level_status_locked: "Locked",
      //    level_status_in_progress: "In Progress",
      //    level_status_skipped: "Skipped",
      //    level_status_complete: "Complete",
      //    level_status_unlocked: "Unlocked",
      //    level_status_optional: "Optional",
      //    level_type_practice: "Practice",
      //    level_type_challenge: "Challenge",
      //    level_type_level: "Level",
      //    level_type_cutscene: "Cutscene",
      //    level_type_capstone: "Capstone",
      //    level_type_intro: "Intro",
      //    level_type_practice_level: "Practice Level",
      //    level_type_challenge_level: "Challenge Level",
      //    level_type_cutscene_level: "Cutscene Level",
      //    level_type_capstone_level: "Capstone Level",
      //    level_type_capstone_project: "Capstone Project",
      //    level_type_intro_level: "Intro Level",
      //    content_type_avatar: "Avatar Selection",
      //    content_type_cinematic: "Cinematic",
      //    content_type_interactive: "Concept Check",
      //    content_type_arena: "Arena",
      //    feedback: "Feedback",
      //    ask_teacher_for_help: "Ask your teacher for help",
      //    ask_teacher_for_help_offline: "Your Teacher is currently offline",
      //    not_enough_credits_bot: "Oops! Looks like you don’t have enough queries. Subscribe now and get the queries you want for the AI-powered support you need!",
      //    not_enough_credits_interval: "No credits left for the __interval__. Consumed __amount__ credits.",
      //    not_enough_credits_interval_multiple: "No credits left for __duration__ __interval__. Consumed __amount__ credits.",
      //    create_account_to_get_credits: "Create an account to get free credits for using the AI-powered support!",
      //    ask_teacher_for_credits: "Ask your teacher for an AI Hackstack license.",
      //    get_credits: "Get Credits",
      //    get_ai_hs_license: "Get AI Hackstack License",
      //    use: "Create",
      //    learn_to_use: "Learn",
      //    navigate_to_previous_page: "Navigate to the previous page",
      //    navigate_to_next_page: "Navigate to the next page",
      //    restart_capstone_stage: "Do you want to restart capstone stage progress to 1?",
    },

    apis: {
      methods: 'Medoty',
      events: 'Zdarzenia',
      //    handlers: "Handlers",
      properties: 'Właściwości',
      //    snippets: "Snippets",
      //    spawnable: "Spawnable",
      //    html: "HTML",
      //    math: "Math",
      array: 'Tablica',
      object: 'Obiekt',
      string: 'Łańcuch',
      function: 'Funkcja',
      //    vector: "Vector",
      //    date: "Date",
      //    jquery: "jQuery",
      //    json: "JSON",
      //    number: "Number",
      //    webjavascript: "JavaScript",
    },

    //  amazon_hoc: {
    //    title: "Keep Learning with Amazon!",
    //    congrats: "Congratulations on conquering that challenging Hour of Code!",
    //    educate_1: "Now, keep learning about coding and cloud computing with AWS Educate, an exciting, free program from Amazon for both students and teachers. With AWS Educate, you can earn cool badges as you learn about the basics of the cloud and cutting-edge technologies such as gaming, virtual reality, and Alexa.",
    //    educate_2: "Learn more and sign up here",
    //    future_eng_1: "You can also try to build your own school facts skill for Alexa",
    //    future_eng_2: "here",
    //    future_eng_3: "(device is not required). This Alexa activity is brought to you by the",
    //    future_eng_4: "Amazon Future Engineer",
    //    future_eng_5: "program which creates learning and work opportunities for all K-12 students in the United States who wish to pursue computer science.",
    //  },

    play_game_dev_level: {
      created_by: 'Stworzone przez {{name}}',
      created_during_hoc: 'Stworzony podczas Godziny Kodowania!',
      restart: 'Restartuj poziom',
      play: 'Zagraj poziom',
      play_more_codecombat: 'Graj więcej CodeCombat',
      learn_about_ozaria: 'Learn About Ozaria',
      default_student_instructions: 'Kliknij, aby przejąć władzę nad bohaterem i wygrać grę!',
      goal_survive: 'Przetrwaj',
      goal_survive_time: 'Przetrwaj przez __seconds__ sekund.',
      goal_defeat: 'Pokonaj wszystkich przeciwników.',
      goal_defeat_amount: 'Pokonaj __amount__ przeciwników.',
      goal_move: 'Udaj się do wszystkich znaczników.',
      goal_collect: 'Zbierz wszystkie itemy.',
      goal_collect_amount: 'Zbierz __amount__ itemów.',
    },

    game_menu: {
      inventory_tab: 'Ekwipunek',
      save_load_tab: 'Zapisz/Wczytaj',
      options_tab: 'Opcje',
      //    my_code_tab: "My Code",
      guide_tab: 'Przewodnik',
      guide_video_tutorial: 'Wideo poradnik',
      guide_tips: 'Wskazówki',
      multiplayer_tab: 'Multiplayer',
      auth_tab: 'Zarejestruj się',
      inventory_caption: 'Wyposaż swojego bohatera',
      choose_hero_caption: 'Wybierz bohatera, język',
      //    change_langugae_caption: "Choose language",
      //    change_language_tab: "Code Format",
      options_caption: 'Ustaw opcje',
      //    my_code_caption: "Quick Code Actions",
      guide_caption: 'Dokumenty i wskazówki',
      multiplayer_caption: 'Graj ze znajomymi!',
      auth_caption: 'Zapisz swój postęp.',
    },

    leaderboard: {
      view_other_solutions: 'Pokaż tablicę wyników',
      scores: 'Wyniki',
      top_players: 'Najlepsi gracze',
      day: 'Dziś',
      week: 'W tym tygodniu',
      all: 'Zawsze',
      latest: 'Najnowsze',
      time: 'Czas',
      damage_taken: 'Obrażenia otrzymane',
      damage_dealt: 'Obrażenia zadane',
      difficulty: 'Trudność',
      gold_collected: 'Złoto zebrane',
      survival_time: 'Przetrwano',
      defeated: 'Pokonani przeciwnicy',
      code_length: 'Linie kodu',
      //    score_display: "__scoreType__: __score__",
    },

    inventory: {
      equipped_item: 'Założone',
      required_purchase_title: 'Wymagane',
      available_item: 'Dostępne',
      restricted_title: 'Zabronione',
      should_equip: '(kliknij podwójnie, aby założyć)',
      equipped: '(założone)',
      locked: '(zablokowane)',
      restricted: '(zabronione)',
      equip: 'Załóż',
      unequip: 'Zdejmij',
      warrior_only: 'Tylko Warrior ',
      ranger_only: 'Tylko Ranger',
      wizard_only: 'Tylko Wizard',
    },

    buy_gems: {
      few_gems: 'Kilka klejnotów',
      pile_gems: 'Stos klejnotów',
      chest_gems: 'Skrzynia z klejnotami',
      purchasing: 'Kupowanie...',
      declined: 'Karta została odrzucona',
      retrying: 'Błąd serwera, ponawiam.',
      prompt_title: 'Niewystarczająca ilość kryształów!',
      prompt_body: 'Weź Premium, aby zdobyć kryształy i dostać się do jeszcze większej ilości poziomów!',
      prompt_button: 'Wejdź do sklepu',
      recovered: 'Przywrócono poprzednie zakupy. Proszę odświeżyć stronę.',
      price: 'x{{gems}} / mieś.',
      buy_premium: 'Kup Premium',
      purchase: 'Kup',
      purchased: 'Zakupiono',
    },

    //  subscribe_for_gems: {
    //    prompt_title: "Not Enough Gems!",
    //    prompt_body: "Subscribe to Premium to get gems and access to even more levels!",
    //  },

    earn_gems: {
      prompt_title: 'Za mało klejnotów',
      prompt_body: 'Graj dalej, a zdobędziesz ich więcej!',
    },

    subscribe: {
      //    best_deal: "Best Deal!",
      //    confirmation: "Congratulations! You now have a CodeCombat Premium Subscription!",
      //    premium_already_subscribed: "You're already subscribed to Premium!",
      subscribe_modal_title: 'CodeCombat Premium',
      comparison_blurb: 'Zostań mistrzem kodowania - zapisz się do <b>Premium</b> już dziś!',
      must_be_logged: 'Najpierw musisz się zalogować. Użyj menu na górze do zalogowania się, lub stworzenia nowego konta.',
      subscribe_title: 'Zapisz się',
      unsubscribe: 'Wypisz się',
      confirm_unsubscribe: 'Potwierdź wypisanie się',
      never_mind: 'Nie ważne, i tak cię kocham',
      thank_you_months_prefix: 'Thank you for supporting us these last',
      thank_you_months_suffix: ' - przez tyle miesięcy nas wspierałeś. Dziękujemy!',
      thank_you: 'Dziękujemy za wsparcie CodeCombat.',
      sorry_to_see_you_go: 'Szkoda, że już się nie zobaczymy! Powiedz nam co moglibyśmy poprawić',
      unsubscribe_feedback_placeholder: 'Och! Cóżeśmy ci takiego uczynili, że nas opuszczasz?',
      stripe_description: 'Miesięczna subskrypcja',
      //    stripe_yearly_description: "Annual Subscription",
      buy_now: 'Kup teraz!',
      subscription_required_to_play: 'Żeby zagrać w ten poziom musisz posiadać subskrypcję.',
      unlock_help_videos: 'Subskrybuj, aby odblokować wszystkie wideo tutoriale.',
      personal_sub: 'Osobista subskrypcja',
      loading_info: 'Wczytywanie informacji o subskrypcji...',
      managed_by: 'Zarządzane przez',
      will_be_cancelled: 'Zostanie anulowana',
      currently_free: 'Obecnie posiadasz darmową subskrypcję',
      currently_free_until: 'Twoja obecna subskrypcja wygaśnie __date__',
      free_subscription: 'Darmowa subskrypcja',
      was_free_until: 'Twoja obecna darmowa subskrypcja wygaśnie',
      managed_subs: 'Zarządzane subskrypcje',
      subscribing: 'Zapisywanie do subskrypcji...',
      current_recipients: 'Obecni odbiorcy',
      unsubscribing: 'Anulowanie subskrypcji',
      subscribe_prepaid: 'Kliknij `Zapisz się`, aby użyć kodu prepaid',
      using_prepaid: 'Używasz kodu prepaid dla miesięcznych subskrypcji',
      //    subscribe_to_premium: "Subscribe to Premium",
      //    feature_level_access: "Play 600+ levels",
      feature_heroes: 'Ekskluzywni bohaterowie',
      feature_learn: 'Naucz się tworzyć gry i strony internetowe!',
      //    feature_languages: "Get all supported languages",
      //    feature_aiyouth: "",
      //    feature_gems: "Earn __gems__ gems/mo (__gems12__ gems/yr)",
      //    feature_all_products: "4-in-1: CodeCombat Home, CodeCombat Junior, CodeCombat Worlds on Roblox, and CodeCombat AI HackStack",
      //    feature_products: "Access CodeCombat Junior, CodeCombat & AI HackStack",
      month_price: '$__price__/miesiąc',
      //    month_price_without_currency: "__price__/mo",
      //    first_month_price: "Only $__price__ for your first month!",
      lifetime: 'Dożywotnia subskrypcja',
      lifetime_price: '$__price__',
      year_subscription: 'Roczna subskrypcja',
      year_price: '$__price__/rok',
      //    year_price_without_currency: "__price__/yr",
      support_part1: 'Potrzebujesz pomocy? Jeśli masz jakieś pytania, to napisz do nas na',
      support_part2: 'support@codecombat.com',
      //    go_prepaid: "Click here after scaning the code and purchasing",
      //    forever: "Forever",
      //    subscription_status: "Your Subscription Status",
      //    currently_not_free: "You don't have a Subscription yet.",
      //    online_classes: "Online Classes",
      //    feature_ai_level_bot: "Accelerate learning with AI-powered support",
      //    sure_buy_as_parent: "Are you sure you want premium access for yourself instead of your child?",
      //    having_activation_code: "Having an activation Code for Premium? <a href=\"/account/prepaid\">Activate the code here</a>",
    },

    announcement: {
      now_available: 'Dostępne dla subskrybentów!',
      subscriber: 'subskrybentem',
      cuddly_companions: 'Milusi towarzysze!',
      kindling_name: 'Żywioł Ognia',
      kindling_description: 'Żywioły ognia chcą tylko, żeby było ci ciepło w nocy. I za dnia. W sumie, to cały czas.',
      griffin_name: 'Mały Gryf',
      griffin_description: 'Gryfy to pół orły, pół lwy. Czyż nie są urocze?',
      raven_name: 'Kruk',
      raven_description: 'Kruki doskonale radzą sobie w przynoszeniu błyszczących buteleczek z lekarstwami.',
      mimic_name: 'Mimik',
      mimic_description: 'Mimiki pomagają w zbieraniu monet za ciebie. Przemieść je na monetę, aby zwiększyć zapasy złota.',
      cougar_name: 'Puma',
      cougar_description: 'Pumy uwielbiają wylegiwać się na słońcu.',
      fox_name: 'Niebieski Lis',
      fox_description: 'Niebieskie lisy są bardzo cwane, uwielbiają też kopać dziury w piachu i śniegu!',
      pugicorn_name: 'Piesorożec',
      pugicorn_description: 'Piesorożce to jedne z najrzadszych stworzeń, oraz potrafią rzucać czary!',
      wolf_name: 'Szczenię Wilka',
      wolf_description: 'Szczenię wilka jest znakomite w polowaniu i zbieraniu, uwielbia też grę w chowanego!',
      ball_name: 'Czerwona piszcząca piła',
      ball_description: 'piłka.zapiszcz()',
      collect_pets: 'Zdobywaj zwierzaki dla swoich bohaterów!',
      each_pet: 'Każdy ze zwierzakówma ma bardzo pomocną unikalną zdolność!',
      upgrade_to_premium: 'Zostań {{subscriber}}, aby móc używać zwierzaków.',
      play_second_kithmaze: 'Zagraj w {{the_second_kithmaze}}, aby odblokować Szczenię Wilka!',
      the_second_kithmaze: 'Drugi Labirynt Kith',
      keep_playing: 'Kontynuuj grę, aby móc odblokować pierwszego zwierzaka!',
      coming_soon: 'Wkrótce',
      //    ritic: "Ritic the Cold",
      //    ritic_description: "Ritic the Cold. Trapped in Kelvintaph Glacier for countless ages, finally free and ready to tend to the ogres that imprisoned him.",
      //    ice_block: "A block of ice",
      //    ice_description: "There appears to be something trapped inside...",
      //    blink_name: "Blink",
      //    blink_description: "Ritic disappears and reappears in a blink of an eye, leaving nothing but a shadow.",
      //    shadowStep_name: "Shadowstep",
      //    shadowStep_description: "A master assassin knows how to walk between the shadows.",
      //    tornado_name: "Tornado",
      //    tornado_description: "It is good to have a reset button when one's cover is blown.",
      //    wallOfDarkness_name: "Wall of Darkness",
      //    wallOfDarkness_description: "Hide behind a wall of shadows to prevent the gaze of prying eyes.",
      //    notifications: "Notifications",
      //    x_announcement: "__x__ Notification",
      //    x_announcements: "__x__ Notifications",
      //    x_announcement_with_unread: "__x__ Notification (__y__ unread)",
      //    x_announcements_with_unread: "__x__ Notifications (__y__ unread)",
      //    see_more: "See __unread__ more unread Notifications",
      //    mark_read: "Mark Read",
      //    read_all: "Read All",
      //    more_announcements: "more notifications...",
    },

    //  avatar_selection: {
    //    pick_an_avatar: "Pick an avatar that will represent you as a player",
    //    select_avatar_title: "Choose Player Avatar",
    //  },

    premium_features: {
      get_premium: 'Kup<br>CodeCombat<br>Premium',
      master_coder: 'Zapisz się już dziś i zostań mistrzem kodu!',
      //    paypal_redirect: "You will be redirected to PayPal to complete the subscription process.",
      subscribe_now: 'Zapisz się teraz',
      hero_blurb_1: 'Zdobędziesz dostęp do __premiumHeroesCount__ super wypasionych, nowych bohaterów! Ujarzmij nieograniczoną moc Okara Tupistopy, zabójczą precyzję Narii Liść, albo wezwij "urocze" szkielety wraz z Nalfarem Cryptorem.',
      //    hero_blurb_2: "Premium Warriors unlock stunning martial skills like Warcry, Stomp, and Hurl Enemy. Or, play as a Ranger, using stealth and bows, throwing knives, traps! Try your skill as a true coding Wizard, and unleash a powerful array of Primordial, Necromantic or Elemental magic!",
      hero_caption: 'Nowi ekscytujący bohaterowie!',
      pet_blurb_1: 'Zwierzaki nie są tylko uroczymi towarzyszami, zapewniają także unikatowe umiejętności. Mały Gryf może przelatywać nad przeszkodami pomoagając bohaterowi, Szczenię Wilka umie przynosić lekarstwa, a Puma potrafi mówić!',
      pet_blurb_2: 'Zbierz wszystkie zwierzaki i poznaj ich unikalne zdolności!',
      pet_caption: 'Przygarnij zwierzaka do towarzystwa!',
      game_dev_blurb: 'Naucz się pisania gier i stwórz poziomy, którymi później możesz podzielić się ze znajomymi! Umieszczaj jakie chcesz przedmioty, pisz kod, który odpowiedzialny będzie za zachowanie się przeciwników i sprawdź, czy twoim kolegom uda się pokonać twój poziom',
      game_dev_caption: 'Stwórz własne gry i zobacz który z twoich przyjaciół je pokona!',
      everything_in_premium: 'Wszystko co dostaniesz wraz z CodeCombat Premium:',
      list_gems: 'Co miesiąc będziesz dostawać klejnoty na zakup sprzętu',
      list_levels: 'Dostęp do __premiumLevelsCount__, a nawet więcej poziomów',
      list_heroes: 'Odblokujesz ekskluzywnych bohaterów',
      list_game_dev: 'Stworzysz grę dla swoich przyjaciół',
      list_web_dev: 'Zbudujesz strony internetowe i interaktywne aplikacje',
      list_items: 'Będziesz mógł używać zwierzaków',
      list_support: 'Otrzymasz pomoc w rozwiązywaniu podchwytliwych zadań',
      list_clans: 'Będziesz mógł tworzyć prywatne klany i konkurować z przyjaciółmi',
      //    ai_bot_learning: "AI-powered support to accelerate learning outcomes!",
      //    ai_bot_description: "CodeCombat’s AI-powered hints feature can evaluate code, point out errors, and explain how to fix them. Most importantly, it provides all the context needed to understand the why, without providing the entire solution. With only current code problem assistance available young learners will still need to work through each level's coding challenge. Premium subscribers receive an allocation of <b>10 AI hints per day</b> to ensure they always have the support they need.",
      //    list_ai_bot: "Premium subscribers receive an allocation of 10 AI hints per day",
      //    ai_bot_notice: "* AI hints rates are subject to change.",
    },

    choose_hero: {
      choose_hero: 'Wybierz swojego bohatera',
      //    choose_junior_hero: "Choose Your Young Hero",
      //    sign_up_to_unlock: "Sign Up to Unlock!",
      //    sign_up_pet_blurb: "Create a free account to play as this pet!",
      programming_language: 'Język programowania',
      programming_language_description: 'Którego języka programowania chcesz używać?',
      default: 'Domyślny',
      experimental: 'Eksperymentalny',
      python_blurb: 'Prosty ale potężny.',
      javascript_blurb: 'Język internetu.',
      coffeescript_blurb: 'Przyjemniejsza składnia JavaScript.',
      lua_blurb: 'Język skryptowy gier.',
      java_blurb: "(Tylko subskrybenci) Android i 'enterprise'.",
      //    cpp_blurb: "(Subscriber Only) Game development and high performance computing.",
      //    code_format: "Code Format",
      //    text_code: "Text code",
      //    blocks_and_code: "Blocks and code",
      //    blocks_text: "Blocks",
      //    blocks_icons: "Blocks (Icons)",
      //    blocks_icons_helptext: "Junior only",
      //    text_code_blurb: "Type text-based code in a real code editor",
      //    blocks_and_code_blurb: "Blocks and text code side-by-side",
      //    blocks_text_blurb: "Drag and drop blocks for tablets or younger learners",
      //    blocks_icons_blurb: "Icon-based blocks for phones or pre-readers",
      status: 'Status',
      weapons: 'Bronie',
      weapons_warrior: 'Miecze - Krótki zasięg, Brak magii',
      weapons_ranger: 'Kusze, Pistolety - Daleki zasięg, Brak magii',
      weapons_wizard: 'Różdżki, Laski - Daleki zasięg, Magia',
      attack: 'Obrażenia',
      health: 'Życie',
      speed: 'Szybkość',
      regeneration: 'Regeneracja',
      range: 'Zasięg',
      blocks: 'Blok',
      backstab: 'Cios',
      skills: 'Umiejętności',
      attack_1: 'Zadaje',
      attack_2: 'z możliwych',
      attack_3: 'obrażeń od broni.',
      health_1: 'Zdobywa',
      health_2: 'z możliwych',
      health_3: 'wytrzymałości pancerza.',
      speed_1: 'Idzie do',
      speed_2: 'metrów na sekundę.',
      available_for_purchase: 'Można wynająć',
      level_to_unlock: 'Musisz odblokować poziom:',
      restricted_to_certain_heroes: 'Tylko nieliczni bohaterowie mogą brać udział w tym poziomie.',
      //    code_format_not_supported: "Not Supported",
      //    code_format_only_junior: "Only Supported in CodeCombat Junior",
      //    code_format_in_mobile: "Only Supported in Big Screen(Pad, laptop, PC...)",
      //    code_format_disable_by_teacher: "Disabled by Teacher",
      //    code_language_subscriber_only: "Subscriber Only",
      //    code_language_not_support_by_blocks: "Not Supported with Blocks",
      //    code_language_not_support_in_classroom: "Not support in Classroom",
    },

    //  char_customization_modal: {
    //    heading: "Customize Your Hero",
    //    body: "Body",
    //    name_label: "Hero's Name",
    //    hair_label: "Hair Color",
    //    skin_label: "Skin Color",
    //  },

    skill_docs: {
      function: 'funkcja',
      method: 'metoda',
      snippet: 'skrawek',
      number: 'numer',
      array: 'tablica',
      object: 'obiekt',
      string: 'ciąg znaków',
      writable: 'zapisywalny',
      read_only: 'tylko do odczytu',
      action: 'Akcja',
      spell: 'Zaklęcie',
      action_name: 'nazwa',
      action_cooldown: 'Zajmuje',
      action_specific_cooldown: 'Odpoczynek',
      action_damage: 'Obrażenia',
      action_range: 'Zasięg',
      action_radius: 'Promień',
      action_duration: 'Czas trwania',
      example: 'Przykład',
      ex: 'np.',
      current_value: 'Aktualna wartość',
      default_value: 'Domyślna wartość',
      parameters: 'Parametry',
      required_parameters: 'Wymagane parametry',
      optional_parameters: 'Opcjonalne parametry',
      returns: 'Zwraca',
      granted_by: 'Zdobyte dzięki:',
      //    still_undocumented: "Still undocumented, sorry.",
      //    description_coming_soon: "Description coming soon",
    },

    save_load: {
      granularity_saved_games: 'Zapisano',
      granularity_change_history: 'Historia',
    },

    options: {
      general_options: 'Opcje ogólne',
      volume_label: 'Głośność',
      music_label: 'Muzyka',
      music_description: 'Wł/Wył muzykę w tle.',
      editor_config_title_coco: 'Konfiguracja edytora',
      editor_config_title_ozar: 'Konfiguracja edytora',
      editor_config_livecompletion_label: 'Podpowiedzi na żywo',
      editor_config_livecompletion_description: 'Wyświetl sugestie autouzupełnienia podczas pisania.',
      editor_config_invisibles_label: 'Pokaż białe znaki',
      editor_config_invisibles_description: 'Wyświetla białe znaki takie jak spacja czy tabulator.',
      editor_config_indentguides_label: 'Pokaż linijki wcięć',
      editor_config_indentguides_description: 'Wyświetla pionowe linie, by lepiej zaznaczyć wcięcia.',
      editor_config_behaviors_label: 'Inteligentne zachowania',
      editor_config_behaviors_description: 'Autouzupełnianie nawiasów, klamer i cudzysłowów.',
      //    editor_config_wide_editor_label: "Enable Wide Editor",
      //    editor_config_wide_editor_description: "Increase the width of editor like old style",
      //    editor_config_screen_reader_mode_label: "Enable Screen Reader Mode",
      //    editor_config_screen_reader_mode_label_disable: "Disable Screen Reader Mode",
      //    editor_config_screen_reader_mode_description: "Display levels in text rather than visually.",
      //    editor_config_livecompletion_disabled_by_teacher: "Your teacher has disabled your autocomplete.",
    },

    about: {
      //    title: "About CodeCombat - Engaging Students, Empowering Teachers, Inspiring Creation",
      //    meta_description: "Our mission is to level computer science through game-based learning and make coding accessible to every learner. We believe programming is magic and want learners to be empowered to to create things from pure imagination.",
      //    learn_more: "Learn More",
      main_title: 'Jeśli chcesz nauczyć się programować, musisz napisać (mnóstwo) kodu.',
      main_description: 'Naszym zadaniem jest dopilnowanie, żebyś robił to z uśmiechem na twarzy.',
      mission_link: 'Misja',
      team_link: 'Zespół',
      story_link: 'Historia',
      press_link: 'Prasa',
      mission_title: 'Nasza misja: każdy na Ziemi powinien mieć dostęp do nauki programowania.',
      mission_description_1: '<strong>Programowanie jest jak magia</strong>. To możliwość tworzenia rzeczy na podstawie własnych fantazji. Stworzyliśmy CodeCombat, by nasi użytkownicy poczuli czarodziejskie moce podczas pisania <strong>kodu</strong>.',
      mission_description_2: 'Jak się później okazało dzięki temu uczą się szybciej. DUŻO szybciej. To jest taka różnica jak rozmawiać o czymś, a robić to samemu. Chcemy, żeby właśnie pisanie kodu było dostępne w każdej szkole i dla <strong>każdego ucznia</strong>, ponieważ każdy powinien choć przez chwilę poczuć magię programowania.',
      team_title: 'Poznaj twórców CodeCombat',
      team_values: 'Bardzo cenimy sobie otwarty dialog, taki gdzie wygrywają najlepsze pomysły. Nasze decyzje opierają się na oczekiwaniach klientów i dawaniu im namacalnych dowodów naszej pracy. Każdy z nas czuje się zaangażowany. Począwszy od naszego CEO, aż po kontrybutorów na GitHubie, ponieważ wiemy, że każdy od kogoś może się nauczyć czegoś nowego.',
      nick_title: 'Współzałożyciel, CEO',
      //    csr_title: "Customer Success Representative",
      //    csm_title: "Customer Success Manager",
      //    scsm_title: "Senior Customer Success Manager",
      //    ae_title: "Account Executive",
      //    sae_title: "Senior Account Executive",
      //    sgd_title: "Senior Game Developer",
      //    gd_title: "Game Developer",
      //    dois_title: "Director of Inside Sales",
      //    ism_title: "Inside Sales Manager",
      //    sism_title: "Senior Inside Sales Manager",
      //    shan_title: "Inside Sales, Europe",
      //    run_title: "Head of Operations, CodeCombat Greater China",
      //    lance_title: "Head of Technology, CodeCombat Greater China",
      //    zhiran_title: "Head of Curriculum, CodeCombat Greater China",
      //    yuqiang_title: "Head of Innovation, CodeCombat Greater China",
      //    swe_title: "Software Engineer",
      //    sswe_title: "Senior Software Engineer",
      //    css_title: "Customer Support Specialist",
      //    am_cs_title: "Associate Manager, Customer Success",
      //    css_qa_title: "Customer Support / QA Specialist",
      //    maya_title: "Senior Curriculum Developer",
      //    bill_title: "General Manager, CodeCombat Greater China",
      //    pvd_title: "Product and Visual Designer",
      //    spvd_title: "Senior Product and Visual Designer",
      //    daniela_title: "Marketing Manager",
      //    mm_title: "Marketing Manager",
      //    bobby_title: "Senior Game Designer",
      //    brian_title: "Senior Game Design Manager",
      //    stephanie_title: "Customer Support Specialist",
      //    sdr_title: "Sales Development Representative",
      //    bd_pr_title: "Business Development and Partnerships Representative",
      retrostyle_title: 'Ilustracje',
      retrostyle_blurb: 'RetroStyle Games',
      community_title: "...oraz nasza społeczność 'open-source'",
      //    lgd_title: "Lead Game Designer",
      //    oa_title: "Operations Associate",
      //    ac_title: "Administrative Coordinator",
      //    sac_title: "Senior Administrative Coordinator",
      //    oss_title: "Operations Support Specialist",
      //    ea_title: "Executive Assistant",
      //    om_title: "Operations Manager",
      //    som_title: "Senior Operations Manager",
      //    sales_om_title: "Sales Operations Manager",
      //    pe_title: "Principal Engineer",
      //    mo_title: "Manager, Operations",
      //    smo_title: "Senior Manager, Operations",
      //    do_title: "Director of Operations",
      //    vp_o_title: "VP, Operations",
      //    scd_title: "Senior Curriculum Developer",
      //    lcd_title: "Lead Curriculum Developer",
      //    cd_title: "Curriculum Developer",
      //    sem_title: "Senior Education Manager",
      //    de_title: "Director of Education",
      //    vpm_title: "VP, Marketing",
      //    vps_title: "VP, Sales",
      //    vpsm_title: "VP, Sales and Marketing",
      //    oi_title: "Online Instructor",
      //    m_oi_title: "Manager, Online Instruction",
      //    aoim_title: "Associate Online Instructor Manager",
      //    bdm_title: "Business Development Manager",
      community_subtitle: 'Ponad 500 kontrybutorów pomogło stworzyć CodeCombat i liczba ta cały czas rośnie!',
      community_description_3: 'CodeCombat jest ',
      community_description_link_2: 'projektem społecznościowym',
      community_description_1: 'z setkami graczy wolontariuszy, którzy tworzą nowe poziomy, kod, nowe funkcje, naprawiają błędy, testują grę oraz tłumaczą ją na 50 języków. Pracownicy i wolontariusze wszyscy zyskali dzięki idei dzielenia się wiedzą oraz wspólnego podejmowania się wysiłków, jak to zwykle działa w społeczności open source. Ta strona powstała na dziesiątkach projektów open source i my także ją udostępniamy społeczności na zasadach open source oraz żeby dostarczyć dociekliwym programistom platformy do eksperymentowania. Każdy może dołączyć do społeczności CodeCombat! Odwiedź naszą',
      community_description_link: 'stronę o współpracy',
      community_description_2: 'żeby dowiedzieć się więcej.',
      number_contributors: 'Ponad 500 kontrybutorów poświęciło swoją wiedzę i czas, aby wspomóc nasz projekt.',
      story_title: 'Nasza historia',
      story_subtitle: 'Od 2013, CodeCombat wyrósł od zaledwie kilku szkiców do wspólnie rozwijanej, tętniącej życiem gry.',
      story_statistic_1a: 'Ponad 20,000,000',
      story_statistic_1b: 'graczy',
      story_statistic_1c: 'zaczęło przygodę z programowaniem dzięki CodeCombat',
      story_statistic_2a: 'Nasza strona przetłumaczona jest na 50 języków — nasi gracze pochodzą z',
      story_statistic_2b: 'ponad 190 krajów',
      story_statistic_3a: 'Razem udało im się napisać',
      story_statistic_3b: '1 miliard linii kodu i cały czas rośnie.',
      story_statistic_3c: 'z pośród wielu dostępnych języków programowania',
      story_long_way_1: 'Udało nam się dużo osiągnąć, ale...',
      story_sketch_caption: 'Pierwszy szkic Nicka opisujący akcje w grze.',
      story_long_way_2: 'wciąż mamy wiele do zrobienia, więc...',
      jobs_title: 'Zacznij z nami pisać przyszłą historię CodeCombat!',
      jobs_subtitle: 'Nie za bardzo się odnajdujesz póki co, ale chcesz pozostać w kontakcie? Zobacz "Stwórz Własną".',
      jobs_benefits: 'Korzyści z pracy u nas',
      jobs_benefit_4: 'Nieograniczony urlop',
      jobs_benefit_5: 'Pomoc w rozwoju zawodowym i dalszej nauce – darmowe książki i gry!',
      jobs_benefit_6: 'Ubezpieczenie medyczne (pakiet złoty), dentystyczne, okulistyczne, bilety komunikacyjne',
      jobs_benefit_9: '10 lat na realizację opcji pracowniczych',
      jobs_benefit_10: 'Urlop macierzyński: 10 tygodni płatnych, następnych 6 w 55%',
      jobs_benefit_11: 'Urlop tacierzyński: 10 tygodni płatnych',
      //    jobs_benefit_12: "$50/mo internet & biz services benefit",
      //    jobs_benefit_14: "100% distributed team",
      jobs_custom_title: 'Stwórz własne stanowisko',
      jobs_custom_description: 'Zainteresował Cię CodeCombat, ale nie możesz znaleźć stanowiska odpowiadającego Twoim kwalifikacjom? Napisz do nas i pokaż co możesz wnieść do naszego zespołu. Chętnie Cię wysłuchamy!',
      jobs_custom_contact_1: 'Napisz do nas',
      jobs_custom_contact_2: 'o sobie, możliwe, że się z Tobą skontaktujemy!',
      contact_title: 'Prasa - Kontakt',
      contact_subtitle: 'Potrzebujesz więcej informacji? Napisz do nas na',
      //    press_subtitle: "or visit our press site at",
      screenshots_title: 'Zrzuty ekranu z gry',
      screenshots_hint: '(kliknij, żeby zobaczyć w pełnym rozmiarze)',
      downloads_title: 'Pobierz pliki i informacje',
      about_codecombat: 'O CodeCombat',
      logo: 'Logo',
      screenshots: 'Zrzuty ekranu',
      character_art: 'Grafiki postaci',
      download_all: 'Pobierz wszystko',
      previous: 'Poprzedni',
      location_title: 'Nasza siedziba w San Francisco:',
      //    ceo: "CEO",
      //    coo: "COO",
      //    game_director: "Game Director",
      //    eng_team_lead: "Engineering Team Lead",
    },

    teachers: {
      licenses_needed: 'Potrzebne licencje',
      //    google_classroom_disabled_text: "To link Google Classroom, login using Google SSO",
      //    select_class: "Select class",
      //    programming_language: "Programming Language",
      //    programming_language_edit_desc: "Language cannot be changed once students join a class. We recommend creating a new class for the same students.",
      //    programming_language_edit_desc_new: "If you change the programming language, your students' progress in the old language will be hidden, and they will have to start over in the new language. We recommend creating a new class for the same students.",
      //    add_a_class: "Add a new class",
      //    select_desired_lang: "Select desired language for your class",
      //    elementary: "Elementary",
      //    middle: "Middle",
      //    high_school: "High School",
      //    class_name: "Class Name",
      //    grades: "Grades",
      //    select_all_that_apply: "Select all that apply",
      //    class_info_modal_sub_title: "Invite students to join your class by sending them:",
      //    class_url: "Class Url",
      //    class_url_desc: "Share URL to have students join your class after signing up",
      //    class_code: "Class Code",
      //    class_code_desc: "Students can enter this code when they sign up at",
      //    invite_by_email: "Invite by Email",
      //    regenerate_class_code: "Regenerate",
      //    invite_modal_sub_title: "Separate each email address by a line break or commas",
      //    no_new_students_imported: "No new students imported",
      //    error_in_importing_classrooms: "Error in importing classrooms",
      //    error_in_importing_students: "Error in importing students",
      //    classroom_items_description: "Whether students should earn gems and equip items during gameplay.",
      //    classroom_live_completion: "Whether to enable coding autocomplete in this classroom. Disabled: turns autocomplete off for all levels. Enabled: allows students to choose. We recommend leaving this enabled.",
      //    classroom_disable_paste: "Whether to disable pasting code into the code editor in this classroom.",
      //    disable_paste_noty: "Your teacher has disabled the paste feature!",
      //    code_formats: "Code Formats",
      //    code_formats_description: "Which code formats students can choose from.",
      //    code_formats_disabled_by: "Blocks and code, Blocks are not supported with __language__ language",
      //    code_formats_mobile: "* Students on mobile will be set to block-based mode",
      //    code_formats_fallback: "* Students will fallback to text-mode for courses without blocks support",
      //    code_formats_text: "text code: real code editor",
      //    code_formats_block: "blocks: block-based editor (python, javascript only)",
      //    code_formats_block_text: "blocks and code: block-based editor with text code(python, javascript only)",
      //    code_formats_block_icon: "blocks(icons): icons editor without text (Junior only) ",
      //    default_code_format: "Default Code Format",
      //    default_code_format_description: "The code format that students will start with.",
      //    not_allow_to_solution: "# Licenses needed to view solutions",
      //    classroom_level_chat: "AI Level Hints",
      //    classroom_level_chat_blurb: "Whether students can ask for AI hints and error explanations.",
      //    classroom_level_chat_option_free_form: "Free form",
      //    classroom_level_chat_option_fixed_prompt_only: "Fixed prompt only",
      //    classroom_level_chat_option_none: "No chat",
      //    initial_free_courses: "Initial Courses",
      //    free_course_blurb_junior: "Great for grades K-5, CodeCombat Junior can flex down to block-based and mobile options for pre-readers, up to Python or JavaScript text code for upper elementary, or to parallel blocks-and-code to help with the transition.",
      //    "free_course_blurb_introduction-to-computer-science": "Great for grades 6-12, CodeCombat's core CS courses progress from the beginner-friendly Introduction to Computer Science, through AP Computer Science Principles, and beyond into advanced CS courses. Start here for middle and high school students.",
      //    "free_course_blurb_intro-to-ai": "Learn essential prompt engineering skills in a wide range of subjects using Al HackStack's Learning Scenarios with popular Al models like ChatGPT, Claude, and DALL-E.",
      //    "free_course_blurb_chapter-1-sky-mountain": "Great for grades 6-8, a narrative coding adventure that establishes the fundamentals of computer science.",
      //    start_teaching_ai_today: "Start Teaching AI Today!",
      //    hackstack_beta_release: "HackStack Beta Release",
      //    introducing_ai_hackstack: "Introducing AI HackStack, a generative AI teaching tool for beginners. It provides safe access to top AI models like ChatGPT, Claude, and DALL-E.",
      //    our_curriculum_empowers_students: "Our curriculum empowers students to use AI to create websites, games, art, and more. Currently in beta.",
      //    test_student_promotion_1: "Ready to walk a mile in your students' coding shoes? Clicking \"Test as Student\" lets you dive into the learning experience firsthand. ",
      //    test_student_promotion_2: "You'll be creating a unique test account that not only mimics the student journey but also saves your progress — unlike the quick previews in our curriculum guide, which are great for a sneak-peek but don't keep track of where you've been.",
      //    test_student_promotion_3: "Your first course is free. Ready for more? We'll guide you on adding a license for continued learning adventures.",
      //    dashboard_update: "Dashboard Update",
      //    dashboard_update_message: "We are currently optimizing the dashboard for your convenience. You can now find the Curriculum Guide in the left sidebar.",
      //    ai_algebra_promotion_title: "A Teacher-Led Algebra + AI Curriculum",
      //    ai_algebra_promotion_description: "Algebra + AI is a structured, year-long, classroom-ready curriculum that strengthens core Algebra skills while integrating AI as an acceleration tool. Traditional methods remain central, teachers guide the instruction, and students apply math through modeling, design thinking, and meaningful assessments.",
      //    switch_to_test_student: "Switching to test student account..",
      //    import_ozaria_classroom: "Import Ozaria Classroom",
      //    import_codecombat_classroom: "Import Codecombat Classroom",
      //    select_ozaria_classroom: "Select Ozaria Classroom",
      //    select_codecombat_classroom: "Select Codecombat Classroom",
      //    select_to_import_from_ozaria: "Select to Import from Ozaria",
      //    select_to_import_from_codecombat: "Select to Import from Codecombat",
      //    all_classrooms_imported: "All classrooms already imported",
      //    club_type: "Club / Camp Type",
      //    create_students_prompt: "How many students would you like to create?",
      //    initial_free_courses_description: "*Courses can be updated using Assign Content after creating class too.",
      //    junior_code_format_only: "Blocks (Icons) only available for Junior",
      //    hackstack_no_code_language_format: "AI HackStack does not need a programming language or code format",
      //    licenses_activated_success: "Licenses have been Activated Successfully!",
      //    license_code_used: "License Code used.",
      //    ai_hs_remix: "AI HackStack Remix",
      //    ai_hs_remix_blurb: "Whether students can use other student's projects to take inspiration from.",
      //    and_more: "and more",
      //    import_classroom: "Import Classroom",
      //    re_import_classroom: "Re-Import Classroom",
      //    need_more_license: "Oops! It looks like you need __additionalLicensesNum__ more license(s) for the course. Visit My Licenses to learn more!",
      //    confirm_apply_license: "Please confirm that you'd like to apply licenses to __numberEnrolled__ student(s). You will have __numberRemaining__ license(s) remaining.",
      //    fail_get_license: "Error! __fails__ students failed to get license",
      //    no_licenses_applied: "No licenses applied to selected student(s).",
      //    revoke_license_tips: "Revoking a license will make it available to apply to other students. Students will no longer be able to access paid content, but their progress will be saved. Please confirm you'd like to proceed.",
      //    assign_course_confirm: "Please confirm that you'd like to assign __courseName__ to __numStudents__ student(s). __numberEnrolled__ license(s) will be applied.",
      //    near_end_trial: "Your Students Are Nearing the End of the Trial Content",
      //    schedule_demo_subheading: "Schedule a Demo to Continue Your Students Coding Journey With...",
      //    schedule_demo_description: "Schedule a demo with our team to unlock more free content and explore our products, curricula, and resources. Let us help you craft a tailored solution for your class, school, or district.",
      //    practice_and_application: "Practice & Application Experiences",
      //    roster_via_csv: "Roster via CSV",
      //    roster_sub_text: "Supports email, firstName and lastName columns. Required: email and firstName.",
      //    roster_sub_text_2: "In case of log-in without SSO, students will have to reset their password.",
      //    roster_sub_text_3: "Existing students in the classroom are not removed.",
      //    roster_download_example: "Download Example CSV",
      //    roster_completed: "Sync completed, refresh to see changes.",
    },

    //  no_licenses_page: {
    //    are_your_students_ready: "Are your students excited and ready to learn more?",
    //    once_students_have_completed: "Once students have completed Chapter 1, they will need licenses in order to continue their journey through the next chapter and beyond.",
    //    get_licenses: "Get Licenses",
    //    get_full_access_to_ozaria: "Get Full Access to Ozaria",
    //    unlock_all: "Unlock all the above plus all the teacher support you need",
    //    unlock_all_dsa: "Unlock all the above plus all the support teachers need",
    //    comprehensive_dashboards: "Comprehensive teacher and administrator dashboards",
    //    lesson_plans_rubrics_guides: "Lesson Plans, Project Rubrics, Solution Guides, and more",
    //    dedicated_customer_success_manager: "A dedicated customer success manager",
    //    automatic_access: "Automatic access to new content and features",
    //    license_quote: "\"In my opinion as a 26 year veteran middle school educator, there is no more engaging resource for teaching coding.\"",
    //    join_our_community: "Join our community",
    //    join_our_community_desc: "Over 12 million people have learned to write Python and JavaScript using CodeCombat. Now, we welcome you to join our community of over 82,000 educators and 25,000 schools with Ozaria, designed for educators who want to inspire a new generation of students to learn Computer Science.",
    //    teach_real_typed_code: "Teach Real, Typed Code",
    //    teach_real_typed_code_desc: "Students learn Python and JavaScript, the two most popular coding languages, and build 21st century skills that will prepare them for any career.",
    //    support_student_progress: "Support Student Progress",
    //    support_student_progress_desc: "Unlock formative and summative assessment data from Concept Checks, Levels, and Capstone Projects to support student progress.",
    //    creative_projects: "Creative Projects",
    //    creative_projects_desc: "Inspire imagination and unleash student creativity with shareable capstone projects, like in Chapter 2 where students design their own storytelling game. ",
    //    looking_for_engaging: "Looking for engaging computer science curriculum?",
    //    licenses_are_required: "Licenses are required for students to continue their journey beyond Chapter 1.",
    //    real_world_skills: "Real-World Skills",
    //    real_world_skills_desc: "Students learn typed Python and JavaScript, the two most popular coding languages, and enhance their critical-thinking skills, creativity, and resilience to prepare them for any career.",
    //    personalized_learning: "Personalized Learning and Scaffolded Instruction",
    //    personalized_learning_desc: "Students learn concepts at their own pace. Levels increase in difficulty while providing built-in hints to encourage persistence and grit.",
    //    flexible_curriculum: "Flexible Standards- Aligned Curriculum",
    //    flexible_curriculum_desc: "100% CSTA-aligned curriculum that can easily be adapted to any schedule, scenario, or setting.",
    //    resources_to_support: "Resources to Support Teachers",
    //    resources_to_support_desc: "Lesson plans, extension activities, curriculum guides, and more instructional resources designed with remote and hybrid settings in mind.",
    //    actionable_insights: "Actionable Insights for Educators",
    //    actionable_insights_desc: "Empower educators with intuitive student progress and assessment data that makes differentiating instruction possible.",
    //  },

    special_offer: {
      special_offer: 'Specjalna oferta',
      project_based_title: 'Kursy bazujące na projektach',
      project_based_description: 'Kursy tworzenia gier i stron internetowych dają możliwość podzielenia się gotowym projektem.',
      great_for_clubs_title: 'Idealne dla kół i klubów szkolnych',
      great_for_clubs_description: 'Nauczyciele mogą kupić maksymalnie __maxQuantityStarterLicenses__ licencji startowych na rok.',
      low_price_title: 'Jedyne __starterLicensePrice__ za ucznia',
      low_price_description: 'Licencje startowe są aktywne przez __starterLicenseLengthMonths__ miesięcy od daty ich zakupu.',
      three_great_courses: 'Trzy świetne kursy dostępne w licencji startowej:',
      license_limit_description: 'Nauczyciele mogą kupić aż do __maxQuantityStarterLicenses__ licencji startowych. Ty posiadasz już ich __quantityAlreadyPurchased__. Jeśli potrzebujesz więcej napisz na __supportEmail__. Licencje startowe są ważne przez __starterLicenseLengthMonths__ miesięcy.',
      student_starter_license: 'Licencje startowe uczniów',
      purchase_starter_licenses: 'Kup licencje startowe',
      purchase_starter_licenses_to_grant: 'Kup licencję startową, aby uzyskać dostęp do __starterLicenseCourseList__ kursów',
      starter_licenses_can_be_used: 'Licencje startowe mogą być natychmiast użyte do rozdysponowania.',
      pay_now: 'Zapłać teraz',
      we_accept_all_major_credit_cards: 'Akceptujemy większość kart płatniczych.',
      cs2_description: 'najpierw łagodnie zaczyna od podstaw, aby następnie zanurzyć uczniów w instrukcjach warunkowych, funkcjach, zdarzeniach, itp...',
      wd1_description: 'wprowadza w podstawy składni HTML i CSS, oraz uczy jak stworzyć swoją pierwszą stronę internetową.',
      gd1_description: 'używa składni, którą uczniowie już znają, aby pokazać im jak stworzyć własny, grywalny poziom w grze.',
      see_an_example_project: 'zobacz przykładowy projekt',
      get_started_today: 'Zacznij dziś!',
      want_all_the_courses: 'Chcesz wszystkie kursy? Poproś o informacje o pełnej licencji.',
      compare_license_types: 'Porównaj typy licencji:',
      cs: 'Informatyka',
      wd: 'Tworzenie stron',
      wd1: 'Tworzenie stron 1',
      gd: 'Tworzenie gier',
      gd1: 'Tworzenie gier 1',
      maximum_students: 'Maksymalna ilość uczniów',
      unlimited: 'Bez limitu',
      priority_support: 'Priorytetowe wsparcie',
      yes: 'Tak',
      price_per_student: '__price__ za ucznia',
      pricing: 'Cennik',
      free: 'Za darmo',
      purchase: 'Kup',
      courses_prefix: 'Kursy',
      courses_suffix: '',
      course_prefix: 'Kurs',
      course_suffix: '',
    },

    teachers_quote: {
      subtitle_coco: 'Twoi uczniowie mogą zacząć nukę w mniej niż godzinę. Będziesz mógł <strong>utworzyć klasy, dodać uczniów, doglądać ich postępy</strong> w nauce programowania.',
      subtitle_ozar: 'Twoi uczniowie mogą zacząć nukę w mniej niż godzinę. Będziesz mógł <strong>utworzyć klasy, dodać uczniów, doglądać ich postępy</strong> w nauce programowania.',
      email_exists: 'Ten adres email jest już zajęty.',
      phone_number: 'Numer telefonu',
      phone_number_help: 'Jak możemy skontaktować się z tobą w ciągu dnia pracy?',
      primary_role_label: 'Twoja główna rola',
      role_default: 'Wybierz rolę',
      primary_role_default: 'Wybierz kim jesteś',
      purchaser_role_default: 'Rola w zakupie subskrypcji',
      //    teacher: "Teacher",
      tech_coordinator: 'Koordynator technologii',
      advisor: 'Specjalista od nauczania/Doradca',
      principal: 'Dyrektor',
      superintendent: 'Kurator',
      parent: 'Rodzic',
      purchaser_role_label: 'Jaki masz wpływ na zakup',
      influence_advocate: 'Wpływam/Doradzam',
      evaluate_recommend: 'Oceniam/Polecam',
      approve_funds: 'Zatwierdzam fundusze',
      no_purchaser_role: 'Nie mam wpływu na zamówienia',
      //    teacher_account_details: "Teacher Account Details",
      district_label: 'Okręg',
      district_name: 'Nazwa okręgu',
      district_na: 'Wprowadź `-` jeśli nie dotyczy',
      organization_label: 'Szkoła',
      school_name: 'Nazwa szkoły',
      city: 'Miasto',
      state: 'Województwo',
      country: 'Kraj',
      num_students_help: 'Ile osób masz zamiar zapisać do CodeCombat?',
      num_students_default: 'Wybierz zakres',
      education_level_label: 'Poziom nauczania uczniów',
      education_level_help: 'Możesz wybrać wiele odpowiedzi.',
      elementary_school: 'Szkoła podstawowa',
      high_school: 'Liceum',
      please_explain: '(proszę wyjaśnić)',
      middle_school: 'Gimnazjum',
      college_plus: 'Studia',
      referrer: 'Jak się o nas dowiedziałeś?',
      referrer_help: 'Na przykład: od innego nauczyciela, na konferencji, od swoich uczniów, Code.org, itp.',
      //    referrer_default: "Select One",
      //    referrer_conference: "Conference (e.g. ISTE)",
      //    referrer_hoc: "Code.org/Hour of Code",
      //    referrer_teacher: "A teacher",
      //    referrer_admin: "An administrator",
      //    referrer_student: "A student",
      //    referrer_pd: "Professional trainings/workshops",
      //    referrer_web: "Google",
      //    referrer_other: "Other",
      anything_else: 'Coś jeszcze powinniśmy wiedzieć?',
      //    anything_else_helper: "",
      thanks_header: 'Prośba otrzymana!',
      thanks_sub_header_coco: 'Dziękujemy za okazanie zainteresowania stroną CodeCombat.',
      thanks_sub_header_ozar: 'Dziękujemy za okazanie zainteresowania stroną CodeCombat.',
      thanks_p: 'Wkrótce się odezwiemy! Jeśli chcesz się z nami skontaktować napisz na:',
      back_to_classes: 'Idź do klas',
      finish_signup: 'Zakończ tworzenie konta nauczyciela:',
      finish_signup_p: 'Create an account to set up a class, add your students, and monitor their progress as they learn computer science.',
      signup_with: 'Zarejestruj się z:',
      connect_with: 'Połącz się z:',
      conversion_warning: 'UWAGA: Obecnie posiadasz <em>konto ucznia</em>. Po wysłaniu tego formularza zostanie ono zaktualizowane do konta nauczyciela.',
      learn_more_modal: 'Konta nauczyciela w CodeCombat mają możliwość monitorowania postępów uczniów, używania licencji i tworzenia klas. Konto nauczyciela nie może być częścią klasy - jeśli jesteś obecnie zapisany do jakiejś klasy, nie będziesz mógł już jej odwiedzać po aktualizacji do konta nauczyciela.',
      create_account: 'Stwórz konto dla nauczyciela',
      create_account_subtitle: 'Uzyskaj wyłączny dostęp do narzędzi pomocnych podczas zajęć. <strong>Utwórz swoją klasę</strong>, dodaj uczniów i <strong>śledź ich postępy</strong>!',
      convert_account_title: 'Aktualizuj do konta nauczyciela',
      not: 'Nie jesteś',
      //    full_name_required: "First and last name required",
    },

    versions: {
      save_version_title: 'Zapisz nową wersję',
      new_major_version: 'Nowa wersja główna',
      submitting_patch: 'Przesyłanie łatki...',
      cla_prefix: 'Aby zapisać zmiany, musisz najpierw zaakceptować naszą',
      cla_url: 'umowę licencyjną dla współtwórców (CLA)',
      cla_suffix: '.',
      cla_agree: 'AKCEPTUJĘ',
      owner_approve: 'Przed pojawieniem się zmian, właściciel musi je zatwierdzić.',
    },

    contact: {
      contact_us: 'Kontakt z CodeCombat',
      welcome: 'Miło Cię widzieć! Użyj tego formularza, żeby wysłać do nas wiadomość. ',
      forum_prefix: 'W sprawach ogólnych, skorzystaj z ',
      //    reddit_page: "public subreddit here ",
      faq_prefix: 'Jest też',
      faq: 'FAQ',
      //    faq_suffix: " for additional assistance.",
      //    prefer_email_prefix: "If you prefer, you can email ",
      //    prefer_email_suffix: " instead.",
      subscribe_prefix: 'Jeśli masz jakiś problem z rozwiązaniem poziomu,',
      subscribe: 'wykup subskrypcję CodeCombat,',
      subscribe_suffix: 'a my z radością Ci pomożemy.',
      subscriber_support: 'Jako, że będziesz subskrybentem CodeCombat, Twoje e-maile będą miały najwyższy priorytet.',
      screenshot_included: 'Dołączymy zrzuty ekranu.',
      where_reply: 'Gdzie mamy odpisać?',
      send: 'Wyślij wiadomość',
      //    ooo_blurb: "The CodeCombat team will be out of the office from June 5th to June 9th, and during this time will have limited access to emails. We will respond to your inquiry as soon as possible, please be aware of the anticipated wait time.",
    },

    account_settings: {
      title: 'Ustawienia Konta',
      not_logged_in: 'Zaloguj się lub stwórz konto, by dostosować ustawienia.',
      me_tab: 'Ja',
      picture_tab: 'Zdjęcie',
      delete_account_tab: 'Usuń swoje konto',
      wrong_email: 'Błędny e-mail',
      wrong_password: 'Błędne hasło',
      //    temp_password_expired: "Your temporary password has been expired.",
      delete_this_account: 'Usuń to konto całkowicie',
      reset_progress_tab: 'Zresetuj cały postęp',
      reset_your_progress: 'Usuń cały postęp w grze i zacznij od początku',
      //    connect_roblox_tab: "Connect Roblox",
      //    connect_roblox_button: "Connect",
      //    re_connect_roblox_button: "Connect Another Account",
      //    disconnect_roblox_button: "Disconnect",
      //    roblox_connected: "Your account <strong>__username__</strong> is connected to Roblox.",
      //    roblox_connected_other_user: "The student's account is connected to  <strong>__username__</strong> Roblox account.",
      //    roblox_not_connected: "Connect your CodeCombat and Roblox accounts.",
      //    roblox_not_connected_other_user: "Connect the student's CodeCombat and Roblox accounts.",
      //    roblox_disconnect_confirm: "Are you sure you want to disconnect your Roblox account?",
      god_mode: 'TRYB BOGA',
      emails_tab: 'Powiadomienia',
      admin: 'Administrator',
      manage_subscription: 'Kliknij, aby zarządzać swoimi subskrypcjami.',
      //    current_password: "Current Password",
      new_password: 'Nowe hasło',
      new_password_verify: 'Zweryfikuj',
      type_in_email: 'Wpisz swój email albo nazwę użytkownika, aby potwierdzić usunięcie konta.',
      type_in_email_progress: 'Wpisz swój email, aby potwierdzić usunięcie całego swojego postępu.',
      type_in_password: 'Wpisz również swoje hasło.',
      email_subscriptions: 'Powiadomienia email',
      email_subscriptions_none: 'Brak powiadomień email.',
      email_announcements: 'Ogłoszenia',
      email_announcements_description: 'Otrzymuj powiadomienia o najnowszych wiadomościach i zmianach w CodeCombat.',
      email_notifications: 'Powiadomienia',
      email_notifications_summary: 'Ustawienia spersonalizowanych, automatycznych powiadomień mailowych zależnych od twojej aktywności w CodeCombat.',
      email_any_notes: 'Wszystkie powiadomienia',
      email_any_notes_description: 'Odznacz by wyłączyć wszystkie powiadomienia email.',
      email_news: 'Nowości',
      email_recruit_notes: 'Możliwości zatrudnienia',
      email_recruit_notes_description: 'Jeżeli grasz naprawdę dobrze, możemy się z tobą skontaktować by zaoferować (lepszą) pracę.',
      contributor_emails: 'Powiadomienia asystentów',
      contribute_prefix: 'Szukamy osób, które chciałyby do nas dołączyć! Sprawdź ',
      contribute_page: 'stronę współpracy',
      contribute_suffix: ', aby dowiedzieć się więcej.',
      email_toggle: 'Zmień wszystkie',
      error_saving: 'Błąd zapisywania',
      saved: 'Zmiany zapisane',
      password_mismatch: 'Hasła różnią się od siebie',
      password_repeat: 'Powtórz swoje hasło.',
      //    switch_new_teacher_dashboard: "Try the new Teacher Dashboard",
      //    view_trial_class_bookings: "View Trial Class Bookings",
    },

    keyboard_shortcuts: {
      keyboard_shortcuts: 'Skróty klawiszowe',
      space: 'Spacja',
      enter: 'Enter',
      press_enter: 'naciśnij enter',
      escape: 'Escape',
      shift: 'Shift',
      run_code: 'Uruchom obecny kod.',
      run_real_time: "Uruchom 'na żywo'.",
      continue_script: 'Kontynuuj ostatni skrypt.',
      skip_scripts: 'Pomiń wszystkie pomijalne skrypty.',
      toggle_playback: 'Graj/pauzuj.',
      scrub_playback: 'Przenoś się w czasie do produ i do tyłu.',
      single_scrub_playback: 'Przenoś się w czasie do produ i do tyłu o jedną ramkę',
      scrub_execution: 'Pomiń wykonywanie obecnego czaru.',
      toggle_debug: 'Pokaż/ukryj debugowanie.',
      toggle_grid: 'Pokaż/ukryj siatkę.',
      toggle_pathfinding: 'Pokaż/ukryj ścieżkę bohatera.',
      beautify: 'Upiększ kod standaryzując jego formatowanie.',
    },

    //  cinematic: {
    //    click_anywhere_continue: "Click to Continue",
    //    instructional_tooltip: "Click these arrow buttons to go backwards and forwards. You can also use the arrow keys on your keyboard to do the same.",
    //    error_find: "Error finding cinematic __slug__.",
    //  },

    community: {
      main_title: 'Społeczność CodeCombat',
      introduction: 'Sprawdź poniżej jak możesz nam pomóc i co sprawia ci najwięcej radości. Nie możemy się doczekać pracy z Tobą!',
      level_editor_prefix: 'Użyj CodeCombat',
      level_editor_suffix: 'do tworzenia i edycji poziomów. Użytkownicy stworzyli poziomy dla swoich klas, przyjaciół, hackathonów, uczniów i rodzeństwa. Jeśli lubisz tworzyć nowe poziomy zacznij od przerobienia już istniejącego!',
      thang_editor_prefix: "Rzeczy dostępne w grze nazywamy 'obiektami'. Użyj",
      thang_editor_suffix: "do modyfikacji grafik CodeCombat. Niech jednostki czymś rzucają, zmień kierunek animacji, zmień punkty ataku jednostki, albo wyślij do nas swój własny arkusz sprite'ów.",
      article_editor_prefix: 'Znalazłeś błąd w dokumentacji? Chcesz napisać instrukcję do nowej rzeczy? Zajrzyj do',
      article_editor_suffix: 'i pomóż graczom CodeCombat w nauczeniu się jak najwięcej.',
      find_us: 'Znajdziesz nas na tych stronach',
      social_github: 'Przejrzyj cały nasz kod na platformie GitHub',
      //    social_reddit: "Join the CodeCombat community on Reddit",
      social_blog: 'Przeczytaj blog CodeCombat na Sett',
      social_discource: 'Dołącz do dyskusji na naszym forum',
      social_facebook: 'Polub CodeCombat na Facebooku',
      social_twitter: 'Obserwuj CodeCombat na Twitterze',
      social_slack: 'Porozmawiaj z nami na publicznym kanale CodeCombat na Slacku',
      contribute_to_the_project: 'Zostań współtwórcą CodeCombat',
    },

    clans: {
      //    title: "Join CodeCombat Clans - Learn to Code in Python, JavaScript, and HTML",
      //    clan_title: "__clan__ - Join CodeCombat Clans and Learn to Code",
      //    meta_description: "Join a Clan or build your own community of coders. Play multiplayer arena levels and level up your hero and your coding skills.",
      clan: 'Klan',
      clans: 'Klany',
      new_name: 'Nazwa nowego klanu',
      new_description: 'Opis nowego klanu',
      make_private: 'Stwórz prywatny klan',
      subs_only: 'tylko subskrybenci',
      create_clan: 'Stwórz nowy klan',
      private_preview: 'Podgląd',
      private_clans: 'Prywatne klany',
      public_clans: 'Publiczne klany',
      my_clans: 'Moje klany',
      clan_name: 'Nazwa klanu',
      name: 'Nazwa',
      chieftain: 'Dowódca',
      edit_clan_name: 'Edytuj nazwę klanu',
      edit_clan_description: 'Edytuj opis klanu',
      edit_name: 'edytuj nazwę',
      edit_description: 'edytuj opis',
      private: '(prywatny)',
      summary: 'Podsumowanie',
      average_rank: '[AI_TRANSLATION]Średnia ranga',
      average_achievements: 'Średnio osiągnięć',
      delete_clan: 'Usuń klan',
      leave_clan: 'Opuść klan',
      join_clan: 'Dołącz do klanu',
      invite_1: 'Zaproszenie:',
      invite_2: '*Zaproś nowe osoby do klanu wysyłając im ten link.',
      members: 'Członkowie',
      progress: 'Postęp',
      not_started_1: 'nierozpoczęty',
      started_1: 'rozpoczęty',
      complete_1: 'ukończony',
      exp_levels: 'Rozwiń poziomy',
      rem_hero: 'Usuń bohatera',
      status: 'Status',
      complete_2: 'Ukończony',
      started_2: 'Rozpoczęto',
      not_started_2: 'Nie rozpoczęto',
      view_solution: 'Pokaż rozwiązanie.',
      view_attempt: 'Pokaż próbę rozwiązania.',
      latest_achievement: 'Ostatnie osiągnięcia',
      playtime: 'Czas gyr',
      last_played: 'Ostatnio grany',
      leagues_explanation: 'Zagraj w lidze przeciwko innym klanom na mapach dla wielu graczy.',
      track_concepts1: 'Śledź tematy',
      track_concepts2a: 'nauczone przez uczniów',
      track_concepts2b: 'nauczone przez członków',
      track_concepts3a: 'Śledź poziomy ukończone przez każdego z uczniów',
      track_concepts3b: 'Śledź poziomy ukończone przez każdego z członków',
      track_concepts4a: 'Obejrzyj swoich uczniów',
      track_concepts4b: 'Obejrzyj swoich członków',
      track_concepts5: 'Rozwiązania',
      track_concepts6a: 'Sortuj uczniów według postępu, albo nazwy',
      track_concepts6b: 'Sortuj członków według postępu, albo nazwy',
      track_concepts7: 'Do dołączenia',
      track_concepts8: 'wymagane zaproszenie',
      private_require_sub: 'Do dołaczenia, bądź stworzenia prywatnych klanów wymagana jest subskrypcja.',
    },

    courses: {
      create_new_class: 'Stwórz nową klasę',
      //    hoc_blurb1: "Try the",
      //    hoc_blurb2: "Code, Play, Share",
      //    hoc_blurb3: "activity! Construct four different minigames to learn the basics of game development, then make your own!",
      solutions_require_licenses: 'Rozwiązania poziomów dostępne są dla nauczycieli posiadających licencję.',
      unnamed_class: 'Klasa bez nazwy',
      edit_settings1: 'Edytuj ustawienia klasy',
      add_students: 'Dodaj uczniów',
      stats: 'Statystyki',
      student_email_invite_blurb: 'Twoi uczniowie mogą użyć kodu <strong>__classCode__</strong> zakładając konto ucznia, bez potrzeby posiadania adresu email.',
      total_students: 'Ilość uczniów:',
      average_time: 'Średni czas gry na poziom:',
      total_time: 'Łączny czas gry:',
      average_levels: 'Średnio ukończonych poziomów:',
      total_levels: 'Łącznie ukończonych poziomów:',
      students: 'Uczniowie',
      concepts: 'Tematy',
      play_time: 'Czas gry:',
      completed: 'Ukończono:',
      enter_emails: 'Wpisz emaila uczniów do zaproszenia. Wpisz każdy nowej linii, albo oddziel je przecinkiem',
      send_invites: 'Zaproś uczniów',
      number_programming_students: 'Ilość programujących uczniów',
      number_total_students: 'Łączna liczba uczniów w szkole',
      enroll: 'Zapisz',
      enroll_paid: 'Zapisz uczniów na opłacony kurs',
      get_enrollments: 'Otrzymaj więcej licencji',
      change_language: 'Zmień język kursu',
      keep_using: 'Używaj dalej',
      switch_to: 'Przełącz na',
      greetings: 'Witamy!',
      back_classrooms: 'Wróć do moich klas',
      back_classroom: 'Wróć do klasy',
      back_courses_coco: 'Wróć do moich kursów',
      back_courses_ozar: 'Wróć do moich kursów',
      edit_details: 'Edytuj detale klasy',
      purchase_enrollments: 'Kup licencje dla uczniów',
      remove_student: 'usuń ucznia',
      assign: 'Przydziel',
      to_assign: 'Przydziel opłacone kursy.',
      student: 'Uczeń',
      teacher: 'Nauczyciel',
      arena: 'Arena',
      available_levels: 'Dostępne poziomy',
      started: 'rozpoczęty',
      complete: 'ukończ',
      practice: 'trenuj',
      required: 'wymagany',
      //    python: "Python (supports blocks)",
      //    javascript: "JavaScript (supports blocks)",
      //    java: "Java (beta)",
      welcome_to_courses_coco: 'Witamy w kursach podróżniku!',
      welcome_to_courses_ozar: 'Witamy w kursach podróżniku!',
      ready_to_play: 'Gotów, by zagrać?',
      start_new_game: 'Rozpocznij nową grę',
      play_now_learn_header: 'Zagraj teraz, a nauczysz się',
      play_now_learn_1: 'podstawowych komend sterujących bohaterem',
      play_now_learn_2: "pętli 'while', którą rozwiążesz różne zagadki",
      play_now_learn_3: 'zmiennych, którymi zadecydujesz co ma robić bohater',
      play_now_learn_4: 'jak pokonać ogra (bardzo przydatna rzecz!)',
      welcome_to_page: 'Panel ucznia',
      my_classes: 'Moje klasy',
      class_added: 'Udało się dodać klasę!',
      //    view_map: "view map",
      //    view_videos: "view videos",
      view_project_gallery: 'przeglądaj projekty innych uczniów z klasy',
      join_class: 'Dołącz do klasy',
      join_class_2: 'Dołącz do klasy',
      ask_teacher_for_code_coco: 'Poproś nauczyciela o kod klasy z CodeCombat! Jeśli już go masz, wpisz go poniżej:',
      ask_teacher_for_code_ozar: 'Poproś nauczyciela o kod klasy z CodeCombat! Jeśli już go masz, wpisz go poniżej:',
      enter_c_code_coco: '<Wpisz kod klasy>',
      enter_c_code_ozar: '<Wpisz kod klasy>',
      join: 'Dołącz',
      joining: 'Dołączanie do klasy',
      course_complete: 'Ukończono kurs',
      //    unit_complete: "Unit Complete",
      play_arena: 'Zagraj na arenie',
      view_project: 'Zobacz project',
      start: 'Start',
      last_level: 'Ostatni grany poziom',
      not_you: 'To nie ty?',
      continue_playing: 'Kontynuuj grę',
      option1_header: 'Zaproś uczniów poprzez email',
      remove_student1: 'Usuń ucznia',
      are_you_sure: 'Na pewno chcesz usunąć tego ucznia z klasy?',
      remove_description1: 'Uczeń straci dostęp do klasy i przypisanych mu kursów. Postęp w grze natomiast NIE zostanie utracony, uczeń może zostać dołączony do klasy w każdym momencie.',
      remove_description2: 'Aktywowana licencja nie zostanie zwrócona.',
      license_will_revoke: 'Ta licencja ucznia będzie zablokowana i będzie mozna ją przydzielić innemu uczniowi.',
      keep_student: 'Zachowaj ucznia',
      removing_user: 'Usuwanie użytkownika',
      subtitle: 'Zobacz opisy kursów i poziomy',
      changelog: 'Pokaż ostatnie zmiany w poziomach kursu.',
      select_language: 'Wybierz język',
      select_level: 'Wybierz poziom',
      play_level: 'Zagraj poziom',
      concepts_covered: 'Omówione tematy',
      view_guide_online: 'Opisy i rozwiązania poziomów',
      //    lesson_slides: "Lesson Slides",
      grants_lifetime_access: 'Przyznaj dostęp do wszystkich kursów.',
      enrollment_credits_available: 'Dostępne licencje:',
      language_select: 'Wybierz język',
      language_cannot_change: 'Gdy uczniowie dołączą do klasy języka nie będzie można zmienić.',
      avg_student_exp_label: 'Średnie doświadczenie uczniów z programowaniem',
      avg_student_exp_desc: 'Pomoże nam to lepiej dopasować kursy.',
      avg_student_exp_select: 'Wybierz najlepszą opcję',
      avg_student_exp_none: 'Bez doświadczenia - brak doświadczenia z kodem',
      avg_student_exp_beginner: 'Początkujący - mniej więcej wie jak wygląda kod',
      avg_student_exp_intermediate: 'Średni - potrafi czytać i rozumieć kod',
      avg_student_exp_advanced: 'Zaawansowany - potrafi samemu napisać jakiś prosty program',
      avg_student_exp_varied: 'Różny poziom doświadczenia',
      //    class_type_label: "Class Type",
      //    class_type_in_school: "In School",
      //    class_type_after_school: "After School",
      //    class_type_online: "Online",
      //    class_type_camp: "Camp",
      //    class_type_camp_esports: "Camp (Esports)",
      //    class_type_camp_junior: "Camp (Roblox)",
      //    class_type_homeschool: "Homeschool",
      //    class_type_other: "Other",
      student_age_range_label: 'Zakres wieku uczniów',
      student_age_range_younger: 'Młodsi niż 6',
      student_age_range_older: 'Starsi niż 18',
      student_age_range_to: 'do',
      //    estimated_class_dates_label: "Estimated Class Dates",
      //    estimated_class_frequency_label: "Estimated Class Frequency",
      //    classes_per_week: "classes per week",
      //    minutes_per_class: "minutes per class",
      create_class: 'Stwórz klasę',
      class_name: 'Nazwa klasy',
      teacher_account_restricted: 'Posiadasz konto nauczyciela, więc nie możesz tu zaglądać.',
      account_restricted: 'Dostęp do tej strony wymaga konta ucznia.',
      update_account_login_title: 'Zaloguj się, aby zaktualizować konto',
      update_account_title: 'Twoje konto wymaga uwagi!',
      update_account_blurb: 'Zanim będziesz mógł dołączyć do klasy, wybierz jak chcesz używać tego konta.',
      update_account_current_type: 'Obecny typ konta:',
      update_account_account_email: 'Email/Nazwa użytkownika:',
      update_account_am_teacher: 'Jestem nauczycielem',
      //    update_account_no_progress: "Let me create classes but save no game progress",
      update_account_teachers_can: 'Konto nauczyciela może:',
      update_account_teachers_can1: 'Tworzyć/zarządzać/dodawać klasy',
      update_account_teachers_can2: 'Zapisywać/usuwać uczniów z kursów',
      update_account_teachers_can3: 'Odblokować wszystkie poziomy kursów do przetestowania',
      update_account_teachers_can4: 'Dostęp do funkcji tylko dla nauczyciela w momencie ich udostępnienia przez nas',
      //    update_account_teachers_warning_new: "Warning: you will not be able to save your progress on any levels; you will need separate student accounts to do that.",
      update_account_remain_teacher: 'Pozostań nauczycielem',
      update_account_update_teacher: 'Zostań nauczycielem',
      update_account_am_student: 'Jestem uczniem',
      //    update_account_no_home: "Let me join classes but not play outside of class",
      update_account_students_can: 'Konto ucznia może:',
      update_account_students_can1: 'Dołączyć do klasy',
      update_account_students_can2: 'Grać w kursach jak uczeń i śledzić swój własny postęp',
      update_account_students_can3: 'Rywalizować z innymi uczniami z klasy w arenach',
      update_account_students_can4: 'Dostęp do funkcji tylko dla uczniów w momencie ich udostępnienia przez nas',
      //    update_account_students_warning_new: "Warning: you will only be able to play the levels your teacher has assigned.",
      unsubscribe_warning: 'Uwaga: Twoja miesięczna subskrypcja zostanie anulowana.',
      update_account_remain_student: 'Pozostań uczniem',
      update_account_update_student: 'Zostań uczniem',
      //    update_account_am_individual: "I am a individual",
      //    update_account_no_classes: "Let me play independently but not join classes",
      //    update_account_individuals_can: "Individual accounts can:",
      //    update_account_individuals_can1: "Earn gems, experience, items, and heroes",
      //    update_account_individuals_can2: "Play through the game as an individual and track your own progress",
      //    update_account_individuals_can3: "Compete against the world in arenas",
      //    update_account_individuals_can4: "Access new individual-only features as we release them",
      //    update_account_individuals_warning_ozaria: "Warning: individual accounts cannot play Ozaria, only CodeCombat.",
      //    update_account_remain_individual: "Remain an Individual",
      need_a_class_code: 'Wpisz kod klasy do której chcesz dołączyć:',
      update_account_not_sure: 'Nie jesteś pewien co masz wybrać? Email',
      update_account_confirm_update_student: 'Na pewno chcesz zaktualizować swoje konto do konta ucznia?',
      update_account_confirm_update_student2: 'Nie będziesz mógł już zarządzać klasami które posiadasz, oraz tworzyć nowych klas. Twoje obecne klasy zostana usunięte z CodeCombat i nie będzie można ich już przywrócić.',
      instructor: 'Instruktor: ',
      youve_been_invited_1: 'Otrzymałeś zaproszenie, do dołaczenia do ',
      youve_been_invited_2: ', gdzie nauczysz się ',
      youve_been_invited_3: ' wraz ze swoimi kolegami z klasy CodeCombat.',
      by_joining_1: 'Dołączając do ',
      by_joining_2: 'będziesz mógł zmienić swoje hasło, jeśli je zapomnisz. Możesz także zweryfikować swój adres email i zmieniać hasło samemu!',
      sent_verification: 'Wysłaliśmy email weryfikacyjny do:',
      you_can_edit: 'Możesz zmienić swój email w ',
      account_settings: 'Ustawieniach konta',
      select_your_hero: 'Wybierz swojego bohatera',
      select_your_hero_description: 'Zawsze możesz zmienić swojego bohatera wybierając stronę kursów i klikając na "Zmień bohatera"',
      select_this_hero: 'Wybierz tego bohatera',
      current_hero: 'Obecny bohater:',
      //    current_hero_female: "Current Hero:",
      web_dev_language_transition: 'Wszystkie klasy będą używać HTML / JavaScript w tym kursie.  Klasy, które wcześniej uczyły sie Pythona, będą miały kilka dodatkowych lekcji z JavaScriptu, aby ułatwić przestawienie się na nowy język.  Klasy, które używały JavaScriptu rozpoczną grę bez tych lekcji.',
      course_membership_required_to_play: 'Musisz dołączyć do kursu, aby móc grać w ten poziom.',
      license_required_to_play_coco: 'Poproś nauczyciela o przydzielenie ci licencji, abyś mógł kontynuować rozgrywkę w CodeCombat!',
      license_required_to_play_ozar: 'Poproś nauczyciela o przydzielenie ci licencji, abyś mógł kontynuować rozgrywkę w CodeCombat!',
      //    level_locked: "This level is locked.",
      //    update_old_classroom: "New school year, new levels!",
      //    update_old_classroom_detail: "To make sure you're getting the most up-to-date levels, make sure you create a new class for this semester by clicking Create a New Class on your",
      //    teacher_dashboard: "teacher dashboard",
      //    update_old_classroom_detail_2: "and giving students the new Class Code that appears.",
      //    view_assessments: "View Assessments",
      //    view_challenges: "view challenge levels",
      //    challenge: "Challenge:",
      //    challenge_level: "Challenge Level:",
      //    status: "Status:",
      //    assessments: "Assessments",
      //    challenges: "Challenges",
      //    level_name: "Level Name:",
      //    keep_trying: "Keep Trying",
      //    start_challenge: "Start Challenge",
      //    locked: "Locked",
      //    concepts_used: "Concepts Used:",
      //    show_change_log: "Show changes to this course's levels",
      //    hide_change_log: "Hide changes to this course's levels",
      //    concept_videos: "Concept Videos",
      //    concept: "Concept:",
      //    basic_syntax: "Basic Syntax",
      //    while_loops: "While Loops",
      //    variables: "Variables",
      //    basic_syntax_desc: "Syntax is how we write code. Just as spelling and grammar are important in writing narratives and essays, syntax is important when writing code. Humans are good at figuring out what something means, even if it isn't exactly correct, but computers aren't that smart, and they need you to write very precisely.",
      //    while_loops_desc: "A loop is a way of repeating actions in a program. You can use them so you don't have to keep writing repetitive code, and when you don't know exactly how many times an action will need to occur to accomplish a task.",
      //    variables_desc: "Working with variables is like organizing things in shoeboxes. You give the shoebox a name, like \"School Supplies\", and then you put things inside. The exact contents of the box might change over time, but whatever's inside will always be called \"School Supplies\". In programming, variables are symbols used to store data that will change over the course of the program. Variables can hold a variety of data types, including numbers and strings.",
      //    locked_videos_desc: "Keep playing the game to unlock the __concept_name__ concept video.",
      //    unlocked_videos_desc: "Review the __concept_name__ concept video.",
      //    video_shown_before: "shown before __level__",
      //    link_google_classroom: "Link Google Classroom",
      //    select_your_classroom: "Select Your Classroom",
      //    no_classrooms_found: "No classrooms found",
      //    create_classroom_manually: "Create classroom manually",
      //    classes: "Classes",
      //    certificate_btn_print: "Print",
      //    certificate_btn_toggle: "Toggle",
      //    error_in_creating_data: "Error in creating data for intro level!",
      //    ask_next_course: "Want to play more? Ask your teacher for access to the next course.",
      //    set_start_locked_level: "Lock levels starting at",
      //    no_level_limit: "-- (no levels locked)",
      //    ask_teacher_to_unlock: "Ask Teacher To Unlock",
      //    ask_teacher_to_unlock_instructions: "To play the next level, ask your teacher to unlock it on their Course Progress screen",
      //    play_next_level: "Play Next Level",
      //    play_tournament: "Play Tournament",
      //    levels_completed: "Levels Completed: __count__",
      //    ai_league_team_rankings: "AI League Team Rankings",
      //    view_standings: "View Standings",
      //    view_winners: "View Winners",
      //    classroom_announcement: "Classroom Announcement",
      //    link_lms_classroom: "Link LMS Classroom",
      //    classroom_items: "Items & Gems",
      //    classroom_live_completion: "Classroom Code Autocomplete: ",
      //    classroom_disable_paste: "Classroom Disable Paste: ",
      //    learn_without_classroom_title: "You can still learn and play without a classroom",
      //    learn_without_classroom_blurb: "Start by playing the free Sky Mountain chapter by <a href='/play/chapter-1-sky-mountain'>clicking here</a>.",
      //    learn_without_classroom_blurb_coco: "Start by playing the free Hour of Code campaign by <a href='/play/intro'>clicking here</a>.",
      //    all_courses_completed: "All Courses Completed!",
      //    all_units_completed: "All Units Completed!",
      //    hide_options: "Hide Options",
      //    more_options: "More Options",
      //    get_test_license: "Get Test Student License",
      //    create_students: "Generate Students",
      //    custom_tournaments: "Custom Tournaments",
      //    play_ozaria: "Play Ozaria",
      //    play_ccw_on_roblox: "Play CodeCombat Worlds on Roblox",
      //    camp_activities: "Camp Activities",
      //    view_camp_activities: "View Camp Activities",
    },

    //  project_gallery: {
    //    no_projects_published: "Be the first to publish a project in this course!",
    //    view_project: "View Project",
    //    edit_project: "Edit Project",
    //  },

    teacher: {
      assigning_course: 'Przydziel kurs',
      //    back_to_top: "Back to Top",
      //    click_student_code: "Click on any level that the student has started or completed below to view the code they wrote.",
      //    code: "__name__'s Code",
      //    complete_solution: "Complete Solution",
      //    course_not_started: "Student has not started this course yet.",
      //    hoc_happy_ed_week: "Happy Computer Science Education Week!",
      //    hoc_blurb1: "Learn about the free",
      //    hoc_blurb2: "Code, Play, Share",
      //    hoc_blurb3: "activity, download a new teacher lesson plan, and tell your students to log in to play!",
      //    hoc_button_text: "View Activity",
      //    no_code_yet: "Student has not written any code for this level yet.",
      //    open_ended_level: "Open-Ended Level",
      //    partial_solution: "Partial Solution",
      //    capstone_solution: "Capstone Solution",
      //    removing_course: "Removing course",
      //    solution_arena_blurb: "Students are encouraged to solve arena levels creatively. The solution provided below meets the requirements of the arena level.",
      //    solution_challenge_blurb: "Students are encouraged to solve open-ended challenge levels creatively. One possible solution is displayed below.",
      //    solution_project_blurb: "Students are encouraged to build a creative project in this level. Please refer to curriculum guides in the Teacher Toolkit for information on how to evaluate these projects.",
      //    feedback_capstone: "The student will create a base project in Part 1. They will make creative updates based on peer feedback in Part 2. Here is a <a target=\"_blank\" rel=\"noopener\" href=\"https://docs.google.com/document/d/1itB0vY6WphjINQYJ9NHkILATcLLlYD3GDSg6FJg55OQ\">Peer Feedback Template</a> that you can share with your students.",
      //    students_code_blurb: "A correct solution to each level is provided where appropriate. In some cases, it’s possible for a student to solve a level using different code. Solutions are not shown for levels the student has not started.",
      course_solution: 'Rozwiązania kursu',
      level_overview_solutions: 'Opisy i rozwiązania poziomów',
      no_student_assigned: 'Do kursu nie został dołączony żaden uczeń.',
      paren_new: '(nowy)',
      //    student_code: "__name__'s Student Code",
      teacher_dashboard: 'Panel nauczyciela',
      my_classes: 'Moje klasy',
      courses_coco: 'Przewodniki',
      courses_ozar: 'Przewodniki',
      enrollments: 'Licencje studentów',
      resources: 'Zasoby',
      help: 'Pomoc',
      language: 'Język',
      edit_class_settings: 'edytuj ustawienia klasy',
      access_restricted: 'Wymagana aktualizacja konta',
      teacher_account_required: 'Ta strona wymaga dostępu na poziomie nauczyciela.',
      create_teacher_account: 'Stwórz konto nauczyciela',
      what_is_a_teacher_account: 'Co to jest konto nauczyciela?',
      teacher_account_explanation: 'Konto nauczyciela w CodeCombat pozwala na stworzenie klasy, monitorowanie postępów uczniów w trakcie kursów, zarządzanie licencjami, oraz dostęp do zasobów pomocnych w budowie programów zajęć.',
      current_classes: 'Obecne klasy',
      archived_classes: 'Zarchiwizowane klasy',
      //    shared_classes: "Shared Classes",
      archived_classes_blurb: 'Klasy mogą zostać zarchiwizowane na przyszłe potrzeby. Anuluj archiwizację klasy, aby móc znowu ją przeglądać w widoku klas.',
      view_class: 'pokaż klasę',
      //    view_ai_league_team: "View AI League team",
      archive_class: 'archiwizuj klasę',
      unarchive_class: 'anuluj archiwizację',
      unarchive_this_class: 'Anuluj archiwizację klasy',
      no_students_yet: 'Ta klasa nie ma żadnych uczniów.',
      no_students_yet_view_class: 'Pokaż klasę, aby dodać uczniów.',
      try_refreshing: '(Może będziesz musiał odświeżyć stronę)',
      create_new_class: 'Utworz nową klasę',
      class_overview: 'Przegląd klasy',
      avg_playtime: 'Średni czas gry',
      total_playtime: 'Łączny czas gry',
      avg_completed: 'Średnio ukończonych poziomów',
      total_completed: 'Razem ukończonych poziomów',
      created: 'Stworzono',
      concepts_covered: 'Omówione zagadnienia',
      earliest_incomplete: 'Pierwszy ukończony poziom',
      latest_complete: 'Ostatnio ukończony poziom',
      enroll_student: 'Zapisz ucznia',
      //    apply_modal_subtitle: "You will be redirected to your My Classes page, where you can apply licenses to your students by:",
      //    apply_modal_list_item_1: "Selecting or creating a class",
      //    apply_modal_list_item_2: "Selecting students you want to apply licenses to",
      //    apply_modal_list_item_3: "Clicking the “Apply Licenses” button",
      apply_license: 'Zastosuj licencję',
      revoke_license: 'Anuluj licencję',
      //    revoke_licenses: "Revoke All Licenses",
      //    revoke_these_licenses: "Select Students and Revoke These Licenses",
      //    check_and_revoke_license: "Status & Revoke",
      //    manage_license: "Manage License",
      course_progress: 'Postępy kursu',
      //    unit_progress: "Unit Progress",
      not_applicable: 'N/A',
      edit: 'edytuj',
      edit_2: 'Edytuj',
      remove: 'usuń',
      latest_completed: 'Ostatnio ukończony:',
      sort_by: 'Sortuj według',
      progress: 'Postęp',
      //    concepts_used: "Concepts used by Student:",
      //    concept_checked: "Concept checked:",
      completed: 'Ukończono',
      practice: 'Ćwicz',
      started: 'Rozpoczęto',
      no_progress: 'Brak postępu',
      not_required: 'Nie wymagane',
      //    view_student_code: "Click to view student code",
      select_course_coco: 'Wybierz kurs do wyświetlenia',
      select_course_ozar: 'Wybierz kurs do wyświetlenia',
      progress_color_key: 'Klucz koloru postępu:',
      level_in_progress: 'Poziom w trakcie...',
      level_not_started: 'Poziom nie rozpoczęty',
      project_or_arena: 'Projekt albo arena',
      students_not_assigned: 'Uczniowie, którzy nie zostali zapisani do {{courseName}}',
      course_overview: 'Przegląd kursu',
      copy_class_code: 'Kopiuj kod klasy',
      class_code_blurb: 'Uczniowie moga dołaczyc do kasy używając właśnie tego kodu. Podczas tworzenia konta ucznia wystarczy podać ten kod kasy, a dres email nie będzie wymagany.',
      copy_class_url: 'Kopiuj URL klasy',
      class_join_url_blurb: 'Możesz także umieścić ten unikalny URL klasy na waszej wspólnej stronie.',
      add_students_manually: 'Zaproś uczniów poprzez email',
      bulk_assign: 'Masowe przydzielanie',
      assigned_msg_1: '{{numberAssigned}} uczniów zostało dołączonych do kursu {{courseName}}.',
      assigned_msg_2: '{{numberEnrolled}} licencji zostało przypisanych.',
      assigned_msg_3: 'Posiadasz jeszcze {{remainingSpots}} dostępnych licencji.',
      assign_course: 'Przypisz kurs',
      //    removed_course_msg: "{{numberRemoved}} students were removed from {{courseName}}.",
      //    remove_course: "Remove Course",
      //    not_assigned_msg_1: "Cannot add users to a course instance until they are added to a prepaid that includes this course",
      not_assigned_modal_title: 'Kurs nie został przypisany',
      not_assigned_modal_starter_body_1: 'Ten kurs wymaga licencji startowej. Nie masz wystarczającej licby licencji startowych, aby je przydzielić do __selected__ zaznaczonych uczniów.',
      not_assigned_modal_starter_body_2: 'Kup licencje startowe, aby mieć dostęp do tego kursu.',
      not_assigned_modal_full_body_1: 'Ten kurs wymaga pełnej licencji. Nie masz wystarczającej liczby pełnych licencji, aby je przydzielić do __selected__ zaznaczonych uczniów.',
      not_assigned_modal_full_body_2: 'Posiadasz jedynie __numFullLicensesAvailable__ dostępnych pełnych licencji (__numStudentsWithoutFullLicenses__ uczniów nie posiada obecnie aktywnej pełnej licencji).',
      not_assigned_modal_full_body_3: 'Proszę wybrać mniej uczniów, albo wyślij wiadomość na __supportEmail__ po poradę.',
      assigned: 'Przypisany',
      enroll_selected_students: 'Zapisz wybranych uczniów',
      no_students_selected: 'Nie wybrano żadnego ucznia.',
      show_students_from: 'Pokaż studentów od',
      apply_licenses_to_the_following_students: 'Zastosuj licencję do powyższych uczniów',
      //    select_license_type: "Select License Type to Apply",
      students_have_licenses: 'Ci uczniowie mają już zastosowaną licencję:',
      all_students: 'Wszyscy uczniowie',
      apply_licenses: 'Zastosuj licencje',
      not_enough_enrollments: 'Brak wsytarczającej liczby licencji.',
      enrollments_blurb: 'Uczniowie potrzebują licencji, aby móc kontynuować naukę po pierwszym kursie.',
      how_to_apply_licenses: 'Jak zastosować licencję',
      export_student_progress: 'Eksport postępu uczniów (do CSV)',
      send_email_to: 'Wyślij email do odzyskiwania hasła do:',
      email_sent: 'Email wysłany',
      send_recovery_email: 'Wyślij email do odzyskania hasła',
      enter_new_password_below: 'Wpisz poniżej nowe hasło:',
      change_password: 'Zmień hasło',
      changed: 'Zmieniono',
      available_credits: 'Dostępne licencje',
      pending_credits: 'Oczekujące licencje',
      //    empty_credits: "Exhausted Licenses",
      //    license_remaining: "license remaining",
      //    licenses_remaining: "licenses remaining",
      //    student_enrollment_history: "Student Enrollment History",
      //    enrollment_explanation_1: "The",
      //    enrollment_explanation_2: "Student Enrollment History",
      //    enrollment_explanation_3: "displays the total number of unique students who were enrolled across all teachers and classrooms added to your dashboard. This includes students in both archived and unarchived classrooms with a class creation date between July 1- June 30 of each respective school year.",
      //    enrollment_explanation_4: "Remember",
      //    enrollment_explanation_5: "classes may be archived and licenses may be reused throughout the school year, so this view allows administrators to understand how many students truly participated in the program overall.",
      //    one_license_used: "1 out of __totalLicenses__ licenses has been used",
      //    num_licenses_used: "__numLicensesUsed__ out of __totalLicenses__ licenses have been used",
      starter_licenses: 'licencje startowe',
      start_date: 'data rozpoczęcia:',
      end_date: 'data zakonczenia:',
      //    get_enrollments_blurb: " We'll help you build a solution that meets the needs of your class, school or district.",
      //    see_also_our: "See also our",
      //    for_more_funding_resources: "for how to leverage CARES Act funding sources like ESSER and GEER.",
      //    how_to_apply_licenses_blurb_1: "When a teacher assigns a course to a student for the first time, we’ll automatically apply a license. Use the bulk-assign dropdown in your classroom to assign a course to selected students:",
      how_to_apply_licenses_blurb_2: 'Mogę zastosować licencję, bez przydzielania kursu?',
      how_to_apply_licenses_blurb_3: 'Tak — przejdź do sekcji "Status licencji" w swojej klasie, a następnie kliknij na "Zastosuj licencję", aby przydzielić ja uczniowi, który jej jeszcze nie posiada.',
      request_sent: 'Wysłano prośbę!',
      //    assessments: "Assessments",
      license_status: 'Status licencji',
      status_expired: 'Licencja wygasła {{date}}',
      status_not_enrolled: 'Nie zapisany',
      status_enrolled: 'Licencja wygaśnie {{date}}',
      //    status_partly_expires: "Partly expires on {{date}}",
      select_all: 'Wybierz wszystko',
      project: 'Project',
      //    projects: "Projects",
      //    project_gallery: "Project Gallery",
      //    view_project: "View Project",
      //    unpublished: "(unpublished)",
      view_arena_ladder: 'Pokaż drabinkę areny',
      resource_hub: 'Baza wiedzy',
      //    pacing_guides: "Classroom-in-a-Box Pacing Guides",
      //    pacing_guides_desc: "Learn how to incorporate all of CodeCombat's resources to plan your school year!",
      //    pacing_guides_elem: "Elementary School Pacing Guide",
      //    pacing_guides_middle: "Middle School Pacing Guide",
      //    pacing_guides_high: "High School Pacing Guide",
      getting_started: 'Wprowadzenie',
      //    student_resources: "Student Resources",
      //    curriculum: "Curriculum",
      //    lesson_slides: "Lesson Slides",
      //    section: "Section",
      educator_faq: 'FAQ dla nauczycieli',
      educator_faq_desc: 'Najczęściej zadawane pytania odnośnie korzystania z CodeCombat w twojej klasie lub szkole.',
      teacher_getting_started: 'Przewodnik dla nauczyciela',
      teacher_getting_started_desc: 'Nowy w CodeCombat? Pobierz ten `Przewodnik dla nauczyciela`. Z jego pomocą założysz konto, stworzysz swoją pierwszą klasę, oraz zaprosisz swoich uczniów do udziału w kursach.',
      student_getting_started: 'Przewodnik dla ucznia',
      student_getting_started_desc: 'Możesz rozdać ten przewodnik uczniom zanim zaczną naukę w CodeCombat, aby mogli zapoznać się z edytorem kodu. Przewodnik ten może znaleźć zastosowanie zarówno dla języka Python, jak i JavaScript.',
      //    standardized_curricula: "Standardized Curricula",
      //    ap_cs_principles: "AP Computer Science Principles",
      //    ap_cs_principles_desc: "AP Computer Science Principles gives students a broad introduction to the power, impact, and possibilities of Computer Science. The course emphasizes computational thinking and problem solving while also teaching the basics of programming.",
      cs1: 'Wprowadzenie do informatyki',
      cs2: 'Informatyka 2',
      cs3: 'Informatyka 3',
      cs4: 'Informatyka 4',
      cs5: 'Informatyka 5',
      cs1_syntax_python: 'Kurs 1 - Podstawy składni Pythona',
      //    cs1_syntax_python_desc: "Cheatsheet with references to common Python syntax that students will learn in Introduction to Computer Science.",
      //    cs1_syntax_javascript: "Course 1 JavaScript Syntax Guide",
      //    cs1_syntax_javascript_desc: "Cheatsheet with references to common JavaScript syntax that students will learn in Introduction to Computer Science.",
      coming_soon: 'Wkrótce dodatkowe przewodniki!',
      //    engineering_cycle_worksheet: "Engineering Cycle Worksheet",
      //    engineering_cycle_worksheet_desc: "Use this worksheet to teach students the basics of the engineering cycle: Assess, Design, Implement and Debug. Refer to the completed example worksheet as a guide.",
      engineering_cycle_worksheet_link: 'Pokaż przykład',
      progress_journal: 'Dziennik postępów',
      //    progress_journal_desc: "Encourage students to keep track of their progress via a progress journal.",
      //    cs1_curriculum: "Introduction to Computer Science - Curriculum Guide",
      //    cs1_curriculum_desc: "Scope and sequence, lesson plans, activities and more for Course 1.",
      //    arenas_curriculum: "Arena Levels - Teacher Guide",
      //    arenas_curriculum_desc: "Instructions on how to run Wakka Maul, Cross Bones and Power Peak multiplayer arenas with your class.",
      //    assessments_curriculum: "Assessment Levels - Teacher Guide",
      //    assessments_curriculum_desc: "Learn how to use Challenge Levels and Combo Challenge levels to assess students' learning outcomes.",
      //    cs2_curriculum: "Computer Science 2 - Curriculum Guide",
      //    cs2_curriculum_desc: "Scope and sequence, lesson plans, activities and more for Course 2.",
      //    cs2_syntax_python: "Course 2 Python Syntax Guide",
      //    cs3_curriculum: "Computer Science 3 - Curriculum Guide",
      //    cs3_curriculum_desc: "Scope and sequence, lesson plans, activities and more for Course 3.",
      //    cs3_syntax_python: "Course 3 Python Syntax Guide",
      //    cs4_curriculum: "Computer Science 4 - Curriculum Guide",
      //    cs4_curriculum_desc: "Scope and sequence, lesson plans, activities and more for Course 4.",
      //    cs4_syntax_python: "Course 4 Python Syntax Guide",
      //    cs5_curriculum_js: "Computer Science 5 - Curriculum Guide (JavaScript)",
      //    cs5_curriculum_desc_js: "Scope and sequence, lesson plans, activities and more for Course 5 classes using JavaScript.",
      //    cs5_curriculum_py: "Computer Science 5 - Curriculum Guide (Python)",
      //    cs5_curriculum_desc_py: "Scope and sequence, lesson plans, activities and more for Course 5 classes using Python.",
      //    cs1_pairprogramming: "Pair Programming Activity",
      //    cs1_pairprogramming_desc: "Introduce students to a pair programming exercise that will help them become better listeners and communicators.",
      gd1: 'Tworzenie gier 1',
      //    gd1_guide: "Game Development 1 - Project Guide",
      //    gd1_guide_desc: "Use this to guide your students as they create their first shareable game project in 5 days.",
      //    gd1_rubric: "Game Development 1 - Project Rubric",
      //    gd1_rubric_desc: "Use this rubric to assess student projects at the end of Game Development 1.",
      //    gd2: "Game Development 2",
      //    gd2_curriculum: "Game Development 2 - Curriculum Guide",
      //    gd2_curriculum_desc: "Lesson plans for Game Development 2.",
      //    gd3: "Game Development 3",
      //    gd3_curriculum: "Game Development 3 - Curriculum Guide",
      //    gd3_curriculum_desc: "Lesson plans for Game Development 3.",
      wd1: 'Tworzenie stron 1',
      //    wd1_curriculum: "Web Development 1 - Curriculum Guide",
      //    wd1_curriculum_desc: "Scope and sequence, lesson plans, activities, and more for Web Development 1.",
      //    wd1_headlines: "Headlines & Headers Activity",
      //    wd1_headlines_example: "View sample solution",
      //    wd1_headlines_desc: "Why are paragraph and header tags important? Use this activity to show how well-chosen headers make web pages easier to read. There are many correct solutions to this!",
      //    wd1_html_syntax: "HTML Syntax Guide",
      //    wd1_html_syntax_desc: "One-page reference for the HTML style students will learn in Web Development 1.",
      //    wd1_css_syntax: "CSS Syntax Guide",
      //    wd1_css_syntax_desc: "One-page reference for the CSS and Style syntax students will learn in Web Development 1.",
      wd2: 'Tworzenie stron 2',
      //    wd2_jquery_syntax: "jQuery Functions Syntax Guide",
      //    wd2_jquery_syntax_desc: "One-page reference for the jQuery functions students will learn in Web Development 2.",
      //    wd2_quizlet_worksheet: "Quizlet Planning Worksheet",
      wd2_quizlet_worksheet_instructions: 'Pokaż instrukcje i przykłady',
      //    wd2_quizlet_worksheet_desc: "Before your students build their personality quiz project at the end of Web Development 2, they should plan out their quiz questions, outcomes and responses using this worksheet. Teachers can distribute the instructions and examples for students to refer to.",
      //    intro_to_cs_short: "Intro to CS",
      //    GD1_short: "Game Dev 1",
      //    GD2_short: "Game Dev 2",
      //    GD3_short: "Game Dev 3",
      //    WD1_short: "Web Dev 1",
      //    WD2_short: "Web Dev 2",
      //    WD3_short: "Web Dev 3",
      //    CS1_short: "Comp Sci 1",
      //    CS2_short: "Comp Sci 2",
      //    CS3_short: "Comp Sci 3",
      //    CS4_short: "Comp Sci 4",
      //    CS5_short: "Comp Sci 5",
      //    CS6_short: "Comp Sci 6",
      //    JR_short: "Junior",
      //    AI_short: "AI",
      student_overview: 'Przegląd',
      student_details: 'Szczegóły studenta',
      student_name: 'Imię ucznia',
      no_name: 'Nie podał imienia.',
      no_username: 'Nie podał nazwiska.',
      no_email: 'Uczeń nie ustawił adresu email.',
      student_profile: 'Profil ucznia',
      playtime_detail: 'Szczegóły czasu gry',
      student_completed: 'Uczeń ukończył',
      student_in_progress: 'Uczeń w trakcie...',
      class_average: 'Średnia klasy',
      not_assigned: 'nie został przydzielony do obecnego kursu',
      playtime_axis: 'Czas gry w sekundach',
      levels_axis: 'Poziomy w',
      student_state: 'Jak',
      student_state_2: 'sobie radzi?',
      student_good: 'radzi sobie dobrze w',
      student_good_detail: 'Ten uczeń utrzymuje tempo klasy.',
      student_warn: 'może potrzebować pomocy w',
      student_warn_detail: 'Ten uczeń może potrzebować trochę pomocy z nowymi zagadnieniami.',
      student_great: 'radzi sobie świetnie w',
      student_great_detail: 'Ten uczeń może być dobrym kandydatem do pomocy innym osobom z tego kursu.',
      full_license: 'Pełna licencja',
      starter_license: 'Licencja startowa',
      //    customized_license: "Customized License",
      //    hackstack_license: "AI HackStack License",
      //    hackstack_credits: "Credits: __limit__ prompts / __durationAmount__ __durationKey__(s)",
      //    coco_full_license: "CoCo License",
      //    ozar_full_license: "Ozaria License",
      trial: 'Demo',
      //    hoc_welcome: "Happy Computer Science Education Week",
      //    hoc_title: "Hour of Code Games - Free Activities to Learn Real Coding Languages",
      //    hoc_meta_description: "Make your own game or code your way out of a dungeon! CodeCombat has four different Hour of Code activities and over 60 levels to learn code, play, and create.",
      //    hoc_intro: "There are three ways for your class to participate in Hour of Code with CodeCombat",
      //    hoc_self_led: "Self-Led Gameplay",
      //    hoc_self_led_desc: "Students can play through our Hour of Code CodeCombat tutorials on their own",
      hoc_game_dev: 'Tworzenie gier',
      hoc_and: 'oraz',
      hoc_programming: 'Programowanie JavaScript/Python',
      hoc_teacher_led: 'Lekcje nauczycielskie',
      hoc_teacher_led_desc1: 'Pobierz nasze',
      //    hoc_teacher_led_link_coco: "Hour of Code lesson plans",
      //    hoc_teacher_led_link_ozar: "Introduction to Computer Science lesson plans",
      //    hoc_teacher_led_desc2: "to introduce your students to programming concepts using offline activities",
      hoc_group: 'Grupowa rozgrywka',
      //    hoc_group_desc_1: "Teachers can use the lessons in conjunction with our Introduction to Computer Science course to track student progress. See our",
      //    hoc_group_link: "Getting Started Guide",
      //    hoc_group_desc_2: "for more details",
      //    hoc_additional_desc1: "For additional CodeCombat resources and activities, see our",
      hoc_additional_desc2: 'Pytania',
      hoc_additional_contact: 'Bądź w kontakcie',
      //    regenerate_class_code_tooltip: "Generate a new Class Code",
      //    regenerate_class_code_confirm: "Are you sure you want to generate a new Class Code?",
      //    revoke_confirm: "Are you sure you want to revoke a Full License from {{student_name}}? The license will become available to assign to another student.",
      //    revoke_alert_no_student: "Please select students first.",
      //    revoke_selected_confirm: "Are you sure you want to revoke Licenses from all selected students?",
      //    revoke_all_confirm: "Are you sure you want to revoke Full Licenses from all students in this class?",
      revoking: 'Anulowanie...',
      //    unused_licenses: "You have unused Licenses that allow you to assign students paid courses when they're ready to learn more!",
      remember_new_courses: 'Pamiętaj o przypisaniu nowych kursów!',
      more_info: 'Więcej informacji',
      how_to_assign_courses: 'Jak przypisać kursy',
      select_students: 'Wybierz uczniów',
      //    select_instructions: "Click the checkbox next to each student you want to assign courses to.",
      choose_course: 'Wybierz kurs',
      //    choose_instructions: "Select the course from the dropdown menu you’d like to assign, then click “Assign to Selected Students.”",
      //    push_projects: "We recommend assigning Web Development 1 or Game Development 1 after students have finished Introduction to Computer Science! See our {{resource_hub}} for more details on those courses.",
      teacher_quest: 'Wyzwanie dla nauczyciela',
      quests_complete: 'Zadania ukonczone',
      teacher_quest_create_classroom: 'Stwórz klasę',
      teacher_quest_add_students: 'Dodaj uczniów',
      teacher_quest_teach_methods: 'Naucz uczniów jak wywoływać metody.',
      teacher_quest_teach_methods_step1: 'Niech przynajmniej 75% jednej klasy przejdzie pierwszy poziom, Dungeons of Kithgard',
      teacher_quest_teach_methods_step2: 'Wydrukuj [Krótki przewodnik ucznia](https://files.codecombat.com/docs/resources/StudentQuickStartGuide.pdf) z [Bazy wiedzy](/teachers/resources).',
      teacher_quest_teach_strings: 'Naucz uczniów jak budować `stringi`.',
      teacher_quest_teach_strings_step1: 'Niech przynajmniej 75% jednej klasy dotrze do True Names',
      teacher_quest_teach_strings_step2: 'Użyj przeglądarki poziomów w [Przewodnikach po kursach](/teachers/courses) i przeglądnij poziom True Names.',
      teacher_quest_teach_loops: 'Niech uczniowie się zapętlą. Naucz ich konstrukcji `loop`.',
      teacher_quest_teach_loops_step1: 'Niech przynajmniej 75% jednej klasy dotrze do Fire Dancing.',
      //    teacher_quest_teach_loops_step2: "Use the Loops Activity in the [CS1 Curriculum guide](/teachers/resources/cs1) to reinforce this concept.",
      teacher_quest_teach_variables: 'Zmień swoje życie ze `zmiennymi`.',
      teacher_quest_teach_variables_step1: 'Niech przynajmniej 75% jednej klasy dotrze do Known Enemy.',
      teacher_quest_teach_variables_step2: 'Wspieraj współpracę. Wypróbuj [Programowanie w parach](/teachers/resources/pair-programming).',
      teacher_quest_kithgard_gates_100: 'Ucieknijcie przez Bramy Kithgardu wraz ze swoja klasą.',
      teacher_quest_kithgard_gates_100_step1: 'Niech przynajmniej 75% jednej klasy dotrze do Kithgard Gates.',
      //    teacher_quest_kithgard_gates_100_step2: "Guide students to think through hard problems using the [Engineering Cycle Worksheet](https://files.codecombat.com/docs/resources/EngineeringCycleWorksheet.pdf).",
      teacher_quest_wakka_maul_100: 'Przygotujcie się na pojedynek w Wakka Maul.',
      teacher_quest_wakka_maul_100_step1: 'Niech przynajmniej 75% jednej klasy dotrze do Wakka Maul.',
      teacher_quest_wakka_maul_100_step2: 'Przeczytaj [Przewodnik po Arenie](/teachers/resources/arenas) w [Bazie wiedzy](/teachers/resources) aby dowiedzieć się jak prowadzić lekcje na Arenie.',
      teacher_quest_reach_gamedev: 'Zwiedzaj nowe światy!',
      teacher_quest_reach_gamedev_step1: '[Uzyskaj licencję](/teachers/licenses) aby Twoi uczniowie mogli zwiedzać nowe światy, jak Programowanie Gier lub Programowanie Www!',
      //    teacher_quest_done: "Want your students to learn even more code? Get in touch with our [school specialists](mailto:schools@codecombat.com) today!",
      teacher_quest_keep_going: 'Nie poddawaj się! Jako następne możesz zrobić:',
      teacher_quest_more: 'Pokaż wszystkie zadania',
      teacher_quest_less: 'Pokaż mniej zadań',
      refresh_to_update: '(odśwież stronę, żeby zobaczyć aktualizację)',
      //    view_project_gallery: "View Project Gallery",
      //    office_hours: "Teacher Webinars",
      //    office_hours_detail: "Learn how to keep up with with your students as they create games and embark on their coding journey! Come and attend our",
      //    office_hours_link: "teacher webinar",
      //    office_hours_detail_2: "sessions.",
      //    success: "Success",
      //    in_progress: "In Progress",
      //    not_started: "Not Started",
      //    mid_course: "Mid-Course",
      //    end_course: "End of Course",
      //    none: "None detected yet",
      //    explain_open_ended: "Note: Students are encouraged to solve this level creatively — one possible solution is provided below.",
      //    level_label: "Level:",
      //    time_played_label: "Time Spent:",
      //    practice_threshold_label: "Practice Threshold:",
      //    back_to_resource_hub: "Back to Teacher Toolkit",
      //    back_to_course_guides: "Back to Course Guides",
      //    print_guide: "Print this guide",
      //    combo: "Combo",
      //    combo_explanation: "Students pass Combo challenge levels by using at least one listed concept. Review student code by clicking the progress dot.",
      //    concept: "Concept",
      //    sync_google_classroom: "Sync Google Classroom",
      //    unit_overview: "Unit Overview",
      //    module_overview: "Module Overview",
      //    chapter1_unit_overview_desc: "Summary of student experience, including Cutscenes, Practice Levels, Intros, and the Capstone project in Chapter 1.",
      //    lesson_plan: "Lesson Plan",
      //    chapter1_lesson_plan_desc: "Detailed classroom guide including learning objectives, CSTA standards, reflection activities, facilitation tips, and more.",
      //    capstone_rubric: "Capstone Rubric",
      //    chapter1_capstone_rubric_desc: "Rubric for evaluating students' Capstone projects and reflection activities at the end of this unit.",
      //    chapter1: "Chapter 1: Up The Mountain",
      //    chapter2: "Chapter 2: The Moon Dancers",
      //    chapter3: "Chapter 3: The Phoenix Lands",
      //    module1: "Module 1: ",
      //    module2: "Module 2: ",
      //    module3: "Module 3: ",
      //    module4: "Module 4: ",
      //    module5: "Module 5: ",
      //    module6: "Module 6: ",
      //    module7: "Module 7: ",
      //    module8: "Module 8: ",
      //    algorithms_and_syntax: "Algorithms and Syntax",
      //    debugging: "Debugging",
      //    variables: "Variables",
      //    conditionals: "Conditionals",
      //    capstone_intro: "Capstone Intro",
      //    capstone_project: "Capstone Project",
      //    level_code: "Level Code",
      //    review_needed: "Review Needed",
      //    review_tooltip_heading: "What does this mean?",
      //    review_tooltip_text: "Red flags appear next to Concept Checks where your student(s) attempted to answer the question 3 or more times. In the <strong>Course Overview</strong> section, red flags appear next to Concept Checks if at least 50% of students who have started or completed the concept check attempted it 3 or more times.",
      //    scroll_to_see_more: "Scroll to see more",
      //    click_to_view_concept_check: "Click to view concept check",
      //    click_to_view_project_gallery: "Click to view project gallery",
      //    review_learning_goal: "Review \"Learning Goal: __learningGoal__\" with students.",
      //    view_capstone_project: "View Capstone Project",
      //    ozaria_dashboard_guide: "Teacher Dashboard Guide",
      //    dashboard_guide_desc: "Walkthrough of Ozaria Teacher Dashboard features that will help you view student progress and work.",
      //    review: "Review",
      //    for_loops: "For Loops",
      //    peer_feedback: "Peer Feedback Form",
      //    presentation_checklist: "Presentation Checklist",
      //    try_ozaria_footer: "Try our new adventure game, Ozaria!",
      //    try_ozaria_free: "Try Ozaria for free",
      //    ozaria_intro: "Introducing Our New Computer Science Program",
      //    share_class: "share class",
      //    permission: "Permission",
      //    not_write_permission: "You don't have write permission to the class",
      //    not_read_permission: "You don't have read permission to the class",
      //    owned_license: "Licensed",
      //    archive_revoke_confirm: " students of the archived class have active licenses. Would you like to revoke them so that you can re-apply them to other students?",
      //    archive_without_revoking: "Archive Without Revoking",
      //    revoke_and_archive: "Revoke and Archive",
      //    license_stats: "License Stats",
      //    redeemers: "Active Students",
      //    removed_redeemers: "Inactive Students",
      //    latest_podcast_episode: "Latest Podcast Episode",
      //    from_the_podcast: "From the Podcast",
      //    edit_student_access_title: "Edit Student Access to Levels",
      //    edit_student_access_title_scenarios: "Edit Student Access to Projects",
      //    edit_student_access_subtitle: "You have selected __levels__ levels for __students__ students.",
      //    edit_student_access_subtitle_scenarios: "You have selected __levels__ projects for __students__ students.",
      //    student_ask_for_help: "Your student __name__ asking for your help.",
      //    never_played: "Never Played",
      //    test_student_modal_header: "Creating Test Student",
      //    test_student_modal_p1: "You'll be creating a unique test account that mimics the student journey and saves your progress.",
      //    test_student_modal_no_class: "Please create a class to join as a student",
      //    test_student_modal_choose_class: "Choose a class to join:",
      //    test_student_modal_redirect: "You will be redirected to your test student account!",
      //    stop_spying_student: "You can return to the teacher account by clicking `Stop Spying` in the user dropdown",
      //    show_practice_levels: "Show Practice Levels",
      //    hide_practice_levels: "Hide Practice Levels",
      //    dashboard_deprecation_message: "This legacy dashboard will be discontinued soon. To ensure uninterrupted access to all features and the best teaching tools, please transition to our new and improved Teacher Dashboard.",
      //    INTRO_short: "Intro",
      //    ELA_short: "ELA",
      //    ALG_short: "ALG",
      //    CR1_short: "CR1",
      //    CR2_short: "CR2",
      //    AI1_short: "AI 1",
      //    AI2_short: "AI 2",
      //    CS_short: "CS",
      //    SANDBOX_short: "Sandbox",
      //    EXPLORATIONS_short: "Explorations",
      //    course_not_covered: "Course __course__ not covered",
      //    license_is: "The student license is: ",
    },

    //  teacher_licenses: {
    //    active_licenses: "Active Licenses",
    //    expired_licenses: "Expired Licenses",
    //  },

    //  teacher_ozaria_encouragement_modal: {
    //    title: "Build Computer Science Skills to Save Ozaria",
    //    sub_title: "You are invited to try the new adventure game from CodeCombat",
    //    cancel: "Back to CodeCombat",
    //    accept: "Try First Unit Free",
    //    bullet1: "Deepen student connection to learning through an epic story and immersive gameplay",
    //    bullet2: "Teach CS fundamentals, Python or JavaScript and 21st century skills",
    //    bullet3: "Unlock creativity through capstone projects",
    //    bullet4: "Support instructions through dedicated curriculum resources",
    //    you_can_return: "You can always return to CodeCombat",
    //  },

    //  educator_signup_ozaria_encouragement: {
    //    recommended_for: "Recommended for:",
    //    independent_learners: "Independent learners",
    //    homeschoolers: "Homeschoolers",
    //    educators_continue_coco: "Educators who want to continue using CodeCombat in their class",
    //    continue_coco: "Continue with CodeCombat",
    //  },

    //  ozaria_cta: {
    //    title1: "Standards Aligned Core Curriculum",
    //    description1: "Immersive, story based curriculum that meets all 6th-8th grade CSTA standards.",
    //    title2: "Turnkey Lesson Plans",
    //    description2: "In-depth presentations and worksheets for teachers to guide students through learning objectives.",
    //    title3: "New Teacher & Admin Dashboards",
    //    description3: "All the actionable insights educators need at a glance, such as student progress and concept understanding.",
    //  },

    //  share_licenses: {
    //    share_licenses: "Share Licenses",
    //    shared_by: "Shared By:",
    //    add_teacher_label: "Enter exact teacher email:",
    //    add_teacher_button: "Add Teacher",
    //    modal_subtitle: "You can make your licenses available to other teachers in a shared pool.",
    //    modal_list_item_1: "Each license can only be used for one student at a time.",
    //    modal_list_item_2: "When teachers revoke licenses from students, the licenses will be returned to the shared pool for other teachers in this group to use.",
    //    subheader: "You can make your licenses available to other teachers in your organization. Each license can only be used for one student at a time.",
    //    teacher_not_found: "Teacher not found. Please make sure this teacher has already created a Teacher Account.",
    //    teacher_not_valid: "This is not a valid Teacher Account. Only teacher accounts can share licenses.",
    //    already_shared: "You've already shared these licenses with that teacher.",
    //    have_not_shared: "You've not shared these licenses with that teacher.",
    //    teachers_using_these: "Teachers who can access these licenses:",
    //    footer: "When teachers revoke licenses from students, the licenses will be returned to the shared pool for other teachers in this group to use.",
    //    you: "(you)",
    //    one_license_used: "(1/__all__ license used)",
    //    licenses_used: "(__licensesUsed__/__all__ licenses used)",
    //    licenses_used_no_braces: "__licensesUsed__/__all__ licenses used",
    //    more_info: "More info",
    //    shared_pool_label: "Teachers in your shared pool:",
    //    teacher_delete_warning: "The shared licenses assigned to the teacher won't be revoked!",
    //    licenses_limit: "Licenses Limit:",
    //  },

    sharing: {
      game: 'Gra',
      webpage: 'Strona internetowa',
      your_students_preview: 'Twoi uczniowe po kliknięciu tutaj zobaczą swoje gotowe projektyt! Niedostępne w podglądzie nauczyciela.',
      unavailable: 'Dzielenie się linkami nie jest dostępne w podglądzie nauczyciela.',
      share_game: 'Podziel się tą grą',
      share_web: 'Podziel się tą stroną',
      victory_share_prefix: 'Za pomocą tego linku możesz zaprosić swoich znajomych i rodzinę do',
      //    victory_share_prefix_short: "Invite people to",
      victory_share_game: 'zagrania w twoją grę',
      victory_share_web: 'obejrzenia twojej strony',
      victory_share_suffix: '.',
      victory_course_share_prefix: 'Ten link pozwoli twoim znajomym i rodzinie',
      victory_course_share_game: 'zagrać w grę',
      victory_course_share_web: 'obejrzeć stronę',
      victory_course_share_suffix: 'którą właśnie stworzyłeś.',
      copy_url: 'Kopiuj URL',
      //    share_with_teacher_email: "Send to your teacher",
      //    share_ladder_link: "Share Multiplayer Link",
      //    ladder_link_title: "Share Your Multiplayer Match Link",
      //    ladder_link_blurb: "Share your AI battle link so your friends and family can play versus your code:",
    },

    game_dev: {
      creator: 'Twórca',
    },

    web_dev: {
      image_gallery_title: 'Galeria obrazów',
      select_an_image: 'Wybierz obraz, którego chcesz użyć',
      scroll_down_for_more_images: '(Przewiń w dół do więcej zdjęć)',
      copy_the_url: 'Skopiuj poniższy adres URL',
      copy_the_url_description: 'Przydatne, jeśli chcesz zastąpić istniejący obraz.',
      copy_the_img_tag: 'Kopiuj tag <img>',
      copy_the_img_tag_description: 'Przydatne, jeśli chcesz wstawić nowy obraz.',
      copy_url: 'Kopiuj URL',
      copy_img: 'Kopiuj <img>',
      how_to_copy_paste: 'Jak kopiować/wklejać',
      copy: 'Kopiuj',
      paste: 'Wklej',
      back_to_editing: 'Zwróć do redagowania',
    },

    classes: {
      archmage_title: 'Arcymag',
      archmage_title_description: '(programista)',
      archmage_summary: 'Jesteś programistą zainteresowanym tworzeniem gier edukacyjnych? Zostań Arcymagiem i pomóż nam ulepszyć CodeCombat!',
      artisan_title: 'Rzemieślnik',
      artisan_title_description: '(twórca poziomów)',
      artisan_summary: 'Buduj i dziel się poziomami z przyjaciółmi i innymi graczami. Zostań Rzemieślnikiem, który pomaga w uczeniu innych sztuki programowania.',
      adventurer_title: 'Podróżnik',
      adventurer_title_description: '(playtester)',
      adventurer_summary: 'Zagraj w nasze nowe poziomy (nawet te dla subskrybentów) za darmo przez ich wydaniem i pomóż nam znaleźć w nich błędy zanim zostaną opublikowane.',
      scribe_title: 'Skryba',
      scribe_title_description: '(twórca artykułów)',
      scribe_summary: 'Dobry kod wymaga dobrej dokumentacji. Pisz, edytuj i ulepszaj dokumentację czytana przez miliony graczy na całym świecie.',
      diplomat_title: 'Dyplomata',
      diplomat_title_description: '(tłumacz)',
      diplomat_summary: 'CodeCombat jest tłumaczone na ponad 45 języków. Dołącz do naszych Dyplomatów i pomóż im w dalszych pracach.',
      ambassador_title: 'Ambasador',
      ambassador_title_description: '(wsparcie)',
      ambassador_summary: 'Okiełznaj naszych użytkowników na forum, udzielaj odpowiedzi na pytania i wspieraj ich. Nasi Ambasadorzy reprezentują CodeCombat przed całym światem.',
      teacher_title: 'Nauczyciel',
    },

    editor: {
      main_title: 'Edytory CodeCombat',
      //    concept_title: "Concept Editor",
      //    standards_title: "Standards Correlation Editor",
      article_title: 'Edytor artykułów',
      thang_title: 'Edytor obiektów',
      level_title: 'Edytor poziomów',
      course_title: 'Edytor kursu',
      achievement_title: 'Edytor osiągnięć',
      //    resource_title: "Resource Editor",
      //    chat_title: "Chat Editor",
      //    ai_scenario_title: "AI Scenario Editor",
      //    ai_project_title: "AI Project Editor",
      //    ai_model_title: "AI Model Editor",
      //    ai_document_title: "AI Document Editor",
      //    ai_chat_message_title: "AI Chat Message Editor",
      //    ai_junior_scenario_title: "AI Junior Scenario Editor",
      //    ai_junior_project_title: "AI Junior Project Editor",
      //    resource_title_general: "__resource__ Editor",
      back: 'Wstecz',
      revert: 'Przywróć',
      revert_models: 'Przywróć wersję',
      pick_a_terrain: 'Wybierz teren',
      dungeon: 'Loch',
      indoor: 'Wnętrze',
      desert: 'Pustynia',
      grassy: 'Trawa',
      mountain: 'Góry',
      glacier: 'Lodowiec',
      small: 'Mały',
      large: 'Duży',
      fork_title: 'Forkuj nowa wersję',
      fork_creating: 'Tworzenie Forka...',
      generate_terrain: 'Generuj teren',
      //    generate_level: "Generate Level",
      //    generate_practice_level: "Generate Practice Level",
      //    generate_all_practice_levels: "Generate All Practice Levels",
      more: 'Więcej',
      wiki: 'Wiki',
      live_chat: 'Czat na żywo',
      thang_main: 'Główna',
      thang_spritesheets: "Arkusze Sprite'ów",
      thang_colors: 'Kolory',
      level_some_options: 'Trochę opcji?',
      level_tab_thangs: 'Obiekty',
      level_tab_scripts: 'Skrypty',
      level_tab_components: 'Komponenty',
      level_tab_systems: 'Systemy',
      level_tab_docs: 'Dokumentacja',
      level_tab_thangs_title: 'Aktualne obiekty',
      level_tab_thangs_all: 'Wszystkie',
      level_tab_thangs_conditions: 'Warunki początkowe',
      level_tab_thangs_add: 'Dodaj obiekty',
      level_tab_thangs_search: 'Przeszukaj obiekty',
      add_components: 'Dodaj komponenty',
      component_configs: 'Konfiguracja komponentów',
      config_thang: 'Kliknij dwukrotnie, aby skonfigurować obiekt',
      delete: 'Usuń',
      duplicate: 'Powiel',
      stop_duplicate: 'Przestań powielać',
      rotate: 'Obróć',
      level_component_tab_title: 'Aktualne komponenty',
      level_component_btn_new: 'Stwórz nowy komponent',
      level_systems_tab_title: 'Aktualne systemy',
      level_systems_btn_new: 'Stwórz nowy system',
      level_systems_btn_add: 'Dodaj system',
      level_components_title: 'Powrót do listy obiektów',
      level_components_type: 'Typ',
      //    concept_edit_title: "Edit Concept",
      //    standards_edit_title: "Edit Standards Correlation",
      level_component_edit_title: 'Edytuj komponent',
      level_component_config_schema: 'Schemat konfiguracji',
      level_system_edit_title: 'Edytuj system',
      //    course_edit_title: "Edit Course",
      //    resource_edit_title: "Edit Resource",
      //    resource_edit_title_general: "Edit __resource__",
      //    chat_edit_title: "Edit Chat",
      //    chat_edit_title_general: "Edit __chat__",
      //    ai_scenario_edit_title: "Edit Scenario",
      //    ai_scenario_edit_title_general: "Edit __scenario__",
      //    ai_project_edit_title: "Edit Project",
      //    ai_project_edit_title_general: "Edit __project__",
      //    ai_model_edit_title: "Edit Model",
      //    ai_document_edit_title: "Edit Document",
      //    ai_chat_message_edit_title: "Edit Chat Message",
      //    ai_junior_scenario_edit_title: "Edit Junior Scenario",
      //    ai_junior_scenario_edit_title_general: "Edit __scenario__",
      //    ai_junior_project_edit_title: "Edit Junior Project",
      //    ai_junior_project_edit_title_general: "Edit __project__",
      create_system_title: 'Stwórz nowy system',
      //    new_concept_title: "Create New Concept",
      //    new_standards_title: "Create New Standards Correlation",
      new_component_title: 'Stwórz nowy komponent',
      new_component_field_system: 'System',
      new_article_title: 'Stwórz nowy artykuł',
      new_thang_title: 'Stwórz nowy typ obiektu',
      new_level_title: 'Stwórz nowy poziom',
      new_article_title_login: 'Zaloguj się, aby stworzyć nowy artykuł',
      new_thang_title_login: 'Zaloguj się, aby stworzyć nowy typ obiektu',
      new_level_title_login: 'Zaloguj się, aby stworzyć nowy poziom',
      new_achievement_title: 'Stwórz nowe osiągnięcie',
      new_achievement_title_login: 'Zaloguj się, aby stworzyć nowy osiągnięcie',
      //    new_course_title: "Create a New Course",
      //    new_course_title_login: "Log In to Create a New Course",
      //    new_resource_title: "Create a New Resource",
      //    new_resource_title_login: "Log In to Create a New Resource",
      //    new_chat_title: "Create a New Chat",
      //    new_chat_title_login: "Log In to Create a New Chat",
      //    new_ai_scenario_title: "Create a New Scenario",
      //    new_ai_scenario_title_login: "Log In to Create a New Scenario",
      //    new_ai_project_title: "Create a New Project",
      //    new_ai_project_title_login: "Log In to Create a New Project",
      //    new_ai_model_title: "Create a New Model",
      //    new_ai_model_title_login: "Log In to Create a New Model",
      //    new_ai_document_title: "Create a New Document",
      //    new_ai_document_title_login: "Log In to Create a New Document",
      //    new_ai_chat_message_title: "Create a New Chat Message",
      //    new_ai_chat_message_title_login: "Log In to Create a New Chat Message",
      //    new_ai_junior_scenario_title: "Create a New Junior Scenario",
      //    new_ai_junior_scenario_title_login: "Log In to Create a New Junior Scenario",
      //    new_ai_junior_project_title: "Create a New Junior Project",
      //    new_ai_junior_project_title_login: "Log In to Create a New Junior Project",
      article_search_title: 'Przeszukaj artykuły',
      //    concept_search_title: "Search Concepts Here",
      //    standards_search_title: "Search Standards Correlations Here",
      thang_search_title: 'Przeszukaj obiekty',
      level_search_title: 'Przeszukaj poziomy',
      achievement_search_title: 'Szukaj osiągnięcia',
      //    course_search_title: "Search Courses",
      //    resource_search_title: "Search Resources",
      //    chat_search_title: "Search Chats",
      //    ai_scenario_search_title: "Search Scenarios",
      //    ai_project_search_title: "Search Projects",
      //    ai_model_search_title: "Search Models",
      //    ai_document_search_title: "Search Documents",
      //    ai_chat_message_search_title: "Search Chat Messages",
      //    ai_junior_scenario_search_title: "Search Junior Scenarios",
      //    ai_junior_project_search_title: "Search Junior Projects",
      read_only_warning2: 'Uwaga: nie możesz zapisać żadnych zmian, ponieważ nie jesteś zalogowany.',
      no_achievements: 'Dla tego poziomu nie ma żadnych osiągnięć.',
      //    achievement_query_misc: "Key achievement off of miscellanea",
      //    achievement_query_goals: "Key achievement off of level goals",
      level_completion: 'Ukończenie poziomu',
      pop_i18n: 'Uzupełnij I18N',
      //    ai_translate: "AI Translate",
      tasks: 'Zadania',
      clear_storage: 'Usuń swoje lokalne zmiany',
      add_system_title: 'Dodaj systemy do poziomu',
      done_adding: 'Zakończono dodawanie',
      //    product: "Product",
      //    link: "Link",
      //    clone_to_new_scenario: "Clone to New Scenario",
      //    translate_warning_content: "Make sure the doc already Populate the i18n and Saved.",
      //    translate_pick_langs: "Pick the Languages you want to transalte.",
      //    translate_it: "Translate it!",
      //    translating: "Translating...",
    },

    article: {
      edit_btn_preview: 'Podgląd',
      edit_article_title: 'Edytuj artykuł',
    },

    polls: {
      priority: 'Priorytet',
    },

    contribute: {
      page_title: 'Współpraca',
      intro_blurb: 'CodeCombat ma w pełni otwarte źródła! Setki graczy pomogły stworzyć obecny wygląd gry. Dołącz do nas i napisz kolejny rozdział w zadaniu CodeCombat, którym jest nauczenie wszystkich programowania!',
      alert_account_message_intro: 'Hej tam!',
      alert_account_message: 'Musisz się najpierw zalogować, jeśli chcesz zapisać się na klasowe e-maile.',
      archmage_introduction: 'Jedną z najlepszych rzeczy w tworzeniu gier jest to, że syntetyzują one tak wiele różnych spraw. Grafika, dźwięk, łączność w czasie rzeczywistym, social networking i oczywiście wiele innych, bardziej popularnych, aspektów programowania, od niskopoziomowego zarządzania bazami danych i administracji serwerem do interfejsu użytkownika i jego tworzenia. Jest wiele do zrobienia i jeśli jesteś doświadczonym programistą z zacięciem, by zajrzeć do sedna CodeCombat, ta klasa może być dla ciebie. Bylibyśmy niezmiernie szczęśliwi mając twoją pomoc przy budowaniu najlepszej programistycznej gry wszech czasów.',
      class_attributes: 'Atrybuty klasowe',
      archmage_attribute_1_pref: 'Znajomość ',
      archmage_attribute_1_suf: ' lub chęć do nauki. Większość naszego kodu napisana jest w tym języku. Jeśli jesteś fanem Ruby czy Pythona, poczujesz się jak w domu. To po prostu JavaScript, tyle że z przyjemniejszą składnią.',
      archmage_attribute_2: 'Pewne doświadczenie w programowaniu i własna inicjatywa. Pomożemy ci się połapać, ale nie możemy spędzić zbyt dużo czasu na szkoleniu cię.',
      how_to_join: 'Jak dołączyć',
      join_desc_1: 'Każdy może pomóc! Zerknij po prostu na nasz ',
      join_desc_2: ', aby rozpocząć i zaznacz kratkę poniżej, aby określić sie jako mężny Arcymag oraz otrzymywać najświeższe wiadomości przez e-mail. Chcesz porozmawiać na temat tego, co robić lub w jaki sposób dołączyć do współpracy jeszcze wyraźniej? ',
      join_desc_3: ' lub zajrzyj do naszego ',
      join_desc_4: ', a dowiesz się wszystkiego!',
      join_url_email: 'Napisz do nas',
      join_url_slack: 'publiczny kanał Slack',
      archmage_subscribe_desc: 'Otrzymuj e-maile dotyczące nowych okazji programistycznych oraz ogłoszeń.',
      artisan_introduction_pref: 'Musimy stworzyć dodatkowe poziomy! Ludzie będą oczekiwać nowych zasobów, a my mamy ograniczone możliwości co do naszych mocy przerobowych. Obecnie, twoja stacja robocza jest na poziomie pierwszym; nasz edytor poziomów jest ledwo używalny nawet przez jego twórców - bądź tego świadom. Jeśli masz wizję nowych kampanii, od pętli typu for do',
      artisan_introduction_suf: ', ta klasa może być dla ciebie.',
      artisan_attribute_1: 'Jakiekolwiek doświadczenie w tworzeniu zasobów tego typu byłoby przydatne, na przykład używając edytora poziomów dostarczonego przez Blizzard. Nie jest to jednak wymagane.',
      artisan_attribute_2: 'Zacięcie do całej masy testowania i iteracji. Aby tworzyć dobre poziomy, musisz dostarczyć je innym i obserwować jak grają oraz być przygotowanym na wprowadzanie mnóstwa poprawek.',
      artisan_attribute_3: 'Na dzień dzisiejszy, cierpliwość wraz z naszym Podróżnikiem. Nasz Edytor Poziomów jest jest strasznie prymitywny i frustrujący w użyciu. Zostałeś ostrzeżony!',
      artisan_join_desc: 'Używaj Edytora Poziomów mniej-więcej zgodnie z poniższymi krokami:',
      artisan_join_step1: 'Przeczytaj dokumentację.',
      artisan_join_step2: 'Stwórz nowy poziom i przejrzyj istniejące poziomy.',
      artisan_join_step3: 'Zajrzyj do naszego publicznego pokoju Slack, aby uzyskać pomoc.',
      artisan_join_step4: 'Pokaż swoje poziomy na forum, aby uzyskać opinie.',
      artisan_subscribe_desc: 'Otrzymuj e-maile dotyczące aktualności w tworzeniu poziomów i ogłoszeń.',
      adventurer_introduction: 'Bądźmy szczerzy co do twojej roli: jesteś tankiem. Będziesz przyjmował ciężkie obrażenia. Potrzebujemy ludzi do testowania nowych poziomów i pomocy w rozpoznawaniu ulepszeń, które będzie można do nich zastosować. Będzie to bolesny proces; tworzenie dobrych gier to długi proces i nikt nie trafia w dziesiątkę za pierwszym razem. Jeśli jesteś wytrzymały i masz wysoki wskaźnik constitution (D&D), ta klasa jest dla ciebie.',
      adventurer_attribute_1: 'Głód wiedzy. Chcesz nauczyć się programować, a my chcemy ci to umożliwić. Prawdopodobnie w tym przypadku, to ty będziesz jednak przez wiele czasu stroną uczącą.',
      adventurer_attribute_2: 'Charyzma. Bądź uprzejmy, ale wyraźnie określaj, co wymaga poprawy, oferując sugestie co do sposobu jej uzyskania.',
      adventurer_join_pref: 'Zapoznaj się z Rzemieślnikiem (lub rekrutuj go!), aby wspólnie pracować lub też zaznacz kratkę poniżej, aby otrzymywać e-maile, kiedy pojawią się nowe poziomy do testowania. Będziemy również pisać o poziomach do sprawdzenia na naszych stronach w sieciach społecznościowych jak',
      adventurer_forum_url: 'nasze forum',
      adventurer_join_suf: 'więc jeśli wolałbyś być informowany w ten sposób, zarejestruj się na nich!',
      adventurer_subscribe_desc: 'Otrzymuj e-maile, gdy pojawią się nowe poziomy do testowania.',
      scribe_introduction_pref: 'CodeCombat nie będzie tylko zbieraniną poziomów. Będzie też zawierać źródło wiedzy, wiki programistycznych idei, na której będzie można oprzeć poziomy. Dzięki temu, każdy z Rzemieślników zamiast opisywać ze szczegółami, czym jest operator porównania, będzie mógł po prostu podać graczowi w swoim poziomie link do artykułu opisującego go. Mamy na myśli coś podobnego do ',
      scribe_introduction_url_mozilla: 'Mozilla Developer Network',
      scribe_introduction_suf: '. Jeśli twoją definicją zabawy jest artykułowanie idei programistycznych przy pomocy składni Markdown, ta klasa może być dla ciebie.',
      scribe_attribute_1: 'Umiejętne posługiwanie się słowem to właściwie wszystko, czego potrzebujesz. Nie tylko gramatyka i ortografia, ale również umiejętność tłumaczenia trudnego materiału innym.',
      contact_us_url: 'Skontaktuj się z nami',
      scribe_join_description: 'powiedz nam coś o sobie, swoim doświadczeniu w programowaniu i rzeczach, o których chciałbyś pisać, a chętnie to z tobą uzgodnimy!',
      scribe_subscribe_desc: 'Otrzymuj e-maile na temat ogłoszeń dotyczących pisania artykułów.',
      diplomat_introduction_pref: 'Jeśli dowiedzieliśmy jednej rzeczy z naszego ',
      //    diplomat_introduction_url: "open source community",
      diplomat_introduction_suf: ', to jest nią informacja o znacznym zainteresowaniu CodeCombat w innych krajach. Tworzymy zespół tłumaczy chętnych do przemieniania zestawów słów w inne zestawy słów, aby CodeCombat było tak dostępne dla całego świata, jak to tylko możliwe. Jeśli chciałbyś mieć wgląd w nadchodzącą zawartość i umożliwić swoim krajanom granie w najnowsze poziomy, ta klasa może być dla ciebie.',
      diplomat_attribute_1: 'Biegła znajomość angielskiego oraz języka, na który chciałbyś tłumaczyć. Kiedy przekazujesz skomplikowane idee, dobrze mieć płynność w obu z nich!',
      diplomat_i18n_page_prefix: 'Możesz zacząć tłumaczyć nasze poziomy przechodząc na naszą',
      diplomat_i18n_page: 'stronę tłumaczeń',
      diplomat_i18n_page_suffix: ', albo nasz interfejs i stronę na GitHub.',
      diplomat_join_pref_github: 'Znajdź plik lokalizacyjny dla wybranego języka ',
      diplomat_github_url: 'na GitHubie',
      diplomat_join_suf_github: ', edytuj go online i wyślij pull request. Do tego, zaznacz kratkę poniżej, aby być na bieżąco z naszym międzynarodowym rozwojem!',
      diplomat_subscribe_desc: 'Otrzymuj e-maile na temat postępów i18n i poziomów do tłumaczenia.',
      ambassador_introduction: 'Oto społeczność, którą budujemy, a ty jesteś jej łącznikiem. Mamy czaty, e-maile i strony w sieciach społecznościowych oraz wielu ludzi potrzebujących pomocy w zapoznaniu się z grą oraz uczeniu się za jej pomocą. Jeśli chcesz pomóc ludziom, by do nas dołączyli i dobrze się bawili oraz mieć pełne poczucie tętna CodeCombat oraz kierunku, w którym zmierzamy, ta klasa może być dla ciebie.',
      ambassador_attribute_1: 'Umiejętność komunikacji. Musisz umieć rozpoznać problemy, które mają gracze i pomóc im je rozwiązać. Do tego, informuj resztę z nas, co mówią gracze - na co się skarżą, a czego chcą jeszcze więcej!',
      ambassador_join_desc: 'powiedz nam coś o sobie, jakie masz doświadczenie i czym byłbyś zainteresowany. Chętnie z tobą porozmawiamy!',
      //    ambassador_join_step1: "Read the documentation.",
      //    ambassador_join_step2: "Find us in our public Slack channel.",
      //    ambassador_join_step3: "Help others in the Ambassador category.",
      ambassador_subscribe_desc: 'Otrzymuj e-maile dotyczące aktualizacji wsparcia oraz rozwoju trybu multiplayer.',
      teacher_subscribe_desc: 'Otrzymuj e-maile dotyczące aktualizacji wsparcia oraz rozwoju wersji dla nauczycieli.',
      changes_auto_save: 'Zmiany zapisują się automatycznie po kliknięci kratki.',
      diligent_scribes: 'Nasi pilni Skrybowie:',
      powerful_archmages: 'Nasi potężni Arcymagowie:',
      creative_artisans: 'Nasi kreatywni Rzemieślnicy:',
      brave_adventurers: 'Nasi dzielni Podróżnicy:',
      translating_diplomats: 'Nasi tłumaczący Dyplomaci:',
      helpful_ambassadors: 'Nasi pomocni Ambasadorzy:',
    },

    ladder: {
      //    title: "Multiplayer Arenas",
      //    arena_title: "__arena__ | Multiplayer Arenas",
      my_matches: 'Moje pojedynki',
      simulate: 'Symuluj',
      simulation_explanation: 'Symulując gry możesz szybciej uzyskać ocenę swojej gry!',
      simulation_explanation_leagues: 'Głównie będziesz pomagał symulować gry dla sojuszniczych graczy w swojej klasie, bądź kursie.',
      simulate_games: 'Symuluj gry!',
      games_simulated_by: 'Gry symulowane przez Ciebie:',
      games_simulated_for: 'Gry symulowane dla Ciebie:',
      games_in_queue: 'Gier obecnie w kolejce:',
      games_simulated: 'Gier zasymulowanych',
      games_played: 'Gier rozegranych',
      ratio: 'Proporcje',
      leaderboard: 'Tabela rankingowa',
      battle_as: 'Walcz jako ',
      summary_your: 'Twój ',
      summary_matches: 'Pojedynki - ',
      summary_wins: ' Wygrane, ',
      summary_losses: ' Przegrane',
      rank_no_code: 'Brak nowego kodu do oceny',
      rank_my_game: 'Oceń moją grę!',
      rank_submitting: 'Wysyłanie...',
      rank_submitted: 'Wysłano do oceny',
      rank_failed: 'Błąd oceniania',
      rank_being_ranked: 'Aktualnie oceniane gry',
      rank_last_submitted: 'przesłano ',
      help_simulate: 'Pomóc w symulowaniu gier?',
      code_being_simulated: 'Twój nowy kod jest aktualnie symulowany przez innych graczy w celu oceny. W miarę pojawiania sie nowych pojedynków, nastąpi odświeżenie.',
      no_ranked_matches_pre: 'Brak ocenionych pojedynków dla drużyny ',
      no_ranked_matches_post: ' ! Zagraj przeciwko kilku oponentom i wróć tutaj, aby uzyskać ocenę gry.',
      choose_opponent: 'Wybierz przeciwnika',
      select_your_language: 'Wybierz swój język!',
      tutorial_play: 'Rozegraj samouczek',
      tutorial_recommended: 'Zalecane, jeśli wcześniej nie grałeś',
      tutorial_skip: 'Pomiń samouczek',
      tutorial_not_sure: 'Nie wiesz, co się dzieje?',
      tutorial_play_first: 'Rozegraj najpierw samouczek.',
      simple_ai: 'Proste AI',
      warmup: 'Rozgrzewka',
      friends_playing: 'Przyjaciele w grze',
      log_in_for_friends: 'Zaloguj się by grać ze swoimi znajomymi!',
      social_connect_blurb: 'Połącz konta i rywalizuj z przyjaciółmi!',
      invite_friends_to_battle: 'Zaproś przyjaciół do wspólnej walki!',
      fight: 'Walcz!',
      watch_victory: 'Obejrzyj swoje zwycięstwo',
      defeat_the: 'Pokonaj',
      watch_battle: 'Oglądaj starcie',
      //    tournament_starts: "Tournament starts __timeElapsed__",
      tournament_started: ', rozpoczęto',
      tournament_ends: 'Turniej kończy się za',
      tournament_ended: 'Turniej zakończył się',
      //    tournament_results_published: ", results published __timeLeft__",
      //    tournament_results_wait_publish: ", results will be published by owner",
      tournament_rules: 'Zasady turnieju',
      tournament_blurb: 'Pisz kod, zbieraj złoto, buduj armię, miażdż przeciników, wygrywaj nagrody, oraz aktualizuj postęp w naszym Chciwym turnieju o $40,000! Sprawdź więcej informacji na',
      //    tournament_blurb_criss_cross: "Win bids, construct paths, outwit opponents, grab gems, and upgrade your career in our Criss-Cross tournament! Check out the details",
      //    tournament_blurb_zero_sum: "Unleash your coding creativity in both gold gathering and battle tactics in this alpine mirror match between red sorcerer and blue sorcerer. The tournament began on Friday, March 27 and will run until Monday, April 6 at 5PM PDT. Compete for fun and glory! Check out the details",
      //    tournament_blurb_ace_of_coders: "Battle it out in the frozen glacier in this domination-style mirror match! The tournament began on Wednesday, September 16 and will run until Wednesday, October 14 at 5PM PDT. Check out the details",
      tournament_blurb_blog: 'naszym blogu',
      rules: 'Zasady',
      winners: 'Zwycięzcy',
      league: 'Liga',
      red_ai: 'Czerwony CPU',
      blue_ai: 'Niebieski CPU',
      wins: 'Wygrał!',
      //    losses: "Losses",
      //    win_num: "Wins",
      //    loss_num: "Losses",
      //    win_rate: "Win %",
      humans: 'Czerwoni',
      ogres: 'Niebiescy',
      //    live_tournament: "Live Tournament",
      //    awaiting_tournament_title: "Tournament Inactive",
      //    awaiting_tournament_blurb: "The tournament arena is not currently active.",
      //    tournament_end_desc: "The tournament is over, thanks for playing",
      //    age: "Age",
      //    age_bracket: "Age Bracket",
      //    bracket_0_11: "0-11",
      //    bracket_11_14: "11-14",
      //    bracket_14_18: "14-18",
      //    bracket_11_18: "11-18",
      //    bracket_open: "Open",
      //    create_tournament: "Create a Tournament",
      //    difficulty_beginner: "Beginner",
      //    difficulty_intermediate: "Intermediate",
      //    difficulty_advanced: "Advanced",
      //    ai_league_ends: "Global AI League ends at __time__",
    },

    user: {
      //    user_title: "__name__ - Learn to Code with CodeCombat",
      stats: 'Statystyki',
      singleplayer_title: 'Poziomy jednoosobowe',
      multiplayer_title: 'Poziomy multiplayer',
      achievements_title: 'Osiągnięcia',
      last_played: 'Ostatnio grany',
      status: 'Status',
      status_completed: 'Ukończono',
      status_unfinished: 'Nie ukończono',
      no_singleplayer: 'Nie rozegrałeś żadnej gry jednoosobowej.',
      no_multiplayer: 'Nie rozegrałeś żadnej gry multiplayer.',
      no_achievements: 'Nie zdobyłeś żadnych osiągnięć.',
      favorite_prefix: 'Ulubiony język to ',
      favorite_postfix: '.',
      not_member_of_clans: 'Nie jesteś członkiem żadnego klanu.',
      //    certificate_view: "view certificate",
      //    certificate_click_to_view: "click to view certificate",
      //    certificate_course_incomplete: "course incomplete",
      //    certificate_of_completion: "Certificate of Completion",
      //    certificate_endorsed_by: "Endorsed by",
      //    certificate_stats: "Course Stats",
      //    certificate_lines_of: "lines of",
      //    certificate_levels_completed: "levels completed",
      //    certificate_for: "For",
      //    for_ozaria_chapters_1_4: "For Ozaria Chapters 1 - 4",
      //    certificate_number: "No.",
      //    heroes_unlocked: "Heroes Unlocked",
      //    current_items: "Items Equipped",
      //    contributor_badges: "Contributor Badges",
      //    contributions_title: "Contributions",
      //    type_stat: "Type",
      //    patches_submit: "Patches Submitted",
      //    patches_approved: "Patches Approved",
      //    patches_accepted: "Patches Accepted",
      //    level_edits: "Level Edits",
      //    total_translations: "Total Translations",
      //    campaign_stats: "Stats",
    },

    achievements: {
      last_earned: 'Ostatnio zdobyty',
      amount_achieved: 'Ilość',
      achievement: 'Osiągnięcie',
      current_xp_prefix: '',
      current_xp_postfix: ' z możliwych',
      new_xp_prefix: 'zdobyto ',
      new_xp_postfix: ' earned',
      left_xp_prefix: '',
      left_xp_rank_infix: '[AI_TRANSLATION] brakuje do rangi ',
      left_xp_postfix: '',
    },

    account: {
      //    title: "Account",
      //    settings_title: "Account Settings",
      //    unsubscribe_title: "Unsubscribe",
      //    payments_title: "Payments",
      //    subscription_title: "Subscription",
      //    invoices_title: "Invoices",
      //    prepaids_title: "Prepaids",
      payments: 'Płatności',
      prepaid_codes: 'Kody przedpłacone',
      purchased: 'Zakupiono',
      //    subscribe_for_gems: "Subscribe for gems",
      subscription: 'Subskrypcje',
      invoices: 'Faktury',
      service_apple: 'Apple',
      service_web: 'Internet',
      paid_on: 'Opłacono',
      service: 'Usługa',
      price: 'Cena',
      gems: 'Klejnoty',
      active: 'Aktywna',
      subscribed: 'Subskrybujesz',
      unsubscribed: 'Anulowano',
      active_until: 'Aktywna do',
      cost: 'Koszt',
      next_payment: 'Następna płatność',
      card: 'Karta',
      status_unsubscribed_active: 'Nie posiadasz już subskrypcji i nie obciążymy cię nowym rachunkiem. Twój profil wciąż jest aktywny.',
      status_unsubscribed: 'Zdobądź dostęp do nowych poziomów, bohaterów, przedmiotów i dodatkowych klejnotów z subskrypcją CodeCombat!',
      not_yet_verified: 'Jeszcze nie potwierdzony.',
      resend_email: 'Wyślij ponownie',
      email_sent: 'Email wysłany! sprawdź swoją skrzynkę.',
      verifying_email: 'Potwierdzanie twojego adresu email...',
      successfully_verified: 'Twój email został potwierdzony!',
      verify_error: 'Coś poszło nie tak podczas weryfikacji twojego adresu email :(',
      //    unsubscribe_from_marketing: "Unsubscribe __email__ from all CodeCombat marketing emails?",
      //    unsubscribe_button: "Yes, unsubscribe",
      //    unsubscribe_failed: "Failed",
      //    unsubscribe_success: "Success",
      //    manage_billing: "Manage Payments",
      //    payments_history: "Payments History",
      //    no_payments_found: "No payments found",
      //    create_a_free_account: "Create a Free Account",
      //    individual_inspiration: "Your new favorite game also happens to teach you real code",
      //    parent_inspiration: "Safe, teacher-backed coding games that build real skills",
      //    individual_completion: "Check your email to dive in! Open the link on your computer for the best way to learn and play while you code.",
      //    parent_completion: "Check your email to get started! For the best results, open the link on a computer so your child can learn and play in the best coding environment.",
      //    all_set: "You're all set!",
      //    date_of_birth: "Date of Birth",
      //    unlock_next_level_with_sign_up: "Create a free account to save your progress and continue your coding journey.",
    },

    account_invoices: {
      amount: 'Kwota w dolarach',
      declined: 'Karta została odrzucona',
      invalid_amount: 'Proszę podać kwotę w dolarach.',
      not_logged_in: 'Zaloguj się, albo stwórz konto, żeby przejrzeć faktury.',
      pay: 'Opłać fakturę',
      purchasing: 'Kupowanie...',
      retrying: 'Błąd serwera, ponawiam.',
      success: 'Zapłacono. Dziękujemy!',
    },

    account_prepaid: {
      purchase_code: 'Kup kod subskrypcji',
      //    purchase_code1: "Subscription Codes can be redeemed to add premium subscription time to one or more accounts for the Home version of CodeCombat.",
      purchase_code2: 'Każde konto w CodeCombat może wykorzysatć konkretny kod subskrypcji tylko raz.',
      //    purchase_code3: "Subscription Code months will be added to the end of any existing subscription on the account.",
      //    purchase_code4: "Subscription Codes are for accounts playing the Home version of CodeCombat, they cannot be used in place of Student Licenses for the Classroom version.",
      purchase_code5: 'Po więcej informacji o licencjach studentów zajrzyj do',
      users: 'Użytkownicy',
      months: 'Miesięcy',
      purchase_total: 'Razem',
      purchase_button: 'Zapisz zakupy',
      your_codes: 'Twoje kody',
      redeem_codes: 'Zamów kod subskrypcji',
      prepaid_code: 'Kod przedpłacony',
      lookup_code: 'Sprawdź kod przedpłacony',
      apply_account: 'Użyj na swoim koncie',
      copy_link: 'Możesz skopiować link do kodu i dać go komuś.',
      quantity: 'Ilość',
      redeemed: 'Zamówione',
      no_codes: 'Brak kodów!',
      you_can1: 'Możesz',
      you_can2: 'kupić kod przedpłacony,',
      you_can3: 'następnie wykorzystać go u siebie, albo dać komuś.',
      //    prepaid_add_months: "This prepaid code adds <strong>__months__ months of subscription</strong> to your account.",
      //    can_use_times: "It can be used <strong>__unlocksLeft__ more</strong> times.",
      //    prepaid_applied_success: "Prepaid applied to your account!",
      //    activation_code_used: "The Activation code has been used.",
      //    redeem_code_error: "Error: Could not redeem prepaid code. ",
    },

    //  ozaria_chrome: {
    //    sound_off: "Mute",
    //    sound_on: "Unmute",
    //    back_to_map: "Back to Map",
    //    level_options: "Level Options",
    //    restart_level: "Restart Level",
    //    max_browser: "Maximize Browser",
    //    ai_hint: "AI Hint",
    //  },

    //  impact: {
    //    hero_heading: "Building A World-Class Computer Science Program",
    //    hero_subheading: "We Help Empower Educators and Inspire Students Across the Country",
    //    featured_partner_story: "Featured Partner Story",
    //    partner_heading: "Successfully Teaching Coding at a Title I School",
    //    partner_school: "Bobby Duke Middle School",
    //    featured_teacher: "Scott Baily",
    //    teacher_title: "Technology Teacher Coachella, CA",
    //    implementation: "Implementation",
    //    grades_taught: "Grades Taught",
    //    length_use: "Length of Use",
    //    length_use_time: "3 years",
    //    students_enrolled: "Students Enrolled this Year",
    //    students_enrolled_number: "130",
    //    courses_covered: "Courses Covered",
    //    course1: "CompSci 1",
    //    course2: "CompSci 2",
    //    course3: "CompSci 3",
    //    course4: "CompSci 4",
    //    course5: "GameDev 1",
    //    fav_features: "Favorite Features",
    //    responsive_support: "Responsive Support",
    //    immediate_engagement: "Immediate Engagement",
    //    paragraph1: "Bobby Duke Middle School sits nestled between the Southern California mountains of Coachella Valley to the west and east and the Salton Sea 33 miles south, and boasts a student population of 697 students within Coachella Valley Unified’s district-wide population of 18,861 students.",
    //    paragraph2: "The students of Bobby Duke Middle School reflect the socioeconomic challenges facing Coachella Valley’s residents and students within the district. With over 95% of the Bobby Duke Middle School student population qualifying for free and reduced-price meals and over 40% classified as English language learners, the importance of teaching 21st century skills was the top priority of Bobby Duke Middle School Technology teacher, Scott Baily.",
    //    paragraph3: "Baily knew that teaching his students coding was a key pathway to opportunity in a job landscape that increasingly prioritizes and necessitates computing skills. So, he decided to take on the exciting challenge of creating and teaching the only coding class in the school and finding a solution that was affordable, responsive to feedback, and engaging to students of all learning abilities and backgrounds.",
    //    teacher_quote: "When I got my hands on CodeCombat [and] started having my students use it, the light bulb went on. It was just night and day from every other program that we had used. They’re not even close.",
    //    quote_attribution: "Scott Baily, Technology Teacher",
    //    read_full_story: "Read Full Story",
    //    more_stories: "More Partner Stories",
    //    partners_heading_1: "Supporting Multiple CS Pathways in One Class",
    //    partners_school_1: "Preston High School",
    //    partners_heading_2: "Excelling on the AP Exam",
    //    partners_school_2: "River Ridge High School",
    //    partners_heading_3: "Teaching Computer Science Without Prior Experience",
    //    partners_school_3: "Riverdale High School",
    //    download_study: "Download Research Study",
    //    teacher_spotlight: "Teacher & Student Spotlights",
    //    teacher_name_1: "Amanda Henry",
    //    teacher_title_1: "Rehabilitation Instructor",
    //    teacher_location_1: "Morehead, Kentucky",
    //    spotlight_1: "Through her compassion and drive to help those who need second chances, Amanda Henry helped change the lives of students who need positive role models. With no previous computer science experience, Henry led her students to coding success in a regional coding competition.",
    //    teacher_name_2: "Kaila, Student",
    //    teacher_title_2: "Maysville Community & Technical College",
    //    teacher_location_2: "Lexington, Kentucky",
    //    spotlight_2: "Kaila was a student who never thought she would be writing lines of code, let alone enrolled in college with a pathway to a bright future.",
    //    teacher_name_3: "Susan Jones-Szabo",
    //    teacher_title_3: "Teacher Librarian",
    //    teacher_school_3: "Ruby Bridges Elementary",
    //    teacher_location_3: "Alameda, CA",
    //    spotlight_3: "Susan Jones-Szabo promotes an equitable atmosphere in her class where everyone can find success in their own way. Mistakes and struggles are welcomed because everyone learns from a challenge, even the teacher.",
    //    continue_reading_blog: "Continue Reading on Blog...",
    //    ozaria_impact_title: "Positive Impacts with Ozaria",
    //    ozaria_impact_blurb: "CodeCombat's sister curriculum, Ozaria, has proven to have a positive impact on the student learning outcomes that matter most to both students and educators.",
    //    ozaria_impact_learn_more: "Learn more about Ozaria's curriculum efficacy here.",
    //  },

    loading_error: {
      could_not_load: 'Błąd podczas ładowania danych z serwera',
      connection_failure: 'Błąd połączenia.',
      connection_failure_desc: 'Wygląda na to, że masz jakieś problemy z internetem! Sprawdź, czy wszystko działa i odśwież stronę.',
      login_required: 'Musisz się zalogować',
      login_required_desc: 'Musisz się zalogować, aby zobaczyć tą stronę.',
      unauthorized: 'Musisz być zalogowany. Nie masz czasem wyłączonych ciasteczek?',
      forbidden: 'Brak autoryzacji.',
      forbidden_desc: 'O nie, nie możemy ci nic pokazać! Upewnij się, że zalogowałeś się na dobre konto, albo odwiedź któryś z linków, aby wrócić do programowania!',
      //    user_not_found: "User Not Found",
      not_found: 'Nie znaleziono.',
      //    resource_not_found: "404 __resource__ Not Found",
      not_found_desc: 'Hmmm... Nie udało się nam nic znaleźć. Odwiedź któryś z linków, aby wrócić do programowania!',
      not_allowed: 'Metoda nie dozwolona.',
      timeout: 'Serwer nie odpowiada.',
      conflict: 'Błąd zasobów.',
      bad_input: 'Złe dane wejściowe.',
      server_error: 'Błąd serwera.',
      unknown: 'Nieznany błąd.',
      error: 'BŁĄD',
      general_desc: 'Coś poszło nie tak, prawdopodobnie to nasza wina. Poczekaj chwilę i spróbuj odświeżyć stronę, albo kliknij któryś z linków, żeby wrócić do programowania!',
      //    too_many_login_failures: "There have been too many unsuccessful login attempts.  Please try again later.",
      //    something_went_wrong: "Oops! Something went wrong",
      //    back_to_dashboard: "Back to Dashboard",
    },

    resources: {
      level: 'Poziom',
      patch: 'Łatka',
      patches: 'Łatki',
      system: 'System',
      systems: 'Systemy',
      component: 'Komponent',
      components: 'Komponenty',
      hero: 'Bohater',
      campaigns: 'Kampanie',
    },

    concepts: {
      advanced_css: 'Zaawansowany CSS',
      advanced_css_rules: 'Zaawansowane reguły CSS',
      advanced_css_selectors: 'Zaawansowane selektory CSS',
      advanced_html: 'Zaawansowany HTML',
      advanced_html_attributes: 'Zaawansowane atrybuty HTML',
      advanced_html_tags: 'Zaawansowane tagi HTML',
      advanced_strings: 'Zaawansowane ciągi znaków',
      advanced_web_scripting: 'Zaawansowane web skrypty',
      algorithms: 'Algorytmy',
      algorithm_average: 'Algorytmy - średnia',
      algorithm_find_minmax: 'Algorytmy - min/maks',
      algorithm_search_binary: 'Algorytmy - szukanie binarne',
      algorithm_search_graph: 'Algorytmy - przeszukiwanie grafu',
      algorithm_sort: 'Algorytmy - sortowanie',
      algorithm_sum: 'Algorytmy - suma',
      alter_existing_web_pages: 'Podmiana obecnych stron',
      arguments: 'Argumenty',
      arithmetic: 'Arytmetyka',
      array_2d: 'Tablice 2D',
      array_index: 'Indeksy tablic',
      array_iterating: 'Iteracja po tablicach',
      array_literals: 'Literał tablicowy',
      array_searching: 'Przeszukiwanie tablic',
      array_sorting: 'Sortowanie tablic',
      arrays: 'Tablice',
      basic_css: 'Podstawowy CSS',
      basic_css_rules: 'Podstawowe reguły CSS',
      basic_css_selectors: 'Podstawowe selektory CSS',
      basic_event_handling: 'Podstawy zarzadzania zdarzeniami',
      basic_game_ai: 'Podstawy SI w grach',
      basic_html: 'Podstawowy HTML',
      basic_html_attributes: 'Podstawowe atrybuty HTML',
      basic_html_tags: 'Podstawowe tagi HTML',
      basic_input_handling: 'Podstawy zarządzania wejściem',
      basic_javascript: 'Podstawy JavaScript',
      basic_syntax: 'Podstawy składni',
      basic_web_scripting: 'Podstawowe web skrypty',
      binary: 'System binarny',
      boolean_and: "Boolowski 'and'",
      boolean_equality: 'Boolowska równość',
      boolean_greater_less: 'Boolowski większy/mniejszy',
      //    boolean_inequality: "Boolean Inequality",
      boolean_logic: "Algebra Boole'a",
      boolean_logic_shortcircuit: "Skróty w logice boole'a",
      boolean_not: "Boolowski 'not'",
      boolean_operator_precedence: 'Boolowskie pierwszeństwo operatorów',
      boolean_or: "Boolowski 'or'",
      //    boolean_with_xycoordinates: "Coordinate Comparison",
      bootstrap: 'Bootstrap',
      break_statements: "Instrukcja 'break'",
      classes: 'Klasy',
      //    comparators: "Comparators",
      //    compound_conditionals: "Compound Conditionals",
      //    conditionals: "Conditionals",
      construct_mazes: 'Konstruowanie labiryntów',
      continue_statements: "Instrukcja 'continue'",
      create_playable_game: 'Tworzenie działających gier',
      create_sharable_interactive_web_page: 'Stworzysz interaktywną stronę internetową',
      create_sharable_web_page: 'Tworzenie stron internetowych',
      //    data_and_analysis: "Data & Analysis",
      //    data_types: "Data Types",
      //    debugging: "Debugging",
      dom_events: 'Zdarzenia DOM',
      dynamic_styling: 'Style dynamiczne',
      //    events: "Events",
      event_concurrency: 'Rywalizacja zdarzeń',
      event_data: 'Dane zdarzeń',
      event_handlers: 'Obsługa zdarzeń',
      //    event_spawn: "Spawn Event",
      for_loops: "Pętle 'for'",
      for_loops_nested: "Zagnieżdżone pętle 'for'",
      for_loops_range: "Funckja 'range' w pętlach 'for'",
      functions: 'Funkcje',
      //    functions_parameters: "Parameters",
      //    functions_multiple_parameters: "Multiple Parameters",
      game_ai: 'SI w grach',
      //    game_design: "Game Design",
      game_goals: 'Cele gry',
      game_spawn: 'Powstawanie gry',
      graphics: 'Grafika',
      graphs: 'Grafy',
      heaps: 'Kopce',
      //    if_condition: "Conditional If Statements",
      //    if_else_if: "If/Else If Statements",
      if_else_statements: 'Wyrażenia if/else',
      if_statements: "Wyrażenia warunkowe 'if'",
      if_statements_nested: "Wyrażenia warunkowe 'if' zagnieżdżone",
      indexing: 'Indeksy tablicy',
      input_handling: 'Zarządzanie wejściami',
      input_handling_flags: 'Zarządzanie wejściem - flagi',
      input_handling_keyboard: 'Zarządzanie wejściem - klawiatura',
      input_handling_mouse: 'Zarządzanie wejściem - mysz',
      intermediate_css: 'Średnio zaawansowany CSS',
      intermediate_css_rules: 'Średnio zaawansowane reguły CSS',
      intermediate_css_selectors: 'Średnio zaawansowane selektory CSS',
      intermediate_html: 'Średnio zaawansowany HTML',
      intermediate_html_attributes: 'Średnio zaawansowane atrybuty HTML',
      intermediate_html_tags: 'Średnio zaawansowane tagi HTML',
      intermediate_web_scripting: 'Średnio zaawansowane web skrypty',
      //    iteration: "Iteration",
      jquery: 'jQuery',
      jquery_animations: 'jQuery - animacje',
      jquery_filtering: 'jQuery - filtrowanie elementów',
      jquery_selectors: 'jQuery - selektory',
      length: 'Rozmiar tablicy',
      //    loops: "Loops",
      //    math_coordinates: "Coordinate Math",
      math_geometry: 'Geometria',
      math_operations: 'Operacje matematyczne',
      //    math_proportions: "Proportion Math",
      math_trigonometry: 'Trygonometria',
      //    methods: "Methods",
      //    nesting: "Nesting",
      //    objects: "Objects",
      object_literals: 'Operacje na obiektach',
      parameters: 'Parametry',
      place_game_objects: 'Umieszczanie obiektów w grze',
      //    problem_solving: "Problem Solving",
      //    programs: "Programs",
      //    properties: "Properties",
      property_access: 'Dostęp do właściwości',
      property_assignment: 'Przypisywanie właściwości',
      //    property_coordinate: "Coordinate Property",
      queues: 'Struktury danych - kolejki',
      reading_docs: 'Czytanie dokumentacji',
      recursion: 'Rekurencja',
      return_statements: "Instrukcja 'return'",
      //    sequences_algorithms: "Sequences & Algorithms",
      stacks: 'Struktury danych - stosy',
      strings: 'Ciągi znaków',
      strings_concatenation: 'Konkatenacja ciągów',
      strings_substrings: 'Podsłowa',
      //    student_code: "Student Code",
      //    syntax: "Syntax",
      trees: 'Struktury danych - drzewa',
      variables: 'Zmienne',
      vectors: 'Wektory',
      while_condition_loops: "Pętle 'while' z warunkami",
      while_loops: "Pętle 'while'",
      while_loops_simple: "Pętle 'while'",
      while_loops_nested: "Zagnieżdżone pętle 'while'",
      xy_coordinates: 'Współrzędne kartezjańskie',
    },

    anonymous_teacher: {
      notify_teacher: 'Powiadom nauczyciela',
      create_teacher_account: 'Utwórz darmowe konto nauczyciela',
      enter_student_name: 'Twoje imię:',
      enter_teacher_email: 'Twój nauczycielski email:',
      teacher_email_placeholder: 'imie.nazwisko@nazwaszkoly.pl',
      student_name_placeholder: 'To wpisz swoje imię',
      teachers_section: 'Nauczyciele:',
      students_section: 'Uczniowie:',
      teacher_notified: 'Poinformowaliśmy Twojego nauczyciela, że chcesz więcej pograć w CodeCombat w klasie!',
    },

    delta: {
      added: 'Dodano',
      modified: 'Zmieniono',
      not_modified: 'Nie zmieniono',
      deleted: 'Usunięto',
      moved_index: 'Przesunięto Index',
      text_diff: 'Różnice w tekscie',
      merge_conflict_with: 'SCAL KONFLIKT Z',
      no_changes: 'Brak zmian',
    },

    legal: {
      page_title: 'Nota prawna',
      //    opensource_introduction: "CodeCombat is part of the open source community.",
      opensource_description_prefix: 'Zajrzyj na ',
      github_url: 'nasz GitHub',
      opensource_description_center: 'i pomóż, jeśli tylko masz ochotę! CodeCombat bazuje na dziesiątkach projektów open source - kochamy je wszystkie. Wpadnij na ',
      archmage_wiki_url: 'naszą wiki dla Arcymagów',
      opensource_description_suffix: ', by zobaczyć listę oprogramowania, dzięki któremu niniejsza gra może istnieć.',
      practices_title: 'Ludzkim językiem',
      practices_description: 'Oto nasze obietnice wobec ciebie, gracza, wyrażone po polsku, bez prawniczego żargonu.',
      privacy_title: 'Prywatność',
      privacy_description: 'Nie sprzedamy żadnej z Twoich prywatnych informacji.',
      security_title: 'Bezpieczeństwo',
      security_description: 'Z całych sił staramy się zabezpieczyć twoje prywatne informacje. Jako że jesteśmy projektem open source, każdy może sprawdzić i ulepszyć nasz system zabezpieczeń.',
      email_title: 'E-mail',
      email_description_prefix: 'Nie będziemy nękać cię spamem. Poprzez',
      email_settings_url: 'twoje ustawienia e-mail',
      email_description_suffix: 'lub poprzez linki w e-mailach, które wysyłamy, możesz zmienić swoje ustawienia i w prosty sposób wypisać się z subskrypcji w dowolnym momencie.',
      cost_title: 'Koszty',
      //    cost_description: "CodeCombat is free to play for its introductory levels, with a $__price__ USD/mo subscription for access to extra levels and __gems__ bonus gems per month. You can cancel with a click, and we offer a 100% money-back guarantee.",
      copyrights_title: 'Prawa autorskie i licencje',
      contributor_title: 'Umowa licencyjna dla współtwórców (CLA)',
      contributor_description_prefix: 'Wszyscy współtwórcy, zarówno ci ze strony jak i ci z GitHuba, podlegają naszemu',
      cla_url: 'CLA',
      contributor_description_suffix: ', na które powinieneś wyrazić zgodę przed dodaniem swojego wkładu.',
      code_title: 'Kod - MIT',
      //    client_code_description_prefix: "All client-side code for codecombat.com in the public GitHub repository and in the codecombat.com database, is licensed under the",
      mit_license_url: 'Licencja MIT',
      code_description_suffix: 'Zawiera się w tym całość kodu w systemach i komponentach, które są udostępnione przez CodeCombat w celu tworzenia poziomów.',
      art_title: 'Grafika/muzyka - Creative Commons ',
      art_description_prefix: 'Całość ogólnej treści dostępna jest pod licencją',
      cc_license_url: 'Międzynarodowa Licencja Creative Commons Attribution 4.0',
      art_description_suffix: 'Zawartość ogólna to wszystko, co zostało publicznie udostępnione przez CodeCombat w celu tworzenia poziomów. Wchodzą w to:',
      art_music: 'Muzyka',
      art_sound: 'Dźwięki',
      art_artwork: 'Artworki',
      art_sprites: "Sprite'y",
      art_other: 'Dowolne inne prace niezwiązane z kodem, które są dostępne podczas tworzenia poziomów.',
      art_access: 'Obecnie nie ma uniwersalnego, prostego sposobu, by pozyskać te zasoby. Możesz wejść w ich posiadanie poprzez URL-e, z których korzysta strona, skontaktować się z nami w celu uzyskania pomocy bądź pomóc nam w ulepszeniu strony, aby zasoby te stały się łatwiej dostępne.',
      art_paragraph_1: 'W celu uznania autorstwa, wymień z nazwy i podaj link do codecombat.com w pobliżu miejsca, gdzie znajduje się użyty zasób bądź w miejscu odpowiednim dla twojego medium. Na przykład:',
      use_list_1: 'W przypadku użycia w filmie lub innej grze, zawrzyj codecombat.com w napisach końcowych.',
      use_list_2: 'W przypadku użycia na stronie internetowej, zawrzyj link w pobliżu miejsca użycia, na przykład po obrazkiem lub na ogólnej stronie poświęconej uznaniu twórców, gdzie możesz również wspomnieć o innych pracach licencjonowanych przy użyciu Creative Commons oraz oprogramowaniu open source używanym na stronie. Coś, co samo w sobie jednoznacznie odnosi się do CodeCombat, na przykład wpis na blogu dotyczący CodeCombat, nie wymaga już dodatkowego uznania autorstwa.',
      art_paragraph_2: 'Jeśli użyte przez ciebie zasoby zostały stworzone nie przez CodeCombat, ale jednego z naszych użytkowników, uznanie autorstwa należy się jemu - postępuj wówczas zgodnie z zasadami uznania autorstwa dostarczonymi wraz z rzeczonym zasobem (o ile takowe występują).',
      rights_title: 'Prawa zastrzeżone',
      rights_desc: 'Wszelkie prawa są zastrzeżone dla poziomów jako takich. Zawierają się w tym:',
      rights_scripts: 'Skrypty',
      rights_unit: 'Konfiguracje jednostek',
      rights_writings: 'Teksty',
      rights_media: 'Multimedia (dźwięki, muzyka) i jakiekolwiek inne typy prac i zasobów stworzonych specjalnie dla danego poziomu, które nie zostały publicznie udostępnione do tworzenia poziomów.',
      rights_clarification: 'Gwoli wyjaśnienia, wszystko, co jest dostępne w Edytorze Poziomów w celu tworzenia nowych poziomów, podlega licencji CC, podczas gdy zasoby stworzone w Edytorze Poziomów lub przesłane w toku tworzenia poziomu - nie.',
      nutshell_title: 'W skrócie',
      nutshell_description: 'Wszelkie zasoby, które dostarczamy w Edytorze Poziomów są darmowe w użyciu w jakikolwiek sposób w celu tworzenia poziomów. Jednocześnie, zastrzegamy sobie prawo do ograniczenia rozpowszechniania poziomów (stworzonych przez codecombat.com) jako takich, aby mogła być za nie w przyszłości pobierana opłata, jeśli dojdzie do takiej konieczności.',
      //    nutshell_see_also: "See also:",
      canonical: 'Angielska wersja tego dokumentu jest ostateczną, kanoniczną wersją. Jeśli zachodzą jakieś rozbieżności pomiędzy tłumaczeniami, dokument anglojęzyczny ma pierwszeństwo.',
      third_party_title: 'Oprogramowanie osób trzecich',
      third_party_description: 'CodeCombat używa (między innymi) poniższych programów osób trzecich:',
      //    cookies_message: "CodeCombat uses a few essential and non-essential cookies.",
      //    cookies_deny: "Decline non-essential cookies",
      //    cookies_allow: "Allow cookies",
    },

    ladder_prizes: {
      title: 'Nagrody w turnieju',
      blurb_1: 'Nagrody zostaną rozdane zgodnie z',
      blurb_2: 'regulaminem turnieju',
      blurb_3: 'dla najlepszych ludzkich i ogrzych graczy.',
      blurb_4: 'Dwa zespoły oznaczają podwójne nagrody!',
      blurb_5: '(Będą dwa pierwsze miejsca, dwa drugie miejsca i tak dalej...)',
      rank: 'Ranking',
      prizes: 'Nagrody',
      total_value: 'Łączna wartość',
      in_cash: 'w gotówce',
      custom_wizard: 'Własny Bohater w CodeCombat',
      custom_avatar: 'Własny avatar w CodeCombat',
      heap: 'sześć miesięcy dostępu',
      credits: 'kredyty',
      one_month_coupon: 'kupon: wybierz między Rails, a HTML',
      one_month_discount: 'zniżka 30%: wybierz między Rails, a HTML',
      license: 'licencja',
      oreilly: 'dowolny ebook',
    },

    calendar: {
      year: 'rok',
      day: 'dzień',
      month: 'miesiąc',
      january: 'styczeń',
      february: 'luty',
      march: 'marzec',
      april: 'kwiecień',
      may: 'maj',
      june: 'czerwiec',
      july: 'lipiec',
      august: 'sierpień',
      september: 'wrzesień',
      october: 'październik',
      november: 'listopad',
      december: 'grudzień',
    },

    //  code_play_create_account_modal: {
    //    title: "You did it!",
    //    body: "You are now on your way to becoming a master coder. Sign up to receive an extra <strong>100 Gems</strong> & you will also be entered for a chance to <strong>win $2,500 & other Lenovo Prizes</strong>.",
    //    sign_up: "Sign up & keep coding ▶",
    //    victory_sign_up_poke: "Create a free account to save your code & be entered for a chance to win prizes!",
    //    victory_sign_up: "Sign up & be entered to <strong>win $2,500</strong>",
    //  },

    server_error: {
      email_taken: 'Email jest już w użyciu',
      username_taken: 'Nazwa użytkownika jest już w użyciu',
      //    easy_password: "Password is too easy to guess",
      //    reused_password: "Password cannot be reused",
    },

    esper: {
      line_no: 'Wiersz $1: ',
      //    uncaught: "Uncaught $1",
      reference_error: 'ReferenceError (błąd referencji): ',
      argument_error: 'Błąd argumentu: ',
      type_error: 'TypeError (błąd typu): ',
      syntax_error: 'Błąd składni: ',
      error: 'Błąd: ',
      x_not_a_function: '`$1` nie jest funkcją',
      x_not_defined: 'nie zdefiniowano: $1',
      spelling_issues: 'Sprawdź dobrze pisownię: może chodziło ci o `$1` zamiast `$2`?',
      capitalization_issues: 'Uważaj na duże i małe litery: `$1` powinno wyglądać tak: `$2`.',
      py_empty_block: 'Pusty $1. Wstaw 4 spacje przed instrukcją wewnątrz $2.',
      fx_missing_paren: 'Jeśli chcesz wywołać `$1` jako funkcję, powinieneś użyć `()`',
      unmatched_token: 'Nawias `$1` nie ma pary.  Każdy otwierający nawias `$2` powinien posiadać jego zamykający odpowiednik `$3`.',
      unterminated_string: 'Ciąg znaków nie ma końca. Umieść odpowiedni znak `"` na końcu swojego ciągu znaków.',
      //    missing_semicolon: "Missing semicolon.",
      //    missing_quotes: "Missing quotes. Try `$1`",
      //    argument_type: "`$1`'s argument `$2` should have type `$3`, but got `$4`: `$5`.",
      //    argument_type2: "`$1`'s argument `$2` should have type `$3`, but got `$4`.",
      //    target_a_unit: "Target a unit.",
      //    attack_capitalization: "Attack `$1`, not `$2`. (Capital letters are important.)",
      //    empty_while: "Empty while statement. Put 4 spaces in front of statements inside the while statement.",
      //    line_of_site: "`$1`'s argument `$2` has a problem. Is there an enemy within your line-of-sight yet?",
      //    need_a_after_while: "Need a `$1` after `$2`.",
      //    too_much_indentation: "Too much indentation at the beginning of this line.",
      //    missing_hero: "Missing `$1` keyword; should be `$2`.",
      //    takes_no_arguments: "`$1` takes no arguments.",
      //    no_one_named: "There's no one named `\"$1\"` to target.",
      //    separated_by_comma: "Function calls paramaters must be seperated by `,`s",
      //    protected_property: "Can't read protected property: $1",
      //    need_parens_to_call: "If you want to call `$1` as function, you need `()`'s",
      //    expected_an_identifier: "Expected an identifier and instead saw '$1'.",
      //    unexpected_identifier: "Unexpected identifier",
      //    unexpected_end_of: "Unexpected end of input",
      //    unnecessary_semicolon: "Unnecessary semicolon.",
      //    unexpected_token_expected: "Unexpected token: expected `$1` but found `$2` while parsing `$3`",
      //    unexpected_token: "Unexpected token $1",
      //    unexpected_token2: "Unexpected token",
      //    unexpected_number: "Unexpected number",
      //    unexpected: "Unexpected '$1'.",
      //    escape_pressed_code: "Escape pressed; code aborted.",
      //    target_an_enemy: "Target an enemy by name, like `$1`, not the string `$2`.",
      //    target_an_enemy_2: "Target an enemy by name, like `$1`.",
      //    cannot_read_property: "Cannot read property `$1` of `undefined`",
      //    attempted_to_assign: "Attempted to assign to readonly property.",
      //    unexpected_early_end: "Unexpected early end of program.",
      //    you_need_a_string: "You need a string to build; one of `$1`",
      //    unable_to_get_property: "Unable to get property '$1' of undefined or null reference",
      //    code_never_finished_its: "Code never finished. It's either really slow or has an infinite loop.",
      //    unclosed_string: "Unclosed string.",
      //    unmatched: "Unmatched `$1`.",
      //    error_you_said_achoo: "You said: `$1`, but the password is: `$2`. (Capital letters are important.)",
      //    indentation_error_unindent_does: "Indentation Error: unindent does not match any outer indentation level",
      //    indentation_error: "Indentation error.",
      //    need_a_on_the: "Need a `:` on the end of the line following `$1`.",
      //    attempt_to_call_undefined: "attempt to call `$1` (a nil value)",
      //    unterminated: "Unterminated `$1`",
      //    target_an_enemy_variable: "Target an `$1` variable, not the string `$2`. (Try using `$3`.)",
      //    error_use_the_variable: "Use the variable name like `$1` instead of a string like `$2`",
      //    indentation_unindent_does_not: "Indentation unindent does not match any outer indentation level",
      //    unclosed_paren_in_function_arguments: "Unclosed `$1` in function arguments.",
      //    unexpected_end_of_input: "Unexpected end of input",
      //    there_is_no_enemy: "There is no `$1`. Use `$2` first.",
      //    try_herofindnearestenemy: "Try `$1`",
      //    there_is_no_function: "There is no function `$1`, but `$2` has a method `$3`.",
      //    attacks_argument_enemy_has: "`$1`'s argument `$2` has a problem.",
      //    is_there_an_enemy: "Is there an enemy within your line-of-sight yet?",
      //    target_is_null_is: "Target is `$1`. Is there always a target to attack? (Use `$2`?)",
      //    hero_has_no_method: "`$1` has no method `$2`.",
      //    there_is_a_problem: "There is a problem with your code.",
      //    did_you_mean: "Did you mean `$1`? You do not have an item equipped with that skill.",
      //    missing_a_quotation_mark: "Missing a quotation mark. ",
      //    missing_var_use_var: "Missing `$1`. Use `$2` to make a new variable.",
      //    you_do_not_have: "You do not have an item equipped with the `$1` skill.",
      //    put_each_command_on: "Put each command on a separate line",
      //    are_you_missing_a: "Are you missing a `$1` after `$2`? ",
      //    your_parentheses_must_match: "Your parentheses must match.",
      //    missing_parentheses: "Missing parentheses? Try `__suggestion__`",
      //    do_nothing_without_parentheses: "`__code__` doesn't do anything without `()`",
      //    error_index_empty: "Cannot read property `__name__` of `__specTypeName__`",
      //    error_call_non_function: "`__name__` is not a function.",
      //    error_not_iterable: "`__var__` is not iterable.",
      //    error_assignment_invalid: "Invalid reference in assignment.",
      //    error_invalid_array_length: "Invalid array length.",
      //    error_didnt_make_generator: "`__name__` didn't make a generator.",
      //    error_undefined_variable: "`__name__` is not defined.",
      //    error_declared_identifier: "Identifier `__name__` has already been declared.",
      //    error_declarations_cant_resolve: "Couldn't resolve declarations component: `__type__`.",
      //    error_strict_no_statement: "Strict mode code may not include a `with` statement.",
      //    error_cant_resolve_ref_component: "Couldn't resolve ref component: `__type__`.",
      //    error_cant_convert_null: "Cannot convert `undefined` or `null` to object.",
      //    error_need_object: "Need an object.",
      //    error_illegal_object_prototype: "Object prototype may only be an `Object` or `null`.",
      //    error_no_prototype: "No prototype.",
      //    error_cant_write_property_to_undefined: "Can't write property of `undefined`: `__idx__`.",
      //    error_cant_write_property_to_non_obj: "Can't write property of non-object type: `__idx__`.",
      //    error_function_isnt_constructor: "function is not a constructor",
      //    error_write_protected_property: "Can't write to protected property: `__name__`",
      //    error_read_protected_property: "Can't read protected property: `__name__`",
      //    error_convert_value_failed: "Cannot convert `__orig__` value to `__new__` value.",
      //    error_convert_object_to_primitive: "Cannot convert object to primitive value.",
      //    error_first_argument_to_be_function: "First argument to `__fun__` must be a function.",
      //    error_write_non_writable: "Can't write to non-writable value.",
      //    error_delete_nonconfigurable_object: "Can't delete non configurable object.",
      //    error_cant_access_get: "Can't access get `__name__` of that type.",
      //    error_base_obj_not_invokable: "Base object not invokable.",
      //    error_arg2_not_callable: "Arg2 not callable.",
      //    error_reduce_empty_array_without_init: "Reduce an empty array with no initial value.",
      //    error_realm_prototype_not_realm: "Realm prototype not realm.",
      //    error_function_tostring_not_generic: "Function.prototype.toString is not generic",
      //    error_regex_on_non_regex: "Calling regex method on non regex.",
      //    error_call_string_on_null: "called String function on null or undefined?",
      //    error_wrong_type: "Wrong Type.",
      //    error_replace_callback_not_written: "Replace with callbacks not written yet",
      //    error_right_hand_side_not_callable: "Right-hand side of `__name__` is not callable",
      //    error_segmentation_fault: "Segmentation Fault `__offset__`.",
      //    error_no_arg_to_reference: "No argument to reference.",
      //    error_unimplemented_property: "Unimplemented property type.",
      //    error_unimplemented: "Unimplemented.",
      //    error_cant_call_reference: "Can't call reference like that.",
      //    error_no_arg_to_dereference: "No argument to dereference.",
      //    error_try_dereference_non: "Tried to dereference non pointer.",
      //    error_no_arg_to_alloc: "No argument to alloc.",
    },

    //  apcsp: {
    //    title: "AP Computer Science Principals | College Board Endorsed",
    //    meta_description: "CodeCombat’s comprehensive curriculum and professional development program are all you need to offer College Board’s newest computer science course to your students.",
    //    syllabus: "AP CS Principles Syllabus",
    //    syllabus_description: "Use this resource to plan CodeCombat curriculum for your AP Computer Science Principles class.",
    //    computational_thinking_practices: "Computational Thinking Practices",
    //    learning_objectives: "Learning Objectives",
    //    curricular_requirements: "Curricular Requirements",
    //    unit_1: "Unit 1: Creative Technology",
    //    unit_1_activity_1: "Unit 1 Activity: Technology Usability Review",
    //    unit_2: "Unit 2: Computational Thinking",
    //    unit_2_activity_1: "Unit 2 Activity: Binary Sequences",
    //    unit_2_activity_2: "Unit 2 Activity: Computing Lesson Project",
    //    unit_3: "Unit 3: Algorithms",
    //    unit_3_activity_1: "Unit 3 Activity: Algorithms - Hitchhiker's Guide",
    //    unit_3_activity_2: "Unit 3 Activity: Simulation - Predator & Prey",
    //    unit_3_activity_3: "Unit 3 Activity: Algorithms - Pair Design and Programming",
    //    unit_4: "Unit 4: Programming",
    //    unit_4_activity_1: "Unit 4 Activity: Abstractions",
    //    unit_4_activity_2: "Unit 4 Activity: Searching & Sorting",
    //    unit_4_activity_3: "Unit 4 Activity: Refactoring",
    //    unit_5: "Unit 5: The Internet",
    //    unit_5_activity_1: "Unit 5 Activity: How the Internet Works",
    //    unit_5_activity_2: "Unit 5 Activity: Internet Simulator",
    //    unit_5_activity_3: "Unit 5 Activity: Chat Room Simulation",
    //    unit_5_activity_4: "Unit 5 Activity: Cybersecurity",
    //    unit_6: "Unit 6: Data",
    //    unit_6_activity_1: "Unit 6 Activity: Introduction to Data",
    //    unit_6_activity_2: "Unit 6 Activity: Big Data",
    //    unit_6_activity_3: "Unit 6 Activity: Lossy & Lossless Compression",
    //    unit_7: "Unit 7: Personal & Global Impact",
    //    unit_7_activity_1: "Unit 7 Activity: Personal & Global Impact",
    //    unit_7_activity_2: "Unit 7 Activity: Crowdsourcing",
    //    unit_8: "Unit 8: Performance Tasks",
    //    unit_8_description: "Prepare students for the Create Task by building their own games and practicing key concepts.",
    //    unit_8_activity_1: "Create Task Practice 1: Game Development 1",
    //    unit_8_activity_2: "Create Task Practice 2: Game Development 2",
    //    unit_8_activity_3: "Create Task Practice 3: Game Development 3",
    //    unit_9: "Unit 9: AP Review",
    //    unit_10: "Unit 10: Post-AP",
    //    unit_10_activity_1: "Unit 10 Activity: Web Quiz",
    //  },

    //  apcsp_marketing: {
    //    course_outline_unit_1: "Unit 1",
    //    course_outline_unit_2: "Unit 2",
    //    course_outline_unit_3: "Unit 3",
    //    course_outline_unit_4: "Unit 4",
    //    course_outline_unit_5: "Unit 5",
    //    course_outline_unit_6: "Unit 6",
    //    course_outline_unit_7: "Unit 7",
    //    course_outline_unit_8: "Unit 8",
    //    course_outline_unit_9: "Unit 9",
    //    course_outline_course_1: "Computer Science 1",
    //    course_outline_course_2: "Computer Science 2",
    //    course_outline_course_3: "Computer Science 3",
    //    course_outline_course_4: "Computer Science 4",
    //    course_outline_course_5: "Creative Development",
    //    course_outline_course_6: "Data",
    //    course_outline_course_7: "Computer Systems and Networks",
    //    course_outline_course_8: "Impact of Computing",
    //    course_outline_course_9: "Exam Prep",
    //    course_outline_description_1: "Students begin the course focusing on creativity, problem solving, and the basic syntax of Python.",
    //    course_outline_description_2: "Students focus on designing and implementing algorithms using the building blocks of Python.",
    //    course_outline_description_3: "Students explore the concept of abstraction by developing their own abstractions inside program code.",
    //    course_outline_description_4: "Students apply their understanding of problem solving, algorithms, and abstractions to design and implement digital games.",
    //    course_outline_description_5: "Students use all that they have learned about Python to complete and submit their Create Performance Task.",
    //    course_outline_description_6: "Students learn how computers consume, transform, store, and produce new information in order to solve problems.",
    //    course_outline_description_7: "Students experience the power of sharing information via computer networks by learning about the Internet.",
    //    course_outline_description_8: "Students examine how computing has revolutionized our lives and society.",
    //    course_outline_description_9: "Students prepare to take the multiple choice section of the AP CSP exam.",
    //    icons_coding_levels: "150+ CodeCombat Coding Levels",
    //    icons_lesson_slides: "60+ Turnkey Lesson Slides",
    //    icons_kahoot: "400+ Kahoot! Quiz Questions",
    //    icons_classroom_instructions: "100+ Hours of Classroom Instruction",
    //    icons_weeks_of_curriculum: "26 Weeks of Curriculum",
    //    icons_project_activities: "25+ Project-Based Activities",
    //    icons_game_learning: "Game-Based Learning",
    //    icons_text_coding: "Text-Based Coding",
    //    icons_chromebook_compatible: "Chromebook Compatible",
    //    icons_standards_aligned: "Standards-Aligned Lessons",
    //    page_title: "AP Computer Science Principles",
    //    page_description: "Our AP CSP curriculum provides game-based and turnkey tools to prepare students for the AP exam.",
    //    page_description_endorsed: "Endorsed by the College Board, our AP CSP curriculum provides game-based and turnkey tools to prepare students for the AP exam.",
    //    request_access: "Request Access",
    //    game_based_learning: "Game-Based Learning",
    //    game_based_learning_description: "Our innovative game-based learning technology has transformed the way students prepare for the AP CSP exam. Through our browser-based games, students learn about important exam topics while exercising the critical thinking skills that are necessary for success on the exam.",
    //    fostering_confidence: "Fostering Confidence in the AP Exam",
    //    fostering_confidence_description: "With our curriculum, students will practice every stage of the Create Task through scaffolded and approachable capstone projects that can be adapted to a wide variety of student needs. We also provide curriculum and Kahoot! quizzes for students to practice multiple choice exam questions.",
    //    accessible_real_world: "Accessible & Real-World Connections",
    //    accessible_real_world_description: "For Data, Impacts of Computing, and additional Big Ideas, our turnkey lesson slides help students explore these topics through meaningful discussions and collaborative projects. Filled with real-world connections, our curriculum will allow students to fully understand how coding affects their everyday lives.",
    //    college_board: "The College Board is currently reviewing our curriculum with an expected endorsement in March 2023.",
    //    our_curriculum_offers: "Our curriculum offers engaging features so that students explore and learn Computer Science through...",
    //    course_outline: "Course Outline",
    //    course_outline_description: "The following descriptions are an overview of the content explored in the CodeCombat AP CSP course.",
    //    explore_our_curriculum: "Explore Our Curriculum",
    //    syllabus: "Syllabus",
    //    pacing_guide: "Pacing Guide",
    //    flyer: "Flyer",
    //    sample_lesson_slides: "Browse through our sample lesson slides",
    //    introduction_to_cs: "Introduction to Computer Science",
    //    introduction_to_cs_description: "Syntax and Sequences",
    //    big_ideas: "Big Ideas: Computer Systems and Networks",
    //    big_ideas_description: "The Internet (Overview)",
    //    get_full_course: "Get the full course here",
    //    professional_development: "Professional Development",
    //    professional_development_description: "CodeCombat offers an online, self-paced professional development course for educators of all levels of AP CSP expertise. Participants will explore the CodeCombat curriculum and learn how it can be used to prepare students to succeed on the AP CSP exam. Through asynchronous discussions with fellow teachers and video conferences with CodeCombat learning designers, you will be equipped with the tools and techniques you need to support all of your students in AP CSP. At the end of the course, you will earn a Certificate of Completion that can be used for the renewal of your teaching credential.",
    //    more_information: "For More Information",
    //    contact_us: "Contact Us",
    //    question_1: "How can I learn more about the AP CSP Course?",
    //    answer_1: "You can check out the College Board’s AP Computer Science Principles __course_overview__ and also explore the __outcomes__ for this course.",
    //    question_2: "What are the technology requirements for CodeCombat’s AP CSP curriculum?",
    //    answer_2: "We recommend at least 4GB of RAM and using a modern browser such as Chrome, Safari, Firefox, or Edge. For additional specifics, please visit __coco_requirements__.",
    //    question_3: "What is the format of our lesson plans and lesson slides?",
    //    answer_3: "All of our lesson slides are in the format of Google Slides and our lesson plans are in the format of Google Docs. These formats allow you to make copies of our curriculum so that you can adapt them to the needs of your students. Lesson slides and lesson plans can also be downloaded as Microsoft® PowerPoint and Word files.",
    //    course_overview: "Course Overview",
    //    outcomes: "outcomes",
    //    coco_requirements: "CodeCombat’s system requirements",
    //    coco_recognized_blurb: "CodeCombat is recognized by College Board as an endorsed provider of curriculum and professional development for AP® Computer Science Principles (AP CSP). This endorsement affirms that CodeCombat’s curriculum is aligned to all the AP Curriculum Framework standards and the AP CSP assessment. This affords schools access to resources including an AP CSP syllabus pre-approved by the College Board’s Course Audit, and officially recognized professional development that prepares teachers to teach this curriculum.",
    //    ap_csp_portal: "AP CSP Portal",
    //  },

    //  apcsp_curriculum: {
    //    access_syllabus: "Access our College Board approved __syllabus__",
    //    college_board_approved_syllabus: "Syllabus",
    //    access_pacing_guide: "Review our suggested __pacing_guide__",
    //    pacing_guide: "Pacing Guide",
    //    resources: "Professional Development Resources",
    //    professional_development_description: "CodeCombat offers an online, self-paced professional development course for educators of all levels of AP CSP expertise. Participants will explore the CodeCombat curriculum and learn how it can be used to prepare students to succeed on the AP CSP exam. Through asynchronous discussions with fellow teachers and video conferences with CodeCombat curriculum developers, you will be equipped with the tools and techniques you need to support all of your students in AP CSP. At the end of the course, you will earn a Certificate of Completion that can be used for the renewal of your teaching credential. We offer our Curriculum on __edapp__.",
    //    contact: "Contact __apcsp_email__ to get access.",
    //    role: "Role",
    //    location: "Location",
    //    state_and_country: "state and country",
    //    no_license: "Our AP CSP curriculum requires a paid license to view. Learn more about CodeCombat's AP CSP curriculum by visiting our About page, linked below.",
    //    request_license: "Join Pilot Program",
    //    page_title: "AP Computer Science Principles Curriculum",
    //    explore_each_unit: "Explore each unit, including <br> <strong>lesson plans</strong> and <strong>lesson slides</strong>",
    //    about_apcsp_curriculum: "About AP CSP Curriculum",
    //    step_1_title: "Get Started Today",
    //    step_1_subtitle: "Upload CodeCombat’s AP CSP syllabus to College Board’s Course Audit.",
    //    step_1_button_1: "View the Syllabus",
    //    step_1_button_2: "Complete the Audit",
    //    join_the_community: "Join the AP Community",
    //    ap_teachers: "Teacher Central",
    //    ap_classroom: "AP Classroom",
    //    slack: "AP Workspace",
    //    join: "Join",
    //  },

    //  hoc_2019: {
    //    heading: "Hour of Code",
    //    start: "Start Your Journey",
    //    create_a_class: "Create a class to track your students' progress and ensure their hour of code games are saved!",
    //    choose_language: "1. CHOOSE LANGUAGE",
    //    programming_language: "Language",
    //    sign_up: "2. SIGN UP",
    //    already_have_account: "Already have a CodeCombat or Ozaria account? Login.",
    //    download_lesson_plan: "Download Lesson Plan",
    //    try_activity_without_class: "Try activity without creating a class",
    //    invite_students: "Invite Students to Your Class By Sending Them",
    //    class_code: "CLASS CODE",
    //    enter_code: "Students can enter this code at www.ozaria.com/hoc",
    //    class_url: "CLASS URL",
    //    share_url: "Share URL to have students automatically join your class.",
    //    start_activity: "Start Activity",
    //    save_progress_modal: "Save your progress and keep playing later",
    //    want_to_save: "Want to save your Hour of Code progress?",
    //    ask_teacher_class_code: "Ask your teacher for your Class Code",
    //    dont_have: "I don't have one, but want to Try the Activity!",
    //    hoc_activity: "Hour of Code Activity",
    //    save_progress: "Save Progress",
    //    err_google_exists: "An account already exists for the Google account you've selected. Please choose another Google account or sign up with a username and password.",
    //    err_username_taken: "An account already exists for the username you've entered. Please choose another username.",
    //    enter_it_here: "Enter it here to save your progress as you play:",
    //    have_a_class_code: "Have a class code?",
    //    create_class_and_try_activity: "Create Class and Try Activity",
    //  },

    //  parents_landing_1: {
    //    online_coding_classes: "Live Online Coding Classes",
    //    powered_by_play: "Powered by Play",
    //    partnership: "in partnership with",
    //    kids_message: "Kids: show this to your parents to get your free coding class and premium heroes!",
    //    codecombat_intro: "CodeCombat combines the power of gameplay and personalized instruction to deliver online coding classes that your child will look forward to every week!",
    //    remote_learning_works: "Remote Learning That Works",
    //    invest_in_future: "Invest in Your Child’s Future While They Have Fun!",
    //    personalized_learning_header: "Personalized Learning",
    //    personalized_learning_details: "Our dedicated teachers offer individualized attention through a structured curriculum.  Your child will become a confident life-long coder as they conquer challenges and celebrate successes together!",
    //    power_of_play_header: "The Power of Play",
    //    power_of_play_details: "Our students type real Python and JavaScript while playing a game from beginning to end! Our engaging curriculum ensures that you’ll never have to force your child to show up to class. We promise.",
    //    early_coding_exposure: "Early Exposure to Coding",
    //    early_coding_exposure_details: "Coding is a highly sought-after job skill, and this demand will only grow. Exposing your child to coding at an early age increases the chance that they’ll pursue Computer Science later in life.",
    //    quote_1: "Even though the class starts every Saturday at 7am, my son is so excited that he wakes up before me! CodeCombat creates a pathway for my son to advance his coding skills.",
    //    parent_name: "Latthaphon Pohpon, Parent",
    //    course_offering: "Course Offerings",
    //    flexible_scheduling: "With individual or small group class options and flexible scheduling available, this is the easiest way to get started in computer science.",
    //    private_instructions: "All classes feature private, individualized instruction. To enroll a group of students, contact <a href=\"mailto:classes@codecombat.com\">classes@codecombat.com</a> for a custom plan.",
    //    most_popular: "Most popular",
    //    best_value: "Best Value",
    //    self_paced: "Self-Paced",
    //    private: "Private",
    //    subscription_plan: "Subscription plan",
    //    per_year: "per year",
    //    price_per_year_1: "$219 per month",
    //    price_per_year_2: "$399 per month",
    //    not_available: "N/A",
    //    one_to_one: "1:1",
    //    private_sessions_1: "1 private session per week",
    //    private_sessions_2: "2 private sessions per week",
    //    benefit_1: "60-minute sessions via Zoom",
    //    benefit_2: "Student to Instructor Ratio",
    //    benefit_3: "CodeCombat premium license included",
    //    benefit_4: "Immediate and personalized feedback",
    //    benefit_5: "Bonus activities, rewards, and course completion certificates",
    //    benefit_6: "End of course projects that demonstrate concepts learned",
    //    benefit_7: "Monthly progress updates from instructor",
    //    benefit_8: "Flexible schedule adapted to each student's learning needs",
    //    benefit_9: "1:1 support in tackling difficult coding concepts",
    //    benefit_10: "Automatic qualification into AI League coding tournaments",
    //    subscription_details: "All subscriptions are billed on a monthly basis and may be paused, cancelled, or resumed with no fees. Your subscription purchase is 100% risk-free within the first 30 days. If for any reason you decide not to continue, simply <a href=\"mailto:classes@codecombat.com\">contact us</a> within 30 days of purchase and we will promptly refund 100% of your payment, no questions asked. All plans are automatically renewed at the same level and billing cycle unless otherwise changed or canceled.",
    //    curriculum: "Our Curriculum",
    //    curriculum_description: "Trusted by over 140,000 educators worldwide, our scaffolded curriculum is critical to helping students persevere. Our students type real code from the start, become more confident with each class, and learn how Computer Science is relevant to their daily lives.",
    //    student_outcomes: "Student Outcomes",
    //    grit_header: "Grit",
    //    grit_description: "CodeCombat challenges students to embrace and learn from their mistakes. Built-in hints help students identify and fix bugs, leading to greater coding confidence.",
    //    problem_solving_header: "Problem Solving Skills",
    //    problem_solving_description: "Through an iterative problem solving process, our students solve coding challenges and flex their creativity to build their own games, websites, and apps for end-of-course projects.",
    //    technological_literacy: "Technological Literacy",
    //    technological_literacy_description: "Students gain a deep understanding of Computer Science and technological literacy skills that will transfer to other disciplines as well as future careers.",
    //    concepts_covered: "Concepts Covered",
    //    beginner: "Beginner",
    //    beginner_description: "For students with little to no text-based coding experience.",
    //    beginner_concepts_1: "Sequences",
    //    beginner_concepts_2: "Algorithms",
    //    beginner_concepts_3: "Syntax",
    //    beginner_concepts_4: "Strings",
    //    beginner_concepts_5: "Arguments",
    //    beginner_concepts_6: "Loops",
    //    beginner_concepts_7: "Variables",
    //    beginner_concepts_8: "Cartesian coordinates",
    //    intermediate_header: "Intermediate",
    //    itermediate_details: "For students with some text-based coding experience.",
    //    intermediate_concepts_1: "Boolean logic",
    //    intermediate_concepts_2: "Properties",
    //    intermediate_concepts_3: "Advanced loops",
    //    intermediate_concepts_4: "Conditionals",
    //    intermediate_concepts_5: "Nested conditionals",
    //    intermediate_concepts_6: "Functions",
    //    intermediate_concepts_7: "Events",
    //    intermediate_concepts_8: "Basic game AI",
    //    advanced_header: "Advanced",
    //    advanced_details: "For students with substantial experience in text-based code and a good grasp of complex concepts.",
    //    advanced_concepts_1: "Advanced strings",
    //    advanced_concepts_2: "Computer arithmetic",
    //    advanced_concepts_3: "Functions with returns",
    //    advanced_concepts_4: "Complex conditionals",
    //    advanced_concepts_5: "Arrays",
    //    advanced_concepts_6: "Break/continue statements",
    //    advanced_concepts_7: "Recursion",
    //    advanced_concepts_8: "Stacks and Queues",
    //    ai_hints: "AI Hints",
    //    ai_hints_details: "Our instructors offer the guidance and support your child needs, but can’t always be there. That’s where our innovative AI hints feature helps the learning continue between sessions. This support feature can evaluate code, point out errors, and explain how to fix them. Most importantly, it provides all the context needed to understand the why, without providing the entire solution. With only current code problem assistance available students will still need to work through each level's coding challenge. Subscribers receive an allocation of <b>20 AI hints per day</b> to ensure they always have the support they need.",
    //    faq_header: "FAQs",
    //    faq_q_1: "How are instructors matched with my child?",
    //    faq_a_1_trial_class: "After the initial trial class, our team carefully matches our online instructors to each student based on their experience level, personality, interests, and schedule. Our team will work with you to improve your experience if you or your child doesn’t love learning with your instructor.",
    //    faq_a_1: "Each of our instructors were hand-picked to represent CodeCombat and provide a fun and personalized learning experience tailored to each student. We believe that your child will enjoy learning with any of our instructors, but if for any reason you would like to change teachers, we are happy to accommodate.",
    //    faq_q_2: "Are there any student age limits?",
    //    faq_a_2: "We recommend our online classes for students aged 7 through 16. However, if your child can type, use a mouse, and is comfortable using a computer, they are welcome to join our class.",
    //    faq_q_3: "What kind of technology do I need to join the class?",
    //    faq_a_3: "Any internet-connected device with a full keyboard. Laptops, PCs, and Chromebooks are recommended, however iPads will work with an external keyboard.",
    //    faq_q_4: "What is the cancellation policy?",
    //    faq_a_4: "Your subscription purchase is 100% risk-free within the first 30 days. If for any reason you decide not to continue, simply <a href=\"mailto:classes@codecombat.com\">contact us</a> within 30 days of purchase and we will promptly refund 100% of your purchase, no questions asked. You can also freeze your subscription at any time and re-activate when it works for you.",
    //    faq_q_5: "What if I need to reschedule a class?",
    //    faq_a_5: "Once you have booked a weekly class with us, we have reserved time in our schedule exclusively for you, so we require 48 hours' advance notice for rescheduling classes. You can reschedule your class by emailing <a href=\"mailto:classes@codecombat.com\">classes@codecombat.com</a>. Classes missed or canceled with less than 48 hours' notice will not be rescheduled or refunded.",
    //    faq_q_6: "What should I expect in the trial class?",
    //    faq_a_6: "Each trial class is a private 60 minute session with <strong>45 minutes of instruction</strong> for the student followed by <strong>15 minutes for discussion with a parent or guardian</strong>. These 15 minutes are important and are set aside to answer any questions, provide insight into how the ongoing curriculum progresses, and help you select the right skill level and coding language for your child. If available, one of our remote learning advisors may join for this part of the session.",
    //    other_questions: "If you have any other questions about our online classes, please <a href=\"mailto:classes@codecombat.com\">contact us.</a>",
    //  },

    //  parents_landing_2: {
    //    splash_title: "Discover the magic of coding at home.",
    //    learn_with_instructor: "Learn with an Instructor",
    //    live_classes: "Live Online Classes",
    //    live_classes_offered: "CodeCombat now offers live online computer science classes for students learning at home. Great for students who work best in 1:1 or small-group settings where learning outcomes are tailored to their needs.",
    //    live_class_details_1: "Small group or private lessons",
    //    live_class_details_2: "JavaScript and Python coding, plus core Computer Science concepts",
    //    live_class_details_3: "Taught by expert coding instructors",
    //    live_class_details_4: "Individualized and instant feedback",
    //    live_class_details_5: "Curriculum trusted by 80,000+ educators",
    //    try_free_class: "Try a free 60 minute class",
    //    pricing_plans: "Pricing Plans",
    //    choose_plan: "Choose Plan",
    //    per_student: "per student",
    //    sibling_discount: "15% Sibling Discount!",
    //    small_group_classes: "Small Group Coding Classes",
    //    small_group_classes_detail: "4 Group Sessions / Mo.",
    //    small_group_classes_price: "$159/mo",
    //    small_group_classes_detail_1: "4:1 student to instructor ratio",
    //    small_group_classes_detail_2: "60 minute classes",
    //    small_group_classes_detail_3: "Build projects and give feedback to other students",
    //    small_group_classes_detail_4: "Screen sharing to get live feedback on coding and debugging",
    //    private_classes: "Private Coding Classes",
    //    four_sessions_per_month: "4 Private Sessions / Mo.",
    //    eight_sessions_per_month: "8 Private Sessions / Mo.",
    //    four_private_classes_price: "$219/mo",
    //    eight_private_classes_price: "$399/mo",
    //    private_classes_detail: "4 or 8 Private Sessions / Mo.",
    //    private_classes_price: "$219/mo or $399/mo",
    //    private_classes_detail_1: "1:1 student to instructor ratio",
    //    private_classes_detail_2: "60 minute classes",
    //    private_classes_detail_3: "Flexible schedule tailored to your needs",
    //    private_classes_detail_4: "Lesson plans and live feedback tailored to students' learning style, pace, and ability level",
    //    best_seller: "Best Seller",
    //    best_value: "Best Value",
    //    codecombat_premium: "CodeCombat Premium",
    //    learn_at_own_pace: "Learn at Your Own Pace",
    //    monthly_sub: "Monthly Subscription",
    //    buy_now: "Buy now",
    //    per_month: " / mo",
    //    lifetime_access: "Lifetime Access",
    //    premium_details_title: "Great for self-driven learners who thrive with complete autonomy.",
    //    premium_details_1: "Access to subscriber-only heroes, pets and skills",
    //    premium_details_2: "Receive bonus gems to buy gear, pets and more heroes",
    //    premium_details_3: "Unlock a deeper understanding of core concepts and skills like web and game development",
    //    premium_details_4: "Premium support for subscribers",
    //    premium_details_5: "Create private clans to invite friends and compete on a group leaderboard",
    //    premium_need_help: "Need help or prefer Paypal? Email <a href=\"mailto:support@codecombat.com\">support@codecombat.com</a>",
    //    not_sure_kid: "Not sure if CodeCombat is right for your kid?  Ask them!",
    //    share_trailer: "Share our game trailer with your kid and have them create an account to get started.",
    //    why_kids_love: "Why Kids Love CodeCombat",
    //    learn_through_play: "Learning Through Play",
    //    learn_through_play_detail: "Students grow their coding skills, and also use problem-solving skills to progress through levels and power up their heroes.",
    //    skills_they_can_share: "Skills They Can Share",
    //    skills_they_can_share_details: "Students build real-world skills and create projects, such as games and webpages, that they can share with friends and family.",
    //    help_when_needed: "Help When They Need It",
    //    help_when_needed_detail: "Using data, every level has been built to be challenging, but never discouraging.  Students are supported with hints when they get stuck.",
    //    book_first_class: "Book your first class",
    //    why_parents_love: "Why Parents Love CodeCombat",
    //    most_engaging: "The most engaging way to learn typed code",
    //    most_engaging_detail: "Your child will have everything they need at the tip of their fingers to program algorithms in Python or JavaScript, build websites and even design their own games, while learning material aligned with national curriculum standards.",
    //    critical_skills: "Building critical skills for the 21st century",
    //    critical_skills_detail: "Your child will learn how to navigate and become citizens in the digital world. CodeCombat is a solution that enhances your child’s critical thinking, creativity, and resilience, empowering them with the skills they need for any industry.",
    //    parent_support: "Supported by parents like you",
    //    parent_support_detail: "At CodeCombat, we’re parents. We’re coders. We’re educators. But most of all, we’re people who believe in giving our kids the best opportunity for success in whatever it is they decide to do.",
    //    everything_they_need: "Everything they need to start typing code on their own",
    //    beginner_concepts: "Beginner Concepts",
    //    beginner_concepts_1: "Basic syntax",
    //    beginner_concepts_2: "While loops",
    //    beginner_concepts_3: "Arguments",
    //    beginner_concepts_4: "Strings",
    //    beginner_concepts_5: "Variables",
    //    beginner_concepts_6: "Algorithms",
    //    intermediate_concepts: "Intermediate Concepts",
    //    intermediate_concepts_1: "If statements",
    //    intermediate_concepts_2: "Boolean comparisons",
    //    intermediate_concepts_3: "Nested conditionals",
    //    intermediate_concepts_4: "Functions",
    //    intermediate_concepts_5: "Basic input handling",
    //    intermediate_concepts_6: "Basic game artificial intelligence",
    //    advanced_concepts: "Advanced Concepts",
    //    advanced_concepts_1: "Event handling",
    //    advanced_concepts_2: "Conditional while loops",
    //    advanced_concepts_3: "Object literals",
    //    advanced_concepts_4: "Parameters",
    //    advanced_concepts_5: "Vectors",
    //    advanced_concepts_6: "Math library operations",
    //    advanced_concepts_7: "Recursion",
    //    get_started: "Get Started",
    //    quotes_title: "What parents and kids are saying about CodeCombat",
    //    quote_1: "\"This is next level coding for kids and it’s pretty fun. I am going to learn a thing or two from this too.\"",
    //    quote_2: "\"I liked learning a new skill that I haven’t done before. I liked that when I was struggling, I could find the goals. I also liked that you could see the code work correctly.\"",
    //    quote_3: "\"Oliver’s Python is coming along. He’s using CodeCombat to make his own video games. He challenges me to play his games, then laughs when I lose.\"",
    //    quote_4: "\"This is one of my favorite things to do. Every morning I wake up and play CodeCombat. If I had to give CodeCombat a rating from 1 to 10, I would give it a 10!\"",
    //    parent: "Parent",
    //    student: "Student",
    //    grade: "Grade",
    //    subscribe_error_user_type: "Looks like you've already signed up for an account. If you're interested in CodeCombat Premium, please contact us at team@codecombat.com.",
    //    subscribe_error_already_subscribed: "You've already signed up for a Premium account.",
    //    start_free_trial_today: "Start free trial today",
    //    live_classes_title: "Live coding classes from CodeCombat!",
    //    live_class_booked_thank_you: "Your live class has been booked, thank you!",
    //    book_your_class: "Book Your Class",
    //    call_to_book: "Call now to book",
    //    student_journey_start: "Congratulations! Your student's coding journey is about to begin!",
    //    enter_email_address: "Please provide your email address to get started:",
    //    enter_parent_email_address: "If you are a student under 18 years of age, please enter your parent or guardian's email address.",
    //    email_sent_success: "Awesome! An email has been sent to the address you provided.",
    //    email_schedule_info: "Please open and click the link to access our trial class scheduling portal and select any available time that works best for you.",
    //    personalized_coding: "Personalized Coding Instruction",
    //    premium_access: "Premium Access",
    //    focus_choice: "Your Focus, Your Choice",
    //    get_free_coding_class: "You Get a Free Coding Class",
    //    tailored_guidance: "Tailored guidance in Python, Javascript, Lua, and more",
    //    enjoy_all_games: "Enjoy all our web games and Roblox experiences",
    //    choice_of_path: "Select from Coding Fundamentals, Game Development, AI Applications, AP CSP Prep, and more for a personalized learning path",
    //    classes_in_spanish_english: "Classes are available in English or Spanish",
    //    free_class: "Free Class",
    //  },

    //  modal_timetap_confirmation: {
    //    congratulations: "Congratulations!",
    //    paragraph_1: "Your student’s coding adventure awaits.",
    //    paragraph_2: "We have your child booked for an online class and we’re so excited to meet them!",
    //    paragraph_3: "Soon you should be recieving an email invitation with the class schedule details as well as your class instructor’s name and contact information.",
    //    paragraph_4: "If for whatever reason you need to modify your class selections, reschedule or just want to talk with a customer care specialist, simply reach out using the contact information provided in your email invitation.",
    //    paragraph_5: "Thank you for choosing CodeCombat and good luck on your computer science journey!",
    //    back_to_coco: "Back to CodeCombat",
    //  },

    //  hoc_2018: {
    //    banner_coco: "Welcome to Hour of Code!",
    //    banner_ozar: "Happy Computer Science Education Week!",
    //    page_heading: "Your students will learn to code by building their own game!",
    //    page_heading_ai_league: "Your students will learn to code their own multiplayer AI!",
    //    page_heading_goblins: "Your students will learn coding by saving a village from goblins!",
    //    step_1: "Step 1: Watch Video Overview",
    //    step_2: "Step 2: Try it Yourself",
    //    step_3: "Step 3: Download Lesson Plan",
    //    try_activity: "Try Activity",
    //    download_pdf: "Download PDF",
    //    solutions: "Solutions",
    //    teacher_signup_heading: "Turn Hour of Code into a Year of Code",
    //    teacher_signup_blurb: "Everything you need to teach computer science, no prior experience needed.",
    //    teacher_signup_input_blurb: "Get first course free:",
    //    teacher_signup_input_placeholder: "Teacher email address",
    //    teacher_signup_input_button: "Get CS1 Free",
    //    activities_header: "More Hour of Code Activities",
    //    activity_label_1: "Beginner CS: Escape the Dungeon!",
    //    activity_label_2: " Beginner GD: Build a Game!",
    //    activity_label_3: "Advanced GD: Build an Arcade Game!",
    //    activity_label_hoc_2018: "Intermediate GD: Code, Play, Create",
    //    activity_label_ai_league: "Beginner CS: Esports Bootcamp: AI League",
    //    activity_label_goblins: "Beginner CS: Goblins 'n' Glory",
    //    activity_button_1: "View Lesson",
    //    about: "About CodeCombat",
    //    about_copy: "A game-based, standards-aligned computer science program that teaches real, typed Python and JavaScript.",
    //    point1: "✓ Scaffolded",
    //    point2: "✓ Differentiated",
    //    point3: "✓ Assessments",
    //    point4: "✓ Project-based courses",
    //    point5: "✓ Student tracking",
    //    point6: "✓ Full lesson plans",
    //    title: "HOUR OF CODE",
    //    acronym: "HOC",
    //    play_video: "Play Video",
    //    featured_title_1: "CodeCombat: Goblins 'n' Glory",
    //    featured_subtitle_1: "Grades 6-8 | JavaScript, Python",
    //    featured_blurb_1: "We need your help! Embark on an epic quest where you take control of the game through your powers of programming.",
    //    featured_title_2: "Esports Bootcamp: AI League",
    //    featured_subtitle_2: "Grades 6-8 | JavaScript, Python",
    //    featured_blurb_2: "Competitive coding has never been so epic! Learn the skills you need to play like the pros in our Esports Bootcamp. No coding experience needed",
    //    featured_title_3: "Ozaria: Your Journey Begins",
    //    featured_subtitle_3: "Grades 6-8 | JavaScript, Python",
    //    featured_blurb_3: "Enter the world of Ozaria where you must use the power of coding to defeat a darkness that has taken over the world!",
    //    page_heading_latest_activities: "Our latest activities are easy to implement and fun to play",
    //  },

    //  hoc_2018_interstitial: {
    //    welcome: "Welcome to CodeCombat's Hour of Code!",
    //    educator: "I'm an educator",
    //    show_resources: "Show me teacher resources!",
    //    student: "I'm a student",
    //    ready_to_code: "I'm ready to code!",
    //  },

    //  hoc_2018_completion: {
    //    congratulations: "Congratulations on completing <b>Code, Play, Share!</b>",
    //    send: "Send your Hour of Code game to friends and family!",
    //    copy: "Copy URL",
    //    get_certificate: "Get a certificate of completion to celebrate with your class!",
    //    get_cert_btn: "Get Certificate",
    //    first_name: "First Name",
    //    last_initial: "Last Initial",
    //    teacher_email: "Teacher's email address",
    //  },

    //  school_administrator: {
    //    title: "School Administrator Dashboard",
    //    my_teachers: "My Teachers",
    //    last_login: "Last Login",
    //    licenses_used: "licenses used",
    //    total_students: "total students",
    //    active_students: "active students",
    //    projects_created: "projects created",
    //    other: "Other",
    //    notice: "The following school administrators have view-only access to your classroom data:",
    //    add_additional_teacher: "Need to add an additional teacher? Contact your CodeCombat Account Manager or email support@codecombat.com. ",
    //    license_stat_description: "Licenses available accounts for the total number of licenses available to the teacher, including Shared Licenses.",
    //    students_stat_description: "Total students accounts for all students across all classrooms, regardless of whether they have licenses applied.",
    //    active_students_stat_description: "Active students counts the number of students that have logged into CodeCombat in the last 60 days.",
    //    project_stat_description: "Projects created counts the total number of Game and Web development projects that have been created.",
    //    no_teachers: "You don’t have any schools tied to your account yet. Please contact your <strong>District Success Manager</strong> or <a href=\"mailto:schools@codecombat.com\">schools@codecombat.com</a> to get your dashboard set up.",
    //    totals_calculated: "How are these totals calculated?",
    //    totals_explanation_1: "How are these totals calculated?",
    //    totals_explanation_2: "Licenses used",
    //    totals_explanation_3: "Counts total licenses applied to students out of total licenses available.",
    //    totals_explanation_4: "Total students",
    //    totals_explanation_5: "Counts teacher’s students across all of their active classrooms. To see total students enrolled in both active and archived classrooms, go to the Student Licenses page.",
    //    totals_explanation_6: "Active students",
    //    totals_explanation_7: "Counts all students who were active within the past 60 days.",
    //    totals_explanation_8: "Projects created",
    //    totals_explanation_9: "Counts total games and web pages created.",
    //    date_thru_date: "__startDateRange__ thru __endDateRange__",
    //    teachers: "Teachers",
    //    students_enrolled: "Students Enrolled",
    //    select_time_range: "Select the time range:",
    //    export: "Export",
    //    preview: "Here is a preview for top 200 lines, Click the Export to get full stats",
    //    empty_results: "Empty Results.",
    //    roster: "Roster",
    //    licenses_total_label: "Licenses",
    //    enrolled_label: "Students Enrolled",
    //    active_classes: "active classes",
    //    licenses_class_label: "Licenses in use",
    //    license_details: "License Details",
    //    view_classes: "View Classes",
    //    my_schools: "My Schools",
    //    admin_licenses: "Admin Licenses",
    //    class_membership_history: "Classroom Membership History",
    //    membership_tooltip: "<p><b>The Classroom Membership History</b> displays the total number of unique students who were enrolled across all classrooms.</p><p><b>Remember:</b> Classes may be archived and licenses may be reused throughout the school year, so these numbers represent how many students truly participated in the program.</p>",
    //    have_license_question: "Have license related questions?",
    //  },

    //  interactives: {
    //    phenomenal_job: "Phenomenal Job!",
    //    try_again: "Whoops, try again!",
    //    select_statement_left: "Whoops! Select a code statement before pressing Submit.",
    //    fill_boxes: "Whoops, make sure to fill all boxes before hitting \"Submit.\"",
    //    cannot_play_video: "Sadly, this video cannot be played in your area.",
    //    console_instructions: "See why by opening your browser console: 1) Right click 2) Choose \"Inspect\" 3) Click the console tab.",
    //    skip_video: "Skip video",
    //    unavailable: "Unavailable",
    //  },

    //  browser_recommendation: {
    //    title: "CodeCombat works best on Chrome!",
    //    pitch_body: "For the best CodeCombat experience we recommend using the latest version of Chrome. Download the latest version of chrome by clicking the button below!",
    //    download: "Download Chrome",
    //    ignore: "Ignore",
    //  },

    //  admin: {
    //    license_type_full: "Full Courses",
    //    license_type_hackstack: "Hackstack",
    //    license_type_customize: "Customize Courses",
    //  },

    //  events: {
    //    title: "CodeCombat Events",
    //    main_title: "CodeCombat Events",
    //    main_description: "The important events of codecombat China",
    //    dashboard: "Events Dashboard",
    //    online_classes: "Online Classes",
    //    my_classes: "My Online Classes",
    //    classes_stats: "Online Classes Stats",
    //    name: "Name",
    //    class_name: "Class Name",
    //    description: "Description",
    //    owner: "Owner",
    //    type: "Type",
    //    members: "Members",
    //    start_date: "Start Date",
    //    end_date: "End Time",
    //    time_range: "Time Range",
    //    rrule: "Recurrence Rules",
    //    add_member: "Add Member",
    //    class_count: "Lessons Count",
    //    done: "Finished Lesson",
    //    attendance: "Attendance",
    //    course_description: "Teacher Notes",
    //    teacher_notes: "Teacher Notes",
    //    levels_completed: "Levels Completed",
    //    no_levels_completed: "No Completed Levels Found",
    //    no_teacher_notes: "No Teacher Notes Found",
    //    no_video_recording: "No Video Recording Found",
    //    reply: "Reply",
    //    video_recording: "Video Recording",
    //    import_from_class: "Import from Class",
    //    link_google_calendar: "Link with Google Calendar",
    //    sync_to_google: "Sync to Google Calendar",
    //    synced_to_google: "Synced to Google Calendar",
    //    google_calendar_attendees: "Google Calendar Attendees",
    //    calendar: "Calendar",
    //    edit_instance_tab_desc: "Edit the single instance of this event, for editing whole events, see edit tab",
    //    edit_event_tab_desc: "Edit the whole event, for editing single instance of this event, see instance tab",
    //    edit_members_tab_desc: "Edit the member of this event, the startDate is depends on the instance date, so select the first instance for the new member",
    //    lessons_count_desc: "The total lessons count of this member, normally it is the same as the event instances count, but it can be different if the member is added after the event started or ended before the event ended",
    //    sync_to_google_desc: "Sync this event to YOUR google calendar, instead of the owner's calendar. And can only work on CodeCombat gmail",
    //    no_data_display: "No data to display",
    //    meetingLink: "Meeting Link",
    //    time_zone: "Time Zone",
    //    timezone_tips: "Note - Your timezone: ",
    //  },

    //  teacher_dashboard: {
    //    lock: "Lock",
    //    unlock: "Unlock",
    //    lock_until_date: "Lock until date",
    //    skip: "Skip",
    //    unskip: "Unskip",
    //    make_optional: "Make optional",
    //    remove_optional: "Remove Optional",
    //    until_date: "until __date__",
    //    unassign: "Unassign",
    //    locked: "Locked",
    //    locked_by_previous: "Locked by previous level",
    //    locked_with_timeframe: "Locked",
    //    skipped: "Skipped",
    //    skipped_desc: "Students cannot play skipped levels. They are marked optional so students can still progress.",
    //    optional: "Optional",
    //    optional_desc: "Students may play these but are not required to complete them.",
    //    assigned: "Assigned",
    //    unlocked: "Unlocked",
    //    unassigned: "Unassigned",
    //    complete: "Complete",
    //    progress: "In Progress",
    //    choose_course: "Click to Select from Dropdown",
    //    teacher_locked_message: "Your teacher has locked the next level",
    //    plan_your_class_title: "Plan your first class by",
    //    plan_your_class1: "Viewing course progression info",
    //    plan_your_class2: "Previewing lesson slides & extension activities",
    //    plan_your_class3: "Trying the first chapter for free",
    //    click_dismiss: "Click to Dismiss",
    //    track_progress: "Track Progress",
    //    track_progress_desc: "Click into the class you just created to view detailed student progress.",
    //    add_classes_title: "Add Classes Here",
    //    add_classes: "Add classes and get students started with the first free chapter!",
    //    all_classes: "All Classes",
    //    my_licenses: "My Licenses",
    //    resource_hub: "Teacher Toolkit",
    //    pd: "Professional Development",
    //    pd_short: "PD",
    //    apcsp: "APCSP",
    //    curriculum_guide: "Curriculum Guide",
    //    curriculum: "Curriculum",
    //    coming_soon: "Coming Soon!",
    //    add_class: "Add New Class",
    //    no_licenses_yet: "No licenses yet",
    //    req_licenses: "Request Licenses",
    //    license_ratio_used: "__totalUsedLicenses__ out of __totalSpots__",
    //    licenses_applied: "Licenses Applied",
    //    student_projects: "Student Projects",
    //    no_classes_yet: "No classes yet",
    //    exemplar_project: "Exemplar Project",
    //    capstone_proj_for: "Capstone Project for __courseName__",
    //    project_rubric: "Project Rubric",
    //    select_chapter: "Select Chapter",
    //    select_course: "Select Course",
    //    concept_flag: "Concept Flag",
    //    support_learning: "Support Learning",
    //    concept_flag_desc: "More than 50% of the class attempted a Concept Check 3 or more times.",
    //    concept_flag_desc2: "Student attempted a Concept Check 3 or more times.",
    //    click_progress_dot_tip: "Tip: Click on the progress bubbles for more details",
    //    color_code: "Color Code",
    //    content_guide: "Content Guide",
    //    story: "Story",
    //    cutscenes: "Cutscenes",
    //    cutscenes_tooltip: "<h3>Cutscene</h3><p>Short videos that explain parts of the epic Ozaria narrative.</p>",
    //    cinematics: "Cinematics",
    //    cinematics_tooltip: "<h3>Cinematic</h3><p>Expositional dialogue that introduces concepts in an engaging back-and-forth between characters.</p><p class=\"small\">Part of an <b>intro</b>, which introduce new concepts in a scaffolded way.</p>",
    //    concepts_tooltip: "<h3>Concept Check</h3><p>Formative checks for student understanding presented in varied formats, including drag-and-drop and code ordering questions.</p><p class=\"small\">Part of an <b>intro</b>, which introduce new concepts in a scaffolded way.</p>",
    //    ozaria_practices_tooltip: "<h3>Practice Level</h3><p>Game-play in which students are practicing concepts while solving puzzles to complete their hero's quest.</p>",
    //    challenges_tooltip: "<h3>Challenge Level</h3><p>Game-play that combines key concepts students have practiced previously.</p>",
    //    capstones_tooltip: "<h3>Capstone Level</h3><p>Students create games and stories using key concepts they learned from the chapter.</p>",
    //    coco_practices_tooltip: "<h3>Practice Level</h3><p>They are optional and only appears for the students that the system think needs extra practice.</p>",
    //    multiplayers_tooltip: "<h3>Multiplayer Level</h3><p>Levels which students can play against others.</p>",
    //    mains_tooltip: "<h3>Core Level</h3><p>Game-play in which students are practicing concepts while solving puzzles to complete their hero's quest.</p>",
    //    learn_to_use_tooltip: "<h3>Learn</h3><p>Students follow guided steps to learn how to craft effective AI prompts, building skills through structured practice.</p>",
    //    practice_tooltip: "<h3>Practice</h3><p>Students apply their prompting skills with light teacher guidance, bridging structured learning and open-ended creation.</p>",
    //    use_tooltip: "<h3>Create</h3><p>Students freely apply their prompting skills with open-ended access to the AI model.</p>",
    //    ai_capstone_tooltip: "<h3>AI Capstone</h3><p>A summative assessment at the end of each module where students build a project from scratch using all the prompting skills from the module.</p>",
    //    concept_checks: "Concept Checks",
    //    practice_level: "Practice Level",
    //    practice_levels: "Practice Levels",
    //    extra_practice: "Extra Practice",
    //    challenge_levels: "Challenge Levels",
    //    capstone_levels: "Capstone Levels",
    //    main_levels: "Core Levels",
    //    multiplayer_levels: "Multiplayer Levels",
    //    learn_levels: "Learn",
    //    use_levels: "Create",
    //    intro: "Intro",
    //    practice: "Practice",
    //    assess: "Assess",
    //    multiplayer: "MultiPlayer",
    //    main: "Main",
    //    type: "Type",
    //    view_options: "View Options",
    //    manage_class: "Manage Class",
    //    assign_content: "Assign Content",
    //    remove_students: "Remove Students",
    //    revoke_licenses: "Revoke Licenses",
    //    remaining_licenses: "__remaining__ license(s) remaining",
    //    start_date: "Start: __date__",
    //    end_date: "End: __date__",
    //    license_questions: "Have questions about applying or revoking licenses?",
    //    need_more_licenses: "Need more licenses? We'll help you build a solution that meets your needs.",
    //    see_also_our: "See also our",
    //    for_more_funding_resources: "for how to leverage CARES Act funding sources like ESSER and GEER.",
    //    support_oz: "support@ozaria.com",
    //    standards_alignment: "Standards Alignment",
    //    standards_sample: "A sample of the standards covered in this Chapter:",
    //    add_course_to_classroom: "Add Course",
    //    play_chapter: "Play Chapter",
    //    play_course: "Play Course",
    //    class_time_range: "Class Time (Range):",
    //    in_game_play_time: "In-Game Play Time:",
    //    class_time: "Class Time",
    //    solution_guide: "Solution Guide",
    //    module: "Module",
    //    need_licenses_tooltip: "<h3>You need licenses to access this content!</h3><p>Please visit the <a href='/teachers/licenses'>My Licenses</a> page for more information.</p>",
    //    lesson_slides_tooltip: "<h3>Lesson Slides</h3><p>Downloadable, step-by-step presentation slides for guiding students through module learning objectives</p>",
    //    project_rubric_tooltip: "<h3>Project Rubric</h3><p>Downloadable and modifiable scoring rubric for the Capstone Project</p>",
    //    exemplar_projects_tooltip: "<h3>Exemplar Project</h3><p>Live view of the exemplar Capstone Project</p>",
    //    add_course_to_classroom_tooltip: "<h3>Add Course to Classroom</h3><p>This course is not yet in your classroom. To add it, click this button.</p>",
    //    want_to_save_tooltip: "<h3>Want to save your progress?</h3><p>Please create a student account, or go to <i>My Account / Test as Student</i> and play Ozaria as a student if you would like to save your progress.</p>",
    //    want_to_save_tooltip_coco: "<h3>Want to save your progress?</h3><p>Please create a student account, or go to <i>My Account / Test as Student</i> and play CodeCombat as a student if you would like to save your progress.</p>",
    //    intro_explain_tooltip: "<b>\"Intros\"</b> introduce new concepts or further the storyline in a scaffolded way. They typically include Cinematics and/or Concept Checks.",
    //    chapter_num: "Chapter __num__",
    //    read: "View Only",
    //    write: "Full Access",
    //    read_blurb: "View Only permits the added teacher to view your class and student progress without the ability to make changes to your class.",
    //    write_blurb: "Full Access grants the added teacher the ability to make modifications to your class (add/remove students, assign chapters, modify licensure)",
    //    shared_with_none: "This class is not currently shared with any other teachers.",
    //    shared_with: "Shared with",
    //    share_info: "To give other teachers access to the class, add their emails below.",
    //    class_owner: "Class Owner",
    //    share: "Share",
    //    add: "Add",
    //    note: "Note",
    //    lock_or_skip_levels: "Lock or Skip Levels",
    //    level_access_status_blurb: "When you choose to skip a level, it will have both the 'locked' and 'optional' status. Unskipping the level will remove both the 'locked' and 'optional' statuses.",
    //    reset_progress: "Reset Progress",
    //    export_progress: "Export Progress",
    //    assessments_tab: "Assessments",
    //    ai_hackstack_junior_tab: "AI Junior",
    //    switch_on: "On",
    //    switch_off: "Off",
    //    ai_league: "AI League",
    //    version_old: "Old",
    //    version_new: "New",
    //    dashboard_version: "Dashboard Version",
    //    arena_days_left: "Days left in Season __season__, __arenaName__:",
    //    arena_days_elapse: "Season __season__, __arenaName__ ended __time__",
    //    global_stats_vs_team_stats: "Global stats vs team stats",
    //    global_stats: "Global stats",
    //    show_stats_for_all_players_and_teams: "show stats for all players and teams.",
    //    team_stats: "Team stats",
    //    show_stats_for_individuals_playing_on_the_same_team: "show stats for individuals playing on the same team.",
    //    for_each_class_you_add_a_team_will_be_automatically_created_for_the_students_in_that_class: "For each class you add, a team will be automatically created for the students in that class.",
    //    view_team_page: "Team Page",
    //    no_modifiers_changed: "Levels already modified for these students",
    //    no_modifiers_changed_unlocks_skipped: "It appears you attempted to unlock levels that aren't currently locked. Please note, if your selected level appears as locked, it might be due to a preceding level being locked. To proceed, ensure to unlock the prior level first.",
    //    view_custom_league: "View Custom League",
    //    view_global_league: "View Global League",
    //    refresh_progress: "Refresh Progress",
    //    assign_content_first: "Please ensure that content is assigned to students before adjusting access levels",
    //    failed_attempts: "Failed Attempts",
    //    no_failed_attempts: "No Failed Attempts",
    //    failed_attempts_subtext: "Number of times incorrect option was selected",
    //    open_project: "Open Project",
    //    create_class_hackstack: "Please create a New Class to access AI HackStack",
    //    add_club: "Add New Club / Camp / Annual",
    //    test_student_only: "(Test Student Only)",
    //    ready_to_review: "Ready to Review",
    //    ozaria_hs_modal_title: "Access AI Hackstack Exclusively on CodeCombat",
    //    ozaria_hs_modal_blurb: "Educators can now access AI Hackstack directly on **[https://codecombat.com/teachers/ai-league]CodeCombat** using the same credentials as Ozaria. For added convenience, you can easily import your classes from Ozaria into CodeCombat.",
    //    ozaria_ai_league_modal_title: "Access AI League Exclusively on CodeCombat",
    //    ozaria_ai_league_modal_blurb: "Educators can now access AI League directly on **[https://codecombat.com/teachers/ai-league]CodeCombat** using the same credentials as Ozaria. For added convenience, you can easily import your classes from Ozaria into CodeCombat.",
    //    completed_all_practice_levels: "The student has successfully completed all practice levels.",
    //    played_some_practice_levels: "The student has started working on the practice levels.",
    //    ai_league_start_title: "Welcome to AI League!",
    //    ai_league_start_blurb: "Our Getting Started guide walks you through everything you need to know - from setting up your first class to running your first tournament.",
    //    ai_league_curriculum_title: "AI League Curriculum",
    //    ai_league_curriculum_blurb: "Access our comprehensive curriculum guides designed specifically for AI League arenas. These resources help you introduce competitive coding concepts and teach strategic thinking.",
    //    ai_league_custom_title: "Custom AI League Tournaments",
    //    ai_league_custom_blurb: "Create your own customized tournaments to engage your students! Select from our library of coding arenas and set competition dates, whether it's a classroom challenge or a school-wide competition.",
    //    this_project_is_remixed: "This project is remixed.",
    //    view_original_project: "View Original Project",
    //    activate_license: "Activate License",
    //    violation: "Violation",
    //    safety_violations: "Safety Violations",
    //    warning: "Warning",
    //    collapse: "Collapse",
    //    num_student: "__num__ Students",
    //    one_student: "__num__ Student",
    //    sort_by_last_name: "Last Name",
    //    sort_by_first_name: "First Name",
    //    sort_by_progress_desc: "Progress (High to Low)",
    //    sort_by_progress_asc: "Progress (Low to High)",
    //    no_write_permission: "You do not have a write permission on this class",
    //    select_student_first: "You need to select student(s) first before performing that action.",
    //    no_progress_to_delete: "No progress to delete",
    //    deleting_progress: "Deleting progress",
    //    delete_progress_warning: "Warning: student progress for __courseName__ will be deleted and cannot be recovered. Are you sure?",
    //    error_adding_teacher: "Error in adding teacher",
    //    error_occurred: "Error occurred: __err__",
    //    password_changed_successfully: "Password Changed successfully!",
    //    remove_students_title: "Remove Students from Class",
    //    remove_confirm_title: "Are you sure you want to remove (this student / these students) from your class?",
    //    remove_list_1: "If licenses are applied, remember to revoke them before removing students in order to apply them to other students.",
    //    remove_list_2: "Student(s) will lose access to this classroom and assigned chapters.",
    //    remove_list_3: "Student progress will not be lost and can be viewed if the student can be added back to the classroom at any time.",
    //    pick_a_license: "Pick a License",
    //    having_access: "Having Access",
    //    course_preview: "Course Preview",
    //    curriculum_coco: "CodeCombat",
    //    curriculum_ozaria: "Ozaria",
    //    curriculum_beta: "Beta",
    //    progress_last_fetched: "Progress last fetched",
    //    refresh_progress_helptext: "Student progress may take 2–3 minutes to sync after completion.",
    //    ai_evaluation: "AI Evaluation",
    //    ai_evaluated_on: "AI Evaluated On",
    //    ai_eval_yes: "AI Passed",
    //    ai_eval_no: "AI Failed",
    //    ai_eval_unsure: "AI Unsure",
    //    ai_eval_unsure_desc: "The AI evaluator could not confidently determine if the student completed the objective.",
    //    ai_struggling: "Struggling",
    //    ai_struggling_desc: "The student picked the wrong option more than once.",
    //    ai_unsafe_desc: "The student's conversation with the AI was flagged as unsafe, such as attempting to cheat, bypass the AI, or use abusive language.",
    //    ai_eval_status: "AI Evaluation Status",
    //    ai_model: "AI Model",
    //    welcome_tour_title: "A 60-second tour",
    //    welcome_tour_desc: "This page can feel busy at first. Let's walk through the handful of things you'll actually use — finding students, reading progress, and assigning work — in order.",
    //    all_students_title: "Your students",
    //    all_students_desc: "Everyone in this class appears in this column. Click any student to open their individual details and progress.",
    //    content_symbol_title: "What's in each lesson",
    //    content_symbol_desc: "Each symbol is one piece of content. Hover to preview it or play the level yourself. The icon shape tells you the type — see the Content Guide above for what each one means.",
    //    progress_dot_title: "How each student is doing",
    //    progress_dot_desc: "Each dot is one student's progress on that level. Its color shows their status (key is above). Click a dot to open exactly where that student is stuck or succeeding.",
    //    assign_content_title: "Assign work",
    //    assign_content_desc: "Select the students you want, then click here to assign them a new course. This is how you give students access to start.",
    //    apply_licenses_title: "Give access to paid courses",
    //    apply_licenses_desc: "Select students and apply a license so they can unlock and play paid content.",
    //    lock_content_title: "Lock content to set the pace",
    //    lock_content_desc: "Hover any module name to reveal its yellow lock icon — click it to stop students moving past that module until you're ready. Need to lock the whole course at once? Use the Lock or Skip Levels button instead.",
    //    tour_replay_title: "Need a refresher?",
    //    tour_replay_desc: "Lost track? Replay this tour anytime by clicking here.",
    //    replay_tour: "Play Tour",
    //    test_student_step_title: "Try It as a Student",
    //    test_student_step_desc: "Switch into a free test student account to experience the class exactly as your students do — assign content, play levels, and check progress. When you're done, click Stop Switching in the navigation bar to return to your teacher account.",
    //    add_students_step_title: "Invite Students to Your Class",
    //    add_students_step_desc: "Share a class code, send a join link, invite by email, or sync with Google Classroom — click here to find every way students can join and start learning.",
    //    teacher_toolkit_tour_desc: "Find Getting Started guides, educator resources, and FAQs here — everything you need to get comfortable before your first class.",
    //    teacher_toolkit_tour_title: "Your Teaching Toolkit",
    //    curriculum_glossary: "Curriculum Glossary",
    //    curriculum_glossary_desc: "💡 New to this curriculum? Here is a quick key to the courses below:",
    //    curriculum_glossary_desc_hackstack: "Intro: Intro to AI, AI: Artificial Intelligence, ALG: Algebra, CR: Career Readiness, CYB: Cyber, ELA: English Language Arts, CS: Computer Science, EXP: Explorations, SBOX: Sandbox",
    //    curriculum_glossary_desc_ozaria: "CH: Chapter",
    //    curriculum_glossary_desc_codecombat: "CS: Computer Science, GD: Game Development, WD: Web Development",
    //    curriculum_glossary_desc_junior: "JR: Junior",
    //    curriculum_glossary_close: "Got it, hide this",
    //    assign_to_class: "Assign to Class",
    //  },

    //  outcomes: {
    //    outcomes_report: "Outcomes Report",
    //    customize_report: "Customize Report",
    //    done_customizing: "Done Customizing",
    //    start_date: "Start date",
    //    end_date: "End date",
    //    country: "Country",
    //    school_admin: "School Administrator",
    //    school_network: "School Network",
    //    school_subnetwork: "School Subnetwork",
    //    classroom: "Classroom",
    //    view_outcomes_report: "View Outcomes Report",
    //    key_concepts: "Key Concepts",
    //    code_languages: "Code Languages",
    //    using_codecombat: "Using CodeCombat's personalized learning engine...",
    //    wrote: "wrote...",
    //    across_an_estimated: "across an estimated...",
    //    in: "in...",
    //    include: "Include ",
    //    archived: "Archived",
    //    max: "Max ",
    //    multiple: "s",
    //    computer_program: "computer program",
    //    computer_programs: "computer programs",
    //    line_of_code: "line of code",
    //    lines_of_code: "lines of code",
    //    coding_hours: "coding hours",
    //    expressed_creativity: "and expressed creativity by building",
    //    report_content_1: "standalone game and web ",
    //    project: "project",
    //    projects: "projects",
    //    progress_stats: "Progress stats based on sampling __sampleSize__ of __populationSize__ students.",
    //    standards_coverage: "Standards Coverage",
    //    coverage_p1_coco: "The full CodeCombat curriculum covers major programming standards in several widely-adopted frameworks, including those of the International Society for Technology in Education (ISTE), the Computer Science Teacher Association (CSTA), and the K-12 Computer Science Framework.",
    //    coverage_p1_ozar: "The full Ozaria curriculum covers major programming standards in several widely-adopted frameworks, including those of the International Society for Technology in Education (ISTE), the Computer Science Teacher Association (CSTA), and the K-12 Computer Science Framework.",
    //    coverage_p2_coco: "At CodeCombat, we believe that students will be most prepared for both real-world computing jobs and further study of computer science by using real, typed code in full programming languages, so instead of using block-based visual programming languages for beginners, we teach Python and JavaScript – the same languages used widely today by companies ranging from Google to the New York Times.",
    //    coverage_p2_ozar: "Ozaria is created by the CodeCombat, the game-based learning company. We believe that students will be most prepared for both real-world computing jobs and further study of computer science by using real, typed code in full programming languages, so instead of using block-based visual programming languages for beginners, we teach Python and JavaScript – the same languages used widely today by companies ranging from Google to the New York Times.",
    //    questions: "Have questions or want more information? We'd be happy to help.",
    //    reach_out_manager: "Reach out to your Account Manager __name__ at ",
    //    stats_include: "Stats include __number__ other __name__",
    //    include_other_product: "Show __product__ stats",
    //    show_other_product: "Show __product__ stats",
    //    show_license_stats: "Show Detail License Stats",
    //    show_license_summary: "Show License Summary",
    //    license_stats: "License Stats",
    //    license_template: "<b>Licenses</b>: __used__ used, __available__ available",
    //    licensed_teachers: "<b>Teachers with licenses</b>: __teachers__",
    //    licensed_schools: "<b>Schools with licenses</b>: __schools__",
    //    students: "Students",
    //    teachers: "Teachers",
    //    licensesUsed: "Licenses Used",
    //    schools: "Schools",
    //    top_teacher_info: "Teacher __A__, __B__ and __n__ other teachers use our platform",
    //    top_teacher_info_1: "Teacher __A__ and __B__ use our platform",
    //    top_teacher_info_2: "Teacher __A__ uses our platform",
    //    ai_league: "AI League",
    //    ai_league_stats: "__n__ players played in AI League arenas",
    //  },

    //  efficacy: {
    //    ozaria_efficacy: "Ozaria Efficacy",
    //    header_subtitle: "Ozaria has proven to have a positive impact on the student learning outcomes that matter most to both students and educators.",
    //    pathway_dialog_line1: "while True:",
    //    pathway_dialog_line2: "hero.moveDown(1)",
    //    pathway_dialog_line3: "hero.moveRight(2)",
    //    exploring_creativity: "Exploring Creativity",
    //    exploring_creativity_description: "Almost all students surveyed said they really enjoyed being able to create their own game at the end of each Chapter.",
    //    essential_skills: "Essential Skills",
    //    essential_skills_description: "Teachers found Ozaria to be a superior curriculum for teaching complex coding concepts as well as essential 21st century skills, such as problem solving and reasoning, critical and computational thinking skills.",
    //    fun_engaging: "Fun & Engaging",
    //    fun_engaging_description: "Ozaria was reported to be a fun and engaging curriculum. Students especially noted how effective it was in teaching text-based coding, and how the tutorials, hints, and error messages provided the appropriate amount of support.",
    //    easy_to_use: "Easy to Use",
    //    easy_to_use_description: "Both teacher and students found the platform easy to implement and use.",
    //    mcintosh_study_title: "Increasing Score Gains on Assessments",
    //    mcintosh_middle_school: "McIntosh Middle School",
    //    mcintosh_study_description: "A novice teacher with advanced level coding experience taught three cohorts of students. Each cohort was studied across a full semester.",
    //    study_highlights_title: "Highlights from the study results:",
    //    mcintosh_study_highlight_1: "98% of students rated their level of enthusiasm for Ozaria as high or extremely high",
    //    mcintosh_study_highlight_2: "100% of students scored above 70% on both the mid-term and final assessments",
    //    read_the_study: "Read the Study (PDF)",
    //    mrms_study_title: "Gaining Confidence in Computer Science",
    //    mountain_ridge_middle_school: "Mountain Ridge Middle School",
    //    mrms_study_description: "An experienced teacher with beginning level coding experience taught two cohorts of students. Each cohort was studied across a full semester.",
    //    mrms_study_highlight_1: "Students made an average gain score of 33% between the pre-assessment and the final assessment",
    //    mrms_study_highlight_2: " Both the teacher and students found Ozaria to be fun, engaging, and easy to use.",
    //    graph1_description: "Students made a 47% average gain score between the pre-assessment and the final assessment.",
    //    graph2_description: "More than 90% of students rated their coding confidence level as Confident or Extremely Confident after using Ozaria.",
    //    quote_section_content: "One thing I am able to do now that I could not do before is actually believe I can code.",
    //    quote_section_footer: "Student, Mountain Ridge Middle School",
    //    teacher_quote1_content: "The curriculum had students thoroughly engaged. They enjoyed the story and the characters. More importantly, they gained confidence in their ability to solve complex problems with concepts they'd learned in Ozaria.",
    //    teacher_quote1_footer1: "Ronnie Cox, Teacher",
    //    teacher_quote1_footer2: "McIntosh Middle School",
    //    student_quote_content: "I like that you can make a mistake and the game corrects it or tells you that there's an error. A lot of beginners make a lot of mistakes when coding and sometimes don't know how to code, so they can't correct their mistakes because they don't know what's wrong. Ozaria is the perfect coding game for beginners.",
    //    student_quote_footer: "Student, McIntosh Middle School",
    //    teacher_quote2_content: "I have absolutely loved using Ozaria in my class for the past three years. My students have thoroughly enjoyed the storyline as they learned Python in a self-paced learning environment. I would highly recommend Ozaria for teachers that know little to nothing about coding, as the support for teachers is very in-depth.",
    //    teacher_quote2_footer1: "Lynette Personett, Teacher",
    //    teacher_quote2_footer2: "Mountain Ridge Middle School",
    //    commitment_title: "CodeCombat’s Commitment to Efficacy",
    //    commitment_description: "We are committed to ensuring our products have a positive and measurable impact on learning outcomes. We create meaningful learning experiences, and use evidence-based practices to design content that will realize the outcomes that matter the most to teachers and students.",
    //    commitment_question: "Interested in implementing an effective and impactful CS curriculum at your school?",
    //    teachers_love_codecombat: "Teachers Love CodeCombat",
    //    teachers_love_description: "Explore the impact of our sister product, CodeCombat, on Computer Science teaching & learning!",
    //    teachers_love_box1: "Report that their students enjoy using CodeCombat to learn how to code",
    //    teachers_love_box2: "Would recommend CodeCombat to other computer science teachers",
    //    teachers_love_box3: "Say that CodeCombat helps them support students’ problem solving abilities",
    //    classroom_image: "Classroom",
    //    ozaria_branding_logo: "Ozaria branding logo",
    //    dog: "Dog",
    //    hero: "Hero",
    //    teacher: "Teacher",
    //  },

    league: {
      //    student_register_1: "Become the next AI Champion!",
      //    student_register_2: "Sign up, create your own team, or join other teams to start competing.",
      //    student_register_3: "Provide the information below to be eligible for prizes.",
      //    teacher_register_1: "Sign up to access your class league profile page and get your class started.",
      //    general_news: "Get emails on the latest news and updates regarding our AI Leagues and tournaments.",
      //    how_it_works1: "Join a __team__",
      seasonal_arena_tooltip: 'Stań do walki ze swoimi znajomymi oraz innymi użytkownikami, używając całej zebranej programistycznej wiedzy, by zdobywać punkty i piąć się w górę tabeli wyników Zawodów Sztucznej Inteligencji, przed mistrzostwami na końcu sezonu.',
      //    summary: "The CodeCombat AI League is uniquely both a competitive AI battle simulator and game engine for learning real Python and JavaScript code.",
      //    join_now: "Join Now",
      //    tagline: "The CodeCombat AI League combines our project-based standards-aligned curriculum, engaging adventure-based coding game, and our annual AI coding global tournament into an organized academic competition unlike any other.",
      //    ladder_subheader: "Use your coding skills and battle strategies to rise up the ranks!",
      //    earn_codepoints: "Earn CodePoints by completing levels",
      //    codepoints: "CodePoints",
      //    free_1: "Access competitive multiplayer arenas, leaderboard, and global coding championships",
      //    free_2: "Earn points for completing practice levels and competing in head-to-head matches",
      //    free_3: "Join competitive coding teams with friends, family, or classmates",
      //    free_4: "Showcase your coding skills and take home great prizes",
      //    compete_season: "Put all the skills you’ve learned to the test! Compete against students and players from across the world in this exciting culmination to the season.",
      //    season_subheading1: "For both Season and Championship arenas, each player programs their team of “AI Heroes” with code written in Python, JavaScript, C++, Lua, or Java.",
      //    season_subheading2: "Their code informs the strategies their AI Heroes will execute in a head-to-head battle against other competitors.",
      //    team_derbezt: "Learn coding and win prizes sponsored by superstar Mexican actor, comedian, and filmmaker Eugenio Derbez.",
      //    invite_link: "Invite players to this team by sending them this link:",
      //    public_link: "Share this team leaderboard with its public link:",
      //    end_to_end: "Unlike other esports platforms serving schools, we own the structure top to bottom, which means we’re not tied to any game developer or have issues with licensing. That also means we can make custom modifications in-game for your school or organization.",
      //    path_success: "The game platform fits into a regular Computer Science curriculum, so as students play through the game levels, they’re completing course work. Students learn coding and computer science while they play, then use these skills in arena battles as they practice and play on the same platform.",
      //    unlimited_potential: "Our tournament structure is adaptable to any environment or use case. Students can participate at a designated time during regular learning, play at home asynchronously, or participate on their own schedule.",
      //    team: "Team",
      //    edit_team: "Edit Team",
      //    start_team: "Start a Team",
      //    leave_team: "Leave Team",
      //    join_team: "Join Team",
      //    view_team: "View Team",
      //    join_team_name: "Join Team __name__",
      //    features: "Features",
      //    built_in: "Built-in Competitive Infrastructure",
      //    built_in_subheader: "Our platform hosts every element of the competitive process, from leaderboards to the game platform, assets, and tournament awards.",
      //    custom_dev: "Custom Development",
      //    custom_dev_subheader: "Customization elements for your school or organization are included, plus options like branded landing pages and in-game characters.",
      //    comprehensive_curr: "Comprehensive Curriculum",
      //    comprehensive_curr_subheader: "CodeCombat is a standards-aligned CS solution that helps educators teach real coding in JavaScript and Python, no matter their experience.",
      //    roster_management: "Roster Management Tools",
      //    roster_management_subheader: "Track student performance within the curriculum and within the game, and easily add or remove students.",
      //    share_flyer: "Share our AI League flyer with educators, administrators, parents, esports coaches or others that may be interested.",
      //    download_flyer: "Download Flyer",
      //    championship_summary: "The __championshipArena__ championship arena is now open! Battle it out for the month of __championshipMonth__ to win prizes in the __championshipArena__ __championshipType__.",
      //    arcade_summary: "The __championshipArena__ arcade arena is now open! Enjoy the break from the competition until __championshipMonth__ to prepare for the next season.",
      //    play_arena_full: "Play __arenaName__ __arenaType__",
      play_arena_short: 'Zagraj w __arenaName__',
      //    view_arena_winners: "View __arenaName__ __arenaType__ winners",
      //    arena_type_championship: "Championship Arena",
      //    arena_type_regular: "Multiplayer Arena",
      //    arena_type_arcade: "Arcade Arena",
      //    blazing_battle: "Blazing Battle",
      //    infinite_inferno: "Infinite Inferno",
      mages_might: 'Igrzyska Magów',
      sorcerers: 'Czarodzieje',
      //    giants_gate: "Giants' Gate",
      //    colossus: "Colossus",
      //    iron_and_ice: "Iron and Ice",
      //    tundra_tower: "Tundra Tower",
      //    magma_mountain: "Magma Mountain",
      //    lava_lake: "Lava Lake",
      //    desert_duel: "Desert Duel",
      //    sandstorm: "Sandstorm",
      //    frozen_fortress: "Frozen Fortress",
      //    equinox: "Equinox",
      //    farmers_feud: "Farmer's Feud",
      //    farmscape: "Farmscape",
      //    storm_siege: "Storm Siege",
      //    snowhold: "Snowhold",
      //    fierce_forces: "Fierce Forces",
      //    anti_gravity: "Anti-Gravity",
      //    solar_skirmish: "Solar Skirmish",
      //    sunfire: "Sunfire",
      //    system_shock: "System Shock",
      //    supercharged: "Supercharged",
      //    pawns_passage: "Pawn's Passage",
      //    kings_gambit: "King's Gambit",
      //    strikers_stadium: "Striker's Stadium",
      //    golden_goal: "Golden Goal",
      //    turbo_track: "Turbo Track",
      //    grand_prix: "Grand Prix",
      //    season_label: "Season __seasonNumber__: __seasonName__",
      //    devour_dash: "Devour Dash",
      //    gridlock_practice: "Gridlock Practice",
      //    chaotic_crossing: "Chaotic Crossing",
      //    season_1: "Forged in Flame",
      //    season_2: "Spells of Fortune",
      //    season_3: "Titan Age",
      //    season_4: "Frosts of War",
      //    season_5: "Sands of Time",
      //    season_6: "Molten Mayhem",
      //    season_7: "Melting Point",
      //    season_8: "Coder's Harvest",
      //    season_9: "Reign of Code",
      //    season_10: "Gravity Games",
      //    season_11: "Summer Smash",
      //    season_12: "Spark of Power",
      //    season_13: "Checkmate Challenge",
      //    season_14: "Racing Rivals",
      //    season_15: "Soccer Showdown",
      //    season_16: "Chomp and Charge",
      //    season_17: "Zone Control",
      //    season_18: "Paths of Peril",
      //    cup: "Cup",
      //    blitz: "Blitz",
      //    clash: "Clash",
      //    arena: "Arena",
      //    season15_announcement_1: "Welcome to Golden Goal Blitz! ⚽ Where soccer meets strategy — and every shot is scripted. No feet. No players. Just code and chaos.",
      //    season15_announcement_2: "Note: this arena is getting updates and new features regullary during the season and the big twist mechanics one month ahead of the final simulation.",
      //    season13_announcement_1: "In the depths of ancient ruins, a magical checkerboard arises and the towers comes alive. Get as many pieces to the end of the line!",
      //    season13_announcement_2: "Note: arena balance adjustments may occur up until May 15th. So be sure to come back often to test your code against the global leaderboard.",
      //    season12_announcement_2: "Collectors fly high, control points emerges, mythical crystals stand tall, as the dungeon expands, the battle is getting fiercer, only the righteous shall be the victor.",
      //    season12_announcement_1: "Deep in the dungeons, mythical crystals stand tall, collecting energy and mana from abandoned ruins. Summon units, cast spells, and claim victory!",
      //    season11_announcement_1: "The competition is getting more heated! As the sun shines above, place down and upgrade your solar panels, avoid shock traps, place down robot crabs, and phase through portals, get as much solar as possible and claim victory!",
      //    season10_announcement_1: "It's fiery hot, and magma boulders are radiating powerful energies! Summon units and cast spells to push the magma boulders to your opponent's area. Adapt to the ever-changing gravity of the battlefield!",
      //    season9_announcement_1: "An epic battle is being waged atop the wintry peaks of Snowhold Clash for the Season 9 championship arena! Draw your cloak close and your code closer as you wield strategy and algorithms to achieve victory in this land beyond the sky.",
      //    season8_announcement_1: "It's harvesting season in Farmscape Blitz Season 8! As the leaves change, it's time to code your way around wild and impenetrable obstacles on the farm. Strategically collect vital boosts to empower your robot worker and utilize special abilities to boost productivity and out-farm your opponents!",
      //    season8_announcement_2: "Note: arena balance adjustments may occur up until August 15th. So be sure to come back often to test your code against the global leaderboard.",
      //    season7_announcement_1: "Witness the dawn of a new challenge in the Equinox Cup! Season 7's tower defense arena offers a unique blend of strategy, monsters, and boss battles for you to conquer.",
      //    season6_announcement_1: "It’s absolute Molten Mayhem with the launch of the Lava Lake Clash finals! Outlast and outwit the competition in this hot take on classic Snake gameplay.",
      //    season6_announcement_2: "Note: arena balance adjustments may occur up until December 15th. So be sure to come back often to test your code against the global leaderboard.",
      //    season5_announcement_1: "The Sandstorm Blitz Final is on. In this basketbrawl of an arena, you must summon the right heroes, call the right plays, and outscore your opponent to take the victory!",
      //    season5_announcement_2: "Note: arena balance adjustments may occur up until September 15th. So be sure to come back often to test your code against the global leaderboard.",
      //    season4_announcement_1: "The Tundra Tower Cup Final is on. In this all new take on the classic tower defense gameplay, you must protect your base from the horde of monsters by building towers and using gravitational anomalies.",
      //    season4_announcement_2: "Note: arena balance adjustments may occur up until April 15th. So be sure to come back often to test your code against the global leaderboard.",
      //    season3_announcement_1: "Time to put your coding skills to the test in our season 3 final arena. The Colossus Clash is live and offers a new challenge and a new leaderboard to climb.",
      //    season3_announcement_2: "Need more practice? Stick with the Giant's Gate Arena to refine your skills. You have until December 14th to play both arenas. Note: arena balance adjustments may occur until December 6th.",
      //    season3_announcement_3: "Great prizes available for top performers in the Colossus Clash:",
      //    season2_announcement_1: "Time to put your coding skills to the test in our season 2 final arena. The Sorcerers Blitz is live and offers a new challenge and a new leaderboard to climb.",
      //    season2_announcement_2: "Need more practice? Stick with the Mage's Might Arena to refine your skills. You have until August 31st to play both arenas. Note: arena balance adjustments may occur until August 23rd.",
      //    season2_announcement_3: "Great prizes available for top performers in the Sorcerers Blitz:",
      //    new_season_prize_1: "$500 Scholarship",
      //    new_season_prize_2: "$300 Scholarship",
      //    new_season_prize_3: "$200 Scholarship",
      //    season1_prize_1: "$1,000 Scholarship",
      //    season1_prize_2: "RESPAWN Gaming Gear",
      //    season1_prize_3: "Custom CodeCombat Avatar",
      //    season1_prize_4: "And more!",
      //    season1_prize_hyperx: "HyperX Premium Peripherals",
      //    codecombat_ai_league: "Join AI League",
      //    register: "Register",
      //    not_registered: "Not Registered",
      //    register_for_ai_league: "Register for AI League",
      //    world: "World",
      //    quickstart_video: "Quickstart Video",
      //    arena_rankings: "Arena Rankings",
      //    arena_rankings_blurb: "Global AI League arena rankings",
      //    arena_rankings_title: "Global leaderboard rank for all players in this team across AI League arenas in the open age bracket.",
      //    competing: "Competing:",
      //    count_student: "student",
      //    count_students: "students",
      //    top_student: "Top:",
      //    top_percent: "top",
      //    top_of: "of",
      //    arena_victories: "Arena Victories",
      //    arena_victories_blurb: "Global AI League arena recent wins",
      //    arena_victories_title: "Win count is based on the last 1000 matches played asynchronously by each player in each of their AI League arenas.",
      //    count_wins: "wins",
      //    codepoints_blurb: "1 CodePoint = 1 line of code written",
      //    codepoints_title: "One CodePoint is earned for every non-whitespace line of code needed to beat the level. Each level is worth the same amount of CodePoints according to its standard solution, regardless of whether the student wrote more or fewer lines of code.",
      //    count_total: "Total:",
      //    join_teams_header: "Join Teams & Get Cool Stuff!",
      //    join_team_hyperx_title: "Join Team HyperX, Get 10% Off",
      //    join_team_hyperx_blurb: "30 team members will be chosen at random for a free gaming mousepad!",
      //    join_team_derbezt_title: "Join Team DerBezt, Get Exclusive Hero",
      //    join_team_derbezt_blurb: "Unlock the Armando Hoyos hero from Mexican superstar Eugenio Derbez!",
      //    join_team_ned_title: "Join Team Ned, Unlock Ned's Hero",
      //    join_team_ned_blurb: "Get the exclusive spatula-wielding hero from YouTube star, Try Guy Ned Fulmer!",
      //    check_out_all: "Check out all the",
      //    pick_best_tournaments: "pick the ones that will work best for your custom tournament!",
      //    final_arena: "Final Arena",
      //    rest_season: "Practice Season",
      //    no_prizes: "No Prizing",
      //    prizing_top_3: "Prizing Awarded to Top 3 Champions",
      //    package_options_and_guide: "Package Options & Implementation Guide",
      //    custom_tournament: "For a Custom Tournament",
      //    you_win: "You can win",
      //    great_prizes: "great prizes",
      //    powered_by: "Powered by",
      //    grand_prize: "Grand Prize",
      //    second_prize: "2nd Place Overall",
      //    third_prize: "3rd Place Overall",
      //    scholarship: "Scholarship",
      //    top_players_win: "Top three players in each division win: HyperX pro peripherals",
      //    team_hyperx: "Team HyperX",
      //    earn_more_gear: "you could earn even more gear!",
      //    prize_footer1: "Awarded to the top performing player across all age groups.",
      //    prize_footer2: "Specific products and models subject to change.",
      //    prize_footer3: "Prizes will be awarded to players who reach the top of the leaderboard in the Finals arena.",
      //    prize_footer4_1: "Age verification necessary to be eligible. Some prizes are limited to US participants only.",
      //    coco_reserves: "CodeCombat reserves",
      //    prize_footer4_2: "the right to determine in its sole discretion if a player qualifies and will receive a prize.",
      //    place: "Place",
      //    arena_under_construction: "Next season's arena is under construction. Check back soon!",
      //    unlock_ai_league: "Unlock the full potential of the AI League.",
      //    esports_anonymous_changing: "Esports player name visibility changing September 1",
      //    esports_get_full_access: "Get Full Access",
      //    click_to_unlock_now: "Click to dismiss for now",
      //    click_to_unlock_before_sep: "Click to make the anonymizing go away before Sep.1",
      //    unlock_content_padding: "Contact our team today to see your student's scoress, ranks, code and more!",
      //    unlock_leaderboard: "Contact Us to unlock the leaderboard",
      //    without_license_blurb: "Unlock the full potential of AI League. Purchase a custom tournament package to access your students’ scores, ranks, code and experience more tournament customization options. See our",
      //    custom_pricing: "Custom Options and Implementation Guide",
      //    more_details: "for more details.",
      //    contact_sales_custom: "Your custom tournament awaits. Choose the arena that you’d like to use for your custom tournament and contact your CodeCombat sales representative to confirm set up and scheduling details.",
      //    create_custom: "Create Custom Tournament",
      //    custom_tournament_text: "Custom Tournament",
      //    promotion_blurb: "Competitive Coding - Free to Get Started",
      //    promotion_part1: "Join coding teams with friends and family",
      //    promotion_part2: "Access global coding arenas and leaderboards",
      //    promotion_part3: "Showcase your coding skills and win prizes",
      //    promotion_part4: "Earn points through practice and head-to-head matches",
      //    codecombat_ai_league_description: "The CodeCombat AI League combines our project-based standards-aligned curriculum, engaging adventure-based coding game, and our annual AI coding global tournament into an academic competition unlike any other.",
      //    teacher_getting_started_guide: "Teacher Getting Started Guide",
      //    try_ai_league_as_a_teacher: "Try AI League as a Teacher",
      //    ai_league_curriculum: "AI League Curriculum",
      //    current_season: "Current Season",
      //    all_time: "All Time",
      //    view_leaderboards_for_team: "Team Leaderboard:",
      //    global_stats: "GLOBAL STATS",
      //    code_your_way: "Code your way",
      //    to_win_the_price: "to first place to win",
      //    regular: "Regular",
      //    championship: "Championship",
      //    global: "Global",
      //    custom: "Custom",
    },

    //  league_v2: {
    //    headline: "Where Future **Coders** Train and **AI** Levels Up the Game",
    //    subhead: "Welcome to AI League 2.0, where we’ve put the AI into AI League! Now you can[NEWLINE]choose to compete solo or team up with AI to outsmart opponents and level up your[NEWLINE]coding skills.",
    //    join_cta: "Join Global Tournament",
    //    free_to_play: "Free to play now",
    //    create_cta: "Create Custom Tournament",
    //    for_educators: "For educators with paid licenses",
    //    ai_league_desc: "The CodeCombat AI League is uniquely both a competitive AI battle simulator and game engine for learning real Python or JavaScript code.",
    //    get_start: "Free to Get Started",
    //    get_start_list_1: "Join global coding[NEWLINE]championships",
    //    get_start_list_2: "Earn codepoints in[NEWLINE]matches",
    //    get_start_list_3: "Team up with friends[NEWLINE]or classmates",
    //    get_start_list_4: "Showcase your skills[NEWLINE]and win prizes",
    //    compete_to_win: "Code Your Way to First Place to Win!",
    //    code_to_compete: "**Esports:** Code to Compete",
    //    compete_desc: "AI League is the ultimate coding arena where players battle using real Python, JavaScript, C++, and more. You can write your own logic or vibe code with an AI assistant to learn the ropes. Every match builds your skills, sharpens your strategy, and brings the heat. This is where smart code wins the game.",
    //    codecombat_reserves: "CodeCombat reserves",
    //    reserved_right: "the right to determine in its sole discretion if a player qualifies and will receive a prize.",
    //    grand_prize: "Grand Prize:[NEWLINE]$500 Scholarship",
    //    second_place: "2nd Place Overall:[NEWLINE]$300 Scholarship",
    //    third_place: "3rd Place Overall:[NEWLINE]$200 Scholarship",
    //    set_up_tournament: "Set Up Your Classroom Tournament",
    //    set_up_desc: "Your first few classroom tournaments are on us. Customize a private esports competition for your students today!",
    //    create_team: "Create a Team/Classroom",
    //    invite_players: "Invite Players",
    //    select_arena: "Select an Arena",
    //    refer_guide: "Refer to the <a href=\"https://docs.google.com/presentation/d/1ouDOu2k-pOxkWswUKuik7CbrUCkYXF7N_jNjGO0II6o/edit#slide=id.gb06b5c7fa4_0_10\">Educator Getting Started Guide</a> to see how easy it can be to bring competitive coding to your school.",
    //    having_question: "Still have questions? Check out our <a target=\"_blank\" href=\"https://codecombat.zendesk.com/hc/en-us/categories/1500000915842-AI-League\">FAQs</a> or <a href=\"https://docs.google.com/forms/d/1rO__VvhM1yCuUHrtHJKXXj3RYA2vCzpRKzMCMaMS6SE\" target=\"_blank\">Contact Us</a> to learn more.",
    //    global_rankings: "Global Ranking",
    //    team_rankings: "Team Ranking",
    //    inspiration_title: "Are you an educator or esports coach?",
    //    inspiration_desc: "This game-based competitive coding competition delivers high engagement with a turn-key approach.",
    //    season_arenas: "Season Arenas",
    //    ranking_desc: "Use your coding skills and battle strategies to rise up the ranks!",
    //    step_1: "Step 1",
    //    step_2: "Step 2",
    //    step_3: "Step 3",
    //    academic_rigor: "Academic Rigor",
    //    asynchronous_competition: "Asynchronous Competition",
    //    greater_accessibility: "Greater Accessibility",
    //    academic_rigor_desc: "The open-ended objective encourages creativity and iteration as players apply what they’ve learned from the core curriculum. The AI assistant offers a more realistic coding experience, but success still depends on strategy, mechanics, and writing solid code.",
    //    asynchronous_competition_desc: "Unlike other esports, our platform allows players to compete anytime/anywhere with no need to coordinate schedules. ",
    //    greater_accessibility_desc: "Since AI League is an academic esport focused on knowledge and strategy, fast reactions or hand-eye coordination are not required. Anyone can compete using a basic computer with internet access, and players can also choose to use the AI assistant to support their coding along the way.",
    //    earn_codepoints: "Earn CodePoints",
    //    earn_by: "By Completing Levels",
    //    search_teams: "Search team",
    //    global_clan_name: "-- Global --",
    //  },

    //  tournament: {
    //    tournament_title: "Tournament Title",
    //    mini_tournaments: "Mini Tournaments",
    //    usable_ladders: "All Usable Ladders",
    //    make_tournament: "Make a mini tournament",
    //    go_tournaments: "Go to mini tournaments",
    //    class_tournaments: "Class mini tournaments",
    //    class_tournaments_more: "More Class mini tournaments",
    //    no_tournaments_owner: "There is no tournament now, please create one",
    //    no_tournaments: "There is no tournament now",
    //    edit_tournament: "Edit Tournament",
    //    create_tournament: "Create a Tournament",
    //    view_tournament: "View Tournament",
    //    upcoming: "Upcoming",
    //    starting: "Starting",
    //    ended: "Ended",
    //    view_results: "View Results",
    //    estimate_days: "In __time__ Days",
    //    team_name: "Team: __name__",
    //    status: "Status: __state__",
    //    from_start: "Start __time__",
    //    from_end: "End __time__",
    //    start_date_time: "Start Time",
    //    end_date_time: "End Time",
    //    results_date_time: "Results Time",
    //    start_date_description: "(PT) The start time of tournament",
    //    end_date_description: "(PT) The end time of tournament",
    //    results_date_description: "Select a time to publish results.",
    //    results_date_suggestion_0: "Note: Tournament may need some time to generate final leaderboard, so you need to allow enough time for the results.",
    //    results_date_suggestion_1: "i.e. 0-50 players: 5 mins",
    //    results_date_suggestion_2: "     50-100 players: 20 mins",
    //    results_date_suggestion_3: "     100-500 players: 10 hours",
    //    select_team_desc: "select your team to creat/edit your tournaments",
    //    already_create_tournaments_num: "You already created __num__ tournaments here:",
    //    can_create_tournaments_num: "You can create __num__ more tournament(s) from below:",
    //    my_teams: "My Teams:",
    //    team: "Team",
    //    team_description: "(Required) Only the players in the team can join this tournament",
    //    review_results: "Review Results",
    //    review_description: "We will email you the results of tournament and wait for you to publish for participants.",
    //    publish_immediately: "Publish Immediately",
    //    publish_description: "The result of tournament will be published immediately once ready.",
    //    error_end_date_too_early: "The End Time cannot be earlier than Start Time",
    //    error_results_date_too_early: "The Results Time cannot be earlier than End Time",
    //    publish_results: "Publish Results",
    //    publish_options: "Publish Options",
    //    anonymize_players: "Anonymize Players",
    //    anonymize_players_description: "Players cannot see each other's name until tournament published.",
    //  },

    //  payments: {
    //    student_licenses: "Student Licenses",
    //    computer_science: "Computer Science",
    //    web_development: "Web Development",
    //    game_development: "Game Development",
    //    per_student: "Per Student",
    //    just: "Just",
    //    teachers_upto: "Teacher can purchase upto",
    //    great_courses: "Great Courses included for",
    //    studentLicense_successful: "Congratulations! Your licenses will be ready to use in a min. Click on the Getting Started Guide in the Teacher Toolkit to learn how to apply them to your students.",
    //    onlineClasses_successful: "Congratulations! Your payment was successful. Our team will reach out to you with the next steps.",
    //    homeSubscriptions_successful: "Congratulations! Your payment was successful. Your premium access will be available in few minutes.",
    //    failed: "Your payment failed, please try again",
    //    session_week_1: "1 session/week",
    //    session_week_2: "2 sessions/week",
    //    month_1: "Monthly",
    //    month_3: "Quarterly",
    //    month_6: "Half-yearly",
    //    year_1: "Yearly",
    //    most_popular: "Most Popular",
    //    best_value: "Best Value",
    //    purchase_licenses: "Purchase Licenses easily to get full access to CodeCombat and Ozaria",
    //    homeschooling: "Homeschooling Licenses",
    //    recurring_month_1: "Recurring billing every month",
    //    recurring_month_3: "Recurring billing every 3 months",
    //    recurring_month_6: "Recurring billing every 6 months",
    //    recurring_year_1: "Recurring billing every year",
    //    purchase_licenses_2: "Purchase licenses for your students to access paid curriculum after the first course",
    //    applying_licenses: "applying licenses",
    //    about: "about",
    //    school_district_heading: "Schools or Districts",
    //    school_district_subheading: "For classrooms, schools and districts with 10 or more students",
    //    classroom_heading: "Small Classroom",
    //    classroom_subheading: "For clubs, after-school programs and small classrooms with 5-9 students.",
    //    customer_support_info_1: "Customer support via email or chat",
    //    customer_support_info_2: "Customer support via email or chat, plus a dedicated school success manager available via phone or email for implementation support",
    //    self_serve_credit: "Self-serve credit card purchase",
    //    multiple_payment_options: "Variety of payment options available, including: purchase order, site licenses, & multi-year discounts.",
    //    admin_dashboard: "Administrator dashboard with actionable data and insights",
    //    pd_info: "Comprehensive 40-hour online course that allows you to learn anytime, anywhere and at any pace.",
    //    implementation_info: "60 min Onboarding Training on how to use CodeCombat and Ozaria to support specific institutional and instructional goals.",
    //    ai_league_info: "Engage students in an exciting esports competition that allows them to showcase their understanding of concepts in a new environment and practice creative problem-solving strategies!",
    //    ai_custom_tournament: "AI League Custom Tournament",
    //    implementation_training: "Implementation Training",
    //    full_access_coco: "Full Access to both CodeCombat",
    //    and_oz: "And Ozaria",
    //    cs_info: "Computer Science 1-6: 65 sessions",
    //    wd_info: "Web Development 1-2: 10 sessions",
    //    gd_info: "Game Development 1-3: 20 sessions",
    //    chap1_info: "Chapter 1: 10 class sessions",
    //    chap2_info: "Chapter 2: 30 class sessions",
    //    chap3_info: "Chapter 3: 25 class sessions",
    //    chap4_info: "Chapter 4: 20 class sessions",
    //    includes: "Includes:",
    //    show_plan_features: "Show Plan Features",
    //    purchase_annually: "Available for purchase one time annually.",
    //    class_school_solution: "We'll help you build a solution that meets the needs of your class, school or district.",
    //    bulk: "Bulk",
    //    discounts: "discounts",
    //    available: "available",
    //    request_quote: "Request a Quote",
    //    business_partner_licenses: "Business Partner Licenses",
    //    bd_subheading: "For Business Partners with at least 10 students, get premium access to CodeCombat’s computer science and coding games:",
    //    bd_info_list_heading: "CodeCombat is the preferred partner for dozens of coding education businesses because:",
    //    bd_info_list_1: "students love our game-based curriculum based in fantasy and adventure and keep coming back for more sessions",
    //    bd_info_list_2: "anyone can teach coding with CodeCombat; the game is the primary teacher and we provide extensive support resources",
    //    bd_info_list_3: "you will receive over 200 hours of curriculum, providing years of educational content for your business",
    //    bd_includes_1: "Full access to CodeCombat and Ozaria with over 200 hours of premium game-based content",
    //    bd_includes_2: "Teacher dashboard for record keeping and progress tracking ",
    //    bd_includes_3: "Online Resource Hub with walkthroughs and tutorials",
    //    bd_help: "For any help, contact",
    //    manage_stripe: "Manage Stripe Billing",
    //    manage_billing_info: "This will take you to Stripe, where you can handle subscription-related tasks such as reviewing your billing history and updating your payment method.",
    //    billing_portal: "Customer Billing Portal",
    //    email_not_verified: "Your email is not verified, please verify it from the account settings!",
    //    stripe_no_data: "You do not have any data to manage on Stripe portal",
    //    manage_payment_and_subscription: "Manage Payment & Subscription",
    //    discover_more_title: "Discover More",
    //    discover_more_desc: "See everything you have access to with your premium account!",
    //    billing_portal_desc: "Manage your subscription, update your payment method, view invoices and more in Stripe.",
    //    billing_portal_btn: "Manage billing with Stripe",
    //    payment_history: "Payment History",
    //    payment_history_btn_all: "View all Invoices",
    //    payment_history_btn_less: "View recent Invoices",
    //  },

    form_validation_errors: {
      required: 'Pole jest wymagane',
      invalidEmail: 'Nieprawidłowy adres email',
      invalidPhone: 'Nieprawidłowy numer telefonu',
      emailExists: 'Email już istnieje',
      //    nameExists: "Username already exists",
      numberGreaterThanZero: 'Powinno być liczbą większą od 0',
      //    requireValidEmail: "Please enter a valid email address.",
      //    requireValidPhone: "Please enter a valid phone number, including area code.",
    },

    //  partners: {
    //    for: "for",
    //    business_partners: "Business Partners",
    //    headline: "Join us in our mission to make coding engaging and accessible to all",
    //    below_headline_blurb: "At CodeCombat we’ve developed comprehensive tools that make learning to code fun and teaching programming easy. Our turnkey solutions can be leveraged in many executions.",
    //    coding_title: "Coding & STEAM Education Businesses:",
    //    coding_blurb: "Valued partners like Code Ninjas and IDEA Lab Kids use our game to teach real Python and JavaScript coding to students in their franchise locations. We offer an easy to use program, implementation resources and training options to ensure an amazing student experience.",
    //    esports_title: "Educational Esports Sponsors:",
    //    esports_blurb: "We are reinventing what an esport can be while engaging thousands of students to learn to code. Endemic esports mainstay __hyperx__ supported the CodeCombat AI League from its inaugural season, building compelling promotional programs around this unique esport.",
    //    hyperx: "HyperX",
    //    respawn: "RESPAWN",
    //    distribution_title: "International Distribution:",
    //    distribution_blurb: "Our programs have served students in over 190 countries and our content is translated into over __forty_languages__. While the US and China are markets where we sell directly, we work closely with local SaaS and EdTech distribution partners around the world to expand our reach",
    //    forty_languages: "40 languages",
    //    equity_social_title: "Tech Equity & Social Impact:",
    //    equity_social_blurb: "Not every partnership is built on the bottom line. As a mission-based organization we seek ways to give back as well. We work closely with foundations and other philanthropy partners to expand access to high-quality coding education.  ",
    //    latin_superstar_blurb: "Additionally, Latin superstar __eugenio_derbez__ has helped us reach the Latinx community with a partnership to engage students in this often underserved and underrepresented group.",
    //    reach_latinx: "reach the Latinx community",
    //    eugenio_derbez_blurb: "\"It is important to me to see Latino boys and girls represented in this space,\" said Eugenio Derbez. \"Coding is the language of the future and if we want to be a part of that future then we need to get our kids coding.\"",
    //    seek_relationships_blurb: "We seek relationships with nonprofits and community-based organizations working with groups underrepresented in computer science and technology careers. Our partnership with __seeds_of_light__ will fund CS educational opportunities for thousands of young learners.",
    //    seeds_of_light: "Seeds of Light",
    //    corporate_team_building_title: "Corporate Team Building",
    //    corporate_team_building_blurb: "Need to engage your employees with a turnkey activity that will inspire their competitive spirit and challenge them to creatively problem solve? Work with us to build a custom competitive coding tournament that will have your team programming their own strategies while playing a game. __see_how__",
    //    footer_blurb: "These are just a few of the partnership structures we have successfully supported. If you would like to initiate a discussion with our business development team on any of these models or have a different partnership opportunity, please reach out today.",
    //    talk_with_us: "Talk with Us",
    //    our_partners: "Our Partners",
    //    see_how: "See How",
    //  },

    //  podcast: {
    //    learning_adventure: "Where learning is always an adventure.",
    //    explores_stem: "Our podcast explores the role of technology, STEM, and creative play in education. With expert guests, we discover how learning is always an adventure.",
    //    listen: "Listen",
    //    download: "Download",
    //    transcript: "Transcript",
    //    learn_more_coco: "Want to learn more about CodeCombat coding experiences?",
    //    subscribe: "Subscribe",
    //    explore_coco: "Explore CodeCombat",
    //    interested_in_being_guest: "Interested in being a guest on EdTech Adventures?",
    //    lets_chat: "Let's Chat",
    //    air_date: "Air date",
    //    play_episode: "Play Episode",
    //    about_guest: "About Our Guest",
    //    about_guests: "About Our Guests",
    //    all_episodes: "View All Episodes",
    //    no_permission: "You don't have permission to view this podcast",
    //    listen_now: "Listen Now",
    //    show_all_episodes: "Show all episodes",
    //  },

    //  library: {
    //    enter_library_card: "Enter your Library Card Number:",
    //    access_coco: "Access CodeCombat",
    //    already_using_library_id: "Already using library id",
    //    play_coco: "to play CodeCombat",
    //    not_library_id: "Not your library id",
    //    access_using_id: "to access using your id!!",
    //    network_detected: "Library network detected, redirecting you to play CodeCombat",
    //    not_redirect_auto: "if redirect doesn't happen automatically",
    //    engage_members: "Give your members access to the most engaging way to learn coding.",
    //    importance_blurb: "Libraries play an important role in advancing educational equity in their communities. Many young learners do not have access or exposure to computer science, and libraries can provide important resources to these underserved groups. That is why we are partnering with libraries across the country to provide access to our game-based learning tools and educational resources.",
    //    games_teach_blurb: "Our games teach real typed Python, JavaScript and C++ coding languages through the power of play. The gameplay is paired with a scaffolded curriculum to allow self-paced learners the ability to master foundational programming concepts before moving on to the more complex. Each level challenges the player to type the code necessary to advance their hero and achieve the level goal.",
    //    platform_built: "Our platform is built to address the specific needs of libraries and their patrons:",
    //    accessible: "Accessible",
    //    accessible_blurb: "A basic computer with internet access is all you need to sign-in and start playing. The content is intended for beginners with no prior coding experience.",
    //    self_paced_intuitive: "Self-Paced and Intuitive",
    //    self_paced_intuitive_blurb: "Teachers are not required as players can dictate the pace at which they move through the curriculum. Our custom code engine and interpreter is designed for beginners, it understands the mistakes kids make and speaks to them using human, beginner-friendly terms.",
    //    engaging_content: "Engaging Content",
    //    engaging_content_blurb: "Game-based learning drives engagement from the start but perhaps even more importantly keeps students engaged when the concepts get more challenging. In a game environment failure and success are expected and embraced as part of the play experience.",
    //    api_integrate: "API integration",
    //    api_integrate_blurb: "Our games can be easily incorporated into your digital library interface through EZProxy or other popular systems. This structure provides instant access with the members’ existing log in and no staff is needed to manage any logistics of licensing or access.",
    //    privacy: "Privacy",
    //    privacy_blurb: "We take user safety, cybersecurity, and data privacy seriously, following many stringent privacy regulations, like COPPA, FERPA, SOPIPA, California AB 1584, CalOPPA, Fair Information Practices, CAN-SPAM, and GDPR. These policies and protective measures have let us securely serve over twenty million users around the world.",
    //    privacy_policy: "our full privacy policy.",
    //    see: "See",
    //    communication_limit: "Communication Limits",
    //    communication_limit_blurb: "To ensure the security of your members, we do not offer in-game chat or other communication features between players, however we do allow members to safely share their coding projects with friends, family and the CodeCombat community. We restrict any upsell or marketing messaging to provide an uninterrupted experience for your patrons.",
    //    usage_stats: "Usage Stats",
    //    usage_stats_blurb: "Gain insight to your members’ usage with our snapshot reporting tool. It provides access to usage stats at any time, including monthly active users, licensed days used and more valuable data points.",
    //    esports: "Academic Esports",
    //    esports_blurb: "Our esports program offers an opportunity to further engage your members through a fun and exciting competition. The AI League allows members to showcase their understanding of coding concepts in a new environment and practice problem solving strategies as they go head to head in battle against the global community.",
    //    work_with_us_blurb: "Work with us to unlock the next generation of engineers, programmers and CS professionals in your community.",
    //    schedule_demo: "Schedule a Demo",
    //    license_modal_subtitle: "Please complete this short form and one of our library specialists will reach out to provide a demo and custom pricing options!",
    //    license_modal_members: "Members Needing Access",
    //    license_modal_members_placeholder: "Approximately how many members will need access?",
    //    license_modal_contact: "Contact Our Team",
    //    license_days_used: "License days used",
    //    licenses_used: "Licenses used",
    //    users_active_licenses: "Users with active licenses",
    //    lines_code: "Lines of Code",
    //    programs_written: "Programs written",
    //    time_spent_min: "Time spent (in min)",
    //    month: "Month",
    //    teacher_classroom_name: "Teacher or classroom name",
    //    already_logged_in: "Already logged in, please logout from the top navigation bar to login again.",
    //    search_box_option: "If search box doesn't load, login by clicking",
    //    new_signups: "New Signups",
    //    heading_for: "for",
    //    heading_libraries: "Libraries",
    //    educational_equity: "Educational Equity",
    //    power_of_play: "Power of play",
    //    library_card: "Library Card Number",
    //    library_signup_promotion: "Sign Up to save progress and continue from where you left off on CodeCombat!!",
    //    welcome_dashboard: "Welcome to your dashboard",
    //    total_licenses_used: "Total Licenses Used",
    //    from_launch_date: "from the date of launch",
    //    renewal_date: "Renewal Date",
    //    access_old_dashboard: "If you want to access the old dashboard, visit",
    //    loading_from: "loading data from",
    //    user_activities: "User Activities",
    //    total_users: "Total Users",
    //    lines_of_code_written: "Lines of Code Written",
    //    hours_spent: "Hours spent",
    //    time_spent: "Time spent (in minutes)",
    //    new_users: "New Users",
    //    age_demographics: "Age demographics",
    //    levels_completed: "Levels Completed",
    //    adjust_dates_explore: "Adjust the dates below to explore patron usage trends over time.",
    //  },

    //  related_accounts: {
    //    subtitle: "Add connections between different CodeCombat accounts to be able to quickly switch between them. For example, as a parent, you could switch to viewing CodeCombat from your kids’ accounts. Or, as a teacher, you could add a test student account for yourself to see what your students see.",
    //    wrong_account: "Please log in to the correct account to confirm the account linking. Log In to the account and open link from email again.",
    //    link_account: "Link your account to",
    //    link_successful_redirect: "Account linked successfully, redirecting",
    //    add_related_user: "Add Related User",
    //    adding: "Adding",
    //    removing: "Removing",
    //    added: "Account added",
    //    related_email: "Related User Email",
    //    relation: "Relation",
    //    bi_directional: "Bi-directional",
    //    account_exists: "Account exists",
    //    link_using_email: "Link account using confirmation email",
    //    link_using_email_blurb: "User will receive a mail on __email__. Please ask the user to confirm linking by pressing on link present in email.",
    //    account_not_exist: "Account does not exist",
    //    account_type: "Account Type",
    //    create_account_and_email: "Create account and send email to link",
    //    authenticate: "Authenticate",
    //    invite: "Invite",
    //    auth_using_pass: "Authenticate using __email__ password",
    //    related_users: "Related Users",
    //    no_related_users: "No related users right now",
    //    send_verify_email: "Send Verify Email",
    //    verified: "Verified",
    //    switch: "Switch",
    //    title: "Related Accounts",
    //    bi_directional_help_text: "Allow added user to switch to your account?",
    //  },

    //  modal_free_class: {
    //    paragraph_1: "Thank you for choosing CodeCombat.",
    //    paragraph_2: "Our team is eager to connect with you to get your child scheduled for a free trial class.",
    //    paragraph_3: "Please provide your contact information and one of our learning advisors will call you to gather student information, identify a teacher based on your child’s preferred learning style and to schedule the trial class.",
    //    name: "Name",
    //    phone_number: "Phone Number",
    //    available: "Are you available to talk now?",
    //    yes: "Yes",
    //    no: "No",
    //    preferred_time: "Preferred time for call if we can't connect now",
    //    anytime: "Anytime",
    //    morning: "Morning (8AM - 12PM)",
    //    afternoon: "Afternoon (12PM - 4PM)",
    //    evening: "Evening (4PM - 8PM)",
    //    time_zone: "Your Time Zone",
    //    email: "Email",
    //  },

    //  mobile_landing: {
    //    subtitle: "Get free access to the most engaging way to teach CS",
    //    you_re_set: "YOU'RE SET!",
    //    done_blurb: "Check your email for instructions on accessing your teacher account. For the best experience, we suggest using a device with an external keyboard and larger screen.",
    //    step_email: "STEP 1",
    //    step_name: "STEP 2",
    //    step_done: "DONE",
    //    video_title: "GET A SNEAK PEEK HERE",
    //    email_confirm: "The email address \"__email__\" is already registered. Would you like to login?",
    //  },

    //  roblox_landing: {
    //    meta_title: "CodeCombat Worlds on Roblox: Play, Code and Create",
    //    headline: "Empowering Every Player to Become a Creator!",
    //    subhead: "Experience the easiest and most enjoyable way to code and create your own Roblox games",
    //    join_the_beta: "Join the Beta",
    //    sign_up: "Sign Up",
    //    box_play_subhead: "Play",
    //    box_code_subhead: "Code",
    //    box_create_subhead: "Create",
    //    box_headline: "Play, Code and Create on Roblox",
    //    box_play_blurb_teacher: "In partnership with Roblox Education, we are combining our proven coding-as-gameplay approach with the creative and social power of the Roblox platform to make a new Roblox experience that teaches coding and game development in-game.",
    //    box_code_blurb_teacher: "The experience will be personalized and differentiated, offering structured and unstructured intuitive practice that allows the player to learn as they like, while still aligning with CSTA and ISTE computer science standards.",
    //    box_create_blurb_teacher: "This engaging play experience will provide the foundational instruction needed to take players from zero coding knowledge to publishing full Roblox games. Our Creative Mode lets players build while playing, without requiring switching modes to the full desktop Roblox Studio IDE.",
    //    box_play_blurb_player: "Explore the 3D immersive experience of CodeCombat Worlds. Program your pets and adventure into a universe of creativity and shared experiences with friends.",
    //    box_code_blurb_player: "Learn real Lua coding, from beginner to advanced. Use code to explore, gather resources, build, and discover your path to glory.",
    //    box_create_blurb_player: "No Roblox Studio? No problem. Code in-game in Creative Mode to make full Roblox games to share with your friends.",
    //    box_play_blurb_parent: "Through our proven game-based learning approach, we engage young learners through play, while teaching coding and game development.",
    //    box_code_blurb_parent: "Coding from the very start of their adventure, the experience is personalized and differentiated, offering structured and unstructured intuitive practice that allows your child to learn as they like.",
    //    box_create_blurb_parent: "Many kids want to create games but don’t know where to start. This engaging play experience will provide the foundational instruction needed to take players from zero coding knowledge to publishing full Roblox games.",
    //    box_play_blurb_partner: "Engage young learners with a next-generation Roblox experience. With support from Roblox Education, we are combining our proven coding-as-gameplay approach with the creative and social power of the Roblox platform to make a new Roblox experience that teaches coding and game development in-game.",
    //    box_code_blurb_partner: "The experience will be personalized and differentiated, offering structured and unstructured intuitive practice that allows the player to learn as they like. We make it easier than ever to teach real coding to your students in either self-paced or instructor-directed contexts.",
    //    box_create_blurb_partner: "Instead of building a standalone curriculum tied to Roblox Studio, take advantage of our in-game Creative Mode and its scaffolded instruction to easily ramp your students from no coding experience to publishing full Roblox games.",
    //    role_teacher: "Teacher",
    //    role_player: "Player",
    //    role_parent: "Parent",
    //    role_partner: "Partner",
    //    select_role: "Please select your role",
    //    question_1: "Do I need to know Lua or Roblox Studio?",
    //    answer_1: "No. This experience will allow anyone to play, code and create from the very start of their adventure, without any coding experience.",
    //    question_2: "Can I create my own games?",
    //    answer_2: "Yes. Game development is at the core of this experience and after completing the core learning levels you will have the opportunity to create your own.",
    //    question_3: "Will my creations be available on Roblox?",
    //    answer_3: "Yes. Anything you create in this experience, you will be able to import into Roblox Studio and then publish to the platform for anyone to play.",
    //    bottom_blurb_parent: "No need to wait - __sign-up__ for our live online classes to get your child coding today! Get them started with CodeCombat web to be the first to get access to the CodeCombat Worlds Roblox experience.",
    //    bottom_blurb_sign_up: "Sign up",
    //    bottom_blurb_partner: "Want to use the new CodeCombat Worlds Roblox experience for your education business, social impact initiative or international distribution opportunity? __reach-out__ to discuss partnering today.",
    //    bottom_blurb_reach_out: "Reach out",
    //    boxes_title: "Play, Code and Create on Roblox",
    //    login_message: "You need to login before connecting your account to Roblox",
    //    connect_button_header: "Account Linking Rewards",
    //    connect_button_linker_badge: "Linker Badge",
    //    connect_button_accounts_linked: "Accounts Linked",
    //    connect_button_pet_chroma: "Pet Chroma",
    //    connect_button_exclusive_pet: "Exclusive Pet",
    //    connect_button_blurb: "Link your CodeCombat and Roblox accounts for a seamless experience!",
    //    connect_button_list_item_1: "Manage subscriptions",
    //    connect_button_list_item_2: "Unlock additional content",
    //    connect_button_list_item_3: "Track progress",
    //    connect_button_list_item_4: "Receive exclusive rewards",
    //    connect_button_list_item_5: "Access curricular resources",
    //    connect_button_list_item_6: "Parent and teacher dashboard access",
    //    connect_button_list_item_7: "Unlock generative AI features",
    //    connect_button_list_item_8: "Creative mode publishing and exporting",
    //    connect_button_connected_blurb: "Congratulations, you have linked your accounts! Invite your friends to help reach the community linking goals.",
    //    connect_button_not_connected_blurb: "The more people link their accounts, the more rewards you'll receive!",
    //    faq_bottom: "See more <a href=\"https://codecombat.zendesk.com/hc/en-us/categories/18084251471383-CodeCombat-Worlds-Roblox-\" target=\"_blank\">frequently asked questions in our help center</a>. <br />If you have any other questions, please <a href=\"mailto:support@codecombat.com\">Contact Us</a>.",
    //    modal_title: "CodeCombat Worlds<br> Now Live on Roblox!",
    //    modal_play_now: "PLAY NOW!",
    //    modal_button_link_roblox_account: "Link Roblox Account",
    //    age_restriction: "You must be 13 years or older to link your Roblox account.",
    //  },

    //  ai: {
    //    prompt_level_chat_1: "What does this error mean?",
    //    prompt_level_chat_2: "Please explain this error.",
    //    prompt_level_chat_3: "What's wrong?",
    //    prompt_level_chat_4: "Please help explain this.",
    //    prompt_level_chat_5: "How can I fix it?",
    //    prompt_level_chat_6: "Help, please.",
    //    prompt_level_chat_7: "What do I do?",
    //    prompt_level_chat_8: "What does this mean?",
    //    prompt_level_chat_9: "Please explain.",
    //    prompt_level_chat_10: "What is this error?",
    //    prompt_level_chat_11: "What is the problem?",
    //    prompt_level_chat_12: "???",
    //    prompt_level_chat_13: "Dear AI, I beseech you, explain my error, in verse.",
    //    prompt_level_chat_hint_1: "Can I get a hint?",
    //    prompt_level_chat_hint_2: "What's the next thing I should do?",
    //    prompt_level_chat_hint_3: "Please help me with the next part of my code.",
    //    prompt_level_chat_hint_4: "Coding hint, please.",
    //    prompt_level_chat_hint_5: "I need a hint on the next step.",
    //    hackstack_promotion: "Unlock the Full Potential of Generative AI",
    //    try_it_free: "Try it free",
    //    hackstack_promotion_blurb: "New to AI? Explore <b>CodeCombat AI HackStack</b> – the simplest route to AI literacy. Unlock the potential of ChatGPT-4, Claude, Stable Diffusion, and DALL-E. This innovative tool offers hands-on AI training, making creation effortless.",
    //    generate: "Generate",
    //    games: "Games",
    //    art: "Art",
    //    websites: "Websites",
    //    code_more: "Code and more",
    //    ideal_endeavour: "It's the ideal companion for any endeavor.",
    //    ai_made_ss: "AI Made Simple & Safe -- Start Today!",
    //    aiss_body: "Built as the simplest path to AI literacy, this tool empowers learners to harness top LLMs with hands-on AI training, making creation easy—whether it’s games, art, writing, code, or more. Together, we help learners safely bring their ideas to life across any subject.",
    //    learn_more: "Learn More!",
    //    cyber_security_modal_header: "Cybersecurity Curriculum for AP and CompTIA Security+",
    //    cyber_security_modal_body: "Our Cybersecurity curriculum has now officially launched. Give students a classroom-ready way to prepare for AP Cybersecurity and CompTIA Security+ through digital simulations, technical writing, and real-world security scenarios, with no specialized hardware required.",
    //  },

    //  user_credits: {
    //    level_chat_left_in_duration: "__credits__ AI Bot queries left for the __duration_key__",
    //    level_chat_left_in_duration_multiple: "__credits__ AI Bot queries left for __duration_amount__ __duration_key__",
    //    level_chat_no_credits_left_duration: "No AI Bot queries left for the __duration_key__",
    //    level_chat_no_credits_left_duration_multiple: "No AI Bot queries left for __duration_amount__ __duration_key__",
    //    level_chat_no_credits_left: "No AI Bot queries left",
    //    level_chat_duration_hour: "hour",
    //    level_chat_duration_day: "day",
    //    level_chat_duration_week: "week",
    //    level_chat_duration_month: "month",
    //    level_chat_duration_year: "year",
    //  },

    //  home_v3: {
    //    mission_title: "Join us in our mission to make coding and AI accessible to all.",
    //    mission_supporting_text: "We’re committed to delivering high quality education solutions that empower everyone to realize their potential and help shape a better future.",
    //    stat_card_1_text: "20 Million",
    //    stat_card_1_description: "Engaged Students",
    //    stat_card_2_text: "1 Billion",
    //    stat_card_2_description: "Lines of Code",
    //    stat_card_3_text: "320,000",
    //    stat_card_3_description: "Supported Teachers",
    //    stat_card_4_text: "75,000",
    //    stat_card_4_description: "Schools Reached",
    //    stat_card_5_text: "190+",
    //    stat_card_5_description: "Countries",
    //    stat_card_6_text: "5.2 Million",
    //    stat_card_6_description: "ESports Players",
    //    learn_to_code: "Learn to **code** and use **AI**, all through the **power of play**.",
    //    innovative_play_experiences: "We create innovative play experiences to make computer science engaging and accessible to all.",
    //    sign_up_today: "Sign-up today to play for free and explore our games and resources.",
    //    im_an_educator: "I’m an Educator",
    //    im_a_parent: "I’m a Parent",
    //    im_a_student: "I’m a Student",
    //    programming_languages: "Programming Languages & AI Tools",
    //    engaging_play_experiences: "Engaging Play Experiences",
    //    for_younger_learners: "For Younger Learners",
    //    your_turnkey_solutions: "Your Turnkey Solutions",
    //    trends_insights: "Trends & Insights",
    //    awards_partners: "Awards & Partners",
    //    faq_visit_help_center: "For answers to frequently asked questions visit our **help center**.",
    //    contact_us: "Contact Us",
    //    for_further_questions: "For further questions",
    //    education_partner: "Education[NEWLINE]Partner",
    //    official_member: "Official[NEWLINE]Member",
    //    best_creativity_tool_for_students: "Best Creativity[NEWLINE]Tool for Students",
    //    official_partner: "Official[NEWLINE]Partner",
    //    hour_of_code_activity_partner: "Hour of Code[NEWLINE]Activity Partner",
    //    top_pick_for_learning: "Top Pick for[NEWLINE]Learning",
    //    testimonals_1_title: "“One thing I am able to do now, that I could not do before, is actually believe I can code.”",
    //    testimonals_1_name: "Mountain Ridge Middle School Student",
    //    testimonals_2_title: "\"Name any program online, I’ve tried it. None of them match up to CodeCombat & Ozaria. Any teacher who wants their students to learn how to code... start here!\"",
    //    testimonals_2_name: "Scott Baily, Bobby Duke Middle School",
    //    testimonals_3_title: "\"I’ve always had aspirations of designing video games and learning how to code ... this is giving me a great starting point.\"",
    //    testimonals_3_name: "Joey, 10th Grade",
    //    testimonals_4_title: "\"What I love the most about CodeCombat is that it does not simplify coding. The students are learning to write actual code, yet doing it in such a way that they are having fun.”",
    //    testimonals_4_name: "Sandra Ahlstrom, Teacher, Sheridan County School District #2",
    //    carousel_1_title: "Game-Based[NEWLINE]Learning",
    //    carousel_1_text: "With our unique approach, students embrace learning as they play and write code from the very start of their adventure, promoting active learning and a growth mindset.",
    //    carousel_2_title: "Text-Based[NEWLINE]Coding",
    //    carousel_2_text: "Our custom code engine and interpreter is designed for beginners, teaching true Python, JavaScript, and C++ programming languages using human, beginner-friendly terms.",
    //    carousel_3_title: "Project-Based[NEWLINE]Assessments",
    //    carousel_3_text: "These projects are an opportunity for students to code their own shareable games. We provide evaluation rubrics so that you can use Capstone projects as your primary summative assessments.",
    //    carousel_4_title: "AI[NEWLINE]Acceleration",
    //    carousel_4_text: "We teach students how to use AI to expedite learning and advance their coding abilities. This powerful combination unlocks the creative potential of those at every skill level.",
    //    carousel_5_title: "Educator[NEWLINE]Empowerment",
    //    carousel_5_text: "Our classroom solutions are built with all the support and resources any educator would need to implement the curriculum and drive successful outcomes.",
    //    carousel_6_title: "Student[NEWLINE]Impact",
    //    carousel_6_text: "Our products have helped over 20 million students enjoy learning Computer Science, teaching them to be critical, confident, and creative learners. We engage all students, regardless of experience, helping them to realize a pathway to success in Computer Science.",
    //    engaging_boxes_1_title: "Ozaria Classroom",
    //    engaging_boxes_1_text: "A narrative coding adventure that establishes the fundamentals of computer science.",
    //    engaging_boxes_2_title: "CodeCombat Classroom",
    //    engaging_boxes_2_text: "A full CS curriculum that builds from core concepts all the way through web development, game development and **[https://codecombat.com/apcsp]AP CSP**.",
    //    engaging_boxes_3_title: "CodeCombat Worlds on Roblox",
    //    engaging_boxes_3_text: "In partnership with Roblox Education, this AI enabled experience super-charges student coding abilities and provides a real-world platform to create amazing games and experiences.",
    //    engaging_boxes_4_title: "CodeCombat AI League Esports",
    //    engaging_boxes_4_text: "An epic competitive coding esports platform that encourages creative programming in a game-based environment.",
    //    engaging_boxes_5_title: "CodeCombat AI HackStack",
    //    engaging_boxes_5_text: "The first generative AI companion tool specifically crafted for those new to AI with a focus on student privacy and safety. Blending simplicity and power, the platform accelerates student abilities and unleashes their creative potential.",
    //    engaging_boxes_6_title: "CodeCombat Home",
    //    engaging_boxes_6_text: "With access to over 530 levels and exclusive features like pets, premium-only items, and heroes, your child can fully immerse themselves in the world of coding. They can even design games to challenge their friends, build websites and apps to share.",
    //    young_learners_1_title: "CodeCombat Junior",
    //    young_learners_1_text: "Our flagship K-5 curriculum features a progression of learning levels that teach basic coding concepts at a slower pace, modeled specifically for elementary students.",
    //    young_learners_1_linkText: "Sign up for Beta Access",
    //    young_learners_2_title: "AI Junior",
    //    young_learners_2_text: "Introduces multi-modal generative AI in a simple and intuitive platform designed specifically for K-5 students.",
    //    young_learners_2_linkText: "Sign up for Beta Access",
    //    solutions_1_title: "Professional Development",
    //    solutions_1_text: "Built to empower all teachers with the skills, knowledge, and confidence to effectively teach computer science.",
    //    solutions_1_middleText: "Earn up to 6 graduate credits.",
    //    solutions_1_linkText: "Try it now",
    //    solutions_2_title: "AP CSP Exam Preperations",
    //    solutions_2_text: "We are recognized by the College Board as an endorsed provider of curriculum and professional development for AP® Computer Science Principles (AP CSP). Our AP CSP curriculum provides game-based and turnkey tools to prepare students for the AP exam.",
    //    solutions_2_linkText: "Try it now",
    //    solutions_3_title: "Grant and Funding Sources",
    //    solutions_3_text: "We understand the funding hurdles that schools encounter and are passionate about helping to overcome these obstacles. Check out our comprehensive guide to grant funding or speak with our team to learn more.",
    //    solutions_4_title: "District-Level Solutions",
    //    solutions_4_text: "Our innovative solutions have helped districts across the country expand or start their computer science programs. Designed with feedback from our community of over 320,000 educators, our comprehensive solution provides a responsive and flexible curriculum that meets the needs of all students and educators. It’s easy to implement and scale with our team providing the training and support your teachers need.",
    //    solutions_5_title: "Live Online Classes",
    //    solutions_5_text: "Our online coding classes combine the power of gameplay and personalized instruction for an experience your child will love. From coding and publishing their own Roblox games, to building a website for a new business, your child will explore all that is possible with AI and coding.",
    //    solutions_6_title: "CodeQuest",
    //    solutions_6_text: "Join us for an immersive educational experience like no other, designed to inspire and empower the next generation of computer science innovators. This rare opportunity brings together students from around the globe to participate in a series of coding hackathons, learn from notable speakers and visit top universities and technology organizations.",
    //    solutions_6_linkText: "Discover More",
    //    solutions_7_title: "Partner Solutions",
    //    solutions_7_text: "Join our mission to make coding accessible and engaging for all by becoming a valued partner. Our flexible partnership structures include educational businesses, esports sponsors, international distributors, and social impact organizations. Partners receive access to our easy-to-use programs, implementation resources, and training options for a successful and enjoyable experience.",
    //    solutions_8_title: "Library Solutions",
    //    solutions_8_text: "As an entirely self-paced and self-directed digital resource, CodeCombat is the best integration for libraries that want to empower their members of all ages to learn how to code. Our platform offers everything learners need to experience a high-level coding education through a uniquely exciting, game-based curriculum. Perfect for beginners all the way up to those who want to master college-level coding concepts.",
    //    learn_more_text: "Discover More",
    //    best_homeschool_curriculum: "Best Homeschool[NEWLINE]Curriculum",
    //    sign_up_free: "Sign Up Free",
    //    try_it_now: "Try it now",
    //    junior_modal_header: "Try Our New K-5 Curriculum Today!",
    //    junior_modal_body: "Perfect for K-5 classrooms, this new curriculum features real coding with icons, drag-and-drop blocks, parallel blocks with text, or purely text-based options. Plus, it’s fully accessible on tablets making it easy to support all learners.",
    //    hs_modal_header: "Unlock Free AI Access This Summer",
    //    hs_modal_body: "Discover how educators innovate with our AI -- watch the quick demo! This summer, explore Claude, DALL-E, Stable Diffusion, and more. Book a brief meeting by August 15 to claim your free 90-day AI educator license -- We'll handle the setup so you can dive right in.",
    //    get_started: "Get Started!",
    //  },

    //  schools_page: {
    //    meta_title: "CodeCombat: the most effective computer science solution for schools",
    //    most_effective_computer_science_solution: "The most effective computer science solution for **schools**",
    //    our_comprehensive_implementation: "Our comprehensive implementation empowers teachers, engages students and delivers successful outcomes.",
    //    start_teach_trial: "Start teaching today with free trial access to all games and teaching resources.",
    //    get_my_solution: "Get My Solution",
    //    flexible_standards_aligned_curriculum_title: "A Flexible Standards Aligned Curriculum",
    //    flexible_standards_aligned_curriculum_text: "Our scaffolded approach covers computer science fundamentals up through advanced courses and features **[https://codecombat.com/apcsp]College Board endorsed AP CSP**, web and game development. We build customized pathways to deliver a personalized learning experience that meets **[https://codecombat.com/standards]CSTA, ISTE and Common Core State Standards**. The flexible curriculum offers the ability to teach Python, JavaScript, C++, Luau and more.",
    //    comprehensive_tools_resources_title: "Comprehensive Tools & Resources",
    //    comprehensive_tools_resources_text: "The teacher resource hub empowers all educators to teach on day one. Easily access lesson plans, student-facing lesson slides, rubrics, extension activities, capstone projects and assessments. Our safe AI integrations accelerate student potential and allow educators to optimize class time. For real-world practice and application, we offer competitive coding esports, Roblox game design and web design options. Additionally, educators can control student pacing with content assignment and locking features.",
    //    accessible_data_insights_title: "Accessible Data & Insights",
    //    accessible_data_insights_text: "We provide administrators the insight they need with real-time usage data and progress reports at the class, school, district and state level. Student level progress tracking enables educators to easily identify when intervention is needed and the built in pre and post module assessments measure student comprehension.",
    //    high_quality_professional_development_title: "High Quality Professional Development",
    //    high_quality_professional_development_text: "**[https://csteachers.org/pd-opportunities/accredited-pd/]Endorsed by the Computer Science Teachers Association (CSTA)**, the course provides 44+ hours of self-directed, web-based, and on-demand learning. The program is self-paced and designed to fit any busy schedule. The course prepares anyone with or without teaching experience to successfully implement a CS curriculum.",
    //    earn_up_to_3_graduate_credits: "Earn up to 6 graduate credits with this course.",
    //    request_a_demo: "Request a Demo",
    //    maximize_your_impact: "All the tools to maximize learning outcomes",
    //    core_curriculum: "Core Curriculum",
    //    practice_enrichment: "Practice & Enrichment",
    //    student_acceleration_ap_csp: "Student Acceleration & AP CSP",
    //    ai_enhanced_core_curriculum: "AI-Enhanced Core Curriculum",
    //    young_learners: "Young Learners",
    //    funding_solutions: "Funding Solutions",
    //    support_development: "Support & Development",
    //    ai_support_acceleration_title: "AI Support & Acceleration",
    //    ai_support_acceleration_text: "We use AI to make teaching time more effective. CodeCombat now supports an AI hints feature that evaluates code, points out errors, and explains how to fix them. Most importantly, it provides all the context needed to understand the why, without revealing the entire solution. Students will still need to work through each level’s coding challenge but now you don’t need to stop class to address individual needs. **Teachers receive an allocation of 100 AI hints per day** and **each student gets 5 AI hints per day**, to ensure they always have the support they need.",
    //    codecombat_ai_hackstack_text: "For those new to AI, we offer **CodeCombat AI HackStack**. This innovative tool not only teaches students how to use AI but provides secure access to many of the latest LLMs including ChatGPT-4, Claude, Stable Diffusion, DALL-E and others. After just a short time working through the training mode, users unlock the full creative potential of the tool, allowing prompt-to-code-to-published projects in minutes. This AI-powered application enables users to generate games, art, websites, code and more. **Teachers receive an allocation of 100 AI prompts per month** and **each student gets 10 AI prompts per week**, to create multiple AI projects.",
    //    pathways_for_success: "Pathways for Success",
    //    for_your_custom_pathway: "For Your Custom Pathway",
    //    elementary_school: "Elementary School",
    //    codecombat_jr: "CodeCombat Junior",
    //    ai_hacksstack_jr: "AI Junior",
    //    codecombat_worlds: "CodeCombat Worlds",
    //    k: "K",
    //    icons_block_based: "Icons & Block-Based",
    //    introduction_to_ai: "Introduction to AI",
    //    grade_1: "Grade 1",
    //    simple_ai_templates: "Simple AI Templates",
    //    grade_2: "Grade 2",
    //    complex_ai_templates: "Complex AI Templates",
    //    explorations: "Explorations",
    //    grade_3: "Grade 3",
    //    block_based: "Block-Based",
    //    grade_4: "Grade 4",
    //    block_based_text: "Block-Based & Text",
    //    grade_5: "Grade 5",
    //    text: "Text",
    //    our_k_5_implementation_pathway: "Our K-5 Implementation Pathway will introduce two new **beginner friendly** platforms which include CodeCombat Junior, our flagship elementary level curriculum features a progression of learning levels that **teach basic coding concepts at a slower pace**, and AI Junior, a **multimodal  AI tool** that allows students to sketch, write, and design their own digital products.This scaffolded progression will let students grow with our immersive content and explore a wide variety of computational thinking and computer science concepts",
    //    middle_school: "Middle School",
    //    high_school: "High School",
    //    ozaria: "Ozaria",
    //    ai_hackstack: "AI HackStack",
    //    ai_league: "AI League",
    //    grade_6: "Grade 6",
    //    introduction_to_coding: "Introduction to Coding",
    //    introduction_to_luau_coding: "Introduction to Lua Coding",
    //    introduction_to_coding_esports: "Introduction to Coding Esports",
    //    grade_7: "Grade 7",
    //    loops_structures: "Loops & Structures",
    //    introduction_to_creative_mode: "Introduction to Creative Mode",
    //    ai_scenarios: "AI Scenarios",
    //    competitive_coding_arenas: "Competitive Coding Arenas",
    //    grade_8: "Grade 8",
    //    functions_data: "Functions & Data",
    //    game_development: "Game Development",
    //    open_ended_ai_projects: "Open-Ended AI Projects",
    //    middle_school_implementation: "Our middle school implementation establishes a **foundation of coding concepts** with Ozaria, our core Computer Science curriculum. This eventually expands to more voice and choice, where students will **explore coding and AI** across three diverse platforms. The **educator and students can choose** how deeply they will explore each of these additional platforms.",
    //    codecombat: "CodeCombat",
    //    ap_csp: "AP CSP",
    //    cs1_4_data_science_cybersecurity_exam_content: "CS1-4 [NEWLINE] Data Science [NEWLINE] Cybersecurity [NEWLINE] Exam Content",
    //    advanced_cs: "Advanced CS",
    //    cs5_6_gd1_3_wd1_2: "CS 5-6 [NEWLINE] GD 1-3 [NEWLINE] WD 1-2",
    //    advanced_game_development: "Advanced Game Development",
    //    advanced_ai_projects: "Advanced AI Projects",
    //    global_esports_tournament: "Global Esports Tournament",
    //    first_year_high_school_curriculum: "The first year of our high school curriculum focuses on **AP CS Principles**, which includes our CodeCombat courses, CS1−CS4 and exam curriculum content such as **Data Science** and **Computing Systems**. The more advanced year allows students to explore more of our **advanced CS courses** and offers voice and choice across our three platforms.",
    //    accessibility_representation_title: "Accessibility & Representation",
    //    accessibility_representation_text: "Our student-centric design meets students where they are and provides them with the support they need. In-person and remote learning capabilities allow students to learn anywhere, anytime. Keyboard accessibility, full-screen reader compatibility and colorblind-friendly color scheme ensures everyone can learn to code.",
    //    accessibility_acr_prefix: "We meet WCAG 2.1 Level AA and Revised Section 508 Standards. See our",
    //    accessibility_acr_link_text: "Accessibility Compliance Report (ACR) / VPAT",
    //    accessibility_acr_suffix: "for more information.",
    //    privacy_security_title: "Privacy & Security",
    //    privacy_security_text: "We take student safety, cybersecurity, and data privacy seriously, and follow the stringent school-grade privacy regulations including COPPA, FERPA, SOPIPA, California AB 1584, CalOPPA, Fair Information Practices, CAN-SPAM, as well as GDPR. All data is stored securely on Amazon Web Services in the US. our AI integrations have guardrails to protect Personal Identifiable Information and restrict sensitive content. Project sharing is controlled and peer-to-peer communication is restricted. Data Processing Agreements are available, visit **https://codecombat.com/privacy** for more information.",
    //    contact_our_team: "Contact Our Team",
    //    for_turnkey_solutions: "For your turnkey solution",
    //    testimonials_1_quote: "“Let me make this clear first. I recommend your product because it is the best programming teaching tool currently on Earth.”",
    //    testimonials_1_name: "Seth Reichelson",
    //    testimonials_1_title: "AP Computer Science Teacher, Lake Brantley High School. White House Champion of Change Winner",
    //    testimonials_2_quote: "“[Ozaria] is a full curriculum for computer science education, it’s super impressive, very extensive [...] It’s got everything you need [...] I don't know that we've seen anything with this much extra stuff to help you teach it well.”",
    //    testimonials_2_name: "Tanner Higgin",
    //    testimonials_2_title: "Editorial Director - Learning Content, Common Sense Education",
    //    testimonials_2_full_review_text: "Full Review Here",
    //    testimonials_3_quote: "“CodeCombat was one of the easiest to implement programs we’ve piloted and student engagement was extremely high. The way the content is designed, scaffolds perfectly and allows students to quickly move into high level programming skills far beyond anything we could have hoped for.”",
    //    testimonials_3_name: "Steve Kong",
    //    testimonials_3_title: "Instructional Services Specialist, Riverside Unified School District",
    //    testimonials_4_quote: "“One thing I am able to do now that I could not do before is actually believe I can code.”",
    //    testimonials_4_name: "",
    //    testimonials_4_title: "Mountain Ridge Middle School Student",
    //    testimonials_5_quote: "“CodeCombat has transformed how I teach coding...I utilize the great teacher resources including Curriculum Guides, Project Guides, and Solutions. Using CodeCombat has helped me to teach fairly advanced concepts in a way the students enjoy and understand. What I love the most about CodeCombat is that it does not simplify coding. The students are learning to write actual code, yet doing it in such a way that they are having fun.”",
    //    testimonials_5_name: "Sandra Ahlstrom",
    //    testimonials_5_title: "Teacher, Sheridan County School District #2",
    //    faq_1_question: "What you need to know about certification exams and AP CSP",
    //    faq_1_answer: "Career Technical Education (CTE) programs in the U.S. focus on equipping students with industry-valued skills and can lead to trade school or college education. Mandated by state and federal laws, CTE programs must offer students postgraduate credit, industry certifications, or internship hours. While some fields, like cybersecurity, offer valued certification exams, others such as software engineering prioritize four-year degrees over such exams. However, passing the AP Computer Science Principles exam serves as a recognized avenue to postsecondary credit, enabling students to bypass costly and time-consuming college requirements. To help prepare students CodeCombat provides an **[https://codecombat.com/apcsp]AP CSP course**, endorsed by the College Board.",
    //    faq_2_question: "How we use AI to support educators",
    //    faq_2_answer: "We use AI to make teaching time more effective. With growing class sizes and limited time for personalized instruction our AI-powered level chat assistant is the perfect tool to take care of your students' individual questions. This powerful helper can evaluate code, point out errors, explain how to fix them, and provide all the context they need to understand the “why”. And most importantly it will not give them the solution. With only next line assistance available students will still need to work through each level's coding challenge but now you don’t need to stop class to address individual needs.",
    //    faq_3_question: "How we integrate AI safely and responsibly",
    //    faq_3_answer: "Our AI technology adheres to safety-first principles, providing confidence to both students and educators. We do not allow our backend LLM providers to train your chats and have established protective measures against inappropriate content. These measures include filtering harmful language, maintaining focus on relevant subjects, safeguarding personal information, and educating students about potential AI pitfalls. Moreover, we log AI chat activity for teacher monitoring and uphold stringent data privacy and security protocols.",
    //    faq_4_question: "Why computer science is important",
    //    faq_4_answer: "Computer science education provides the immediate benefits of boosting problem-solving competencies, sharpening mathematical abilities, and encourages the logical thinking necessary for success across other core school subjects. The learning extends far beyond the code, enhancing students' capability to solve complex problems and adapt to different situations. See how Ozaria helps make those **[https://docs.google.com/presentation/d/1xcc1tw4k8oY9basXuxO0v_RU9z-Dr8ImvbvbuNvJeHA/edit#slide=id.g134a7e7c8f1_0_3]cross curricular connections**. Our curriculum is designed to equip students today with the crucial computer science skills that will prepare them for the digital jobs of tomorrow.",
    //    faq_5_question: "Why game-based learning works",
    //    faq_5_answer: "Game-based learning is so effective because it provides a safe environment where failure is not feared but expected, offering an opportunity for growth and understanding. This approach encourages students to learn from their mistakes and adapt their strategies for success. Furthermore, the interactive and dynamic nature of games helps students retain information more effectively, as they are learning through practical, hands-on experiences. It actively engages students in the learning process, increasing their motivation and enjoyment.",
    //    faq_6_question: "How to find alternative funding sources",
    //    faq_6_answer: "Computer science education has become a vital component of a student's academic journey, however, many schools face challenges in securing the necessary resources to provide their students with comprehensive computer science programs. At CodeCombat, we understand the funding hurdles that schools encounter and are passionate about helping them overcome these obstacles. Grants can be a valuable resource but difficult to discover and apply for. Check out our comprehensive **[https://codecombat.com/grants]guide to grant funding** or speak with our team to learn more.",
    //    faq_7_question: "How to get started",
    //    faq_7_answer_1: "Create your Teacher or Admin Account",
    //    faq_7_answer_2: "Create a class",
    //    faq_7_answer_3: "Add students",
    //    faq_7_answer_4: "Sit back and watch your students have fun learning to code",
    //    faq_8_question: "Support for Clever and Google login",
    //    faq_8_answer: "We offer both Clever and Google Classroom integration. Check out our **[https://codecombat.com/teachers/resources/clever-faq]Clever Integration FAQ** for more details on how to get started.  If you are using Google Classroom be sure to use the Google Single Sign-On (SSO) Modal to sign up for your teacher account. If you already have an account using your Google email, use the Google SSO modal to log in next time. In the Create Class modal, you will see an option to Link Google Classroom. We only support rostering via Google Classroom at this time. Note: you must use Google SSO to sign up or log in at least once in order to see the Google Classroom integration option.",
    //    faq_9_question: "Recommended browser and operating system",
    //    faq_9_answer: "CodeCombat and Ozaria run best on computers with at least 4GB of RAM, on a modern browser such as Chrome, Safari, Firefox, or Edge. Chromebooks with 2GB of RAM may have minor graphics issues in later courses. A minimum of 200 Kbps bandwidth per student is required, although 1+ Mbps is recommended.",
    //    core_curriculum_1_title: "Ozaria Classroom",
    //    core_curriculum_1_text: "A narrative coding adventure that establishes the fundamentals of computer science.",
    //    core_curriculum_1_link_text: "Try it now",
    //    core_curriculum_2_title: "CodeCombat Classroom",
    //    core_curriculum_2_text: "A full CS curriculum that builds from core concepts all the way through web development, game development and **[http://codecombat.com/apcsp]AP CSP**.",
    //    core_curriculum_2_link_text: "Try it now",
    //    practice_enrichment_1_title: "CodeCombat AI League Esports",
    //    practice_enrichment_1_text: "An epic competitive coding esports platform that encourages creative programming in a game-based environment.",
    //    practice_enrichment_1_link_text: "Try it now",
    //    practice_enrichment_2_title: "CodeCombat Worlds on Roblox",
    //    practice_enrichment_2_text: "In partnership with Roblox Education, this AI enabled experience super-charges student coding abilities and provides a real-world platform to create amazing games and experiences.",
    //    practice_enrichment_2_link_text: "Try it now",
    //    student_acceleration_1_title: "CodeCombat AI HackStack",
    //    student_acceleration_1_text: "The first generative AI companion tool specifically crafted for those new to AI with a focus on student privacy and safety. Blending simplicity and power, the platform accelerates student abilities and unleashes their creative potential.",
    //    student_acceleration_1_link_text: "Try it now",
    //    student_acceleration_2_title: "AP CSP Exam Preperations",
    //    student_acceleration_2_text: "We are recognized by the College Board as an endorsed provider of curriculum and professional development for AP® Computer Science Principles (AP CSP). Our AP CSP curriculum provides game-based and turnkey tools to prepare students for the AP exam.",
    //    student_acceleration_3_title: "Algebra + AI",
    //    student_acceleration_3_text: "A complete, teacher-led Algebra + AI curriculum that builds strong math foundations while integrating AI as a tool. Students develop deep reasoning, modeling skills, and critical thinking through structured, classroom-ready lessons.",
    //    student_acceleration_4_title: "Cybersecurity",
    //    student_acceleration_4_text: "A classroom-ready cybersecurity curriculum with digital simulations that eliminate the need for specialized hardware, plus technical writing, safe AI use, and learning aligned with AP Cybersecurity and CompTIA Security+.",
    //    young_learners_1_title: "CodeCombat Junior",
    //    young_learners_1_title_classroom: "CodeCombat Junior Classroom",
    //    young_learners_1_text: "Our flagship K-5 curriculum features a progression of learning levels that teach basic coding concepts at a slower pace, modeled specifically for elementary students.",
    //    young_learners_1_link_text: "Sign up for Beta Access",
    //    young_learners_2_title: "AI Junior",
    //    young_learners_2_text: "Introduces multi-modal generative AI in a simple and intuitive platform designed specifically for K-5 students.",
    //    young_learners_2_link_text: "Sign up for Beta Access",
    //    funding_solutions_1_title: "Grant and Funding Sources",
    //    funding_solutions_1_text: "We understand the funding hurdles that schools encounter and are passionate about helping to overcome these obstacles. Check out our comprehensive guide to grant funding or speak with our team to learn more.",
    //    funding_solutions_1_link_text: "Discover More",
    //    support_development_1_title: "Live Online Classes",
    //    support_development_1_text: "Want to provide high-quality CS instruction, but don’t have the staff to execute? Our team of master instructors can provide engaging virtual lessons perfect for in-class or after school programs.",
    //    support_development_1_link_text: "Sign up for Beta Access",
    //    faq_header: "Frequently Asked Questions",
    //    faq_see_more: "See more frequently asked questions in our **[https://codecombat.zendesk.com/hc/en-us]help center**.",
    //    trends_1_title: "AI isn’t Replacing Coding, It’s Accelerating it!",
    //    trends_1_text: "We've officially entered the AI era. Along with hype and hyperbole comes a wave of fear and uncertainty concerning the future of computer science. Videos of AI writing code with simple inputs and stories of engineers replaced by AI bots fueled a dramatic yet ultimately flawed narrative. The truth is, AI isn’t replacing coding; it’s accelerating it!",
    //    trends_1_linkText: "Read the Blog",
    //    trends_2_title: "Career Technical Education with Pat Keeney",
    //    trends_2_text: "Career Technical Education (CTE) prepares students to become lifelong learners and provides them with the skills and knowledge they need to succeed in their future careers. In this episode, Pat Keeney, CTE Champion at McGraw Hill, shares his experience",
    //    trends_2_linkText: "Listen to the Podcast",
    //    learn_more_text: "Discover More",
    //    your_turnkey_solutions: "Your Turnkey Solutions",
    //    free_teacher_account: "Free Teacher Account",
    //    trial_the_curriculum: "Trial the curriculum with your students today!",
    //    try_it_free: "Try It Free",
    //  },

    //  hackstack_page: {
    //    header: "Learn, create, and accelerate with **AI HackStack**",
    //    header_details: "Together, we empower learners to safely bring their ideas to life across any subject.",
    //    header_details_teacher: "With a license, unlock 100 monthly prompts for yourself and 30 weekly for students to bring your ideas to life across any subject.",
    //    accessible_safe_use: "Accessible, safe, and responsible use of AI",
    //    learn_title: "Learn",
    //    learn_description: "From **English Language Arts** to **Mathematics** and **Science**, students discover how to craft safe and effective prompts for generating output in each discipline. Learn essential prompt engineering skills in a **wide range of subjects** using Al HackStack's Learning Scenarios. Along the way, your students will gain hands-on experience with popular Al models like Claude, DALL-E, and Stable Diffusion.",
    //    create_title: "Create",
    //    create_description: "Bring your wildest ideas to life with HackStack's Al **sandbox environment**. Here, students will be able to quickly prototype interdisciplinary projects of all kinds. Use our turnkey curriculum to help your students engage in meaningful discussions about the **responsible use** of Al and the **ethical implications** of their creations. This holistic approach not only sparks innovation but also cultivates digital citizenship, equipping students with the skills and awareness needed to thrive in the digital age.",
    //    remix_title: "Remix",
    //    remix_description: "Supercharge the creative process by customizing one of the many projects found in Al HackStack's **community library**. The remix feature not only accelerates individual progress but also fosters a **collaborative ecosystem** where ideas evolve rapidly. As students remix and build upon each other's work, the collective output of your classroom will reach new creative heights, resulting in an impressive showcase of student-driven innovation.",
    //    privacy_title: "Safety and Privacy",
    //    privacy_subtitle: "Our AI platforms fuel student curiosity and creativity, with the privacy and security you need.",
    //    data_title: "Your Data is Safe",
    //    data_description: "We carefully vet Al tools before they are added to Al HackStack. If they're not safe, we don't include them. We also screen user prompts to make sure they don't contain any Personally Identifiable Information. If they do, we replace it with a placeholder value before giving it to an external Al model. Additionally, you have the power to lock specific Al tools so that your students cannot access the ones you don't feel comfortable using.",
    //    moderation_title: "Our Moderation Practices",
    //    moderation_description: "We monitor user prompts and Al output to make sure they don't contain any inappropriate content. You can review every prompt that your student has written in the Al HackStack teacher dashboard. We also provide turnkey resources to help you and your students navigate the complexity of using Al, and provide professional development opportunities for those who want more guidance on what to look for when students are using Al.",
    //    professional_development: "High Quality Professional Development",
    //    professional_development_text: "We offer professional development opportunities for those who want more guidance on how to use AI in the classroom. These professional development workshops were modeled after **[https://www.teachai.org/toolkit]Teach AI**, **[https://www.edsafeai.org/safe]EdSafe**, **[https://csteachers.org/k12standards/]CSTA**, and **[https://ai4k12.org/]AI4K12’s** AI standards, which focus on the safe and responsible use of AI.",
    //    ask_pd: "Ask about AI PD",
    //    testimonials_1_quote: "The energy and excitement... in experimenting with different models and brainstorming and pitching their first Al programs were truly uplifting! I can't wait to check out these programs. Here's to making Al accessible to everyone!",
    //    testimonials_1_name: "Vivienne Byrd",
    //    testimonials_1_title: "STEAM Librarian & Program Lead of Citizen Science Initiative, Los Angeles Public Library",
    //    try_it_free: "Try It Free",
    //    faq_1_question: "How old should my students be to use AI HackStack?",
    //    faq_1_answer: "AI HackStack is great for middle school and high school-aged students. Our safety and privacy practices allow us to help younger users, like your students, interface safely with AI.  Do you teach elementary-aged students? If so, **[mailto:team@codecombat.com]connect with our team** to learn more about CodeCombat AI Junior, which introduces multimodal generative AI in a simple and intuitive platform designed specifically for K-5 students.\"",
    //    faq_2_question: "How we integrate AI safely and responsibly?",
    //    faq_2_answer: "Our AI technology adheres to safety-first principles, providing confidence to both students and educators. We do not allow our backend LLM providers to train your chats and have established protective measures against inappropriate content. These measures include filtering harmful language, maintaining focus on relevant subjects, safeguarding personal information, and educating students about potential AI pitfalls. Moreover, we log AI chat activity for teacher monitoring and uphold stringent data privacy and security protocols.",
    //    faq_3_question: "What LLMs is AI HackStack using?",
    //    faq_3_answer_1: "ChatGPT-4: A model designed for natural language understanding and generation tasks.",
    //    faq_3_answer_2: "Claude: A language model that focuses on performance and safety in AI interactions.",
    //    faq_3_answer_3: "Stable Diffusion: A model that generates images from text descriptions.",
    //    faq_3_answer_4: "DALL-E: An image generation model that creates visuals based on text prompts.",
    //    faq_3_answer_5: "We continuously evaluate these models for performance and safety, ensuring we update to the latest versions available.",
    //    faq_4_question: "How to find alternative funding sources?",
    //    faq_4_answer: "Computer science education has become a vital component of a student's academic journey, however, many schools face challenges in securing the necessary resources to provide their students with comprehensive computer science programs. At CodeCombat, we understand the funding hurdles that schools encounter and are passionate about helping them overcome these obstacles. Grants can be a valuable resource but difficult to discover and apply for. Check out our comprehensive **[https://codecombat.com/grants]guide to grant funding** or **[mailto:team@codecombat.com]speak with our team** to learn more.",
    //    faq_5_question: "How to get started",
    //    faq_5_answer_1: "Create your Teacher or Admin Account",
    //    faq_5_answer_2: "Create a class",
    //    faq_5_answer_3: "Add students",
    //    faq_5_answer_4: "Unlock AI HackStack for your class",
    //    faq_5_answer_5: "Sit back and watch your students have fun learning about AI",
    //    faq_6_question: "Support for Clever and Google login",
    //    faq_6_answer: "We offer both Clever and Google Classroom integration. Check out our **[https://codecombat.com/teachers/resources/clever-faq]Clever Integration FAQ** for more details on how to get started. If you are using Google Classroom be sure to use the Google Single Sign-On (SSO) Modal to sign up for your teacher account. If you already have an account using your Google email, use the Google SSO modal to log in next time. In the Create Class modal, you will see an option to Link Google Classroom. We only support rostering via Google Classroom at this time. Note: you must use Google SSO to sign up or log in at least once in order to see the Google Classroom integration option.",
    //    faq_7_question: "Recommended browser and operating system",
    //    faq_7_answer: "TBA",
    //    faq_8_question: "How many prompts do I get?",
    //    faq_8_answer: "With a license, you get 100 monthly prompts for teacher and 30 weekly for students. Individual premium users get 50 prompts per month.",
    //    learn_more: "Learn More",
    //    promo_modal_title: "Explore AI HackStack",
    //    promo_modal_subtitle: "Unlock the Full Potential of Generative AI",
    //    promo_modal_text: "**New to AI? Explore CodeCombat AI HackStack** — the easiest way to dive into AI literacy. Unlock the power of top models like **ChatGPT-4**, **Claude**, **Stable Diffusion**, and **DALL-E**. With hands-on tools, creating games, art, websites, code, and more has never been simpler. It’s the perfect companion for any creative project, no experience required!",
    //    explore_hackstack: "Explore Hackstack",
    //    learn_1_text: "Play in a safe[NEWLINE]AI sandbox",
    //    learn_2_text: "Cross-[NEWLINE]Curricular[NEWLINE]Lessons",
    //    learn_3_text: "Prompt[NEWLINE]Engineering",
    //    learn_4_text: "Remix AI[NEWLINE]Project",
    //    learn_5_text: "Ethics-Centered[NEWLINE]Reflection",
    //    learn_6_text: "Actionable[NEWLINE]Data",
    //    learn_7_text: "Professional[NEWLINE]Development[NEWLINE]for AI",
    //  },

    //  hackstack_algebra_page: {
    //    header: "Algebra + AI Curriculum",
    //    header_powered_by: "Powered By",
    //    header_details: "A classroom-ready Algebra + AI curriculum focused on deep reasoning and hands-on exploration before introducing AI. Students compare methods, verify AI outputs, and solve larger problems, with teachers guiding the instruction.",
    //    header_details_teacher: "With a license, your students get a classroom-ready Algebra + AI curriculum focused on deep reasoning and hands-on exploration.",
    //    cta_get_solution: "Get My Solution",
    //    cta_explore: "Explore AI Algebra",
    //    features_title: "A Core Algebra Curriculum Enhanced With AI",
    //    feature_1_title: "Foundations First\nAI Second",
    //    feature_2_title: "Teaches to Critically\nEvaluate AI",
    //    feature_3_title: "Teacher-Guided\nReal-World Modeling",
    //    lesson_flow_title: "Inside a Module: Lesson Flow in Action",
    //    step: "Step",
    //    step_1_title: "Mathematical Reasoning Without AI",
    //    step_1_desc: "Students first solve problems with pen, paper or a calculator to build a strong foundation in algebra and learn to reason through equations independently before introducing AI.",
    //    step_1_tag: "Traditional",
    //    step_2_title: "Mathematical Reasoning With AI",
    //    step_2_desc: "Students then use an AI tool to solve the same problems and compare its process and results to their own, helping them see how AI approaches problem solving and where it differs.",
    //    step_2_tag: "AI + Traditional",
    //    step_3_title: "Practice",
    //    step_3_desc: "By working through more problems with both traditional and AI methods, students learn to verify AI outputs, identify errors or misinterpretations and refine prompts to improve accuracy.",
    //    step_3_tag: "AI + Traditional",
    //    step_4_title: "AI Modeling",
    //    step_4_desc: "Students move beyond simple calculations by using AI to model equations across larger or more complex datasets, showing how AI can scale problem solving in ways not possible by hand.",
    //    step_4_tag: "AI Enabled",
    //    step_5_title: "Checking AI Modeling",
    //    step_5_desc: "Finally, students use alternative AI tools or verification methods to cross-check their models for accuracy, reinforcing the importance of validation and accountability when working with AI.",
    //    step_5_tag: "AI Enabled",
    //    module_structure_title: "Algebra + AI Module Structure",
    //    module_1_title: "Mathematical Reasoning Without AI",
    //    module_1_desc: "Students first solve problems with pen, paper or a calculator to build a strong foundation in algebra and learn to reason through equations independently before introducing AI.",
    //    module_1_tag: "Traditional",
    //    module_2_title: "Mathematical Reasoning With AI",
    //    module_2_desc: "Students then use an AI tool to solve the same problems and compare its process and results to their own, helping them see how AI approaches problem solving and where it differs.",
    //    module_2_tag: "AI + Traditional",
    //    module_3_title: "Practice",
    //    module_3_desc: "By working through more problems with both traditional and AI methods, students learn to verify AI outputs, identify errors or misinterpretations and refine prompts to improve accuracy.",
    //    module_3_tag: "AI + Traditional",
    //    module_4_title: "AI Modeling",
    //    module_4_desc: "Students move beyond simple calculations by using AI to model equations across larger or more complex datasets, showing how AI can scale problem solving in ways not possible by hand.",
    //    module_4_tag: "AI Enabled",
    //    module_5_title: "Checking AI Modeling",
    //    module_5_desc: "Finally, students use alternative AI tools or verification methods to cross-check their models for accuracy, reinforcing the importance of validation and accountability when working with AI.",
    //    module_5_tag: "AI Enabled",
    //    trusted_standards_title: "Built on Trusted Standards",
    //    trusted_standards_text: "Our curriculum aligns with Common Core Math standards and practices, strengthening students' skills in algebra, functions, modeling, and statistics. Additionally they'll develop AI literacy skills, such as prompt engineering, evaluating accuracy, using appropriate LLMs, understanding data, and considering human impact and design, all within teacher-guided instruction.",
    //    trusted_standards_link: "Learn More",
    //    curriculum_path_title: "A Structured Path from Algebra Foundations to AI Application",
    //    curriculum_path_cta: "Free Teacher Account",
    //    curriculum_path_subtitle: "Trial the curriculum with your students today!",
    //    testimonial_1_quote: "It shifted learning from just finding the final answer to understanding the step-by-step logic behind each problem.",
    //    testimonial_1_name: "Montebello High School Student",
    //  },

    //  hackstack_cyber_page: {
    //    header: "Cybersecurity Curriculum",
    //    header_details: "Explore real-world security concepts through digital simulations, technical writing, and classroom-ready lessons designed for flexible implementation.",
    //    header_aligned: "CompTIA Security+\nand AP Cybersecurity Aligned",
    //    cta_explore: "Explore Cybersecurity",
    //    features_title: "Designed for Real-World Cybersecurity Skills",
    //    feature_1_title: "Certification Pathways",
    //    feature_1_desc: "Builds skills students can carry into future coursework, certification, and careers",
    //    feature_2_title: "Technical Writing",
    //    feature_2_desc: "Real cybersecurity reports, memos, and assessments",
    //    feature_3_title: "Flexible Digital Delivery",
    //    feature_3_desc: "Digital simulations, no specialized hardware required",
    //    pathways_title: "Pathways at a Glance",
    //    module: "Module",
    //    module_1_title: "Intro to Security",
    //    module_1_tag: "Internal Memos",
    //    module_1_desc: "Students learn foundational security concepts and practice communicating risks clearly.",
    //    module_2_title: "Securing Spaces",
    //    module_2_tag: "Risk Assessments",
    //    module_2_desc: "Students evaluate environments, identify vulnerabilities, and recommend safer practices.",
    //    module_3_title: "Securing Networks",
    //    module_3_tag: "IOC Reports",
    //    module_3_desc: "Students investigate indicators of compromise and document evidence from simulated scenarios.",
    //    module_4_title: "Securing Devices",
    //    module_4_tag: "Remediation Reports",
    //    module_4_desc: "Students propose fixes, explain tradeoffs, and connect technical decisions to real-world outcomes.",
    //    module_5_title: "Securing Apps & Data",
    //    module_5_tag: "Incident Reports",
    //    module_5_desc: "Students apply what they've learned to analyze incidents and communicate next steps.",
    //    standards_cta: "See Standards Alignment",
    //    safety_title: "Built with Student Safety in Mind",
    //    safety_text: "AI HackStack supports safe, school-ready AI exploration with vetted tools, privacy filters, and educator controls. CodeCombat is built with student safety, cybersecurity, and data privacy in mind, following school-grade privacy requirements including COPPA, FERPA, SOPIPA, California AB 1584, CalOPPA, CAN-SPAM, and GDPR.",
    //  },

    //  standards_page: {
    //    standards_aligned_curriculum: "**Standards Aligned Curriculum**",
    //    curriculum_description: "CodeCombat offers robust course pathways aligned with several national and state standard frameworks across grades K-12 including AP level programming courses in many languages. Our curriculum engages students to explore and learn computer science through standards-aligned lessons.",
    //    most_effective_computer_science_solution: "The most effective computer science solution for **[https://codecombat.com/schools]schools**",
    //    comprehensive_implementation: "Our comprehensive implementation empowers teachers, engages students and delivers successful outcomes.",
    //    carousel_1_title: "Computer Science Teachers Association (CSTA)",
    //    carousel_1_text: "The **[https://csteachers.org/k12standards/]Computer Science Teachers Association K-12 Computer Science Standards** outline a core set of learning objectives that are designed to provide the foundation for a complete computer science curriculum and its implementation in K-12.[NEWLINE]CodeCombat is recognized by CSTA as an endorsed provider of curriculum and professional development. Learn the skills to effectively teach computer science with our self-directed, CSTA-accredited **[https://www.ozaria.com/professional-development]Professional Development** course. Earn up to 40 credit hours any time, from any device.[NEWLINE]Learn about the detailed CSTA Standards Alignment below:",
    //    carousel_1_button_1_text: "CSTA Alignment",
    //    carousel_1_button_2_text: "CodeCombat",
    //    carousel_2_title: "AP Computer Science Principles (AP CSP)",
    //    carousel_2_text: "CodeCombat is recognized by College Board as an endorsed provider of curriculum and professional development for AP® Computer Science Principles (AP CSP). This endorsement affirms that CodeCombat’s curriculum is aligned to all of the AP Curriculum Framework standards and the AP CSP assessment. This affords schools access to resources including an AP CSP syllabus pre-approved by the College Board’s Course Audit, and officially recognized professional development that prepares teachers to teach this curriculum.[NEWLINE]Learn more about our CodeCombat AP CSP curriculum below:",
    //    carousel_2_button_1_text: "CodeCombat AP CSP",
    //    carousel_3_title: "International Society for Technology in Education (ISTE)",
    //    carousel_3_text: "Focused on pedagogy, not tools, the **[https://iste.org/standards]ISTE Standards** are a framework that guides educators in using technology to create high-impact, sustainable, and scalable learning experiences for all students.[NEWLINE]CodeCombat’s curriculum is designed to meet the needs of all ISTE standards, for both students and teachers.[NEWLINE]Learn about the detailed ISTE Standards Alignment below:",
    //    carousel_3_button_1_text: "Ozaria",
    //    carousel_3_button_2_text: "CodeCombat",
    //    carousel_4_title: "Common Core State Standards",
    //    carousel_4_text: "The **[https://corestandards.org/]Common Core State Standards** are a set of uniform academic standards for K–12 Mathematics and English Language Arts.[NEWLINE]CodeCombat integrates a variety of cross-curricular connections to core subject areas throughout our curriculum. [NEWLINE]Learn about the detailed Common Core Standards Alignment below:",
    //    carousel_4_button_1_text: "Ozaria",
    //    carousel_4_button_2_text: "CodeCombat",
    //    carousel_5_title: "Next Generation Science Standards (NGSS)",
    //    carousel_5_text: "The **[https://www.nextgenscience.org/]Next Generation Science Standards (NGSS)** are K–12 science content standards, setting expectations for what students should know and be able to do. These standards were developed by states to improve science education for all students.[NEWLINE]CodeCombat is a perfect curriculum partner for introducing key science and engineering concepts from NGSS.[NEWLINE]Learn about the detailed NGSS Standards Alignment below:",
    //    carousel_5_button_1_text: "NGSS Alignment",
    //    carousel_5_button_2_text: "CodeCombat",
    //  },

    //  codequest_page: {
    //    join_us: "Join Us",
    //    start_application: "Start Application",
    //    codequest: "CodeQuest",
    //    date: "Date",
    //    date_time: "July 22 - July 27, 2024",
    //    supporting_text: "Join us for an immersive educational experience like no other, designed to inspire and empower the next generation of computer science innovators through coding and AI. Students aged 13-17 are welcome.",
    //    apply_now: "Apply Now",
    //    insight: "An insightful real-world learning experience!",
    //    testimonials_heading: "This rare opportunity brings together students from around the globe. Here’s the student experience at a glance.",
    //    engaging_hackathongs: "Engaging Hackathons",
    //    insightful_speakers: "Insightful Speakers",
    //    university_visits: "University Campus Visits",
    //    silicon_valley_experience: "Silicon Valley Experience",
    //    content_title: "The Student Experience",
    //    core_curriculum_heading_1: "Multiple ",
    //    core_curriculum_heading_2: "hackathon competitions",
    //    core_curriculum_heading_3: " designed to ",
    //    core_curriculum_heading_4: "inspire creativity",
    //    core_curriculum_heading_5: " in coding and ",
    //    core_curriculum_heading_6: "teach real world applications of AI",
    //    core_curriculum_title_1: "AI HackStack Project Challenge",
    //    core_curriculum_text_1: "The first generative AI companion tool specifically crafted for those new to AI, enables students to go from text-to-code-to-output instantaneously. <br /><br /> Competitors will be partnered with other students to develop a project using AI prompting and present for judging.",
    //    core_curriculum_title_2: "AI League CodeQuest Global Final",
    //    core_curriculum_text_2: "An epic competitive coding esports platform that encourages creative programming in a game-based environment. <br /><br /> Competitors will be partnered with other students to develop the optimal code to outwit the other teams, collect head-to-head wins and finish atop the leaderboard.",
    //    core_curriculum_heading_11: "Hackathons will be held at ",
    //    core_curriculum_heading_12: "renowned universities",
    //    core_curriculum_heading_13: "offering a unique experience for students to",
    //    core_curriculum_heading_14: "immerse",
    //    core_curriculum_heading_15: " themselves in the ",
    //    core_curriculum_heading_16: "collegiate setting",
    //    core_curriculum_text_11: "Globally acclaimed for its cutting-edge research and innovation, UC Berkeley provides comprehensive and rigorous computer science programs. These programs enhance creative problem-solving skills and encourage a deeper understanding of computational theory, equipping individuals to be transformative leaders in the rapidly evolving tech industry.",
    //    core_curriculum_text_12: "Recognized worldwide as a leader in technology and innovation, Stanford offers robust programs in computer science, fostering creative thinking and a deep understanding of theoretical foundation, preparing individuals to become pioneering leaders in computer science and technology.",
    //    core_curriculum_heading_21: "Our roster of speakers offer ",
    //    core_curriculum_heading_22: "unparalleled insight",
    //    core_curriculum_heading_23: "into what it takes to pursue success in computer science and will help judge the competitions.",
    //    core_curriculum_title_21: "UC Berkeley Featured Speaker",
    //    core_curriculum_text_21: "While immersed in the collegiate setting of this storied university, students will be welcomed by representatives from the Department of Electrical Engineering and Computer Sciences at UC Berkeley, who will provide a glimpse into the extensive research and cutting edge developments in computer science happening right here on campus. Students will gain insight into what it is like to be a part of these research programs and what career pathways can be realized.",
    //    core_curriculum_title_22: "Google X - The Moonshot Factory Featured Speaker",
    //    core_curriculum_text_22: "In 2010, Google founders Larry Page and Sergey Brin decided to form a new division of the company to work on moonshots: far-out, sci-fi sounding technologies that could one day make the world a radically better place. 10 years in, X has incubated hundreds of different moonshot projects, many of which have gone on to become independent businesses. Hear how this diverse group of inventors and entrepreneurs build and launch technologies that aim to improve the lives of millions, even billions, of people.",
    //    core_curriculum_title_23: "Nick Winter, CEO, CodeCombat",
    //    core_curriculum_text_23: "Nick is the founder and CEO of CodeCombat. A proven leader in the edtech industry, Nick blends his passion for education with his technological expertise to make learning programming more accessible and engaging for students across the globe. Prior to CodeCombat, he co-founded Skritter, a platform for learning Chinese and Japanese characters. With a strong commitment to revolutionize the education sector, Nick actively contributes to making coding a fundamental skill for the future generation. His dedication and vision continue to inspire and impact the realm of edtech.",
    //    core_curriculum_title_24: "Apple Tech Development Workshop",
    //    core_curriculum_text_24: "Hear first hand from a panel of venture capitalists and tech leaders as they detail the process for building a global tech platform and creating a successful business plan. This interactive presentation will pull back the curtain on what it's like to build the next great piece of tech and how to launch it.",
    //    core_curriculum_heading_31: "San Francisco and Silicon Valley offer students the unique opportunity to ",
    //    core_curriculum_heading_32: "experience life at a tech giant",
    //    core_curriculum_heading_33: " and ",
    //    core_curriculum_heading_34: "explore the sights of the city",
    //    core_curriculum_title_31: "Visit Google HQ & X- The Moonshot Factory",
    //    core_curriculum_text_31: "Located in Mountain View California, the Google campus offers a unique glimpse into the heart of Silicon Valley innovation. Students will encounter whimsical architecture, a multitude of collaborative workspaces, and tech-driven art installations that inspire creativity and provide a peek at what working in tech could be like. This exclusive tour will visit X - The Moonshot Factory to see how this innovative team inside of Google is creating radical new technologies to solve some of the world's hardest problems.",
    //    core_curriculum_title_32: "Apple Park HQ Visit & Workshop",
    //    core_curriculum_text_32: "Apple Park is the global headquarters for the innovative tech&nbsp;&nbsp;giant and a must visit attraction when in San Fransisco. Students will experience Steve Jobs’ “Garage Culture” that inspired Apple to become the largest company in the world, and join a workshop with venture capitalists and tech leaders, to hear first hand what it takes to build a global tech platform and create your own business plan.",
    //    core_curriculum_title_33: "San Francisco Tour",
    //    core_curriculum_text_33: "Students have the opportunity to immerse themselves in the diverse and dynamic charm of San Francisco. From the iconic Golden Gate Bridge and historic Alcatraz Island to the bustling piers and serene parks, there&#39;s adventure at every turn. A visit to San Francisco is a fascinating blend of natural beauty, urban sophistication, and rich cultural heritage, promising an unforgettable experience.",
    //    cta_supporting: "The specifics regarding the planned series of activities are subject to changes due. We commit to keeping you informed of such changes as much as possible, although they may occur without advance notice.",
    //    contact: "Contact Our Team",
    //    if_question: "If you have any questions",
    //    how_it_works: "How it Works",
    //    apply: "Apply",
    //    apply_time: "January-February",
    //    apply_steps_1: "Students interested in participating will fill out an application.",
    //    apply_steps_2: "A skills assessment or evaluation may be needed to confirm your ability to participate.",
    //    confirm: "Confirm",
    //    confirm_time: "March-April",
    //    confirm_steps_1: "If you are accepted, a program advisor will contact you to confirm the additional details.",
    //    confirm_steps_2: "An initial deposit will be required to hold your spot in the program.",
    //    confirm_steps_3: "Your travel will be coordinated and booked.",
    //    confirm_steps_4: "A liability waiver will be required for all participants.",
    //    travel: "Travel",
    //    travel_time: "July",
    //    travel_steps_1: "Prior to departure you will receive a comprehensive travel packet with all the information you will need to know.",
    //    travel_steps_2: "Preparations have been made to shuttle participants from the airport to the hotel and to and from the activities throughout the week. Transportation back to the airport for departure will also be arranged.",
    //    travel_steps_3: "The full package fee will be due prior to travel, minus the initial deposit fee.",
    //    frame_heading_1: "The paced schedule will fill the days with a mixture of ",
    //    frame_heading_2: "learning",
    //    frame_heading_3: " and ",
    //    frame_heading_4: "fun",
    //    all_participants: "All Participants",
    //    international_participants: "International Participants",
    //    schedule_day_title_1: "Monday",
    //    schedule_day_title_2: "Tuesday",
    //    schedule_day_title_3: "Wednesday",
    //    schedule_day_title_4: "Thursday",
    //    schedule_day_title_5: "Friday",
    //    schedule_day_title_6: "Saturday",
    //    schedule_event_title_1: "Travel Day",
    //    schedule_event_title_2: "San Francisco",
    //    schedule_event_title_3: "UC Berkeley",
    //    schedule_event_title_4: "Silicon Valley",
    //    schedule_event_title_5: "Stanford",
    //    schedule_event_sub_title_1: "Arrival",
    //    schedule_event_sub_title_2: "Tour",
    //    schedule_event_sub_title_3: "Hackathon",
    //    schedule_event_sub_title_4: "Tours & Speakers",
    //    schedule_event_sub_title_6: "Departure",
    //    frame_content_heading: "Included in most package options",
    //    frame_content_flight_title: "Airfare & Local Transportation",
    //    frame_content_flight_text: "Round-trip flights on major carriers and transportation to and from airport, hotel and event locations.",
    //    frame_content_hotel_title: "Hotel Accommodations",
    //    frame_content_hotel_text: "All hotels must meet our high standards for quality, safety, and cleanliness.",
    //    frame_content_meal_title: "Meals",
    //    frame_content_meal_text: "Minimum three meals per day, as well as snacks and water available throughout each activity filled day.",
    //    frame_cta_text: "Download Schedule",
    //    frame_cta_supporting: "All experience details are subject to change.",
    //    frame_core_heading_1: "This Opportunity is Open to ",
    //    frame_core_heading_2: "International",
    //    frame_core_heading_3: " and ",
    //    frame_core_heading_4: "Domestic",
    //    frame_core_heading_5: " Participants",
    //    frame_core_international_title_text: "International: ",
    //    frame_core_international_title_span: "FULL WEEK",
    //    frame_core_international_text: "The complete experience including all three hackathon days, multiple university campus experiences and two days of San Francisco and Silicon Valley immersion.",
    //    frame_core_international_price: "Pricing: $ 10,000",
    //    frame_core_international_price_text_1: "For our ",
    //    frame_core_international_price_text_2: "international participants",
    //    frame_core_international_price_text_3: "coming from outside the US",
    //    frame_core_international_price_text_4: "Includes air-travel and accommodations",
    //    frame_core_domestic_title_text: "Domestic (US): ",
    //    frame_core_domestic_title_span: "3 DAYS",
    //    frame_core_domestic_text: "Includes participation in all three hackathon days and features multiple university campus experiences.",
    //    frame_core_domestic_price: "Pricing: $3,750 (Early bird price: $2,950 if you book before 3/31)",
    //    frame_core_domestic_price_text_1: "For ",
    //    frame_core_domestic_price_text_2: "US-based participants",
    //    frame_core_domestic_price_text_3: "Includes air-travel and accommodations",
    //    frame_core_domestic_price_2: "Pricing: $2,175 (Early bird price: $1,675 if you book before 3/31)",
    //    frame_core_domestic_price_text_4: "local participants",
    //    frame_core_domestic_price_text_5: "Does not include travel or accommodations. Students will need to meet at each event site to participate",
    //    accessibility_title: "Health and Safety Precautions",
    //    accessibility_text_1: "Students will remain in secure facilities guided by our team of education advisors.",
    //    accessibility_text_2: "All chaperones and education advisors have completed background checks.",
    //    accessibility_text_3: "All facilities will be approved for safety, on-site quality control, and cleanliness.",
    //    accessibility_text_4: "At this time there are no travel restrictions due to Covid or another illness. If a travel restriction is reinstated or if our team deems there to be a concern for the health of the participants, the experience may be changed or cancelled.",
    //    faq: "Frequently Asked Questions",
    //    faq_q_1: "Is there an age requirement?",
    //    faq_a_1: "Participants must be aged 13-17 and be able to provide legal documentation to travel.",
    //    faq_q_2: "Can I travel with my child?",
    //    faq_a_2: "Some parents do choose to travel, however the activities, events, travel and accommodations are only provided for students.",
    //    faq_q_3: "How much experience do you need to participate?",
    //    faq_a_3: "A basic understanding of programming in any language is all that a student must know. Since we are grouping them into teams of varying experience levels we expect those with more experience to support those with less.",
    //    faq_q_4: "Should I bring my laptop?",
    //    faq_a_4: "We will supply all the hardware and software needed to participate in the hackathons. While we will allow participants to use their personal computers, our team may not be able to fully support or troubleshoot all issues, so we recommend using the equipment provided.",
    //    faq_q_5: "Do I need bring any identification supporting materials?",
    //    faq_a_5_1: "Domestic - if the participant is traveling alone, we ask their parent or legal guardian to complete an emergency contact form that includes identification information about their child.",
    //    faq_a_5_2: "Global - global students need to bring their passports (with VISA) with them.",
    //    faq_q_6: "What accommodations can my child expect?",
    //    faq_a_6: "All participants and chaperones will be staying at the same hotel, with separate accommodations for participants and chaperones. Participants will share a room with a fellow participant. Staff members are never allowed to be alone with participants. Parents who wish to accompany their child will share a room together.",
    //    faq_q_7: "What if my child is allergic to certain foods or has medical needs?",
    //    faq_a_7: "Any health concerns pertaining to your child should be identified in the emergency contact form.",
    //    faq_q_8: "Who will be chaperoning my child?",
    //    faq_a_8_1: "Our pledge is to put your children in the company of the most trustworthy and capable individuals we can hire–certified instructors and counselors who are well suited to the task of caring for participants. Each staff member undergoes an intense background and reference check; the effort we put into screening and selecting our staff is part of that pledge.",
    //    faq_a_8_2: "Our staff work with your children in the context of a visible, well scrutinized environment that has many built-in checks and balances. Instructors and counselors are guided by clear, firm policies regarding behavior. Their actions are visible to co-workers and participants.",
    //    faq_q_9: "What general safety measures do you have in place?",
    //    faq_a_9: "All staff go through emergency and crisis management training.",
    //    faq_q_10: "What is your refund policy?",
    //    faq_a_10: "Deposits to hold your space are refundable up until travel is booked for the participant. Once travel is booked we will not be able to provide a refund.",
    //    more_faq: "See more frequently asked questions in our ",
    //    help_center: "help center",
    //  },

    //  hackstack: {
    //    "Action_missing-renderer-for-action-type-actiont": "Missing renderer for action type \"__actionType__\"",
    //    ActionButton_create: "Create",
    //    ActionButton_learn: "Learn",
    //    "AddEndOfLessonMsgButton_end-lesson": "End Lesson",
    //    "AddTeacherMsgButton_add-teacher-message": "Add Teacher Message",
    //    "AlternatePromptChoicesForm_save-choices": "Save Choices",
    //    App_alt: "",
    //    App_loading: "Loading...",
    //    "ChatInputForm_enter-your-prompt-here": "enter your prompt here",
    //    "ChatLayout_tw-fixed-tw-inset-0-tw-z-30-tw-bg-black5": "tw-fixed tw-inset-0 tw-z-30 tw-bg-black/50 tw-transition-opacity tw-duration-300 tw-ease-in-out md:tw-hidden",
    //    "ChatMessage_are-you-sure-you-want-to-delete-this-mes": "Are you sure you want to Delete this Message?",
    //    ChatMessage_delete: "Delete",
    //    ChatMessage_edit: "Edit",
    //    "ChatMessage_update-a-messageactorteacherteacherendof": "Update a __messageActorTeacherTeacherEndOfLesson__ Lesson",
    //    CodeThumbnail_copy: "Copy",
    //    "CodeThumbnail_open-in-editor": "Open in editor",
    //    "CodeThumbnail_run-code": "Run Code",
    //    "CodeThumbnail_edit-code": "Edit Code",
    //    "ConfirmDeleteChatMessageButton_confirm-delete": "Confirm Delete",
    //    ContinueRenderer_continue: "Continue →",
    //    EditAlternatePromptChoicesPage_cancel: "Cancel",
    //    "EditAlternatePromptChoicesPage_save-choices": "Save Choices",
    //    "EditChatMessagePage_chat-message-settings": "Chat Message Settings",
    //    "Empty_select-or-create-a-project-to-get-starte": "Select or create a project to get started!",
    //    EndOfLessonRenderer_feedback: "Feedback",
    //    "EndOfLessonRenderer_start-a-new-project": "Start a New Project →",
    //    FullscreenModal_close: "Close",
    //    "GenericError_something-went-wrong": "Something went wrong",
    //    "HowItWorksPage_ah-now-thats-a-question-i-cant-answer-ju": "Ah, now that's a question I can't answer just yet. But if you want to have a say in it, you've got to experience what's possible, so... let's start creating. Are you ready?",
    //    "HowItWorksPage_ah-thats-the-best-part-you-dont-have-to-": "Ah! That's the best part. You don't have to. I take care of it all. Just chat with me, and I'll do the rest.",
    //    "HowItWorksPage_bet-so-what-if-i-wanna-create-a-sock-mat": "bet - so what if i wanna create a sock matching sim game",
    //    "HowItWorksPage_but-i-dont-even-know-how-to-use-them-all": "but i don't even know how to use them all",
    //    "HowItWorksPage_but-i-dont-have-accounts-for-those-and-i": "but i don't have accounts for those and I think chatgpt is blocked here",
    //    "HowItWorksPage_but-who-made-you": "but who made you?",
    //    "HowItWorksPage_codecombat-ai-hackstack-is-an-all-in-one": "CodeCombat AI HackStack is an all-in-one AI tool for creating games, art, songs, apps, and more by just chatting. It runs everything for you, hosts your projects, and helps with coding. CORE mode is free and teaches you through multiple-choice prompts. PRO+ mode is $9.99/mo for free-form prompts. Projects are secure and don't feed big tech data. It's made by the CodeCombat team to make AI accessible to everyone. Now, let's start creating.",
    //    "HowItWorksPage_core-mode-is-free-and-you-dont-even-need": "CORE mode is free and you don't even need an account to TRY IT! If you want to go wild with free-form prompts in PRO+ mode, it's $9.99/mo, but you can try a few of these for free every day.",
    //    "HowItWorksPage_did-they-use-ai-to-create-you": "did they use ai to create you?",
    //    "HowItWorksPage_hey-ai-so-how-do-i-use-this-thingy": "hey ai - so how do I use this thingy?",
    //    "HowItWorksPage_how-do-i-start": "how do i start?",
    //    "HowItWorksPage_i-dont-know-how-to-code-tho": "i don't know how to code tho",
    //    "HowItWorksPage_i-got-you-we-can-build-that-and-more": "I got you! We can build that and more.",
    //    "HowItWorksPage_i-used-ai": "I used AI.",
    //    "HowItWorksPage_is-it-free": "is it free??",
    //    "HowItWorksPage_just-chat": "just chat?",
    //    "HowItWorksPage_just-chat-and-lets-see-what-we-can-creat": "Just chat and let's see what we can create together.",
    //    "HowItWorksPage_just-chat-with-me-ill-show-you": "Just chat with me, I'll show you.",
    //    "HowItWorksPage_learn-anything-create-something-do-every": "Learn ANYTHING, create SOMETHING, do EVERYTHING with CodeCombat AI HackStack. AI empowerment for all!",
    //    "HowItWorksPage_lets-go": "LET'S GO!!!",
    //    HowItWorksPage_marketing: "Marketing",
    //    "HowItWorksPage_maybe-i-should-just-stick-to-directly-us": "maybe i should just stick to directly using chatgpt or use bing or bard",
    //    HowItWorksPage_more: "more?",
    //    "HowItWorksPage_most-things-if-the-ai-isnt-smart-enough-": "Most things. If the AI isn't smart enough for something yet, it will be soon! You'll be able to access all sorts of creative projects in our gallery. Here are a few I'm working on with other users now: - A choose your own adventure story generator that can mail you a physical book - An ecommerce store for custom Roblox clothing and accessories - A virtual pimple popper extreme game Yes some creators are taking the “infinite creativity” thing literally!",
    //    "HowItWorksPage_no-coding-experience-no-problem-just-tel": "No coding experience, no problem. Just tell me what you want and I will generate the code for you. Many projects don't even need code, but if you know even just a little, I can amplify your abilities to create something spectacular.",
    //    "HowItWorksPage_no-worries-my-friend-i-have-the-keys-to-": "No worries, my friend! I have the keys to the creative kingdom. You can access all the best AI tools with a single AI HackStack account.",
    //    "HowItWorksPage_not-with-ai-hackstack-i-access-all-the-l": "Not with AI HackStack. I access all the latest models, from GPT-4 to Stable Diffusion and everything in between.",
    //    "HowItWorksPage_of-course": "Of course.",
    //    "HowItWorksPage_oh-im-an-incredible-host-every-project-h": "Oh, I'm an incredible host! Every project has a URL you can share with the world. Build a website and start a business all with chat. Or download your project, sync to GitHub, or grab your code and venture offthe choice is yours.",
    //    "HowItWorksPage_ok-so-where-does-my-project-live": "ok -so where does my project live?",
    //    "HowItWorksPage_ok-well-can-i-really-make-anything": "ok well can i really make anything?",
    //    "HowItWorksPage_so-how-are-you-making-all-this": "so - how are you making all this?",
    //    "HowItWorksPage_so-if-ai-can-create-ai-what-happens-next": "so if ai can create ai what happens next?",
    //    "HowItWorksPage_the-codecombat-team-they-got-really-good": "The CodeCombat team. They got really good at making it easy to learn hard stuff by teaching 20 million beginners how to code with game-based learning, so when the tech got good enough, they wanted to do the same thing for AI. If AI is the future of creation, then we need to make it easy for anyone to use!",
    //    "HowItWorksPage_tldr-summarize-this-chat": "tl;dr. summarize this chat",
    //    "HowItWorksPage_well-start-you-off-easy-in-core-mode-wit": "We'll start you off easy in CORE mode with some super simple Q&A to prep you on how to make the best prompts. Then we string those prompts together to create your first project. Within a few minutes, you're ready for PRO+ mode, where the guardrails come off and anything is possible.",
    //    "HowItWorksPage_what-they-send-it-but-i-put-like-private": "what?!!! they send it… -but i put, like, private stuff in there! like that love-you-more rap battle for alex!",
    //    "HowItWorksPage_wow-dont-you-need-like-a-100-different-a": "WOW!!! - don't you need like a 100 different ai tools for that",
    //    "HowItWorksPage_yeah-thats-why-those-are-free-they-feed-": "Yeah, that's why those are free. They feed your data into their next AI so it can learn to make better love rap battles. But when you use me, they don't store it or train on it. So if you're in a school or you're under 18 with parental consent or under 13 in general, you technically can't use ChatGPT directly. With AI HackStack you're safe, secure, and good to go.",
    //    "HowItWorksPage_yep-im-here-to-accelerate-your-creative-": "Yep! I'm here to accelerate your creative potential, supercharge your dreams, provide rocket fuel for your imagination! Games, music, movies, apps, art, websites, code and anything else rattling around in that amazing head of yours are all possible right here.",
    //    "HowItWorksPage_you-could-but-i-answer-faster-dont-rate-": "You could BUT I… - answer faster - don't rate -limit you - give you more AI models - teach you how to use AI - automatically build and host projects for you - have a simpler yet more powerful UI - give built -in ethics guidance so you don't inadvertently rip off artists - let you view the source code and remix anyone's projects Oh, and I don't… SEND ALL YOUR CHATS TO OPENAI/MICROSOFT/GOOGLE TO TRAIN ON!!!!!",
    //    LeftSidebar_new: "+ New ",
    //    LeftSidebar_projects: "Projects",
    //    LeftSidebar_scenarios: "Scenarios",
    //    "LeftSidebarItem_untitled-isprojectprojectscenario": "Untitled __isProjectProjectScenario__",
    //    MessageBubble_ai: "AI",
    //    "MessageBubble_ais-response-was-cut-off-because-it-reac": "AI's response was cut off because it reached its length limit. Try asking a more specific question, or break it into smaller parts.",
    //    MessageBubble_teacher: "Teacher",
    //    MessageBubble_you: "You",
    //    NewProjectPage_: "▲",
    //    "NewProjectPage_codecombat-ai": "CodeCombat AI",
    //    NewProjectPage_filters: "Filters ▼",
    //    "NewProjectPage_learn-more": "Learn more",
    //    "NewProjectPage_new-ai-project": "New AI Project",
    //    "NewProjectPage_prompt-the-ai-to-create-websites-games-w": "Prompt the AI to create websites, games, web apps, stories, art, and more with the CodeCombat AI HackStack.",
    //    "NewScenarioPage_a-webpage": "a webpage",
    //    "NewScenarioPage_codecombat-ai": "CodeCombat AI",
    //    "NewScenarioPage_create-new-scenario": "Create new Scenario",
    //    NewScenarioPage_document: "Document",
    //    "NewScenarioPage_lets-go": "Let's Go!",
    //    NewScenarioPage_make: "make",
    //    NewScenarioPage_mode: "Mode",
    //    NewScenarioPage_task: "Task",
    //    NewScenarioPage_tool: "Tool",
    //    "NewScenarioPage_whats-this": "What's this?",
    //    "NotFound_not-found": "Not Found",
    //    ProjectTile_with: "with",
    //    "PromptQuizRenderer_choose-the-best-prompt": "Choose the best prompt:",
    //    PromptQuizRenderer_continue: "Continue →",
    //    "RenderedMessage_unknown-action-type-msgactiondatatype": "Unknown action type: __msgActionDataType__",
    //    ScenarioDetailsPanel_beta: "Beta",
    //    ScenarioDetailsPanel_draft: "Draft",
    //    ScenarioDetailsPanel_name: "Name",
    //    "ScenarioDetailsPanel_release-phase": "Release phase",
    //    ScenarioDetailsPanel_released: "Released",
    //    "ScenarioDetailsPanel_save-scenario": "Save Scenario",
    //    "ScenarioDetailsPanel_scenario-settings": "Scenario settings",
    //    "ScenarioDetailsPanel_allow-user-upload-file": "Allow user to upload file",
    //    "ScenarioPage_youre-in-scenario-creation-mode-go-ahead": "You're in scenario creation mode! Go ahead, mess around and try to build a cool scenario, then click \"beta\" or \"released\" to share it with the world! If you ever don't like a prompt, just go back and edit it.",
    //    "ScenarioPage_youre-in-scenario-creation-mode-non-admin": "Here's a free-form way to prompt an AI Model",
    //    "ScenarioPromptMessage_alternate-choices": "Alternate Choices",
    //    ScenarioPromptMessage_edit: "Edit",
    //    "ScenarioPromptMessage_prompt-choices": "Prompt Choices",
    //    TeacherMessageForm_create: "Create",
    //    "Topbar_back-to-chat": "← Back to Chat",
    //    UpdateChatMessageForm_update: "Update",
    //    "creditMessage_creditcreditsleft-creditinitialcredits-c": "__creditCreditsLeft__ / __creditInitialCredits__ credits left for __durAmount__ __creditDurationKey__",
    //    creditMessage_the: "the",
    //    "onDelete_are-you-sure-you-want-to-delete-this-isp": "Are you sure you want to delete this __isProjectProjectScenario__?",
    //    renderFilterCheckboxes_clear: "Clear",
    //    "renderFilterCheckboxes_create-your-own-project": "Create your own project",
    //    "renderFilterCheckboxes_creates-photorealistic-images-from-text": "Creates photorealistic images from text.",
    //    "renderFilterCheckboxes_learn-how-to-use-a-model": "Learn how to use a model",
    //    "renderFilterCheckboxes_learn-what-you-can-create-with-ai": "Learn what you can create with AI.",
    //    "renderFilterCheckboxes_quickly-and-easily-creates-images-from-t": "Quickly and easily creates images from text.",
    //    "renderFilterCheckboxes_use-models-to-create-your-own-ai-project": "Use models to create your own AI projects.",
    //    "renderFilterCheckboxes_writes-code-for-web-games-and-apps": "Writes code for web games and apps.",
    //    "renderFilterCheckboxes_writes-stories-and-summarizes-documents": "Writes stories and summarizes documents.",
    //    "renderFilterCheckboxes_key-write": "write",
    //    "renderFilterCheckboxes_key-code": "code",
    //    "renderFilterCheckboxes_key-simulate": "simulate",
    //    "renderFilterCheckboxes_key-study": "study",
    //    "renderFilterCheckboxes_key-draw": "draw",
    //    "renderFilterCheckboxes_key-graph": "graph",
    //    "renderFilterCheckboxes_key-learn": "learn",
    //    "renderFilterCheckboxes_key-advertise": "advertise",
    //    "renderFilterCheckboxes_key-model": "model",
    //    "renderFilterCheckboxes_key-solve": "solve",
    //    choices: "Choices",
    //    "could-not-find-project-with-id-projectid": "Could not find project with id __projectId__",
    //    generated: "generated",
    //    "missing-action-data-for-project-projecti": "Missing action data for project __projectId__",
    //    "overwriting-existing-dev-command-callbac": "Overwriting existing dev command callback for key: __key__",
    //    prompt: "Prompt",
    //    "teacher-response": "Teacher Response",
    //    "unhandled-payload-exhaustivecheck": "Unhandled payload: __exhaustiveCheck__",
    //    modes: "Modes",
    //    tools: "Tools",
    //    tasks: "Tasks",
    //    documents: "Documents",
    //    "stable-diffusion-description": "Creates photorealistic images from text.",
    //    "dall-e-3-description": "Quickly and easily creates images from text.",
    //    "gpt-4-description": "Writes code for web games and apps.",
    //    "claude-description": "Writes stories and summarizes documents.",
    //    locked: "LOCKED",
    //    view: "View",
    //    continue: "Continue",
    //    no_assigned_projects: "Your teacher has not assigned any AI projects yet.",
    //    continue_here: "Continue",
    //    start_new: "Start from scratch",
    //    choice_prompt_1: "What would you like to do next?",
    //    choice_prompt_2: "You can continue with your project or start a new one from scratch!",
    //    create_from_scratch: "Create from scratch",
    //    complete_to_unlock: "Complete a __model__ learn mode project to unlock",
    //    actionbutton_finished: "Learned",
    //    my_class: "My Class",
    //    my_creations: "My Creations",
    //    my_trainings: "My Trainings",
    //    my_courses: "My Courses",
    //    what_do_you_want_to_do_today: "What do you want to do today?",
    //    learn_ai: "Learn AI",
    //    create_ai: "Create AI",
    //    learn_with_ai: "Learn With AI",
    //    create_with_ai: "Create With AI",
    //    name_conflict: "Name Conflict, please choose a different name",
    //    edit: "Edit",
    //    delete: "Delete",
    //    duplicate: "Duplicate",
    //    use_as_a_template: "Use as a Template",
    //    get_inspired: "Get Inspired",
    //    remixed_from: "Remixed from",
    //    hackstack_credits: "AI HackStack Credits",
    //    model: "Model",
    //    play_as_a_student: "Play as a Student",
    //    student_view: "Student View",
    //    tags: "Tags",
    //    see_all: "See All",
    //    created_by: "created by",
    //    remix: "Remix",
    //    copy: "copy",
    //    copied: "copied!",
    //    copied_error: "error copying!",
    //    NewScenarioPage_name: "Display Name",
    //    learning_modules: "Learning Modules",
    //    level_complete: "You did it! Level complete. Continue your AI journey with the next level.",
    //    run_code_tour_title: "Ready to see the magic?",
    //    run_code_tour_text: "Press “Output” and watch your project come to life. No experience required!",
    //    hint_course_map_welcome: "Explore courses across the AI Galaxy.",
    //    hint_intro_to_ai: "Start with Intro to AI.",
    //    hint_click_to_continue: "Click anywhere to continue",
    //    hint_click_target: "Click the item to continue",
    //    hint_start_this_level: "Start this level.",
    //    hint_level_learn: "Learn how to chat with HackStack.",
    //    hint_level_practice: "Use Practice levels to change existing projects.",
    //    hint_level_create: "Build projects from scratch with Create levels.",
    //    hint_instructor_message: "Your instructor gives guidance.",
    //    hint_ai_message: "Here is HackStack's response.",
    //    hint_output: "Open Output to see and test results.",
    //    hint_choice: "Choose a response to continue.",
    //    hint_prompt_input: "Tell HackStack what to do.",
    //    ready_to_review_helptext: "Mark this when your project is complete. Your teacher will then see it as ready to review on their side.",
    //    ready_to_review_confirm_text: "Ready to Submit? Click OK to notify your teacher to review your project.",
    //    no_course_instances: "You do not have any course instances. Please contact your teacher to get access to the AI Hackstack.",
    //    restart_scenario_confirm: "Your progress will be lost. Are you sure you want to restart?",
    //  },

    //  galaxy: {
    //    title: "Welcome to HackStack Galaxy",
    //    description: "Explore new worlds and use AI to help you in your journey. ",
    //    premium_only: "Premium only",
    //    not_enrolled: "Not Enrolled",
    //    need_sign_up: "Sign up to access",
    //    locked_by_teacher: "Locked by teacher",
    //  },

    //  new_premium: {
    //    mastering_code: "Master coding and AI with **premium home access**",
    //    unlock_passion: "Unlock unlimited access to hundreds of coding adventures and generative AI projects. Build real skills, tackle engaging challenges, and explore at your own pace from home.",
    //    boxes_title: "Premium access to all games & projects, with a single subscription",
    //    junior_title: "CodeCombat Junior",
    //    junior_text: "Our flagship K-5 curriculum features a progression of learning levels that teach basic coding concepts at a slower pace.",
    //    codecombat_worlds_text: "Developed in partnership with Roblox Education, this experience accelerates your coding abilities to create amazing Roblox games and experiences.",
    //    junior_text_short: "Our K-5 curriculum teaches coding concepts from icon blocks to text at a slower pace.",
    //    codecombat_text_short: "A game-based coding adventure that features web development, game development, and more.",
    //    ai_league_text_short: "A competitive coding esports platform that encourages creative programming.",
    //    codecombat_worlds_text_short: "Developed with Roblox Education, learn coding and game development on Roblox.",
    //    ai_hackstack_text_short: "Learn anything, create something, do everything with the first generative AI tool crafted for those new to AI.",
    //    subscription_includes_title: "Your subscription includes",
    //    subscription_includes_1: "Access to all learning adventures",
    //    subscription_includes_2: "AI project creation credits",
    //    subscription_includes_3: "More gems, heroes, and items",
    //    subscription_includes_4: "Game, website, and app creation",
    //    subscription_includes_5: "Premium support",
    //    testimonials_2_name: "Amanda S.",
    //    features_1: "Full Access to All[NEWLINE]Learning Adventures",
    //    features_2: "Master AI with[NEWLINE]AI HackStack",
    //    features_3: "Unlock More Gems,[NEWLINE]Heroes & Items",
    //    features_4: "Create Games,[NEWLINE]Websites & Apps",
    //    features_5: "Premium Support[NEWLINE]& AI-Powered Help",
    //    every_learner_different_learning_style: "**Every learner has a unique pace and passion for technology. Our engaging game-based learning programs provide the perfect environment to explore coding and AI, keeping you motivated and excited to learn—even as concepts become more advanced**",
    //    adapt_interests: "We adapt to your interests",
    //    carousel_items_1_title: "Coding[NEWLINE]Fundamentals",
    //    carousel_items_1_text: "For learners with little to no coding experience, most sessions will start in CodeCombat Junior to build foundational skills before progressing to CodeCombat for deeper programming knowledge. AI HackStack will accelerate learning and showcase real-world applications of coding and AI. CodeCombat Worlds and AI League provide additional opportunities for practice, creativity, and fun.",
    //    carousel_items_2_text: "If you love games and want to create them, our game development-focused curriculum is the perfect fit. You'll start building interactive projects with CodeCombat, then bring your ideas to life in CodeCombat Worlds, where you can design and publish real games on the Roblox platform. AI League offers a competitive edge by deepening your understanding of game dynamics, while AI HackStack helps refine and enhance your creations through iterative development.",
    //    carousel_items_3_text: "Web development is constantly evolving, and staying ahead of the curve is essential. In this curriculum, foundational web development activities will be conducted in CodeCombat, while CodeCombat Junior provides an accessible starting point for younger learners. AI HackStack will serve as the primary platform for building and publishing projects, with limited use of CodeCombat Worlds and AI League to reinforce key coding concepts in an engaging way.",
    //    carousel_items_4_text: "Esports enthusiasts will love the competitive spirit of this learning experience. Starting with CodeCombat Junior and CodeCombat, learners will build a strong coding foundation before taking on the challenge of our AI League global esports tournaments, where scholarships and prizes are up for grabs year-round. With a focus on creative coding and iteration, they’ll also harness the power of AI HackStack to level up their skills and gain a competitive edge.",
    //    carousel_items_5_title: "AI Literacy",
    //    carousel_items_5_text: "AI is shaping the future, and those who can harness its power will unlock endless opportunities. This learning experience starts with CodeCombat Junior and CodeCombat. It expands into AI HackStack, where learners will master the art of crafting effective AI prompts and using the latest generative AI tools in a safe and secure environment. ",
    //    cs_benefits: "Computer science education offers immediate benefits, such as improving **problem-solving skills, sharpening mathematical abilities,** and strengthening **logical thinking—skills** that support success across many subjects. But the learning goes beyond just coding. It helps learners tackle complex challenges, adapt to new situations, and develop a growth mindset that lasts a lifetime.",
    //    our_solutions: "Our solutions are designed to equip you with essential computer science skills today, preparing you for the **digital careers of tomorrow.**",
    //    learning_code_challenging: "Learning to code can be challenging, but you don’t have to do it alone. Our innovative AI hints feature provides real-time guidance to help you keep progressing. It can evaluate your code, highlight errors, and explain how to fix them, all while ensuring you understand the reasoning behind each solution—without simply giving away the answer. Since AI hints only assist with your current coding challenge, you'll still need to think critically and solve each level on your own. Premium subscribers receive 10 AI hints per day, giving you the support you need to keep learning with confidence.",
    //    new_to_ai: "For those new to AI, we offer **[/ai]AI HackStack**, an innovative tool that teaches learners how to use AI safely and responsibly. With secure access to cutting-edge AI models like ChatGPT-4, Claude, Stable Diffusion, DALL·E, and more, users can create and experiment with AI- powered projects. In just a short time, they’ll unlock the full creative potential of AI, turning prompts into code, games, art, websites, and more—all in minutes. Every Premium subscriber receives 50 prompts per month, providing plenty of opportunities to explore and build with AI.",
    //    premium_page_title: "CodeCombat Premium",
    //  },

    //  parents_v2: {
    //    testimonials_1_quote: "I can't even begin to explain the profound changes that have occurred in Luka academically since he's been working with you.",
    //    testimonials_1_name: "Marina G.",
    //    testimonials_1_title: "proud parent",
    //    testimonials_2_quote: "One thing I am able to do now that I could not do before is actually believe I can code.",
    //    testimonials_2_name: "Student",
    //    testimonials_2_title: "Mountain Ridge Middle School",
    //    testimonials_3_quote: "Even though the class starts every Saturday at 7am, my son is so excited that he wakes up before me! CodeCombat creates a pathway for my son to advance his coding skills.",
    //    testimonials_3_name: "Latthaphon Pohpon",
    //    testimonials_3_title: "Parent",
    //    comprehensive_package_item_0_text: "One-Hour[NEWLINE]Private 1:1[NEWLINE]Sessions",
    //    comprehensive_package_item_1_text: "24/7 Access to[NEWLINE]Play and Learn",
    //    comprehensive_package_item_2_text: "Same-Day[NEWLINE]Support",
    //    comprehensive_package_item_3_text: "Progress[NEWLINE]Updates",
    //    comprehensive_package_item_4_text: "Class[NEWLINE]Recordings",
    //    comprehensive_package_item_5_text: "Student[NEWLINE]Certification",
    //    comprehensive_package_item_6_text: "30-Day[NEWLINE]Money-Back[NEWLINE]Guarantee",
    //    grid_most_popular: "Most Popular",
    //    grid_best_value: "Best Value",
    //    grid_self_paced: "**[/premium]Self Paced**",
    //    grid_1_sessions_weekly: "**[/payments/initial-online-classes-71]1 Session Weekly**",
    //    grid_2_sessions_weekly: "**[/payments/initial-online-classes-71]2 Sessions Weekly**",
    //    grid_features: "Features",
    //    grid_99_annual: "$99 Annual",
    //    grid_219_monthly: "$219 Monthly",
    //    grid_399_monthly: "$399 Monthly",
    //    grid_self_paced_year_price: "$__price__ Annual",
    //    grid_self_paced_year_price_without_currency: "__price__ Annual",
    //    grid_personalized_instruction: "1:1 Personalized Instruction",
    //    grid_premium_access: "Premium Access",
    //    grid_codecombat: "CodeCombat",
    //    grid_ozaria: "Ozaria",
    //    grid_ai_league: "AI League",
    //    grid_codecombat_worlds: "CodeCombat Worlds",
    //    grid_ai_hackstack: "AI HackStack",
    //    grid_parent_dashboard: "Personalized Parent Dashboard",
    //    grid_lesson_slides: "Contextual Lesson Slides",
    //    grid_connections_applications: "Real-world Connections & Applications",
    //    grid_monthly_reports: "Monthly Progress Reports",
    //    grid_completion_certificates: "Course Completion Certificates",
    //    grid_apcsp_option: "AP CSP Preparation Option",
    //    grid_class_recording: "Class Recording Option*",
    //    grid_money_back: "30-Day Money-Back Guarantee**",
    //    grid_ai_hints_allowance: "CodeCombat AI Hints Allowance (Daily)***",
    //    grid_prompts_allowance: "CodeCombat AI HackStack Prompts Allowance (Monthly)***",
    //    step_boxes_header_text: "The engaging, project-based curriculum focuses on teaching **real-world text-based coding languages**. While our hands-on approach ensures that students spend a majority of their class time coding, having fun, and experiencing real-time feedback, thus preventing feelings of frustration or stagnation.",
    //    step_box_1_title: "Live Instructions",
    //    step_box_1_subtitle: "Engage",
    //    step_box_1_footer_text: "What kind of loops exist in the real world?",
    //    step_box_2_title: "Live Instructions",
    //    step_box_2_subtitle: "Explore",
    //    step_box_2_footer_text: "Loops are a way to repeat a sequence of code.",
    //    step_box_3_title: "Game Time",
    //    step_box_3_subtitle: "Evaluate",
    //    step_box_3_footer_text: "Build a game using loops.",
    //    step_box_4_title: "Game Time",
    //    step_box_4_subtitle: "Extend",
    //    step_box_4_footer_text: "Use loops to collect the lightstones.",
    //    step_boxes_footer_text: "Trusted by over **320,000 educators** worldwide, our scaffolded curriculum is critical to helping students persevere. Our students type real code from the start, become more confident with each class, and learn how Computer Science is relevant to their daily lives.",
    //    play_code_create: "Play, code and create with the most engaging **live online coding classes**",
    //    unlock_passion: "Unlock your child’s passion for computer science and potential for success with our flexible curriculum and personalized instruction.",
    //    schedule_free_class: "Schedule a Free Class",
    //    enroll_now: "Or, **[https://codecombat.com/payments/initial-online-classes-71]enroll now**",
    //    create_parent_account: "Create Parent Account",
    //    to_explore: "To explore",
    //    testimonials_1_full_review_text: "Testimonial 1 Full Review Text",
    //    adapt_interests: "We adapt to your child’s interests",
    //    comprehensive_packages: "Our comprehensive packages include",
    //    classes_recorded: "Classes are recorded by default for quality and training purposes. We store class recordings for 3-5 business days. We will not record classes if requested.",
    //    subscriptions_billed: "All subscriptions are billed in advance and may be paused, canceled, or resumed with no additional fees. Live Online Classes subscriptions are 100% risk-free within the first 30 days. If for any reason you decide not to continue, simply **contact us** within 30 days of purchase and we will refund 100% of your payment. All plans are automatically renewed at the same level and billing cycle unless otherwise changed or canceled. We do not offer refunds after the first 30 days. Cancellation after the first 30 days will take effect at the start of the next billing cycle.",
    //    ai_hints: "AI hints and prompt allowances are subject to change",
    //    prefix_or: "Or, ",
    //    signup_description: "Sign Up for Self-Paced Access",
    //    homeschool_solution: "Looking for a homeschool solution",
    //    teach_child: "If you plan to teach your child, we can provide a turnkey solution that empowers you to deliver our curriculum in your own home. We provide all the teaching resources needed for you and your child to succeed including course solution guides. Contact our team to learn more - email **[mailto:classes@codecombat.com]classes@codecombat.com** to connect with a learning advisor.",
    //    meet_instructors: "**Meet our Instructors**",
    //    why_cs_important: "Why computer science is important",
    //    cs_benefits: "Computer science education provides the immediate benefits of boosting **problem-solving competencies, sharpening mathematical abilities**, and encourages the **logical thinking** necessary for success across many other core school subjects. The learning extends far beyond the code, enhancing students' capability to solve complex problems, adapt to different situations and foster a growth mindset. See how Ozaria helps make those **cross curricular connections.**",
    //    curriculum_design: "Our curriculum is designed to equip your child today with the crucial computer science skills that will prepare them for the **digital jobs of tomorrow.**",
    //    concepts_covered: "Concepts covered",
    //    beginner_level: "Beginner",
    //    beginner_title: "For students with little to no text-based coding experience",
    //    intermediate_level: "Intermediate",
    //    intermediate_title: "For students with some text-based coding experience",
    //    advanced_level: "Advanced",
    //    advanced_title: "For students with substantial experience in  text-based coding and a good grasp of complex concepts",
    //    cs_careers: "For those interested in pursuing careers in coding and computer science, no worries; AI is not going to replace you. In fact, according to the **[https://www.mckinsey.com/mgi/our-research/generative-ai-and-the-future-of-work-in-america]McKinsey Global Institute Report [Generative AI and the future of work in America]**, by 2030, STEM jobs will see the second highest labor demand growth at +23%, just behind healthcare. STEM professionals will be well positioned to understand and adopt the latest AI technologies as they continue to evolve, making those with computer science knowledge even more effective and valuable.",
    //    why_game_based: "Why game-based learning works",
    //    game_based_effective: "Game-based learning is so effective because it provides a safe environment where failure is not feared but seen as an expected opportunity for growth and understanding. This approach encourages players to learn from their mistakes and adapt their strategies for success. Furthermore, the interactive and dynamic nature of games helps young learners retain information more effectively, as they are learning through practical, hands-on experiences. It actively engages them in the learning process, increasing their motivation and enjoyment.",
    //    how_integrate_ai: "How we integrate AI safely and responsibly",
    //    see_how: "See how our instructors blend core curriculum concept review, real-world application, in-game practice and creative coding exercises into a fun and personalized experience.",
    //    ai_technology_description: "Our AI technology adheres to **safety-first principles**, providing confidence to both learners and instructors. We do not allow our backend LLM providers to train on your chats and have established **protective measures against inappropriate content**. These measures include filtering harmful language, maintaining focus on relevant subjects, safeguarding personal information, and educating learners about potential AI pitfalls. Moreover, we log AI chat activity for instructor monitoring and uphold **stringent data privacy and security protocols**.",
    //    instructors_offer_guidance: "Our instructors offer the guidance and support your child needs, but can’t always be there. That’s where our innovative AI hints feature helps the learning continue between sessions. This support feature can evaluate code, point out errors, and explain how to fix them. Most importantly, it provides all the context needed to understand the why, without providing the entire solution. With only current code problem assistance available students will still need to work through each level's coding challenge. Subscribers receive an allocation of 20 AI hints per day to ensure they always have the support they need.",
    //    new_to_ai: "For those new to AI, we offer **[/ai]CodeCombat AI HackStack**. Our instructors use this innovative tool to teach your child how to use AI safely and responsibly. The application provides secure access to many of the latest LLMs including ChatGPT-4, Claude, Stable Diffusion, DALL-E and others. After just a short time working with our instructors, your child will unlock the full creative potential of the tool, allowing prompt-to-code-to-published projects in minutes. This AI-powered application enables users to generate games, art, websites code and more. Every live online classes subscriber receives 200 prompts per month to create multiple AI projects.",
    //    ap_csp_preparation: "AP CSP Preperation",
    //    ap_csp_description: "Did you know that you don’t need to be enrolled in an AP CSP class to take the AP CSP exam? If your child plans to pursue a career in computer science taking the AP Computer Science Principles exam can be a promising first step, and we can help. Passing the exam serves as a recognized avenue to postsecondary credit, enabling learners to bypass costly and time-consuming college requirements. Our course, endorsed by the College Board affirms that our curriculum is aligned to all the AP Curriculum Framework standards and the AP CSP assessment.",
    //    get_prepared_for_ap_csp_exam: "**[/apcsp]Get prepared for the AP CSP exam**",
    //    schedule_a_free_class: "Schedule a Free Class",
    //    boxes_title: "Personalized instruction and premium access with a single subscription",
    //    ozaria_title: "Ozaria",
    //    ozaria_text: "An enchanting narrative coding adventure that establishes the fundamentals of computer science.",
    //    personalized_instruction: "An enchanting narrative coding adventure that establishes the fundamentals of computer science.",
    //    codecombat_title: "CodeCombat",
    //    codecombat_text: "A game-based computer science curriculum that features web development, game development and prep for the AP CSP exam.",
    //    ai_league_sports_title: "AI League Sports",
    //    ai_league_sports_text: "An epic competitive coding esports platform that encourages creative programming in a game-based environment.",
    //    codecombat_worlds_title: "CodeCombat Worlds",
    //    codecombat_worlds_text: "Developed in partnership with Roblox Education,this experience accelerates your child’s coding abilities to create amazing Roblox games and experiences.",
    //    ai_hackstack_title: "AI HackStack",
    //    ai_hackstack_text: "Learn anything, create something, do everything with the first generative AI companion tool specifically crafted for those new to AI. It’s AI empowerment for all!",
    //    every_child_different_learning_style: "**Every child has a different learning style and academic interests. We’ve developed a suite of effective game-based learning programs to ensure your child stays engaged and excited to keep learning even when topics become complex or challenging.**",
    //    carousel_items_1_title: "Coding[NEWLINE]Fundamental",
    //    carousel_items_1_title_prefix: "**Focus:**",
    //    carousel_items_1_text: "For students with little to no coding experience, most class sessions will be in Ozaria to build foundational skills and then in CodeCombat to deepen programming knowledge. AI HackStack will be used to help accelerate your child’s coding abilities and showcase real-world applications of their new-found skills. CodeCombat Worlds and AI League will offer occasional practice and creative play opportunities.",
    //    carousel_items_2_title: "Game[NEWLINE]Development",
    //    carousel_items_2_title_prefix: "**Focus:**",
    //    carousel_items_2_text: "If your child loves games and wants to make them, then our game development focused curriculum will feature CodeCombat at the core for the initial game development activities and projects. In no time your child will be working in CodeCombat Worlds building and publishing real games to the Roblox platform. Competing in our AI League provides additional insight into successful game dynamics and development, while AI HackStack will be a powerful tool for iterative game development.",
    //    carousel_items_3_title: "Web[NEWLINE]Development",
    //    carousel_items_3_title_prefix: "**Focus:**",
    //    carousel_items_3_text: "Developing for the web is ever evolving and it’s important to stay ahead of the curve. In this curriculum focus the initial web development activities will be conducted in CodeCombat, while Ozaria will be used for those new to coding. AI HackStack will be heavily implemented as the platform to build an publish to the web, with limited use of CodeCombat Worlds and AI League to help reinforce key coding concepts.",
    //    carousel_items_4_title: "Competitive[NEWLINE]Coding Esports",
    //    carousel_items_4_title_prefix: "**Focus:**",
    //    carousel_items_4_text: "Esports enthusiasts will love the competitive spirit of this curriculum focus. With a foundation built from CodeCombat, your child will be competing in our AI League global esports tournaments year-round with scholarships and prizes on the line. With an emphasis on creative coding and iteration your child will learn how to use our AI HackStack tool to supercharge their abilities in competition.",
    //    carousel_items_5_title: "AI[NEWLINE]Applications",
    //    carousel_items_5_title_prefix: "**Focus:**",
    //    carousel_items_5_text: "AI is everywhere and those that can harness its power will be able to maximise their potential. This curriculum focus builds from CodeCombat but it’s AI HackStack that will help teach the art of drafting the strongest AI prompts and how to use all the latest generative AI tools in a safe and secure environment. The generative AI feature built into CodeCombat Worlds will offer yet another real world opportunity to see what your child can do with AI.",
    //    carousel_items_6_title: "AP CSP[NEWLINE]Preparations",
    //    carousel_items_6_title_prefix: "**Focus:**",
    //    carousel_items_6_text: "If your child plans to pursue a career in computer science taking the AP Computer Science Principles exam can be a promising first step. Passing the exam serves as a recognized avenue to postsecondary credit, enabling learners to bypass costly and time-consuming college requirements. Our course, endorsed by the College Board affirms that our curriculum is aligned to all the AP Curriculum Framework standards and the AP CSP assessment. You do not need to be enrolled in a high school AP class to take the exam and we can support you in finding an in-person exam location.",
    //    instructors_1_text: "Brian is a passionate coding teacher with 13 years in the classroom teaching mathematics and computer science. He has experience with Java, Python, Javascript, HTML, and CSS. With a bachelor’s in Mathematics Education and a Masters's in Educational Theory he loves sharing his passion for math and computer science with others. He believes that by teaching computer science we are preparing our youth to be the next generation of exceptional problem solvers.",
    //    instructors_2_text: "Shreeaa has a passion for helping others discover the joy of coding. Having previously found success with a career in software development, she brings real-world knowledge to her classes. Her teaching style is hands-on and practical, with a focus on helping one gain the skills they need to create real-world projects while having lots of fun. Whether you're new to coding or looking to expand your knowledge, she’s here to support you on your journey.",
    //    instructors_3_text: "Tai is currently studying both Criminal Justice and Cyber Security. He has a passion for justice and technology, and hopes to use his skills to make the world a safer place. In addition to his studies, Tai worked at the YMCA for over five years, where he gained valuable experience in child care. He is dedicated to fostering a safe and supportive environment for all, whether it's working with children or in the tech industry.",
    //    instructors_4_text: "Carson has been teaching coding for two years, with professional experience in many programming languages, including Python, Javascript and HTML. Carson's teaching approach focuses on relating the concepts to things the student is passionate about or interested in. He prefers to let the student explore and find their own path, while guiding them through learning in the way that suits their style and personality.",
    //    instructors_5_text: "Dania is a Computer Engineering graduate with a passion for teaching and spreading knowledge. Dania has over six years of experience teaching different programming languages and computer literacy. She believes in the importance of learning coding at a young age to ensure them an edge in today's fast-moving digital world where coding is the global language.",
    //    instructors_6_text: "Riley’s journey began when he taught himself Python while pursuing his first Bachelor's degree. His passion for education led him to become a high school Social Studies teacher, where he continued to enhance his coding skills on the side. After three years of teaching, he decided to return to school to earn another Bachelor's degree in Computer Science. His enthusiasm for education remains as strong as ever, and now he is genuinely excited to be teaching something he loves. He fosters meaningful interactions with his students, igniting their genuine interest in the subject matter rather than relying solely on strict memorization.",
    //    instructors_7_text: "Ishraq is a passionate coding teacher with experience in full-stack web development. She started coding in middle school and believes that coding at a young age is vital. Having started coding at a young age she understands how important it is for them to enjoy the process of learning and goes the extra mile to ensure her students love every class.",
    //    instructors_8_text: "This is Edi, short for Edwin. He lives in Bali, Indonesia and has been running a programming school for the past two years. In his former career he was an IT professional who traveled across the globe implementing project structure. His passions are teaching and sharing knowledge and loves the chance to teach children and introduce them to the wonderful world of programming. Sampai Jumpa lagi (Indonesian for see you soon)!",
    //    instructors_9_text: "Meet Kislay, a mom, engineering graduate, coding instructor, and math enthusiast with three years of edtech teaching experience. She is passionate about teaching coding and math to others, and has helped hundreds of students from diverse backgrounds with their math concepts and coding languages such as Python, JavaScript, HTML/CSS, and Node.js. Her teaching style emphasizes practical, real-world applications, and her goal is to help her students build the skills and confidence they need to succeed in the tech industry.",
    //    instructors_10_text: "Nadeem was first inspired to take up coding while studying Java in community college. After transferring to the University of California, Berkeley and picking up Python, his passion and excitement for coding grew. As a current PhD student in computational mathematics, coding now sits at the heart of what he works on everyday. Coming from a large family, Nadeem has always enjoyed being around kids, and relishes the opportunity to mentor young students.",
    //    instructors_11_text: "Bhavika has a Masters Degree in Information Systems and  extensive experience in tech. She started her career in Web Development and has explored other areas of IT, such as Middleware Administration and QA Testing. She has experience in several programming languages including Python, Django, AngularJS, Lua Coding, HTML and CSS. She believes no one is ever too young to start learning these vital skills.",
    //    instructors_12_text: "Sergio has been a Technology/Computer Science teacher for seven years, working in international schools in both South America and South Korea. He is originally from Venezuela and is currently living in Colombia. With a degree in Computer Science Education, he teaches Python, HTML, CSS, JavaScript, and Swift, amongst others non-coding subjects. He has also earned several certificates in programming languages and is currently working on a Data Science certification. He believes that learning how to code can help anyone solve problems in the real world. And yes, he can teach in spanish.",
    //    instructors_13_text: "Bella currently studies Computer Science at UC Berkeley and is passionate about sharing the excitement of the technological world with others. From robotics to web development, Bella has been teaching computer programming for over five years and fosters an inclusive and supportive learning environment so that students can prosper and take control of their coding journey.",
    //    faq_1_question: "What should I expect in the trial class?",
    //    faq_1_answer: "Each trial class is a private 60 minute session with **45 minutes of instruction** for the student followed by **15 minutes for discussion with a parent or guardian**. These 15 minutes are important and are set aside to answer any questions, provide insight into how the ongoing curriculum progresses, and help you select the right skill level and coding language for your child.",
    //    faq_2_question: "How are instructors matched with my child?",
    //    faq_2_answer: "After the initial trial class, our team carefully matches our online instructors to each student based on their experience level, personality, interests, and schedule. Our team will work with you to improve your experience if you or your child doesn’t love learning with your instructor.",
    //    faq_3_question: "Are there any student age limits?",
    //    faq_3_answer: "We offer a variety of approaches to ensure younger and older students alike can get the most out of our curriculum and instruction. We mostly serve elementary to high school aged students. However, if your child can type, use a mouse, and is comfortable using a computer, they are welcome to join our class.",
    //    faq_4_question: "What kind of technology do I need to join the class?",
    //    faq_4_answer: "Your student will need a reliable internet connection and a laptop or desktop computer. We do not recommend tablets, as students will need the ability to screen share their browser.",
    //    faq_5_question: "What is the cancellation policy?",
    //    faq_5_answer: "Your subscription purchase is 100% risk-free within the first 30 days. If for any reason you decide not to continue, simply contact us at **[mailto:classes@codecombat.com]classes@codecombat.com** within 30 days of purchase and we will promptly refund 100% of your purchase, no questions asked.",
    //    faq_6_question: "What if I need to reschedule a class?",
    //    faq_6_answer: "Once you have booked a weekly class with us, we have reserved time in our schedule exclusively for you, so we require 48 hours' advance notice for rescheduling classes. You can reschedule your class by emailing **[mailto:classes@codecombat.com]classes@codecombat.com**. Classes missed or canceled with less than 48 hours' notice will not be rescheduled or refunded.",
    //    faq_7_question: "What if we have vacation planned?",
    //    faq_7_answer: "We offer the option to pause your classes for up to two weeks. If an extended break is needed, we will suspend your subscription for the duration of your break and will connect with you upon your return to reinstate classes. Please note that we may need to find a new time if your student’s instructor is no longer available at your previous time.",
    //    faq_8_question: "Do you provide group classes?",
    //    faq_8_answer: "We do not arrange or assign group classes, but if you have a group of students looking to work together, we are happy to facilitate a group class for them.",
    //    faq_9_question: "Do you offer any discounts?",
    //    faq_9_answer: "We offer discounts for siblings and group classes. We do not arrange or assign group classes, but if you have a group of students looking to work together, we will facilitate a group class for them. Please reach out to **[mailto:classes@codecombat.com]classes@codecombat.com** for questions about specific pricing details.",
    //    faq_10_question: "Will my student get to work with the same instructor?",
    //    faq_10_answer: "Yes, once your subscription is arranged, your student will work with the same instructor each week. Periodically a substitute might need to be arranged for scheduling conflicts, but this is rare.",
    //    faq_11_question: "Is my child’s data secure?",
    //    faq_11_answer: "We take student safety, cybersecurity, and data privacy seriously, and follow the stringent school-grade privacy regulations including COPPA, FERPA, SOPIPA, California AB 1584, CalOPPA, Fair Information Practices, CAN-SPAM, as well as GDPR. All student data is stored securely on Amazon Web Services in the US. Our AI integrations have guardrails to protect Personal Identifiable Information (PII) and restrict sensitive content. Project sharing is controlled and peer-to-peer communication is restricted. Visit  **[https://codecombat.com/privacy]https://codecombat.com/privacy** for more information.",
    //    faq_12_question: "Do you offer classes in other languages?",
    //    faq_12_answer: "We offer the full class experience in both English and Spanish. However our talented group of instructors speak many other languages. If you have a specific language preference please reach out to **[mailto:classes@codecombat.com]classes@codecombat.com** to see if we can accommodate your child’s preferred language.",
    //    faq_13_question: "What makes our class experience different?",
    //    faq_13_answer: "Unlike other coding education platforms, our game-based approach uses our proprietary games and technology to deliver more engaging experience and more effective outcomes. We’ve developed our own web-based games and a fully immersive experience on Roblox that makes learning to code and game creation more enjoyable.",
    //  },

    //  roblox: {
    //    header_title: "Empowering every player to become a **creator**!",
    //    header_content: "Experience the easiest and most enjoyable way to code and create your own Roblox games",
    //    link_reward: "Account Linking Rewards",
    //    link_reward_desc: "Link your CodeCombat and Roblox accounts to unlock features and rewards",
    //    link_encouragement: "The more people link their accounts, the more rewards you'll receive!",
    //    connect_button_list_item_1: "Manage subscriptions",
    //    connect_button_list_item_2: "Unlock premium content",
    //    connect_button_list_item_3: "Track progress",
    //    connect_button_list_item_4: "Earn exclusive rewards",
    //    connect_button_list_item_5: "Access curricular resources",
    //    connect_button_list_item_6: "Unlock generative AI features",
    //    connect_button_list_item_7: "Creative mode publishing",
    //    connect_button_list_item_8: "Parent and teacher dashboards",
    //    link_now: "Link Now",
    //    pcc_on_roblox: "Play, Code and Create on Roblox",
    //    play_title: "Play",
    //    play_desc: "Explore the 3D immersive experience of CodeCombat Worlds. Program your pets and adventure into a universe of creativity and shared experiences with friends.",
    //    code_title: "Code",
    //    code_desc: "Learn real Lua coding, from beginner to advanced. Use code to explore, gather resources, build, and discover your path to glory.",
    //    create_title: "Create",
    //    create_desc: "No Roblox Studio? No problem. Code in-game in Creative Mode to make full Roblox games to share with your friends.",
    //    what_create: "What will you create?",
    //    access_guidebook: "Access Guidebook",
    //    guidebook_description: "Everything you need to know to get started",
    //    faq_1_question: "Do I need to know Lua or Roblox Studio?",
    //    faq_1_answer: "No. This experience will allow anyone to play, code and create from the very start of their adventure, without any coding experience.",
    //    faq_2_question: "Can I create my own games?",
    //    faq_2_answer: "Yes. Game development is at the core of this experience and after completing the essential learning levels you will have the opportunity to create your own.",
    //    faq_3_question: "Will my creations be available on Roblox?",
    //    faq_3_answer: "Yes. Players can share their experiences within CodeCombat Worlds and import their experiences to Studio for publishing via a plugin, maintaining Studio compatibility.",
    //    faq_4_question: "Do I need a Roblox account?",
    //    faq_4_answer: "Yes. All players can sign-up for free at roblox.com. Don't forget to link your CodeCombat account and Roblox account to access all the features and rewards.",
    //    faq_5_question: "Will it work on my Chromebook or mobile device?",
    //    faq_5_answer: "Yes. CodeCombat Worlds allows you to play, type real code and create games on PC, Mac, Chromebooks, tablets, phones, and consoles.",
    //    promo_modal_title: "Discover CodeCombat Worlds",
    //    promo_modal_text: "**Want to build a Roblox game but can’t code?** Jump into **CodeCombat Worlds** — where you’ll learn by playing! Start in Rift Village, coding your pets to harvest, and battle. Then tackle Lua (the coding language of Roblox) in the Learning Levels, and finally unleash your ideas in Creative Mode to craft immersive Roblox games. The power to create is in your hands!",
    //    having_trouble: "Having trouble?",
    //    check_help_doc: "View our connection guide here",
    //  },

    //  pd_page: {
    //    implementation_training_title: "Implementation Training",
    //    implementation_training_blurb: "Educators are provided with a live, online 60 minute onboarding training and guidance on how to use CodeCombat or Ozaria to support specific institutional and instructional goals. The implementation is focused on a comprehensive teacher dashboard walkthrough that covers:",
    //    list_1: "How to add classes & students",
    //    list_2: "How to track & lock student progress",
    //    list_3: "An overview of how to use the resources available in the Resource Hub, including: Course Guide, Lesson Plans, Lesson Slides, & Educator FAQ",
    //    modal_subtitle: "To get licenses for our professional development course, send us a message and our classroom success team will be in touch!",
    //    email_message: "Hi! I’m interested in learning more about your professional development course and discussing pricing options.",
    //    professional_development_title: "Professional Development[NEWLINE](With Ozaria)",
    //    professional_development_blurb: "This 40+ hour online, self-directed course provides educators with the knowledge, skills and resources to implement high-quality CS instruction.",
    //    list_4: "It adheres to the ESSA guidelines for exemplary professional learning, is endorsed by the CSTA and qualifies for valuable professional education credit hours.",
    //    list_5: "The course is built on a Learn It, Try It, Teach It model ensuring teachers have a solid foundation of the concepts before they implement it in the classroom.",
    //    list_6: "Earn up to 3 graduate-level education credit hours while exploring core CS concepts and teaching strategies that include computational thinking, inquiry-based learning, SEL and DEI.",
    //    download_table_of_contents: "Download Table of Contents",
    //    ap_csp_professional_development_title: "AP CSP Professional Development[NEWLINE](With CodeCombat)",
    //    ap_csp_professional_development_blurb: "This 40+ hour online, largely self-directed course is ideal for any educator who wants to prepare their students to succeed on the AP Computer Science Principles exam using CodeCombat.",
    //    list_7: "Both this course and the CodeCombat AP CSP curriculum are endorsed by the College Board. The hours completed in this course can be used to qualify for valuable professional education credit.",
    //    list_8: "The course leverages synchronous, small group conversations with AP CSP teachers from across the globe in order to deepen one’s CS knowledge and enrich one’s classroom practices.",
    //    list_9: "Through CodeCombat’s partnership with Southern New Hampshire University (SNHU), you can earn up to 3 graduate-level credit hours while learning how to best prepare your students to take the AP CSP exam.",
    //    download_syllabus: "Download Syllabus",
    //    get_full_course: "Get Full Course",
    //    try_sample_lesson: "Try Sample Lesson",
    //    trophy_header: "Level up as a Computer Science Teacher with our Professional Development offerings!",
    //  },

    //  junior_page: {
    //    testimonials_1_quote: "The future is programmable and you will need to be able to code to participate… I think CodeCombat has the best CS curriculum on the market… the teacher toolkit is what sets it apart.",
    //    testimonials_1_name: "Jacob Kaminski",
    //    testimonials_1_title: "STEM Program Director, American STEM Prep",
    //    start_their_coding_journey_today: "**Start** their coding journey **today!**",
    //    our_flagship_k_5_curriculum: "Our **flagship K-5 curriculum** features a scaffolded progression of learning levels that **teach coding concepts at a slower pace**, modeled specifically for elementary students.",
    //    sign_up_to_start_today: "Sign up to start today",
    //    testimonials_1_full_review_text: "Full review text",
    //    scaffolded_approach: "Scaffolded Approach",
    //    no_matter_the_coding_experience: "No matter the coding experience, CodeCombat Junior **meets students where they’re at.** They can code with icon blocks, word blocks, blocks and text code in parallel, or text-based coding with industry standard languages.",
    //    accessible_to_all: "Accessible to All",
    //    with_our_tablet_friendly_platform: "We’ve anticipated the challenges our youngest learners might face, incorporating **no-reading and no-typing options.** The simplified user interface performs exceptionally well on Chromebooks, as well as tablets and iPads without physical keyboards, ensuring equity and accessibility for all, irrespective of their device.",
    //    adaptive_to_each_student: "Adaptive to Each Student",
    //    codecombat_junior_automatically_assesses: "CodeCombat Junior automatically assesses learner’s coding success and recommends **custom-generated practice levels** when they need extra support. This provides a personalized learning pathway for every student while offering the ability for parents and educators to track progress.",
    //    coding_fundamentals_and_cross_curricular_connections: "Coding Fundamentals and Cross-Curricular Connections",
    //    our_curriculum_offers_student_facing: "For educators, our curriculum offers student-facing lesson slides and approachable activities to teach both core K-5 coding concepts and cross-curricular connections. The unplugged activities **integrate coding concepts with other disciplines like Math and ELA.** Topics include sequencing stories, visualizing and graphing data, narratives, and number sentences. All of our lessons are designed to **meet Computer Science Teachers Association (CSTA) Standards and Common Core Standards.**",
    //    request_a_quote: "Request a Quote",
    //    scope_and_sequence: "Scope and Sequence",
    //    check_out_this_resource: "Check out **[https://docs.google.com/spreadsheets/d/1_2zr55qsEcbHDyDNoelYamN9ov0G35ju7s-ufttSzVQ]this resource** as a starting point for your personalized approach.",
    //    connect_with_our_team: "Connect with our team to access all the teacher resources, a personalized learning pathway, generative practice levels, and more. We’ll help you integrate this comprehensive K-5 coding curriculum to ensure your students thrive at every stage of their coding journey.",
    //    faq_1_question: "FAQ 1 Question",
    //    faq_1_answer: "FAQ 1 Answer",
    //    faq_2_question: "FAQ 2 Question",
    //    faq_2_answer: "FAQ 2 Answer",
    //    faq_3_question: "FAQ 3 Question",
    //    faq_3_answer: "FAQ 3 Answer",
    //    faq_4_question: "FAQ 4 Question",
    //    faq_4_answer: "FAQ 4 Answer",
    //    meta_title: "CodeCombat Junior: K-5 Computer Science for Schools",
    //    our_comprehensive_implementation: "Our comprehensive implementation",
    //    trends_1_title: "Kickstarting CS in K-5 Classrooms",
    //    trends_1_text: "Watch as CodeCombat's Director of Education, Charlotte Cheng, and STEM Program Director, Jacob Kaminski, explore how to integrate **CodeCombat Junior** and **CodeCombat Worlds** into your classroom. They share practical strategies, success stories, and answer questions from fellow educators.",
    //    trends_1_linkText: "Learn more",
    //    trends_2_title: "CodeCombat Junior: A New Dynamic Approach to K-5 Coding",
    //    trends_2_text: "Learn more about how **CodeCombat Junior** can bring coding education to K-5 classrooms. From drag-and-drop icon-based block coding to text-based coding in Python and JavaScript, this adaptable platform supports students at every stage. With over 1,100 levels and more in development, CodeCombat Junior offers endless opportunities.",
    //    trends_2_linkText: "Read the blog",
    //    get_a_headstart: "Get a Headstart from Home",
    //    parents_junior_perfect: "Parents, CodeCombat Junior is the perfect way to start introducing your child not only to computer science but all the benefits, including problem solving, logic and reasoning, persistence, computational thinking and creative exploration.",
    //    explore_learning_options: "Explore Learning Options",
    //    promo_modal_subtitle: "Play, Learn, and Grow with Game‑Based Coding",
    //    promo_modal_text: "**Kickstart their coding adventure with scaffolded levels designed for ages 5–8—no reading or typing needed!** They’ll learn with icon blocks, word blocks, or simple text side by side, and tackle adaptive challenges that keep them engaged. Works seamlessly on **Chromebooks**, **tablets**, and **iPads**.",
    //  },

    //  paywall: {
    //    badge_free: "Free",
    //    "badge_sales-call": "Unlock with Call",
    //    badge_paid: "Paid",
    //    badge_tooltip_free: "Explore our levels at no cost!",
    //    "badge_tooltip_sales-call": "Interested in more? Give us a call and unlock!",
    //    badge_tooltip_paid: "This content is exclusive to users with a valid license.",
    //  },

    //  exams: {
    //    timer_tip: "A timer will start when you click Start Exam",
    //    no_permission: "Only users with permission can take the exam",
    //    level_num: "Challenge __num__",
    //    time_left: "Time Left (HH:mm):",
    //    submit_tip: "Are you sure you want to mark as complete? You will not be able to play the levels again.",
    //    start_exam: "Start Exam",
    //    continue_exam: "Continue Exam",
    //    return_to_exam: "Return to the Exam",
    //  },

    //  hoc_page: {
    //    hoai_activities_poetry_title: "AI HackStack: Poetry in Motion",
    //    hoai_activities_poetry_description: "Bring poetry to life with AI HackStack! Learners explore a poem’s theme, craft prompts to generate images, and evaluate AI outputs for bias while blending ELA skills with AI literacy as words transform into art.",
    //    hoai_activities_social_title: "AI HackStack: Social Media Showdown",
    //    hoai_labels_grade: "Grades 6+",
    //    hoai_labels_multimodal: "Multimodal AI",
    //    hoai_labels_ela: "ELA",
    //    hoai_labels_algebra: "Algebra",
    //    hoai_labels_cs: "CS",
    //    hoai_activities_social_description: "Play social media manager in this algebra and AI challenge! Prompt AI to build formulas, model engagement, and judge celebrity content battles while mastering math and AI literacy.",
    //    hoai_activities_vibe_title: "AI HackStack: Vibe Coding Lab",
    //    hoai_activities_vibe_description: "Dive into vibe coding with AI HackStack! Guide a hero with simple algorithms, explore syntax, and prompt AI to remix code into games and sites for a creative, fast, and fun coding experience.",
    //    hoai_activities_esports_title: "CodeCombat: AI Esports",
    //    hoai_activities_esports_description: "AI meets esports in this coding challenge! Learn prompts and algorithms, experiment with vibe coding, then team up with an AI assistant to face the CPU in the ultimate AI League battle.",
    //    learn_and_engage_with_these_csedweek_activities: "**Learn** and **engage** with these **CSEdWeek** activities!",
    //    latest_activities: "Latest Activities",
    //    hoai_activities: "Hour of AI Activities",
    //    turn_csedweek_into_a_cs_year: "Turn CSEdWeek into a CS Year",
    //    start_teaching_today_with_free_trial_access_to_all_games_and_teaching_resources: "Start teaching today with free trial access to all games and teaching resources.",
    //    more_of_our_csedweek_activities: "More of Our CSEdWeek Activities",
    //    latest_activities_1_title: "AI HackStack: Exploring AI Basics",
    //    latest_activities_1_text: "Unleash your creativity and explore the future with AI HackStack! From designing AI-generated art to building intelligent tools, dive into hands-on activities that make learning safe, fun, and inspiring for all skill levels.",
    //    latest_activities_1_label_1: "Grades 6-8",
    //    latest_activities_1_label_2: "Multimodal AI",
    //    latest_activities_2_title: "CodeCombat Junior",
    //    latest_activities_2_text: "Ready, set, code! Help your pet collect gems by mastering the basics of programming. Learn to create sequences, solve puzzles, and build algorithms in this hands-on adventure!",
    //    latest_activities_2_label_1: "Grades K-5",
    //    latest_activities_2_label_2: "JavaScript, Python",
    //    latest_activities_2_label_3: "Tablet Friendly",
    //    try_activity: "Try Activity",
    //    view_lesson: "View Lesson",
    //    codecombat_worlds_title: "CodeCombat Worlds",
    //    codecombat_worlds_text: "Master coding by creating your own Roblox games, from coding pets in the Overworld to crafting games in Creative Mode!",
    //    codecombat_worlds_label_1: "Grades 2+",
    //    codecombat_worlds_label_2: "Lua",
    //    codecombat_worlds_label_3: "Tablet Friendly",
    //    codecombat_worlds_label_4: "Download Required",
    //    goblins_glory_title: "CodeCombat: Goblins 'n' Glory",
    //    goblins_glory_text: "We need your help! Embark on an epic quest where you take control of the game through your powers of programming.",
    //    goblins_glory_label_1: "Grades 6-8",
    //    goblins_glory_label_2: "JavaScript, Python",
    //    ai_league_title: "Esports Bootcamp: AI League",
    //    ai_league_text: "Competitive coding has never been so epic! Learn the skills you need to play like the pros in our Esports Bootcamp. No coding experience needed.",
    //    ai_league_label_1: "Grades 6-8",
    //    ai_league_label_2: "JavaScript, Python",
    //    ozaria_title: "Ozaria: Your Journey Begins",
    //    ozaria_text: "Enter the world of Ozaria where you must use the power of coding to defeat a darkness that has taken over the world!",
    //    ozaria_label_1: "Grades 6-8",
    //    ozaria_label_2: "JavaScript, Python",
    //    escape_dungeon_title: "Beginner CS: Escape the Dungeon!",
    //    escape_dungeon_text: "Choose your hero and code your way through the ogre patrols, lava pits, and laser beams of Kithgard Dungeon. Level up, earn gems, and loot magic items to unlock new programming powers!",
    //    escape_dungeon_label_1: "Grades 6-8",
    //    escape_dungeon_label_2: "JavaScript, Python",
    //    beginner_game_dev_title: "Beginner Game Dev: Build Your Own Game!",
    //    beginner_game_dev_text: "First, level up your Python or JavaScript programming skills by coding your way out of danger and grabbing sweet loot. Then use your programming powers to build your own game and see if your friends can beat it!",
    //    beginner_game_dev_label_1: "Grades 6-8",
    //    beginner_game_dev_label_2: "JavaScript, Python",
    //    intermediate_game_dev_title: "Intermediate Game Dev: Code, Play, Create",
    //    intermediate_game_dev_text: "Code and play a series of game levels while learning important Computer Science concepts. On the final level, show off your creativity and skills to code your own game from scratch!",
    //    intermediate_game_dev_label_1: "Grades 6+",
    //    intermediate_game_dev_label_2: "JavaScript, Python",
    //    advanced_game_dev_title: "Advanced Game Dev: Build an Arcade Game!",
    //    advanced_game_dev_text: "Ready to create an even cooler game? Brush up on advanced coding concepts like functions and events using Python or JavaScript, then use those skills to build your own arcade survival game!",
    //    advanced_game_dev_label_1: "Grades 6+",
    //    advanced_game_dev_label_2: "JavaScript, Python",
    //  },
  },
}
